var app = angular.module('news', [
    'ngCookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    // 'ngRaven',
    'barney',
    'angular-carousel',
    'angularLazyImg',
    'DAM_Personalization',
    'DAM_CookieAlert'
]).constant('EventBus', new JsEventbus())

    .config(['$routeProvider', '$compileProvider', '$locationProvider', '$httpProvider', '$sceDelegateProvider', 'BarneyConfigProvider', 'lazyImgConfigProvider', 'PersonalizationProvider', 'CookieAlertProvider',
        function ($routeProvider, $compileProvider, $locationProvider, $httpProvider, $sceDelegateProvider, Config, lazyImgConfigProvider, Personalization, CookieAlert) {

            /*******************
            ***   HASHBANG   ***
            *******************/

            $locationProvider.hashPrefix('!');


            /*******************
            ***    CONFIG    ***
            *******************/
            Config.init({
                config: CONFIG
            });


            /*******************
            ***   LAZY IMG   ***
            *******************/

            lazyImgConfigProvider.setOptions({
                // how early you want to load image (default = 100)
                offset: 150,

                // in case of loading image failure what class should be added (default = null)
                errorClass: 'error',

                // in case of loading image success what class should be added (default = null)
                successClass: 'b-loaded',

                // function fired on loading error
                onError: function (image) { },

                // function fired on loading success
                onSuccess: function (image) {
                    var cardsContent = document.querySelectorAll('.home.cards-content');
                    var cardsMarginBottom = 30;
                    if (window.innerWidth > 1200) {
                        cardsMarginBottom = 45;
                    }

                    Array.prototype.forEach.call(cardsContent, function (el, i) {
                        el.style.height = (el.querySelector('figure').offsetHeight + cardsMarginBottom) + 'px';
                    });
                },

                // if scrollable container is not $window then provide it here
                container: angular.element(window)
            });


            /*******************
            ***    ROUTING   ***
            *******************/

            var getTemplatePrefix = function () {
                if (Config.get('IS_STAGING')) {
                    if (Config.get('IS_JENKINS_DEPLOYED')) {
                        return Config.get('JS_BUILD_URL') + 'app';
                    }
                }
                return Config.get('JS_TEMPLATE_PREFIX');
            };

            $routeProvider
                .when(Config.get('ROUTER_HOME'), {
                    controller: 'HomeCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/home/home.html',
                    className: 'home-page',
                    analyticsPageTitle: 'HP'
                })
                .when(Config.get('ROUTER_NEWS'), {
                    controller: 'NewsCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/news/news.html',
                    className: 'news-page',
                    analyticsPageTitle: 'Categories'
                })
                .when(Config.get('ROUTER_CATEGORY'), {
                    controller: 'CategoryCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/category/category.html',
                    className: 'category-page',
                    analyticsPageTitle: 'CatSingle'
                })
                .when(Config.get('ROUTER_SEARCH'), {
                    controller: 'SearchCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/search/search.html',
                    className: 'search-page',
                    analyticsPageTitle: 'Search'
                })
                .when(Config.get('ROUTER_TAG'), {
                    controller: 'TagCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/tag/tag.html',
                    className: 'tag-page',
                    analyticsPageTitle: 'TagSingle'
                })
                .when(Config.get('ROUTER_ZOOM'), {
                    controller: 'ZoomParentCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/zoomParent/zoomParent.html',
                    className: 'zoom-page',
                    analyticsPageTitle: 'Zoom',
                    reloadOnSearch: false
                })
                .when(Config.get('ROUTER_ERROR'), {
                    controller: 'ErrorCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/error/error.html',
                    className: 'error-page',
                    analyticsPageTitle: 'Error',
                    showAlways: true
                })
                .when(Config.get('ROUTER_ERROR_SINGLE'), {
                    controller: 'ErrorCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/error/error.html',
                    className: 'error-page',
                    analyticsPageTitle: 'Error',
                    showAlways: true
                })
                .when(Config.get('ROUTER_VIDEO'), {
                    controller: 'VideoListCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/video/video-list.html',
                    className: 'video-list-page',
                    analyticsPageTitle: 'Video-List'
                })
                .when(Config.get('ROUTER_VIDEO_SINGLE'), {
                    controller: 'VideoZoomCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/video/video-zoom.html',
                    className: 'video-zoom-page',
                    analyticsPageTitle: 'Video-Zoom'
                })
                .when(Config.get('ROUTER_ACCOUNT'), {
                    controller: 'AccountCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account/account.html',
                    className: 'account-page',
                    analyticsPageTitle: 'Account',
                    showAlways: true
                })
                .when(Config.get('ROUTER_SETTINGS'), {
                    controller: 'AccountCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account/account.html',
                    className: 'account-page',
                    analyticsPageTitle: 'Account',
                    showAlways: true
                })
                .when(Config.get('ROUTER_LOGIN'), {
                    controller: Config.get('SHOW_OTP_LOGIN') ? 'LoginOtp30Ctrl' : 'Login30Ctrl',
                    templateUrl: getTemplatePrefix() + '/pages/' + (Config.get('SHOW_OTP_LOGIN') ? 'account30/loginOtp.html' : 'account30/login.html'),
                    className: 'login-page',
                    analyticsPageTitle: 'Login',
                    showAlways: true
                })
                .when(Config.get('ROUTER_FORGOT'), {
                    controller: Config.get('ENABLE_NEWTON_USER') ? 'Forgot30Ctrl' : 'ForgotCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/' + (Config.get('ENABLE_NEWTON_USER') ? 'account30/forgot.html' : 'account/forgot.html'),
                    className: 'forgot-page',
                    analyticsPageTitle: 'Forgot',
                    showAlways: true
                })
                .when(Config.get('ROUTER_UNSUBSCRIBED'), {
                    controller: 'CanceledCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account/canceled.html',
                    className: 'unsubscribed-page',
                    analyticsPageTitle: 'Unsubscribed',
                    showAlways: true
                })
                .when(Config.get('ROUTER_ADDEMAIL'), {
                    controller: 'AccountCreationCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account30/accountCreation.html',
                    className: 'account-creation-page',
                    analyticsPageTitle: 'AccountCreation',
                    showAlways: true
                })
                .when(Config.get('ROUTER_CHANGEPSW'), {
                    controller: 'ChangePasswordCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account30/changePassword.html',
                    className: 'change-password-page',
                    analyticsPageTitle: 'ChangePassword',
                    showAlways: true
                })
                .when(Config.get('ROUTER_RESETPSW'), {
                    controller: 'ResetPasswordCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account30/resetPassword.html',
                    className: 'reset-password-page',
                    analyticsPageTitle: 'ResetPassword',
                    showAlways: true
                })
                .when(Config.get('ROUTER_CONFIRMMAIL'), {
                    controller: 'ConfirmMailCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/account30/confirmMail.html',
                    className: 'confirm-mail-page',
                    analyticsPageTitle: 'ConfirmMail',
                    showAlways: true
                })
                .when(Config.get('ROUTER_MYSPACE'), {
                    controller: 'MySpaceCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/myspace/myspace.html',
                    className: 'my-space-page',
                    analyticsPageTitle: 'MySpace'
                })
                // Personalisation
                .when(Config.get('ROUTER_HISTORY'), {
                    controller: 'PlaylistCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/playlist/playlist.html',
                    className: 'playlist-page',
                    analyticsPageTitle: 'Playlist',
                    resolve: {
                        Model: function (HiStory) {
                            return HiStory;
                        }
                    },
                    params: {
                        title: 'History'
                    }
                })
                .when(Config.get('ROUTER_FAVORITES'), {
                    controller: 'PlaylistCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/playlist/playlist.html',
                    className: 'playlist-page',
                    analyticsPageTitle: 'Playlist',
                    resolve: {
                        Model: function (Favorites) {
                            return Favorites;
                        }
                    },
                    params: {
                        title: 'Favorites',
                        section: 'favorites'
                    }
                })
                .when(Config.get('ROUTER_WATCHLATER'), {
                    controller: 'PlaylistCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/playlist/playlist.html',
                    className: 'playlist-page',
                    analyticsPageTitle: 'Playlist',
                    resolve: {
                        Model: function (WatchLater) {
                            return WatchLater;
                        }
                    },
                    params: {
                        title: 'Watchlater',
                        section: 'watchlater'
                    }
                })
                .when(Config.get('ROUTER_GLOSSARY'), {
                    controller: 'GlossaryCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/glossary/glossary.html',
                    className: 'glossary-page',
                    analyticsPageTitle: 'Glossary'
                })
                .when(Config.get('ROUTER_GLOSSARY_SINGLE'), {
                    controller: 'GlossaryCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/glossary/glossary.html',
                    className: 'glossary-page',
                    analyticsPageTitle: 'Glossary'
                })
                .when(Config.get('ROUTER_GOTO'), {
                    controller: function ($location, BarneyBrowser) {
                        if (BarneyBrowser.getQueryParams().url) {
                            window.location.href = BarneyBrowser.getQueryParams().url;
                        } else {
                            $location.path('ROUTER_ERROR');
                        }
                    },
                    template: '<div></div>',
                    showAlways: true
                })
                .otherwise({
                    redirectTo: Config.get('ROUTER_ERROR')
                });

            if (Config.get('ROUTER_CONTACT_US')) {
                $routeProvider.when(Config.get('ROUTER_CONTACT_US'), {
                    controller: 'ContactUsCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/contactUs/contactUs.html',
                    className: 'contact-us-page',
                    analyticsPageTitle: 'ContactUs'
                });
            }

            if (Config.get('ROUTER_CONTACT_US') && Config.get('USE_CONTACT_FORM_V2')) {
                $routeProvider.when(Config.get('ROUTER_CONTACT_US'), {
                    controller: 'ContactFormCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/contactForm/contactForm.html',
                    className: 'contact-us-page',
                    analyticsPageTitle: 'ContactUs'
                });
            }

            var termsRoutes = Config.get('ROUTER_TERMS_LIST');

            /* eslint-disable no-inner-declarations, no-loop-func */

            for (var k = 0; k < termsRoutes.length; k++) {
                function getParams(index) {
                    return {
                        SUBSECTION: function () {
                            return termsRoutes[index].subsection;
                        },
                        CONTENT_ID: function () {
                            return termsRoutes[index].content_id;
                        }
                    };
                }

                /* eslint-enable no-inner-declarations, no-loop-func */

                $routeProvider.when(termsRoutes[k].path, {
                    controller: 'TermsCtrl',
                    templateUrl: getTemplatePrefix() + '/pages/terms/terms.html',
                    className: 'settings-page',
                    resolve: getParams(k),
                    showAlways: true
                });
            }


            /*******************
            ***   SANITIZE   ***
            *******************/

            $compileProvider.aHrefSanitizationWhitelist(/^\s*(file|http|https?|whatsapp):/);
            //$compileProvider.aHrefSanitizationWhitelist(/^\s*(http|https?|whatsapp):\/\/(twitter.com|send)/);


            /*******************
            ***  HTTP CALLS  ***
            *******************/

            // add default get params to API calls
            $httpProvider.defaults.withCredentials = true;
            $httpProvider.interceptors.push(function () {
                return {
                    request: function (httpConfig) {
                        if (!httpConfig.params) { httpConfig.params = {}; }

                        // if(httpConfig.url.indexOf('.html') === -1){
                        //     httpConfig.params.access_token = NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        // }

                        if (httpConfig.url.indexOf('lapis') !== -1) {
                            // httpConfig.params.fw = Config.get('FW_TYPE');
                            // httpConfig.params.lang = Config.get('LANGUAGE');
                            // httpConfig.params.real_customer_id = Config.get('REAL_CUSTOMER_ID');
                            httpConfig.params.timestamp = Math.floor(Date.now() / 1000);
                            httpConfig.params.tld = Config.get('TLD');
                        }
                        return httpConfig;
                    }
                };
            });

            $httpProvider.interceptors.push('JwtInterceptor');

            // $httpProvider.interceptors.push(function() {
            //     return {
            //         request: function(httpConfig) {
            //             console.log(JwtToken)
            //             if (Config.get('JWT_ENABLED')) {
            //
            //             }
            //             return httpConfig;
            //         }
            //     }
            // });

            /*******************
            ** VIDEOS AND CUSTOM VIDEOS  **
            *******************/

            var videoEmbeddedUrls = ['self'];
            // whitelist youtube, dailymotion and vimeo URLs
            videoEmbeddedUrls.push(
                'http://*.youtube.com/**',
                'https://*.youtube.com/**',
                'http://*.dailymotion.com/**',
                'https://*.dailymotion.com/**',
                'http://*.vimeo.com/**',
                'https://*.vimeo.com/**'
            );

            if (Config.get('BPLAYER_DEST_DOMAIN') && Config.get('BPLAYER_DEST_DOMAIN') !== Config.get('DEST_DOMAIN')) {
                videoEmbeddedUrls.push(Config.get('BPLAYER_DEST_DOMAIN') + '**');
            }
            $sceDelegateProvider.resourceUrlWhitelist(videoEmbeddedUrls);


            /*******************
            *** DISABLE DEBUG **
            *******************/

            $compileProvider.debugInfoEnabled(false);


            /*******************
            *  PERSONALIZATION *
            *******************/

            Personalization.init({
                templatePrefix: getTemplatePrefix(),
                accessTokenMethod: function () {
                    return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                },
                favoritesGetURL: Config.get('MOA_API_FAVORITES_GETLIST'),
                favoritesSetURL: Config.get('MOA_API_FAVORITES_SET'),
                favoritesDeleteURL: Config.get('MOA_API_FAVORITES_DELETE'),
                historyGetURL: Config.get('MOA_API_HISTORY_GETLIST'),
                historySetURL: Config.get('MOA_API_HISTORY_SET'),
                watchlaterGetURL: Config.get('MOA_API_WATCHLATER_GETLIST'),
                watchlaterSetURL: Config.get('MOA_API_WATCHLATER_SET'),
                watchlaterDeleteURL: Config.get('MOA_API_WATCHLATER_DELETE')
            });

            CookieAlert.init({
                // init confs
                cookieAlertEnabled: Config.get('SHOW_PRIVACY_BLOCK'),
                closeCookieOnScroll: Config.get('CLOSE_COOKIE_ON_SCROLL'),
                closeCookieOnExternalClick: Config.get('CLOSE_COOKIE_ON_EXTERNAL_CLICK'),
                closeCookieOnInternalClick: Config.get('CLOSE_COOKIE_ON_INTERNAL_LINK'),
                isHybrid: Config.get('IS_HYBRID'),
                templatePrefix: getTemplatePrefix()
            });
        }
    ])

    .run(['$rootScope', '$location', '$route', '$window', 'BarneyMeta', 'BarneyDict', 'BarneyConfig', 'BarneyBrowser', 'Cat', 'User', 'GoogleManager', 'Settings', 'MetaTitleManager', 'EventBus', 'optimizeCanonicalFilter',
        function ($rootScope, $location, $route, $window, Meta, Dict, Config, Browser, Cat, User, GoogleManager, Settings, MetaTitleManager, Bus, optimizeCanonical) {

            /*******************
            ***   LANGUAGE   ***
            *******************/
            var RTL_LANGS = {
                ar: true,
                he: true,
                fa: true,
                ur: true,
                ps: true,
                dv: true,
                sd: true,
                ug: true,
                yi: true
            };
            function getDirection(langCode) {
                if (!langCode) {
                    return 'ltr';
                }
                var langPrefix = langCode.split('-')[0].toLowerCase();
                return RTL_LANGS[langPrefix] ? 'rtl' : 'ltr';
            }
            $rootScope.showMultilanguage = Config.get('SHOW_MULTIPLE_LANGUAGE');
            if ($rootScope.showMultilanguage){
                $rootScope.languageList = Config.get('MULTILANGUAGE_LIST') || [];
                $rootScope.currentLanguage = Config.get('LANGUAGE');
            }
            var isoLang = COUNTRY_ISO_LANG || $rootScope.currentLanguage || '';
            $rootScope.RTLlang = getDirection(isoLang);

            /*******************
            ***   LOAD CSS   ***
            *******************/

            // Gameasy mechanism to avoid FOUC
            if (!Config.get('KIOSK_SERVICE') && Config.get('HAS_CRITICAL_LESS')) {    //critical first-loading enabled
                var lessCSS;
                var lessURL;
                lessURL = [Config.get('LESS_URL'), '?file=app.less&country=', Config.get('API_COUNTRY'), '&v=', Config.get('SERVICE_CSS_VERSION'), '&operator=', Config.get('OP'), '&IS_STAGING=', Config.get('IS_STAGING')].join('');
                lessCSS = loadCSS(lessURL, document.querySelector('#confs'));
                onloadCSS(lessCSS, function () {
                    var resizeEvent = window.document.createEvent('UIEvents'); 
                    resizeEvent.initUIEvent('resize', true, false, window, 0); 
                    window.dispatchEvent(resizeEvent);
                });
            } else if (Config.get('THANKYOUPAGE_ON_MIP')) {
                Bus.trigger('cssHasFinished');
            }


            /*******************
            ***  DICTIONARY   ***
            *******************/

            Dict.init({
                showKey: Config.get('IS_STAGING') ? 'missing' : 'default',
                dict: DICTIONARY
            });
            $rootScope.showFooterServiceDescription = Config.get('SHOW_OPERATOR_MESSAGE') && !!Dict.get('WEBAPP_OPERATOR_MESSAGE');

            /*******************
            ***    LOGGER    ***
            *******************/

            JsLogger.init({
                level: 'log',
                enable: Config.get('IS_STAGING') ? true : false
            });

            JsLogger.info('Config', Config.list());
            JsLogger.info('Dictionary', Dict.list());


            /*******************
            ***    STORAGE   ***
            *******************/

            JsStorage.init({
                type: Config.get('HYBRIDONDEVICE') ? 'localstorage' : 'cookie'
            });

            // Init SnowPlow 
            if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                const collectorUrl = window.location.origin.includes('https') ? window.location.origin.replace('https://', '') : window.location.origin.replace('http://', '');
                const collector = window.location.origin.includes('2') ? 'com-digitalvirgo-prod1.mini.snplow.net' : collectorUrl;
                var appId = Dict.get('SNOWPLOW_APP_ID') || '';
                var optionsSp = window.location.origin.includes('2') ? {
                    appId: appId
                } : {
                    appId: appId,
                    discoverRootDomain: true,
                    cookieName: '_snp_',
                    contexts: {
                        performanceTiming: true                        
                    }
                };
                window.snowplow('newTracker', 'sp1', collector, optionsSp);
                
            }


            /**************************
            ***    NEWTON + USER    ***
            **************************/
            // set Newton init properties
            var newtonInitProperties = Cat.getCatParams();
            newtonInitProperties.environment = Config.get('DEVICE_OS') ? Config.get('DEVICE_OS') : 'webapp';
            var campaignRecognitionShare = Browser.getQueryParams().campaignRecognitionShare;
            if (typeof campaignRecognitionShare !== 'undefined') {
                newtonInitProperties.cr = campaignRecognitionShare;
                $rootScope.campaignRecognition = campaignRecognitionShare;
            }

            if (Config.get('ENABLE_NEWTON_USER')) {

                useris.init({
                    domain: Config.get('DEST_DOMAIN'),
                    country: Config.get('REAL_COUNTRY'),
                    enableAliasCheck: Config.get('ENABLE_ALIAS_URL'),
                    alaisCheckUrl: Config.get('ALIAS_URL'),
                    disablePinInput: Config.get('HIDE_LOGINPIN'),
                    hybridnews: 0,
                    store_type: '',
                    apikey: Config.get('MOTIME_API_KEY'),
                    enableGoogleCheckbox: Config.get('SHOW_GOOGLE_CHECKBOX'),
                    emailIdentityEnabled: Config.get('IDENTITY_EMAIL_ENABLED'),
                    identityFbEnabled: Config.get('IDENTITY_FB_ENABLED'),
                    redirectToMipRegisterAtStart: Config.get('REDIRECT_TO_MIP_REGISTER_AT_START'),
                    logger: console,
                    regexObject: {
                        msisdn: Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'),
                        pin: Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_PIN'),
                        password: Config.get('REGEXP_VALIDATE_PASSWD') || '[a-zA-Z0-9]',
                        email: Config.get('REGEXP_VALIDATE_EMAIL'),
                        generic: '.',
                        genericPassword: '.'
                    }
                });

                // (1) Newton init
                NewtonAdapter.init({
                    logger: JsLogger,
                    enable: Config.get('ENABLE_NEWTON_TRACKING'),
                    waitLogin: true,
                    secretId: Config.get('NEWTON_SECRETID'),
                    properties: newtonInitProperties,
                    config: {
                        isInternational: !!Config.get('IS_INTERNATIONAL'),
                        whiteLabel: Config.get('WHITE_LABEL'),
                        getSnowPlowInstance: function () {
                            return window.snowplow || null;
                        }
                    }
                }).then(function () {
                    // (2) User init
                    User.init(function (resp) {
                        JsLogger.info('User ', resp);
                        if (NewtonAdapter.isUserLogged()) {

                            //TODO caso suspended
                            
                            if (resp.suspended) {
                                //console.log('suspended - app', resp);
                            }

                            // Raven.setUserContext(resp);

                            if (JsStorage.get('user-login-show-feedback', { type: 'cookie' })) {
                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dict.get('WEBAPP_UO30_FEEDBACK_LOGIN')
                                    }
                                });

                                JsStorage.delete('user-login-show-feedback', { type: 'cookie' });
                            }
                        } else if (JsStorage.get('user-logout-show-feedback', { type: 'cookie' })) {
                            useris.PopupManager.showUserFeedback({
                                type: 'positive',
                                feedback: {
                                    message: Dict.get('WEBAPP_UO30_FEEDBACK_LOGOUT')
                                }
                            });

                            JsStorage.delete('user-logout-show-feedback', { type: 'cookie' });
                        }
                    });

                    // (3) Newton login
                    NewtonAdapter.login({
                        logged: false
                    });

                    // (4) Listen Newton login/logout
                    NewtonAdapter.setUserStateChangeListener({
                        onLoginStateChange: function () {
                            User.init(function (resp) {
                                Bus.trigger('User-State-Changed');
                                if (NewtonAdapter.isUserLogged()) {
                                    Bus.trigger('User-Login');
                                    Bus.trigger('User-Login-Menu', resp);
                                    // Raven.setUserContext(resp);
                                } else {
                                    Bus.trigger('User-Logout');
                                    Bus.trigger('User-Logout-Menu', resp);
                                    // Raven.setUserContext();
                                }
                            });
                        }
                    });
                });
            } else {
                // (1) User init
                User.init(function (resp) {
                    JsLogger.info('User ', resp);
                    if (resp.logged) {
                        // Raven.setUserContext(resp);
                    }
                });

                User.getStatus(function (userStatus) {
                    if (userStatus.session_id) {
                        newtonInitProperties.bridge_session_id = userStatus.session_id;
                    }

                    // (2) Newton init
                    NewtonAdapter.init({
                        logger: JsLogger,
                        enable: Config.get('ENABLE_NEWTON_TRACKING'),
                        waitLogin: true,
                        secretId: Config.get('NEWTON_SECRETID'),
                        properties: newtonInitProperties,
                        config: {
                            isInternational: !!Config.get('IS_INTERNATIONAL'),
                            whiteLabel: Config.get('WHITE_LABEL')
                        }
                    });

                    if (userStatus.logged) {
                        // set Newton login properties
                        var userProperties = {};
                        userProperties.msisdn = userStatus.msisdn ? userStatus.msisdn : '';
                        userProperties.white_label_id = Config.get('WHITE_LABEL') ? Config.get('WHITE_LABEL') : '';
                        userProperties.country = Config.get('TLD') ? Config.get('TLD') : '';
                        userProperties.real_country = Config.get('REAL_COUNTRY') ? Config.get('REAL_COUNTRY') : '';

                        // (3a) Newton login
                        NewtonAdapter.login({
                            logged: true,
                            type: 'custom',
                            userId: userStatus.user,
                            userProperties: userProperties
                        });
                    } else {
                        // (3b) Newton login
                        NewtonAdapter.login({
                            logged: false
                        });
                    }
                });
            }

            /*******************
             ** BANNER DIGI  **
             *******************/
            if (window.sessionStorage.getItem('bannerpromoflag')) {

                if (window.performance) {
                    // Page refreshed
                    if (performance.navigation.type === 1) {
                        window.sessionStorage.removeItem('bannerpromoflag');
                    }
                }
            }

            /**************************
            ***    FACEBOOK PIXEL   ***
            **************************/

            if (Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter) {
                facebookpixeladapter.init(Config.get('FACEBOOK_PIXEL_ID'));
                facebookpixeladapter.pageView();
            }


            /**************************
            ***    NEWTON+LOGVIEW   ***
            **************************/

            if (Config.get('SETTRACK_PARAMS')) {
                NewtonAdapter.setLogView(Config.get('SETTRACK_PARAMS'));
            }

            $rootScope.showCookieAlert = !!Config.get('SHOW_PRIVACY_BLOCK') && (!Config.get('DIDOMI_API_KEY') || !Config.get('DIDOMI_ID'));

            $rootScope.closeCookieAlert = function () {
                // Check Banner and tracking
                if (Config.get('SHOW_BANNER_PROMO')) {
                    NewtonAdapter.trackEvent({
                        name: 'ViewBannerPromo',
                        properties: {
                            category: 'Behavior',
                            action: 'ViewBannerPromo',
                            label: window.location.href
                        }
                    });
                }
                // Set user properties
                User.getStatus(function (response) {
                    if (response.logged && !!Config.get('PRIVACY_BLOCK_SAVE_USER_FLAG')) {
                        var saveCookieObj = {
                            privacy_agreed: true,
                            date_privacy_cookie_agree: new Date().toISOString().slice(0, 19).replace('T', ' ')
                        };

                        User.setProperties(saveCookieObj);

                        JsLogger.log('Privacy accepted on: ', saveCookieObj);
                    }
                });
            };

            User.getStatus(function (response) {
                if (response.logged && !!Config.get('PRIVACY_BLOCK_SAVE_USER_FLAG')) {
                    User.getProperty('privacy_agreed', function (privacyAgreed) {
                        $rootScope.cookieAgreed = !!privacyAgreed;
                        if (document.cookie.indexOf('prvcflag') === -1) {
                            NewtonAdapter.trackEvent({
                                name: 'CookieAlertLoad',
                                properties: {
                                    category: 'Behavior',
                                    action: 'CookieAlertLoad',
                                    label: window.location.href
                                }
                            });
                        }
                    });
                } else {
                    $rootScope.cookieAgreed = false;
                    if (!!Config.get('SHOW_PRIVACY_BLOCK') && document.cookie.indexOf('prvcflag') === -1) {
                        NewtonAdapter.trackEvent({
                            name: 'CookieAlertLoad',
                            properties: {
                                category: 'Behavior',
                                action: 'CookieAlertLoad',
                                label: window.location.href
                            }
                        });
                    }
                }
            });

            if (Config.get('SHOW_BANNER_PROMO') && !!Config.get('SHOW_PRIVACY_BLOCK') && document.cookie.indexOf('prvcflag') >= 0) {
                NewtonAdapter.trackEvent({
                    name: 'ViewBannerPromo',
                    properties: {
                        category: 'Behavior',
                        action: 'ViewBannerPromo',
                        label: window.location.href
                    }
                });
            }


            /*******************
            ***   METATAGS   ***
            *******************/

            Meta.init({
                title: MetaTitleManager.getMetaTitle({
                    maskType: 'default',
                    content: '',
                    noMaskValue: Dict.get('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict.get('SEO_WEBAPP_TITLE_COUNTRY')
                }),
                //fbAppId: Config.get('FB_APPID'),
                description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX'),
                ogType: Dict.get('SEO_WEBAPP_META_OGTAGS_TYPE'),
                ogTitle: Dict.get('SEO_WEBAPP_HEAD_TITLE_INDEX'),
                ogDescription: Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX'),
                ogSiteName: Dict.get('SEO_WEBAPP_META_OGTAGS_NAME'),
                ogUrl: $location.absUrl(),
                ogImage: Config.get('META_DEFAULT_OGIMAGE_HOME'),
                ogImageWidth: '1024',
                ogImageHeight: '576',
                className: '',
                sectionClassName: Config.get('KIOSK_SERVICE') ? 'kiosk-service ' + Config.get('THEME') : '',
                jsonld: '',
                canonical: ''
            });

            // set host name
            $rootScope.hostName = $location.host();
            if ($rootScope.hostName.indexOf('http://') < 0) {
                $rootScope.hostName = window.location.protocol + '//' + $rootScope.hostName;
            }

            $rootScope.$on('$routeChangeStart', function (event, current, previous) {
                // revert meta tags: used when tags aren't set
                Meta.revert();

                // set class name of body tag
                if (!!current.$$route && !!current.$$route.className) {
                    Meta.set({ className: current.$$route.className });
                }
            });


            /*******************
            ***    HISTORY   ***
            *******************/

            Browser.init();

            /*******************
            ***   ANALYTICS  ***
            *******************/

            JsAnalytics.init({
                enabled: Config.get('ENABLE_ANALYTICS'),
                logger: JsLogger,
                dimensions: {
                    UserStatus: 1,
                    AccessType: 2,
                    SocialNetworkSource: 3,
                    SubscriptionDate: 4,
                    Valuable: 5,
                    Country: 6,
                    ProductTitle: 7,
                    Action: 8,
                    Environment: 9,
                    Ref: 10,
                    PaymentType: 11,
                    'User ID': 12
                }
            });

            var dimensionAlreadySet = false;

            /**************************
            ***  GOOGLE TAG MANAGER ***
            **************************/
            var operator = JsStorage.get('operator', { type: 'cookie' });
            Settings.getNetworkProperty().$promise.then(function (resp) {
                User.init(function (UserResp) {

                    var userStatus = function (H) {
                        if (operator === undefined) {
                            return Dict.get('WEBAPP_SERVICE_STATE_UNKNOWN' + H);
                        } else if (UserResp.logged) {
                            return Dict.get('WEBAPP_SERVICE_STATE_LOGGED' + H);
                        } else if (!UserResp.logged) {
                            return Dict.get('WEBAPP_SERVICE_STATE_UNLOGGED' + H);

                        }
                    };

                    var userLogged = function (H) {
                        if (NewtonAdapter.isUserLogged()) {
                            return Dict.get('WEBAPP_USER_IDENTIFIED' + H);
                        } else {
                            return Dict.get('WEBAPP_USER_NOT_IDENTIFIED' + H);
                        }
                    };

                    var dataLayerDefault = {
                        'Tipo de red': resp.networkType ? Dict.get('WEBAPP_TYPE_CONNECTION_3G') : Dict.get('WEBAPP_TYPE_CONNECTION_WIFI'),
                        'Seccion de navegacion': Dict.get('WEBAPP_NAVIGATION_SECTION'),
                        'Seccion de navegacion /h': Dict.get('WEBAPP_NAVIGATION_SECTION_H'),
                        'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                        'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER_H'),
                        Vertical: Dict.get('WEBAPP_VERTICAL_CATEGORY'),
                        'Vertical /h': Dict.get('WEBAPP_VERTICAL_CATEGORY_H'),
                        'Subcategoria tematica': Dict.get('WEBAPP_VERTICAL_SUBCATEGORY'),
                        'Subcategoria tematica /h': Dict.get('WEBAPP_VERTICAL_SUBCATEGORY_H'),
                        Servicio: Dict.get('WEBAPP_SERVICE_NAME'),
                        'Servicio /h': Dict.get('WEBAPP_SERVICE_NAME_H'),
                        Contenido: Dict.get('WEBAPP_NO_APPLICABLE_CONTENT'),
                        'Contenido /h': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                        'Proveedor del servicio': Dict.get('WEBAPP_SERVICE_PROVIDER'),
                        'Proveedor del servicio /h': Dict.get('WEBAPP_SERVICE_PROVIDER_H'),
                        'Proveedor tecnico del servicio': Dict.get('WEBAPP_TECHNICAL_PROVIDER'),
                        'Proveedor tecnico del servicio /h': Dict.get('WEBAPP_TECHNICAL_PROVIDER_H'),
                        'Estado de suscripcion al servicio': userStatus(''),
                        'Estado de suscripcion al servicio /h': userStatus('_H'),
                        'Estado de identificación de usuario': userLogged(''),
                        'Estado de identificación de usuario /h': userLogged('_H')
                    };


                    GoogleManager.init(dataLayerDefault);

                });

            });

            /****************************************
            *** get conf pages with GTM setting  ****
            *****************************************/
            var gtmPagesConf = [];
            var gtmPagesPath = [];

            if (Config.get('GTM_PAGES')) {
                gtmPagesConf = Config.get('GTM_PAGES');
                // set the route path page
                for (var i = 0; i < gtmPagesConf.length; i++) {
                    gtmPagesPath.push(Config.get(gtmPagesConf[i]));
                }
            }

            /****************************************
            * get conf pages with canonical setting *
            *****************************************/
            var canonicalPagesPath = [];

            if (Config.get('CANONICAL_URL_PAGES')) {
                var canonicalPagesConf = Config.get('CANONICAL_URL_PAGES');
                // set the route path page
                for (var k = 0; k < canonicalPagesConf.length; k++) {
                    canonicalPagesPath.push(Config.get(canonicalPagesConf[k]));
                }
            }

            /****************************************
            *** get conf pages with META_ACCOUNT_PAGES setting  ****
            *****************************************/

            var metaTitleAccountConf = [];
            var metaTitleAccountPath = [];
            if (Config.get('META_ACCOUNT_PAGES')) {
                metaTitleAccountConf = Config.get('META_ACCOUNT_PAGES');
                // set the route path page
                for (var y = 0; y < metaTitleAccountConf.length; y++) {
                    metaTitleAccountPath.push(Config.get(metaTitleAccountConf[y]));
                }
            }

            /**************************
            ***     ROUTE CHANGE    ***
            **************************/

            $rootScope.$on('$routeChangeStart', function (event, next, current) {
                // block access to adult product if unlogged
                User.getStatus(function (resp) {
                    if (Config.get('SITE_PROFILE') === 'sex' && !resp.logged && (!!next && !!next.$$route && !next.$$route.showAlways)) {
                        $location.path(Config.get('ROUTER_GOTO')).search('url', '/subscribe');
                    }
                });
            });

            $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {

                var currentRoute = current.$$route;
                var prevPage = !!Browser.getPrevState() && !!Browser.getPrevState().className ? Browser.getPrevState().className : '';

                /****************************************************************
                 * GTM_PAGES check router page path in conf with
                 * current router path, if It's not in array, set GTM 'other pages'
                 ****************************************************************/

                /****************************************************************
                 * META_ACCOUNT_PAGES check router page path in conf with
                 * current router path, if It's  in array, set meta.title per tutte le pagine
                 * di account - /account /login /forgot
                 ****************************************************************/

                if (metaTitleAccountPath.length > 0 && metaTitleAccountPath.indexOf(currentRoute.originalPath) !== -1) {
                    Meta.set({
                        title: MetaTitleManager.getMetaTitle({
                            maskType: 'list',
                            content: Dict.get('SEO_WEBAPP_HEAD_TITLE_ACCOUNT')
                        })
                    }, function () {
                        if ((currentRoute.originalPath !== '') && (gtmPagesPath.length > 0 && gtmPagesPath.indexOf(currentRoute.originalPath) === -1)) {
                            GoogleManager.set({
                                'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                                'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                                Contenido: Dict.get('WEBAPP_NO_APPLICABLE_CONTENT'),
                                'Contenido /h': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                                event: 'changePage'
                            });
                        }
                    });
                }

                /****************************************************************
                 * CANONICAL_URL_PAGES check router page path in conf with
                 * current router path, if it's in array then
                 * add meta tag 'canonical' with correct URL without query string
                 ****************************************************************/

                if ((currentRoute.originalPath !== '') && (canonicalPagesPath.length > 0 && canonicalPagesPath.indexOf(currentRoute.originalPath) !== -1)) {
                    Meta.set({
                        canonical: optimizeCanonical($location.absUrl())
                    });
                }

                User.getStatus(function (resp) {

                    // set dimension
                    if (!dimensionAlreadySet) {
                        JsAnalytics.setDimension({
                            UserStatus: (resp.logged) ? 'logged' : 'not logged',
                            AccessType: (resp.subscribed) ? 'premium' : 'free',
                            Country: Config.get('TLD'),
                            Environment: 'webapp'
                        });
                        dimensionAlreadySet = true;
                    }

                    // track page
                    if (currentRoute) {
                        if (Config.get('ENABLE_ANALYTICS_META_TITLE')) {
                            JsAnalytics.trackPage({
                                page: $location.path(),
                                title: Meta.get('title')
                            });
                        } else if (currentRoute.analyticsPageTitle) {
                            JsAnalytics.trackPage({
                                page: $location.path(),
                                title: currentRoute.analyticsPageTitle
                            });
                        } else if (typeof currentRoute.analyticsPageTitle === 'undefined') {
                            JsAnalytics.trackPage({
                                page: $location.path()
                            });
                        }
                    }
                });

                if (!!currentRoute && currentRoute.controller) {
                    // set page properties
                    var pageProperties = {
                        properties: {
                            url: $location.path(),
                            page_path: $location.absUrl(),
                            page_title: '',
                            http_referrer: document.referrer,
                            previous_page: prevPage
                        }
                    };


                    if (currentRoute.analyticsPageTitle) {
                        pageProperties.properties.page_title = currentRoute.analyticsPageTitle;

                        // track page
                        NewtonAdapter.trackPageview(pageProperties);
                        
                    }

                }
            });
        }
    ]);



// stampa la URL di embedded
angular.module('news').filter('embedUrl',
    ['BarneyConfig',
        function (Config) {

            return function (url, canPlay, videoId) {
                var protocol = location.protocol;
                if (!/^(f|ht)tps?:\/\//i.test(url)) {
                    // protocol= 'https:';// yt solo htts e daylimotion  VIMEO NO
                    url = protocol + url;
                }
                // if(canPlay && Config.get('PLAYER_AUTOPLAY')){
                //  url += '&autoplay=1';
                // }
                // url += '&origin='+ window.location.origin ;
                url += '&origin=' + window.location.origin + '&player_id=news_' + videoId;
                return url;
            };

        }
    ]
);


// prende il primo video dalla videaogallery e ne ritorna l'id
angular.module('news').filter('topVideo',
    ['BarneyConfig', function (Config) {

        return function (item) {
            if (item.video_gallery.length) {
                return item.video_gallery[0];
            }
            return false;
        };

    }]
);

//setta le dimensioni delle immagini dalle chiavi di conf USED_RATIO e IMG_SIZES (nato per WWE che vuuole 16:9 invece di 4:3)
angular.module('news').filter('imagesize',
    ['BarneyConfig', function (Config) {

        return function (url, imgtype, imgdim, aspect) {
            var imgSizeConf = Config.get('IMG_SIZES'),
                ratio = Config.get('USED_RATIO') ? Config.get('USED_RATIO').split(':') : [4, 3], // fallback, perchè sai mai.
                imgW = parseInt(imgSizeConf[imgtype][imgdim], 10),
                imgH = Math.round((imgW / parseInt(ratio[0], 10)) * parseInt(ratio[1], 10));
            
            if (url && imgtype) {
                if (aspect === 'vertical') {
                    url = url.replace('[WSIZE]', imgH);
                    url = url.replace('[HSIZE]', imgW);
                    url = url.replace('[METHOD]', 'cropin');
                } else {
                    url = url.replace('[WSIZE]', imgW);
                    url = url.replace('[HSIZE]', imgH);
                    url = url.replace('[METHOD]', 'crop');
                }
            }
            return url;
        };

    }]
);

angular.module('news').filter('timestampToDate',
    ['BarneyConfig',
        function (Config) {

            return function (timestamp, iso8601) {
                if (timestamp) {
                    var fullDate = new Date(timestamp * 1000);
                    var fullMonth = fullDate.getMonth() + 1;
                    var fullDay = fullDate.getDate();
                    fullMonth = (fullMonth < 10) ? '0' + fullMonth : fullMonth;
                    fullDay = (fullDay < 10) ? '0' + fullDay : fullDay;

                    if (iso8601) {
                        return fullDate.toISOString();
                    }

                    if (Config.get('DATE_FORMAT') === 'gg/mm/aaaa') {
                        // 25/12/1999
                        return fullDate.getDate() + '/' + fullMonth + '/' + fullDate.getFullYear();
                    } else {
                        // 12/25/1999
                        return fullMonth + '/' + fullDate.getDate() + '/' + fullDate.getFullYear();
                    }
                } else {
                    return null;
                }
            };

        }
    ]
);


angular.module('news').filter('setDateField',
    ['BarneyConfig', 'timestampToDateFilter',
        function (Config, timestampToDate) {

            return function (item, customField, iso8601) {

                var itemDate = item[customField] ? item[customField] : (item[Config.get('ITEM_FIELD_FOR_DATE')] || item.born_date);

                return timestampToDate(itemDate, iso8601);
            };
        }
    ]
);

angular.module('news').factory('MetaTitleManager',
    ['BarneyDict', 'BarneyConfig',
        function (Dict, Config) {

            var maskValue = '';
            var composedString = '';
            var titleMask = false;

            if (Config.get('ENABLE_META_TITLE_MASK') && Config.get('TITLE_MASK')) {
                titleMask = Config.get('TITLE_MASK');
            }

            var cosmicReplace = function (string) {
                var str = string ? string.replace(/%\w+%/g, function (all) {
                    while (all.indexOf('%') >= 0) {
                        all = all.replace('%', '');
                    }

                    var dictKey = all.replace('DICTKEY_', '');
                    return Dict.get(dictKey);
                }) : '';

                console.log('*** COSMIC REPLACE ***', str);

                return str;
            };

            /*
                - metaTitleObject.noMaksValue: // default value if metatitle mask is disabled;
                - metaTitleObject.maskType: // should be home, list, zoom. If no value, takes default.
                - metaTitleObject.content: // value of the page (category, content ...)
            */

            return {
                getMetaTitle: function (metaTitleObject) {
                    if (titleMask) {
                        switch (metaTitleObject.maskType) {
                        case 'home':
                            maskValue = titleMask[metaTitleObject.maskType];
                            maskValue = cosmicReplace(maskValue);

                            composedString = maskValue;
                            break;
                        case 'list':
                            maskValue = titleMask[metaTitleObject.maskType];
                            maskValue = cosmicReplace(maskValue);

                            composedString = maskValue.replace('<LIST_TITLE>', metaTitleObject.content);

                            break;
                        case 'zoom':
                            maskValue = titleMask[metaTitleObject.maskType];

                            maskValue = cosmicReplace(maskValue);
                            composedString = maskValue.replace('<CONTENT_TITLE>', metaTitleObject.content);

                            break;
                        default:
                            maskValue = titleMask.default;
                            maskValue = cosmicReplace(maskValue);

                            composedString = maskValue;

                            break;
                        }

                        return composedString;
                    } else {
                        return metaTitleObject.noMaskValue;
                    }
                }
            };
        }
    ]
);

angular.module('news').filter('generateWelcomeMailUrl',
    ['BarneyConfig',
        function (Config) {

            return function (url, key) {
                return url.replace(':' + key, objectToQueryString(Config.get(key)));
            };

            function objectToQueryString(object) {
                var str = [];
                for (var p in object) {
                    str.push(p + '=' + object[p]);
                }
                return str.join('&');
            }

        }
    ]
);

angular.module('news').filter('getByteSize',
    function () {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        var getByteSize = function (bytes) {


            if (!bytes.match(/^(\d+)(?:(\.|,)\d+)?$/)) {
                return bytes;
            }


            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);

            if (bytes === 0) {
                return 'n/a';
            }

            if (i === 0) {
                return bytes + ' ' + sizes[i];
            }

            return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i]; //eslint-disable-line
        };

        return function (bytes) {
            return getByteSize(bytes);
        };
    }
);

angular.module('news').factory('EventThrottler',
    ['$timeout',
        function ($timeout) {
            return function (callbackFunction, delay) {
                var scrollThrottleTimeout = false;
                var throttled = false;
                var throttlingTimeout = 250;

                if (typeof delay !== 'undefined') {
                    throttlingTimeout = delay;
                }

                var scrollHandler = function () {
                    if (!throttled) {
                        callbackFunction();
                        throttled = true;
                        scrollThrottleTimeout = $timeout(function () {
                            throttled = false;
                        }, throttlingTimeout);
                    }
                };

                return scrollHandler;
            };
        }
    ]
);

angular.module('news').filter('getFormattedKey',
    ['BarneyDict',
        function (Dict) {

            var getFormattedKey = function (key, format) {
                if (typeof format === 'string' && Dict.get(key + '_' + format.toUpperCase())) {
                    return key + '_' + format.toUpperCase();
                }

                return key;
            };

            return function (key, format) {
                return getFormattedKey(key, format);
            };
        }
    ]
);


angular.module('news').filter('optimizeCanonical',
    function() {
        return function(canonicalString){
            if(canonicalString && canonicalString.length > 0) {
                var returnedCanonical = canonicalString;
                var indexOfQuestion = returnedCanonical.indexOf('?');
                var indexOfHashbang = returnedCanonical.indexOf('#!');

                if(indexOfQuestion !== -1 && (indexOfQuestion < indexOfHashbang)){
                    returnedCanonical = returnedCanonical.substr(0, indexOfQuestion) + returnedCanonical.substr(indexOfHashbang);
                }

                if(returnedCanonical.indexOf('?') > 0) {
                    returnedCanonical = returnedCanonical.split('?')[0];
                }

                return returnedCanonical;
            } else {
                return '';
            }
        };
    }
);

angular.module('news').service('Utility',
    ['BarneyConfig',
        function (Config) {
            return {
                getTemplatePrefix: function(){
                    if(Config.get('IS_STAGING')){
                        if(Config.get('IS_JENKINS_DEPLOYED')){
                            return Config.get('JS_BUILD_URL') + 'app';
                        }
                    }
                    return Config.get('JS_TEMPLATE_PREFIX');
                },
                ie6toie11Detection: function(){
                    if((!(window.ActiveXObject) && 'ActiveXObject' in window)){
                        return true;
                    }else{
                        return false;
                    }

                },
                arraySearchIndex: function (arr, val) {

                    for (var i = 0; i < arr.length; i++) { if (arr[i] === val) { return i; } }
                    return false;
                }
            };
        }
    ]
);

angular.module('news').service('addQueryInPath',
    ['$location', '$route', '$rootScope',
        function ($location, $route, $rootScope) {
            return {

                init: function () {
                    var originalPath = $location.path;
                    $location.path = function (newpath, reload) {
                        if (reload === false) {
                            var lastRoute = $route.current;
                            var setPath = $rootScope.$on('$locationChangeSuccess', function () {
                                $route.current = lastRoute;
                                setPath();
                            });
                        }

                        return originalPath.apply($location, [newpath]);
                    };
                },

                addQuery: function(path, query, reload){
                    if(typeof $location.path === 'function'){
                        $location.path(path + query, reload);
                    }
                }


            };
        }
    ]
);

// angular.module('news').filter('timestampVersioning',
//    [function() {

//        return function(url, timestamp) {

//            var param = '?v=';
//            var urlVersioning = '';
//            if (url.match(/\?./)) {
//                param = '&v=';
//            }
//            urlVersioning = url + param + timestamp;

//            return urlVersioning;
//        };

//    }]
//);


// angular.module('news').directive('iframe', function(){
//     return {
//         restrict: 'E',
//         link: function(scope, element, attrs, ctrl, transclude) {
//             var wrapper = angular.element('<div class='container-video'></div>');

//             element.after(wrapper);
//             wrapper.prepend(element);

//             scope.$on('$destroy', function() {
//                 wrapper.after(element);
//                 wrapper.remove();
//             });
//         }
//     };
// });
angular.module('news').factory('Banner',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('MOA_API_SPOT_BANNER_LIST'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Banner', 'get', array);
                        return array;
                    }
                }

            });
        }
    ]
);

angular.module('news').factory('Cat',
    ['$http', '$location', 'BarneyConfig', 'BarneyBrowser',
        function($http, $location, Config, Browser){


            var getCookieParams = function(cookieName){

                var queryParams = {};
                var cookie = decodeURIComponent(cookieName);
                var pairs = cookie.split('&');

                JsLogger.log('Cat params', 'cookie ', cookie, 'Pairs ', pairs);

                for (var i = 0; i < pairs.length; i++) {
                    var pair = pairs[i].split('=');
                    queryParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
                }

                JsLogger.log('Cat query params: ', queryParams);

                return queryParams;
            };

            this.getCatParams = function(){
                var key = '';

                if(Config.get('CAT_TRACKING_ENABLED')){

                    var queryString = Browser.getQueryParams();

                    JsLogger.log('cat queryString params: ', queryString);

                    if(!queryString || !queryString.trackExecutionKey || !queryString.dest){
                        JsLogger.log('CAT', 'no valid cat params in query styring. I\'m looking into cookie...');

                        var cookieCat = JsStorage.get(Config.get('CAT_TRACK_COOKIE_NAME'));

                        if (!!cookieCat){
                            queryString = getCookieParams(cookieCat);

                            JsLogger.log('CAT found params cookie ' + cookieCat, queryString);
                        } else {
                            JsLogger.log('CAT', 'no valid cat params in cookie... I don\'t have any other places to look. :\'(');
                        }
                    }

                    if(!!queryString && !!queryString.trackExecutionKey && !!queryString.dest){
                        JsLogger.log('CAT ', 'checking params');

                        JsStorage.delete(Config.get('CAT_TRACK_COOKIE_NAME'));

                        var params = {
                            callback: 'JSON_CALLBACK'
                        };

                        var catParams = Config.get('CAT_PARAMS');

                        JsLogger.log('CAT PARAMS', catParams);

                        for (key in catParams.MANDATORY){
                            params[catParams.MANDATORY[key]] = queryString[key];
                        }

                        for (key in catParams.OPTIONAL){
                            if (typeof queryString[key] !== 'undefined'){
                                params[catParams.OPTIONAL[key]] = queryString[key];
                            }
                        }

                        var promise = $http({
                            method: 'JSONP',
                            url: Config.get('CAT_TRACKING_URL'),
                            params: params
                        });

                        promise.then(function(response){
                            JsLogger.log('CAT', queryString, params, response.data.data);
                        });

                        return {
                            referral_utm_source: queryString.utm_source ? queryString.utm_source : '',
                            referral_utm_medium: queryString.utm_medium ? queryString.utm_medium : '',
                            referral_utm_campaign: queryString.utm_campaign ? queryString.utm_campaign : '',
                            referral_utm_content: queryString.utm_content ? queryString.utm_content : '',
                            trackExecutionKey: queryString.trackExecutionKey ? queryString.trackExecutionKey : '',
                            dest: queryString.dest ? queryString.dest : ''
                        };

                    } else {

                        JsLogger.log('No query params, no CAT data to track!');
                    }
                }

                return {};
            };

            return this;
        }
    ]
);

angular.module('news').factory('Category',
    ['$resource', 'BarneyConfig', '$location',
        function ($resource, Config, $location) {

            /*
                Se vogliono il redirect a qualcos'altro, 
                fare una chiave di conf con dentro la url, 
                e una come ON/OFF della funzionalità 
                (questo codice è per TUTTI i news/kids eccetera, attenzione alle regression)
            */
            var urlFallback = Config.get('MISSING_CAT_URL_FALLBACK');// qui mettiamo la url di fallback
            var missingCatCheck = Config.get('MISSING_CAT_CHECK');// qui mettiamo true solo su mtopvideo
            var redirect = urlFallback || '/';

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_GET_BY_CATEGORY'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Category', 'get', array);
                        return array;
                    },
                    interceptor: {
                        responseError: function(data) {
                            JsLogger.log('CategoryError', data);
                            if (missingCatCheck){
                                $location.path(redirect);
                            }
                        },
                        response: function(data) {
                            JsLogger.info('API', 'Category', 'getInfo', data);
                            return data.data;
                        }
                    }
                },

                getList: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_CATEGORIES_LIST'),
                    params: {
                        FORMATS: function(){
                            if(Config.get('FORMATS_FILTER') && Config.get('FORMATS_FILTER') !== ''){
                                return Config.get('FORMATS_FILTER');
                            } else {
                                return '';
                            }
                        }
                    },
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Category', 'getList', array);
                        return array;
                    }
                },

                getInfo: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_CATEGORIES_LIST'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Category', 'getInfo', object);
                        return object;
                    },
                    interceptor: {
                        responseError: function(data) {
                            JsLogger.log('CategoryError', data);
                            if (missingCatCheck){
                                $location.path(redirect);
                            }
                        },
                        response: function(data) {
                            JsLogger.info('API', 'Category', 'getInfo', data);
                            return data.data;
                        }
                    }
                }

            });

        }
    ]
  );

angular.module('news').factory('FooterLinks',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return {
                getList: function(){
                    JsLogger.info('API', 'FooterLinks', 'getList', FOOTER_LINKS);
                    return FOOTER_LINKS;
                }
            };

        }
    ]
);

'use strict';

angular.module('news').factory('HeaderLinks',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return {
                getList: function(){
                    JsLogger.info('API', 'HeaderLinks', 'getList', HEADER_LINKS);
                    return HEADER_LINKS;
                }
            };

        }
    ]
);

angular.module('news').factory('Glossary',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('MOA_API_GLOSSARYITEM'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Glossary', 'get', array);
                        return array;
                    }
                },

                getList: {
                    method: 'GET',
                    url: Config.get('MOA_API_GLOSSARYLIST'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var response = angular.fromJson(data);
                        var parsedResponse = [];
                        if(!Array.isArray(response)){
                            for (var key in response) {
                                parsedResponse = parsedResponse.concat(response[key]);
                            }
                        }
                        JsLogger.info('API', 'Glossary', 'getList', response, parsedResponse);
                        return parsedResponse;
                    }
                }

            });

        }
    ]
  );

angular.module('news').factory('GoogleManager',
    ['$q', 'BarneyConfig', '$timeout', function($q, Config, $timeout) {

        return {
            defer: $q.defer(),

            init: function(initDL){
                console.log(['API', 'Header', '1', initDL]);
                if(Config.get('GOOGLE_TAG_ENABLE') && Config.get('GOOGLE_TAG_ID') && Config.get('ENABLE_DATA_LAYER_MANAGER')){
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(initDL);
                    console.log(['API', 'Header', '2', initDL]);

                    /*eslint-disable */
                   
                        (function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer',Config.get('GOOGLE_TAG_ID'));
                    
                    /*eslint-enable */
                }
                this.defer.resolve(initDL);
            },
            set: function(setDL){
                console.log(['API', 'Header', '3', setDL]);
                this.defer.promise.then(function(defaultDataLayer){
                    if(Config.get('GOOGLE_TAG_ENABLE') && Config.get('GOOGLE_TAG_ID') && Config.get('ENABLE_DATA_LAYER_MANAGER')){
                        var newDataLayer = {};
                        for(var ddlKey in defaultDataLayer){
                            newDataLayer[ddlKey] = defaultDataLayer[ddlKey];
                        }
                        for(var sdlKey in setDL){
                            newDataLayer[sdlKey] = setDL[sdlKey];
                        }
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(newDataLayer);
                        console.log(['API', 'Header', '4', newDataLayer]); 
                        
                    }
                });
            }
        };
    }]
);

angular.module('news').factory('Home',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            /*******************
            ***  REMOTE API  ***
            *******************/

            var remoteAPI = $resource('', {}, {

                getCategories: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_HOMEPAGE'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Home', 'getCategories (remote)', object);
                        return object;
                    }
                },

                getTag: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_HOMEPAGE_TAG'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Home', 'getTag (remote)', object);
                        return object;
                    }
                },

                getVideo: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_HOMEPAGE_CUSTOMVIDEO'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Home', 'getVideo (remote)', array);
                        return array;
                    }
                }

            });


            /*******************
            ***  LOCAL API   ***
            *******************/

            var localAPI = {

                getCategories: function(params, callback){
                    // get data
                    var data = {
                        category_items: HOME_CONTENT.category_items,
                        top_carousel: HOME_CONTENT.top_carousel
                    };

                    // return data
                    JsLogger.info('API', 'Home', 'getCategories (local)', data);
                    callback(data);
                },
                getTag: function(params, callback){
                    // get data
                    var data = HOME_CONTENT.tag;

                    // handle data
                    // if(params.size){
                    //  data.items = data.items.splice(0, params.size);
                    // }

                    // return data
                    JsLogger.info('API', 'Home', 'getTag (local)', data);
                    callback(data);
                },
                getVideo: function(params, callback){
                    // get data
                    var data = HOME_CONTENT.customvideo;

                    // handle data
                    // if(params.size){
                    //  data = data.splice(0, params.size);
                    // }

                    // return data
                    JsLogger.info('API', 'Home', 'getVideo (local)', data);
                    callback(data);
                }

            };


            /*******************
            ***  INTERFACE   ***
            *******************/

            return {
                getCategories: (Config.get('ENABLE_HOME_CONTENT') && !!HOME_CONTENT && !!HOME_CONTENT.category_items && !!HOME_CONTENT.top_carousel) ? localAPI.getCategories : remoteAPI.getCategories,
                getTag: (Config.get('ENABLE_HOME_CONTENT') && !!HOME_CONTENT && !!HOME_CONTENT.tag) ? localAPI.getTag : remoteAPI.getTag,
                getVideo: (Config.get('ENABLE_HOME_CONTENT') && !!HOME_CONTENT && !!HOME_CONTENT.customvideo) ? localAPI.getVideo : remoteAPI.getVideo
            };

        }
    ]
  );

angular.module('news').factory('Latest',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_GET_LATEST'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Latest', 'get', array);
                        return array;
                    }
                }

            });

        }
    ]
);

angular.module('news').factory('Mail',
    ['$resource', 'BarneyConfig', 'generateWelcomeMailUrlFilter',
        function ($resource, Config, generateWelcomeMailUrl) {

            return $resource('', {}, {

                sendAfterChangePassword: {
                    method: 'GET',
                    url: Config.get('MOA_API_MOA_MAILER_PASSWORDCHANGED'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Zoom', 'get', object);
                        return object;
                    }
                },

                sendAfterReset: {
                    method: 'GET',
                    url: Config.get('MOA_API_MOA_MAILER_RESETPASSWORD'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Zoom', 'getRelated', array);
                        return array;
                    }
                },

                sendWelcomeMail: {
                    method: 'GET',
                    url: generateWelcomeMailUrl(Config.get('MOA_API_MOA_MAILER_WELCOMEMAIL'), 'MAILPRODUCT_OTHERPARAMS'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Mail', 'sendWelcomeMail', array);
                        return array;
                    }
                }

            });
        }
    ]
  );

angular.module('news').factory('MFP',
    ['$resource', 'BarneyConfig', '$location',
        function ($resource, Config, $location) {


            var start = function (additionalParams, callback) {

                var isUserLogged = NewtonAdapter.isUserLogged();
                var environment = Config.get('DEVICE_OS') ? Config.get('DEVICE_OS') : 'webapp';
                if (environment !== 'webapp') {
                    var storeUrl = additionalParams.storeUrl;
                    if (storeUrl.indexOf('<page>') !== -1) {
                        storeUrl = storeUrl.replace('<page>', encodeURIComponent($location.url()));
                    }
                    if (Config.get('MFP_ENABLE') && ((isUserLogged && Config.get('MFP_AUTOLOGIN_ENABLE')) || Config.get('MFP_REDIRECTONLY_ENABLE'))) {

                        NewtonAdapter.getTransientToken(function (err, resp) {
                            var ponyParams = {
                                data: {
                                    return_url: $location.absUrl(),
                                    cookieData: {
                                        cookie: {},
                                        newton: {
                                            session_id: NewtonAdapter.getSessionId() ? (NewtonAdapter.getSessionId()) : '',
                                            user_id: resp.token ? resp.token : resp
                                        }
                                    }
                                }
                            };

                            var cookiesList = Config.get('MFP_COOKIE_LIST').split(',');

                            for (var i = 0; i < cookiesList.length; i++) {
                                if (JsStorage.get(cookiesList[i], { type: 'cookie' })) {
                                    ponyParams.data.cookieData.cookie[cookiesList[i]] = JsStorage.get(cookiesList[i], { type: 'cookie' });
                                }
                            }

                            var mfpParams = {
                                apikey: Config.get('MOTIME_API_KEY') ? Config.get('MOTIME_API_KEY') : Config.get('MOA_API_KEY'),
                                contents_inapp: {
                                    api_country: Config.get('MFP_CONTENT_INAPP_API_COUNTRY') ? Config.get('MFP_CONTENT_INAPP_API_COUNTRY') : Config.get('API_COUNTRY'),
                                    country: Config.get('MFP_CONTENT_INAPP_TLD') ? Config.get('MFP_CONTENT_INAPP_TLD') : Config.get('TLD'),
                                    fpnamespace: Config.get('MFP_NAMESPACE') ? Config.get('MFP_NAMESPACE') : Config.get('SITE_PROFILE'),
                                    extData: {}
                                },
                                country: Config.get('MFP_TLD') ? Config.get('MFP_TLD') : Config.get('TLD'),
                                expire: Config.get('MFP_EXPIRE') || 300

                            };

                            JsLogger.log('PONY', encodeURIComponent(JSON.stringify(ponyParams)), 'MFP', mfpParams);

                            if (Config.get('ENABLE_NEWTON_USER')) {
                                ponyParams.data = btoa(JSON.stringify(ponyParams.data));
                            }

                            actions.createPony(ponyParams).$promise
                                .then(function (data) {

                                    var ponyUrl = data.ponyUrl || '';
                                    var domainProtocol = window.location.protocol;
                                    mfpParams.contents_inapp.extData.ponyUrl = ponyUrl ? ponyUrl.replace('&', '') : '';
                                    mfpParams.contents_inapp.extData.return_url = $location.absUrl();
                                    mfpParams.contents_inapp.extData.domain = Config.get('DEST_DOMAIN').indexOf(domainProtocol) < 0 ? domainProtocol + Config.get('DEST_DOMAIN') : Config.get('DEST_DOMAIN');

                                    if (additionalParams.appId) {
                                        mfpParams.contents_inapp.extData.appid = additionalParams.appId;
                                    }

                                    mfpParams.contents_inapp = JSON.stringify(mfpParams.contents_inapp);

                                    actions.set(mfpParams).$promise.then(function () {

                                        //Appsflyer - imagazine
                                        if (Config.get('APPSFLYER_ENABLED') && Config.get('APPSFLYER_AUTOLOGIN')) {
                                            if (storeUrl.indexOf('<pony>') !== -1) {
                                                ponyUrl = ponyUrl.replace('&', '');
                                                storeUrl = storeUrl.replace('<pony>', encodeURIComponent(ponyUrl));
                                                storeUrl = storeUrl.replace('<redirectUrl>', encodeURIComponent($location.absUrl()));
                                                JsLogger.log('Appsflyer Store Url redirect to: ', storeUrl);
                                                window.location.href = storeUrl;
                                            }
                                        } else {  //MFP - pocoyohouse

                                            if (ponyUrl) {
                                                ponyUrl = ponyUrl.replace('&_PONY=', '');
                                                storeUrl = storeUrl.replace('<cmp>', ponyUrl);
                                            }
                                            var appId = '';

                                            if (additionalParams.appId) {
                                                appId = additionalParams.appId;
                                            }
                                            storeUrl = storeUrl.replace(/<appId>/gi, appId);
                                            storeUrl = storeUrl + '&domain=' + encodeURIComponent(Config.get('DEST_DOMAIN'));

                                        }

                                        JsLogger.log('PONY URL', ponyUrl, 'STORE URL', storeUrl);
                                        callback(storeUrl);

                                    });
                                });
                        });
                    } else {
                        window.location.href = storeUrl;
                    }
                }
            };

            var actions = $resource('', {}, {

                createPony: {
                    method: 'GET',
                    url: Config.get('MOA_API_CREATEPONY'),
                    cache: false,
                    isArray: false,
                    transformResponse: function(data){
                        var obj = angular.fromJson(data);
                        JsLogger.info('API', 'MFP', 'createPony', obj);
                        return obj;
                    }
                },

                set: {
                    method: 'JSONP',
                    url: Config.get('MFP_API_URL') + 'put',
                    params: {
                        callback: 'JSON_CALLBACK'
                    },
                    cache: false,
                    transformResponse: function(data){
                        var obj = angular.fromJson(data);
                        JsLogger.info('API', 'MFP', 'set', obj);
                        return obj;
                    }
                },

                setSession: {
                    method: 'GET',
                    url: Config.get('DEST_DOMAIN') + 'mfpset.php',
                    cache: false,
                    transformResponse: []
                }
            });

            return {
                start: start
            };
        }
    ]
);

angular.module('news').factory('Search',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_SEARCH'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Search', 'get', array);
                        return array;
                    }
                }
            });
        }
    ]
);

angular.module('news').factory('Settings',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('MOA_API_SMART_SECTION'),
                    isArray: false,
                    cache: false,
                    params: {
                        HYBRID: function(){
                            return 0;
                        },
                        access_token: function(){
                            return Config.get('ENABLE_NEWTON_USER') && NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Settings', 'get', object);
                        return object;
                    }
                },

                getList: {
                    method: 'GET',
                    url: Config.get('MOA_API_SMART_SECTION'),
                    isArray: false,
                    cache: false,
                    params: {
                        access_token: function(){
                            return Config.get('ENABLE_NEWTON_USER') && NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Settings', 'getList', object);
                        return object;
                    }
                },

                getAliasForMsisdn: {
                    method: 'GET',
                    url: Config.get('ALIAS_CHECK_URL'),
                    isArray: false,
                    cache: false,
                    withCredentials: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'User', 'getAliasForMsisdn', object);
                        return object;
                    }
                },

                getNetworkProperty: {
                    method: 'GET',
                    url: Config.get('DEST_DOMAIN') + Config.get('NETWORK_INFO_API_URL'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Settings', 'getNetworkProperty', object);
                        return object;
                    }
                }
            });
        }
    ]
  );

angular.module('news').factory('Shortener',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_URLSHORTENER'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Shortener', 'get', object);
                        return object;
                    }
                }
            });
        }
    ]
);

angular.module('news').factory('SocialSVC',
    ['$window', 'BarneyConfig', 'BarneyBrowser',
        function($window, Config, Browser){

            var sharingItem = {};

            var generateSocialUrl = function(social, shareUrl, logged, utmMedium, utmCampaign) {
                var queryParams = {};
                var loggedString = logged ? 'logged' : 'unlogged';
                queryParams.utm_source = social + '-' + loggedString;
                queryParams.utm_medium = utmMedium;
                queryParams.utm_campaign = utmCampaign;
                queryParams.v = Date.now();

                if(Config.get('FACEBOOK_SHARE_CR') || Config.get('TWITTER_SHARE_CR') || Config.get('WHATSAPP_SHARE_CR')){
                    switch(social){
                    case 'facebook':
                        if(Config.get('FACEBOOK_SHARE_CR')) {
                            console.log('facebook campaignRecognitionShare: ' + Config.get('FACEBOOK_SHARE_CR'));
                            queryParams.campaignRecognitionShare = Config.get('FACEBOOK_SHARE_CR');
                        }
                        break;

                    case 'twitter':
                        if(Config.get('TWITTER_SHARE_CR')) {
                            console.log('TWITTER campaignRecognitionShare: ' + Config.get('TWITTER_SHARE_CR'));
                            queryParams.campaignRecognitionShare = Config.get('TWITTER_SHARE_CR');
                        }
                        break;

                    case 'whatsapp':
                        if(Config.get('WHATSAPP_SHARE_CR')) {
                            console.log('whatsapp campaignRecognitionShare: ' + Config.get('WHATSAPP_SHARE_CR'));
                            queryParams.campaignRecognitionShare = Config.get('WHATSAPP_SHARE_CR');
                        }
                        break;

                    default:
                        console.warn('No campaignRecognitionShare setted for social!');
                    }
                }

                return Browser.addQueryParams(queryParams, shareUrl);
            };

            return {

                setUrl: function(obj){
                    sharingItem[obj.itemId] = {
                        shareUrl: obj.shareUrl,
                        facebook: generateSocialUrl('facebook', obj.shareUrl, obj.logged, obj.utmMedium, obj.utmCampaign),
                        twitter: generateSocialUrl('twitter', obj.shareUrl, obj.logged, obj.utmMedium, obj.utmCampaign),
                        whatsapp: generateSocialUrl('whatsapp', obj.shareUrl, obj.logged, obj.utmMedium, obj.utmCampaign)
                    };
                },

                getUrl: function(itemId, social){
                    if(sharingItem[itemId] && sharingItem[itemId][social]){
                        return sharingItem[itemId][social];
                    }
                    return false;
                },

                share: function(obj){
                    if(obj && obj.type && obj.shareUrl){
                        if(obj.type === 'facebook'){
                            window.open('https://www.facebook.com/sharer/sharer.php?u=' + obj.shareUrl);
                        } else if(obj.type === 'twitter'){
                            window.open('https://twitter.com/intent/tweet?url=' + obj.shareUrl);
                        } else if(obj.type === 'whatsapp'){
                            $window.location.href = 'whatsapp://send?text=' + obj.shareUrl;
                        }
                    } else {
                        console.warn('Social API', 'Type or share url not defined', obj);
                    }
                }
            };

        }
    ]
);

angular.module('news').factory('Tag',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_GET_BY_TAG'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Tag', 'get', array);
                        return array;
                    }
                },

                getList: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_TAGS_LIST'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Tag', 'getList', array);
                        return array;
                    }
                },

                getInfo: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_TAGS_LIST'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Tag', 'getInfo', object);
                        return object;
                    }
                },

                getSuggestedVideo: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_GET_RELATED_VIDEOS_BY_TAG'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Tag', 'getSuggestedVideo', array);
                        return array;
                    }
                }
            });

        }
    ]
  );

'use strict';

angular.module('news').factory('User', ['BarneyConfig', 'User20', 'User30',
    function (Config, User20, User30) {

        // if use User30
        if(Config.get('ENABLE_NEWTON_USER')){
            return User30;
        } else {
            return User20;
        }

    }]
);

angular.module('news').factory('User20',
    ['$resource', '$rootScope', '$q', 'BarneyConfig',
        function ($resource, $rootScope, $q, Config) {

            /**************************
            ***    PRIVATE SPACE    ***
            **************************/

            var userInitPromise = $q.defer();
            $rootScope.userReady = false;

            var apiCalls = $resource('', {}, {
                userCheck: {
                    method: 'GET',
                    url: Config.get('MOA_API_USER_CHECK'),
                    isArray: false,
                    cache: false,
                    params: {
                        CONTENT_ID: 0
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'User', 'userCheck (remote)', object);
                        return object;
                    }
                },
                userCanUse: {
                    method: 'GET',
                    url: Config.get('MOA_API_USER_CAN_USE'),
                    isArray: false,
                    cache: false,
                    params: {
                        hybrid: 0

                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'User', 'userCanUse', object);
                        return object;
                    }
                },
                userCanUseInfinite: {
                    method: 'GET',
                    url: Config.get('MOA_API_USER_CAN_USE_INFINITE_ZOOM_LIST'),
                    isArray: false,
                    cache: false,
                    params: {
                        hybrid: 0
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'User', 'userCanUseInfinite', object);
                        return object;
                    }
                },
                userUpdate: {
                    method: 'POST',
                    url: Config.get('MOA_API_USER_OPTIONSUPDATE'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'User', 'userUpdate', object);
                        return object;
                    }
                }
            });

            /**************************
            ***    PUBLIC SPACE     ***
            **************************/

            return {
                // init user: call user.check API and get status
                init: function(callback){
                    if(!!JsStorage.get('dadanetuser', { type: 'cookie' })){
                        userInitPromise.promise = apiCalls.userCheck().$promise;
                        userInitPromise.promise.then(function(resp){
                            $rootScope.userReady = true;
                            $rootScope.userLogged = resp.logged;
                            if(callback){ callback(resp); }
                        });
                    } else {
                        userInitPromise.promise.then(function(resp){
                            $rootScope.userReady = true;
                            $rootScope.userLogged = resp.logged;
                            if(callback){ callback(resp); }
                        });
                        var userCheckObject = {
                            logged: 0,
                            message: 'Not found',
                            status: '404',
                            subscribed: false
                        };
                        userInitPromise.resolve(userCheckObject);
                        JsLogger.info('API', 'User', 'userCheck (local)', userCheckObject);
                    }
                },

                // return user status
                getStatus: function(callback){
                    userInitPromise.promise.then(function(resp){
                        callback(resp);
                    });
                },

                // return user property
                getProperty: function(property, callback){
                    userInitPromise.promise.then(function(resp){
                        callback(resp[property]);
                    });
                },

                setProperties: function(properties){
                    userInitPromise.promise.then(function(){
                        apiCalls.userUpdate(properties);
                    });
                },
                canUse: function(contentid, infiniteCanUse, callback){
                    userInitPromise.promise.then(function(){
                        if (infiniteCanUse) {
                            apiCalls.userCanUseInfinite({
                                CONTENT_ID: contentid
                            }, function(resp){
                                callback(resp);
                            }, function(){
                                callback(false);
                                JsLogger.error('canUseInfinite API is wrong');
                            });
                        } else {
                            apiCalls.userCanUse({
                                CONTENT_ID: contentid
                            }, function(resp){
                                callback(resp);
                            }, function(){
                                callback(false);
                                JsLogger.error('canUse API is wrong');
                            });
                        }
                    });
                }
            };
        }
    ]
);

angular.module('news').factory('User30',
    ['$resource', '$rootScope', '$q', 'BarneyConfig', 'EventBus',
        function ($resource, $rootScope, $q, Config, Bus) {

            /**************************
            ***    PRIVATE SPACE    ***
            **************************/

            $rootScope.userReady = false;

            var apiCalls = $resource('', {}, {
                userCheck: {
                    method: 'GET',
                    url: Config.get('MOA_API_MIP_USER_PROFILE_GET'),
                    isArray: false,
                    cache: false,
                    params: {
                        ACCESS_TOKEN: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        return object;
                    }
                },
                userCanUse: {
                    method: 'GET',
                    url: Config.get('MOA_API_USER_CANUSE'),
                    isArray: false,
                    cache: false,
                    params: {
                        ACCESS_TOKEN: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        },
                        hybrid: 0,
                        ua: function(){
                            return Config.get('UA');
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        return object;
                    }
                },
                userCanUseInfinite: {
                    method: 'GET',
                    url: Config.get('MOA_API_USER_CANUSE_INFINITE_ZOOM_LIST'),
                    isArray: false,
                    cache: false,
                    params: {
                        ACCESS_TOKEN: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        },
                        hybrid: 0,
                        ua: function(){
                            return Config.get('UA');
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        return object;
                    }
                },
                userUpdate: {
                    method: 'POST',
                    url: Config.get('MOA_API_MIP_USER_PROFILE_UPDATE'),
                    isArray: false,
                    cache: false,
                    params: {
                        ACCESS_TOKEN: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        return object;
                    }
                },
                userUnsubscribe: {
                    method: 'GET',
                    url: Config.get('MOA_API_USER_UNSUBSCRIBE'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        return object;
                    }
                }
            });

            /**************************
            ***    PUBLIC SPACE     ***
            **************************/

            return {
                init: function(callback){
                    var _this = this;

                    if(NewtonAdapter.isUserLogged()){
                        apiCalls.userCheck().$promise.then(function(resp){
                            //TODO caso suspended
                            if (resp.suspended) {
                                //console.log('suspended - init', resp);

                            }
                            $rootScope.userReady = true;
                            $rootScope.userLogged = true;
                            if(callback){ callback(resp); }
                            JsLogger.info('API', 'User', 'init', 'logged', NewtonAdapter.getUserToken(), resp);
                            Bus.trigger('User-Init', resp);
                        });
                    } else {
                        var userCheckObject = {
                            logged: 0,
                            message: 'Not found',
                            status: '404',
                            subscribed: false
                        };
                        $rootScope.userReady = true;
                        $rootScope.userLogged = false;
                        if(callback){ callback(userCheckObject); }
                        JsLogger.info('API', 'User', 'init', 'unlogged', userCheckObject);
                        Bus.trigger('User-Init', userCheckObject);
                    }
                },

                getStatus: function(callback){
                    Bus.on('User-Init', function(resp){
                        callback(resp);
                    });
                },

                getProperty: function(property, callback){
                    Bus.on('User-Init', function(resp){
                        callback(resp[property]);
                    });
                },

                setProperties: function(properties, callback){
                    var newProperties = {
                        data_user: properties
                    };
                    Bus.on('User-Init', function(){
                        apiCalls.userUpdate(newProperties).$promise.then(function(userUpdateResp){
                            if(callback){ callback(userUpdateResp); }
                        });
                    });
                },

                canUse: function(contentid, infiniteCanUse, callback){
                    Bus.on('User-Init', function(){
                        if (infiniteCanUse) {
                            apiCalls.userCanUseInfinite({
                                CONTENT_ID: contentid
                            }, function(resp){
                                callback(resp);
                            }, function(){
                                callback(false);
                                JsLogger.error('canUseInfinite API is wrong');
                            });
                        } else {
                            apiCalls.userCanUse({
                                CONTENT_ID: contentid
                            }, function(resp){
                                callback(resp);
                            }, function(){
                                callback(false);
                                JsLogger.error('canUse API is wrong');
                            });
                        }

                    });
                },

                unsubscribe: function(params, callback){
                    var unsubscribeUser = function () {
                        apiCalls.userUnsubscribe(params, function(resp){
                            Bus.off('User-Init', unsubscribeUser);
                            callback(resp);
                        }, function(err){
                            callback(false);
                        });
                    };

                    Bus.on('User-Init', unsubscribeUser);
                }
            };
        }
    ]
);

angular.module('news').factory('Video',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_CUSTOM_VIDEO_ZOOM'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Video', 'get', array);
                        return array;
                    }
                },

                getRelated: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_CUSTOM_VIDEO_ZOOM'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Video', 'getRelated', array);
                        return array;
                    }
                },

                getList: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_CUSTOM_VIDEO_LIST'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Video', 'getList', array);
                        return array;
                    }
                }

            });

        }
    ]
  );

angular.module('news').factory('Zoom',
    ['$resource', 'BarneyConfig',
        function ($resource, Config) {

            return $resource('', {}, {

                get: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_ZOOM'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Zoom', 'get', object);
                        return object;
                    }
                },

                getRelated: {
                    method: 'GET',
                    url: Config.get('LAPIS_API_RELATED'),
                    isArray: true,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        JsLogger.info('API', 'Zoom', 'getRelated', array);
                        return array;
                    }
                },

                getInternalVideo: {
                    method: 'GET',
                    url: Config.get('URLMGR_VIDEO_STREAMING_INFO'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Video', 'getInternalVideo', object, data);
                        return object;
                    }
                }

            });

        }
    ]
  );

angular.module('news').factory('Myspace',
    ['$resource', 'BarneyConfig', 'Personalization',
        function ($resource, Config, Personalization) {
            
            var removeMyspaceItem = function(param, section){
                   
                if(section === 'favorites'){
                    return removeMyspaceItemType.removeFavorities({
                        id_item_collection: param
                    });
                } else if(section === 'watchlater') {
                    return removeMyspaceItemType.removeWatchlaters({
                        id_item_collection: param
                    });
                }
            
                   
                return removeMyspaceItemType;
            };

            var removeMyspaceItemType = $resource('', {}, {

                removeFavorities: {
                    method: 'GET',
                    url: Personalization.get('favoritesDeleteURL'),
                    params: {
                        access_token: function(){
                            return Config.get('ENABLE_NEWTON_USER') && NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){


                        return angular.fromJson(data);

                    }
                },
                removeWatchlaters: {
                    method: 'GET',
                    url: Personalization.get('watchlaterDeleteURL'),
                    params: {
                        access_token: function(){
                            return Config.get('ENABLE_NEWTON_USER') && NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        return angular.fromJson(data);

                    }
                }

                    
            });

            return {
                removeMyspaceItem: removeMyspaceItem
            };

        }
    ]
);

angular.module('news').factory('JwtInterceptor', ['BarneyConfig', '$injector', '$q', function(Config, $injector, $q) {
    var clientId = 'digiparenting'; // TODO
    var clientSecret = 'ce06ca1fd1c6fbb5e1b2df7dfeac0e4345017709b5c8fa010a80c85e9785207b'; // TODO
    var refreshUrl = Config.get('MOA_API_AUTHORIZE_TO_LAPIS');
    var currentCall = null;
    var lastResponse = null;

    function generate($http) {
        return $q(function(resolve) {
            var now = Date.now() / 1000;
            // check if the last retrieved token is still valid
            if (lastResponse && lastResponse.expire > now) {
                return resolve(lastResponse);
            }
            var body = 'k=' + clientId + '&s=' + clientSecret;
            // perform an http call to the jwt authorization endpoint
            $http.post(refreshUrl, body, {
                skipJwt: true, // this is needed otherwise this same call will trigger another intercept that will wait for this to complete but this will never complete!
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            })
            .then(function(res) {
                // locally save the response to reuse it in future calls
                lastResponse = res.data;
                resolve(lastResponse);
            });
        });
    }

    return {
        // Intercept ALL http requests
        request: function(httpConfig) {
            // Skip if JWT is not enabled or if we force the request to skip the jwt token
            if (!Config.get('JWT_ENABLED') || httpConfig.skipJwt) {
                return httpConfig;
            }
            // this is needed to avoid circular dependency
            var $http = $injector.get('$http');

            if (!currentCall) {
                // "cache" the current call to prevent multiple simultaneous auth requests
                currentCall = generate($http);
            }
            return currentCall.then(function(data) {
                // remove the call from the cache
                currentCall = null;
                if (data && data.token && data.token_type) {
                    // if there is a token response, add the Authorization header to the original outgoing request
                    httpConfig.headers.Authorization = data.token_type + ' ' + data.token;
                }
                // return the original request
                return httpConfig;
            });
        }
    };
}]);


function ValidationError(message) {
    this.name = 'ValidationError';
    this.message = message;
}
ValidationError.prototype = Error.prototype;

angular.module('news').factory('Contact',
    ['$resource', 'BarneyConfig', 'BarneyDict',
        function($resource, Config, Dict) {
            return $resource('', {}, {
                sendMail: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    url: Config.get('MOA_API_MOA_MAILER_CONTACTUS'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        JsLogger.info('API', 'Zoom', 'get', object);
                        return object;
                    },
                    transformRequest: function(data) {
                        if (Config.get('REGEXP_VALIDATE_EMAIL')
                            && !(new RegExp(Config.get('REGEXP_VALIDATE_EMAIL')).test(data.from))
                        ) {
                            throw new ValidationError(Dict.get('WEBAPP_EMAIL_VALIDATION_ERROR'));
                        }
                        return angular.toJson(data);
                    }
                }
            });
        }
    ]
);

angular.module('news').factory('SocialSVCPlatformAware',
    ['$window', 'BarneyConfig', 'BarneyBrowser', 'EventBus',
        function($window, Config, Browser, EventBus){
            var sharingItem = {};

            var android = navigator.userAgent.match(/Android/i);
            var ios = navigator.userAgent.match(/iPhone|iPad|iPod/i);
            var isDesktop = !(ios || android);

            var shareActions = {
                whatsapp: function(obj) {
                    return shareAction(
                        (isDesktop ? 'https://api.whatsapp.com/send?text=' : 'whatsapp://send?text=') + obj.shareUrl
                    );
                },
                telegram: function(obj) {
                    return shareAction(
                        (isDesktop ? 'https://telegram.me/share/msg?url=' + location.host + '&text=' : 'tg://msg?text=') + obj.shareUrl
                    );
                },
                twitter: function(obj) {
                    return shareAction(
                        (isDesktop ? 'https://twitter.com/intent/tweet?url=' : 'twitter://post?message=') + obj.shareUrl
                    );
                },
                facebook: function(obj) {
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + obj.shareUrl);
                },
                email: function(obj) {
                    window.location.href = 'mailto:?subject=' + obj.title + '&body=' + obj.shareUrl;
                },
                sms: function(obj) {
                    var url = '';
                    if (android) {
                        url = 'sms:?body=' + obj.shareUrl;
                    }
                    if (ios) {
                        url = 'sms:&body=' + obj.shareUrl;
                    }
                    window.location.href = url;
                },
                copy: function(obj) {
                    copyAction(obj.unsafeShareUrl);
                }
            };

            function generateSocialUrl(social, shareUrl, logged, utmMedium, utmCampaign) {
                var queryParams = {};
                var loggedString = logged ? 'logged' : 'unlogged';

                queryParams.utm_source = social + '-' + loggedString;
                queryParams.utm_medium = utmMedium;
                queryParams.utm_campaign = utmCampaign;
                queryParams.v = Date.now();

                if(Config.get('FACEBOOK_SHARE_CR') || Config.get('TWITTER_SHARE_CR') || Config.get('WHATSAPP_SHARE_CR')){
                    switch(social){
                    case 'facebook':
                        if(Config.get('FACEBOOK_SHARE_CR')) {
                            console.log('facebook campaignRecognitionShare: ' + Config.get('FACEBOOK_SHARE_CR'));
                            queryParams.campaignRecognitionShare = Config.get('FACEBOOK_SHARE_CR');
                        }
                        break;

                    case 'twitter':
                        if(Config.get('TWITTER_SHARE_CR')) {
                            console.log('TWITTER campaignRecognitionShare: ' + Config.get('TWITTER_SHARE_CR'));
                            queryParams.campaignRecognitionShare = Config.get('TWITTER_SHARE_CR');
                        }
                        break;

                    case 'whatsapp':
                        if(Config.get('WHATSAPP_SHARE_CR')) {
                            console.log('whatsapp campaignRecognitionShare: ' + Config.get('WHATSAPP_SHARE_CR'));
                            queryParams.campaignRecognitionShare = Config.get('WHATSAPP_SHARE_CR');
                        }
                        break;

                    default:
                        console.warn('No campaignRecognitionShare setted for social!');
                    }
                }
                return Browser.addQueryParams(queryParams, shareUrl);
            }

            function setUrl(obj) {
                sharingItem[obj.itemId] = {
                    shareUrl: obj.shareUrl,
                    facebook: generateSocialUrl('facebook', obj.shareUrl, obj.logged, obj.utmMedium, obj.utmCampaign),
                    twitter: generateSocialUrl('twitter', obj.shareUrl, obj.logged, obj.utmMedium, obj.utmCampaign),
                    whatsapp: generateSocialUrl('whatsapp', obj.shareUrl, obj.logged, obj.utmMedium, obj.utmCampaign),
                    copy: obj.shareUrl
                };
                return sharingItem[obj.itemId];
            }

            function shareAction(url) {
                if (isDesktop) {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }

            function copyAction(url) {
                var span = document.createElement('span');
                span.textContent = url;
                span.style.whiteSpace = 'pre'; // Preserve consecutive spaces and newlines
                // Paint the span outside the viewport
                span.style.position = 'absolute';
                span.style.left = '-9999px';
                span.style.top = '-9999px';
                var selection = window.getSelection();
                window.document.body.appendChild(span);
                var range = window.document.createRange();
                selection.removeAllRanges();
                range.selectNode(span);
                selection.addRange(range);
                try {
                    window.document.execCommand('copy');
                } catch (err) {
                    console.error(err);
                }
                selection.removeAllRanges();
                span.remove();
            }

            return {
                setUrl: setUrl,

                getUrl: function(itemId, social){
                    if(sharingItem[itemId] && sharingItem[itemId][social]){
                        return sharingItem[itemId][social];
                    }
                    return false;
                },

                openShare: function(obj) {
                    EventBus.trigger('openShare', {
                        urls: setUrl(obj),
                        title: obj.itemTitle,
                        trackingTitle: obj.itemTrackingTitle,
                        id: obj.itemId
                    });
                },

                share: function(obj){
                    if (obj && obj.shareUrl) {
                        var encodedObj = {
                            shareUrl: encodeURIComponent(obj.shareUrl),
                            title: obj.title ? encodeURIComponent(obj.title) : '',
                            unsafeShareUrl: obj.shareUrl
                        };

                        if (typeof shareActions[obj.type] === 'function') {
                            shareActions[obj.type](encodedObj);
                        } else {
                            console.warn('Social API', 'Invalid type', obj);
                        }
                    } else {
                        console.warn('Social API', 'Share url not defined', obj);
                    }
                }
            };

        }
    ]
);

'use strict';

angular.module('news').factory('Language', ['BarneyConfig',
    function (Config) {
        /* eslint-disable */
        var languageData = [
        {
          'English': 'Afar',
          'French': 'afar',
          'alpha2': 'aa',
          'alpha3': 'aar',
          'alpha3t': null
        },
        {
          'English': 'Abkhazian',
          'French': 'abkhaze',
          'alpha2': 'ab',
          'alpha3': 'abk',
          'alpha3t': null
        },
        {
          'English': 'Afrikaans',
          'French': 'afrikaans',
          'alpha2': 'af',
          'alpha3': 'afr',
          'alpha3t': null
        },
      
        {
          'English': 'Akan',
          'French': 'akan',
          'alpha2': 'ak',
          'alpha3': 'aka',
          'alpha3t': null
        },
      
        {
          'English': 'Albanian',
          'French': 'albanais',
          'alpha2': 'sq',
          'alpha3': 'alb',
          'alpha3t': 'sqi'
        },
        {
          'English': 'Amharic',
          'French': 'amharique',
          'alpha2': 'am',
          'alpha3': 'amh',
          'alpha3t': null
        },
        {
          'English': 'Arabic',
          'French': 'arabe',
          'alpha2': 'ar',
          'alpha3': 'ara',
          'alpha3t': null
        },
      
        {
          'English': 'Aragonese',
          'French': 'aragonais',
          'alpha2': 'an',
          'alpha3': 'arg',
          'alpha3t': null
        },
        {
          'English': 'Armenian',
          'French': 'arménien',
          'alpha2': 'hy',
          'alpha3': 'arm',
          'alpha3t': 'hye'
        },
        {
          'English': 'Assamese',
          'French': 'assamais',
          'alpha2': 'as',
          'alpha3': 'asm',
          'alpha3t': null
        },{
          'English': 'Avaric',
          'French': 'avar',
          'alpha2': 'av',
          'alpha3': 'ava',
          'alpha3t': null
        },
        {
          'English': 'Avestan',
          'French': 'avestique',
          'alpha2': 'ae',
          'alpha3': 'ave',
          'alpha3t': null
        },
      
        {
          'English': 'Aymara',
          'French': 'aymara',
          'alpha2': 'ay',
          'alpha3': 'aym',
          'alpha3t': null
        },
        {
          'English': 'Azerbaijani',
          'French': 'azéri',
          'alpha2': 'az',
          'alpha3': 'aze',
          'alpha3t': null
        },
      
      
        {
          'English': 'Bashkir',
          'French': 'bachkir',
          'alpha2': 'ba',
          'alpha3': 'bak',
          'alpha3t': null
        },
      
        {
          'English': 'Bambara',
          'French': 'bambara',
          'alpha2': 'bm',
          'alpha3': 'bam',
          'alpha3t': null
        },
      
        {
          'English': 'Basque',
          'French': 'basque',
          'alpha2': 'eu',
          'alpha3': 'baq',
          'alpha3t': 'eus'
        },{
          'English': 'Belarusian',
          'French': 'biélorusse',
          'alpha2': 'be',
          'alpha3': 'bel',
          'alpha3t': null
        },
      
        {
          'English': 'Bengali',
          'French': 'bengali',
          'alpha2': 'bn',
          'alpha3': 'ben',
          'alpha3t': null
        },
      
      
        {
          'English': 'Bihari languages',
          'French': 'langues biharis',
          'alpha2': 'bh',
          'alpha3': 'bih',
          'alpha3t': null
        },
      
      
        {
          'English': 'Bislama',
          'French': 'bichlamar',
          'alpha2': 'bi',
          'alpha3': 'bis',
          'alpha3t': null
        },
      
      
        {
          'English': 'Bosnian',
          'French': 'bosniaque',
          'alpha2': 'bs',
          'alpha3': 'bos',
          'alpha3t': null
        },
      
        {
          'English': 'Breton',
          'French': 'breton',
          'alpha2': 'br',
          'alpha3': 'bre',
          'alpha3t': null
        },{
          'English': 'Bulgarian',
          'French': 'bulgare',
          'alpha2': 'bg',
          'alpha3': 'bul',
          'alpha3t': null
        },
        {
          'English': 'Burmese',
          'French': 'birman',
          'alpha2': 'my',
          'alpha3': 'bur',
          'alpha3t': 'mya'
        },
        {
          'English': 'Catalan; Valencian',
          'French': 'catalan; valencien',
          'alpha2': 'ca',
          'alpha3': 'cat',
          'alpha3t': null
        },{
          'English': 'Chamorro',
          'French': 'chamorro',
          'alpha2': 'ch',
          'alpha3': 'cha',
          'alpha3t': null
        },
      
        {
          'English': 'Chechen',
          'French': 'tchétchène',
          'alpha2': 'ce',
          'alpha3': 'che',
          'alpha3t': null
        },
      
        {
          'English': 'Chinese',
          'French': 'chinois',
          'alpha2': 'zh',
          'alpha3': 'chi',
          'alpha3t': 'zho'
        },
        {
          'English': 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
          'French': 'slavon d\'église; vieux slave; slavon liturgique; vieux bulgare',
          'alpha2': 'cu',
          'alpha3': 'chu',
          'alpha3t': null
        },
        {
          'English': 'Chuvash',
          'French': 'tchouvache',
          'alpha2': 'cv',
          'alpha3': 'chv',
          'alpha3t': null
        },
      {
          'English': 'Cornish',
          'French': 'cornique',
          'alpha2': 'kw',
          'alpha3': 'cor',
          'alpha3t': null
        },
        {
          'English': 'Corsican',
          'French': 'corse',
          'alpha2': 'co',
          'alpha3': 'cos',
          'alpha3t': null
        },{
          'English': 'Cree',
          'French': 'cree',
          'alpha2': 'cr',
          'alpha3': 'cre',
          'alpha3t': null
        },
      {
          'English': 'Czech',
          'French': 'tchèque',
          'alpha2': 'cs',
          'alpha3': 'cze',
          'alpha3t': 'ces'
        },
      
        {
          'English': 'Danish',
          'French': 'danois',
          'alpha2': 'da',
          'alpha3': 'dan',
          'alpha3t': null
        },
        {
          'English': 'Divehi; Dhivehi; Maldivian',
          'French': 'maldivien',
          'alpha2': 'dv',
          'alpha3': 'div',
          'alpha3t': null
        },
      
      {
          'English': 'Dutch; Flemish',
          'French': 'néerlandais; flamand',
          'alpha2': 'nl',
          'alpha3': 'dut',
          'alpha3t': 'nld'
        },
      
        {
          'English': 'Dzongkha',
          'French': 'dzongkha',
          'alpha2': 'dz',
          'alpha3': 'dzo',
          'alpha3t': null
        },
      {
          'English': 'English',
          'French': 'anglais',
          'alpha2': 'en',
          'alpha3': 'eng',
          'alpha3t': null
        },
      
        {
          'English': 'Esperanto',
          'French': 'espéranto',
          'alpha2': 'eo',
          'alpha3': 'epo',
          'alpha3t': null
        },
        {
          'English': 'Estonian',
          'French': 'estonien',
          'alpha2': 'et',
          'alpha3': 'est',
          'alpha3t': null
        },
        {
          'English': 'Ewe',
          'French': 'éwé',
          'alpha2': 'ee',
          'alpha3': 'ewe',
          'alpha3t': null
        },
      
      
        {
          'English': 'Faroese',
          'French': 'féroïen',
          'alpha2': 'fo',
          'alpha3': 'fao',
          'alpha3t': null
        },
      
        {
          'English': 'Fijian',
          'French': 'fidjien',
          'alpha2': 'fj',
          'alpha3': 'fij',
          'alpha3t': null
        },
      
        {
          'English': 'Finnish',
          'French': 'finnois',
          'alpha2': 'fi',
          'alpha3': 'fin',
          'alpha3t': null
        },
      
      
        {
          'English': 'French',
          'French': 'français',
          'alpha2': 'fr',
          'alpha3': 'fre',
          'alpha3t': 'fra'
        },
      {
          'English': 'Western Frisian',
          'French': 'frison occidental',
          'alpha2': 'fy',
          'alpha3': 'fry',
          'alpha3t': null
        },
        {
          'English': 'Fulah',
          'French': 'peul',
          'alpha2': 'ff',
          'alpha3': 'ful',
          'alpha3t': null
        },
      
      {
          'English': 'Georgian',
          'French': 'géorgien',
          'alpha2': 'ka',
          'alpha3': 'geo',
          'alpha3t': 'kat'
        },
        {
          'English': 'German',
          'French': 'allemand',
          'alpha2': 'de',
          'alpha3': 'ger',
          'alpha3t': 'deu'
        },
      
      
        {
          'English': 'Gaelic; Scottish Gaelic',
          'French': 'gaélique; gaélique écossais',
          'alpha2': 'gd',
          'alpha3': 'gla',
          'alpha3t': null
        },
        {
          'English': 'Irish',
          'French': 'irlandais',
          'alpha2': 'ga',
          'alpha3': 'gle',
          'alpha3t': null
        },
        {
          'English': 'Galician',
          'French': 'galicien',
          'alpha2': 'gl',
          'alpha3': 'glg',
          'alpha3t': null
        },
        {
          'English': 'Manx',
          'French': 'manx; mannois',
          'alpha2': 'gv',
          'alpha3': 'glv',
          'alpha3t': null
        },
        {
          'English': 'Greek, Modern (1453-)',
          'French': 'grec moderne (après 1453)',
          'alpha2': 'el',
          'alpha3': 'gre',
          'alpha3t': 'ell'
        },
        {
          'English': 'Guarani',
          'French': 'guarani',
          'alpha2': 'gn',
          'alpha3': 'grn',
          'alpha3t': null
        },
      
        {
          'English': 'Gujarati',
          'French': 'goudjrati',
          'alpha2': 'gu',
          'alpha3': 'guj',
          'alpha3t': null
        },
      
      
        {
          'English': 'Haitian; Haitian Creole',
          'French': 'haïtien; créole haïtien',
          'alpha2': 'ht',
          'alpha3': 'hat',
          'alpha3t': null
        },
        {
          'English': 'Hausa',
          'French': 'haoussa',
          'alpha2': 'ha',
          'alpha3': 'hau',
          'alpha3t': null
        },
      
        {
          'English': 'Hebrew',
          'French': 'hébreu',
          'alpha2': 'he',
          'alpha3': 'heb',
          'alpha3t': null
        },
        {
          'English': 'Herero',
          'French': 'herero',
          'alpha2': 'hz',
          'alpha3': 'her',
          'alpha3t': null
        },
      
      
        {
          'English': 'Hindi',
          'French': 'hindi',
          'alpha2': 'hi',
          'alpha3': 'hin',
          'alpha3t': null
        },
      
      
        {
          'English': 'Hiri Motu',
          'French': 'hiri motu',
          'alpha2': 'ho',
          'alpha3': 'hmo',
          'alpha3t': null
        },
        {
          'English': 'Croatian',
          'French': 'croate',
          'alpha2': 'hr',
          'alpha3': 'hrv',
          'alpha3t': null
        },
      
        {
          'English': 'Hungarian',
          'French': 'hongrois',
          'alpha2': 'hu',
          'alpha3': 'hun',
          'alpha3t': null
        },
      
      
        {
          'English': 'Igbo',
          'French': 'igbo',
          'alpha2': 'ig',
          'alpha3': 'ibo',
          'alpha3t': null
        },
        {
          'English': 'Icelandic',
          'French': 'islandais',
          'alpha2': 'is',
          'alpha3': 'ice',
          'alpha3t': 'isl'
        },
        {
          'English': 'Ido',
          'French': 'ido',
          'alpha2': 'io',
          'alpha3': 'ido',
          'alpha3t': null
        },
        {
          'English': 'Sichuan Yi; Nuosu',
          'French': 'yi de Sichuan',
          'alpha2': 'ii',
          'alpha3': 'iii',
          'alpha3t': null
        },
      
        {
          'English': 'Inuktitut',
          'French': 'inuktitut',
          'alpha2': 'iu',
          'alpha3': 'iku',
          'alpha3t': null
        },
        {
          'English': 'Interlingue; Occidental',
          'French': 'interlingue',
          'alpha2': 'ie',
          'alpha3': 'ile',
          'alpha3t': null
        },
      
        {
          'English': 'Interlingua (International Auxiliary Language Association)',
          'French': 'interlingua (langue auxiliaire internationale)',
          'alpha2': 'ia',
          'alpha3': 'ina',
          'alpha3t': null
        },
      
        {
          'English': 'Indonesian',
          'French': 'indonésien',
          'alpha2': 'id',
          'alpha3': 'ind',
          'alpha3t': null
        },
      
      
        {
          'English': 'Inupiaq',
          'French': 'inupiaq',
          'alpha2': 'ik',
          'alpha3': 'ipk',
          'alpha3t': null
        },
      
      
        {
          'English': 'Italian',
          'French': 'italien',
          'alpha2': 'it',
          'alpha3': 'ita',
          'alpha3t': null
        },
        {
          'English': 'Javanese',
          'French': 'javanais',
          'alpha2': 'jv',
          'alpha3': 'jav',
          'alpha3t': null
        },
      
        {
          'English': 'Japanese',
          'French': 'japonais',
          'alpha2': 'ja',
          'alpha3': 'jpn',
          'alpha3t': null
        },
      
      {
          'English': 'Kalaallisut; Greenlandic',
          'French': 'groenlandais',
          'alpha2': 'kl',
          'alpha3': 'kal',
          'alpha3t': null
        },
      
        {
          'English': 'Kannada',
          'French': 'kannada',
          'alpha2': 'kn',
          'alpha3': 'kan',
          'alpha3t': null
        },
      
        {
          'English': 'Kashmiri',
          'French': 'kashmiri',
          'alpha2': 'ks',
          'alpha3': 'kas',
          'alpha3t': null
        },
        {
          'English': 'Kanuri',
          'French': 'kanouri',
          'alpha2': 'kr',
          'alpha3': 'kau',
          'alpha3t': null
        },
      
        {
          'English': 'Kazakh',
          'French': 'kazakh',
          'alpha2': 'kk',
          'alpha3': 'kaz',
          'alpha3t': null
        },{
          'English': 'Central Khmer',
          'French': 'khmer central',
          'alpha2': 'km',
          'alpha3': 'khm',
          'alpha3t': null
        },
      
        {
          'English': 'Kikuyu; Gikuyu',
          'French': 'kikuyu',
          'alpha2': 'ki',
          'alpha3': 'kik',
          'alpha3t': null
        },
        {
          'English': 'Kinyarwanda',
          'French': 'rwanda',
          'alpha2': 'rw',
          'alpha3': 'kin',
          'alpha3t': null
        },
        {
          'English': 'Kirghiz; Kyrgyz',
          'French': 'kirghiz',
          'alpha2': 'ky',
          'alpha3': 'kir',
          'alpha3t': null
        },
      
      
        {
          'English': 'Komi',
          'French': 'kom',
          'alpha2': 'kv',
          'alpha3': 'kom',
          'alpha3t': null
        },
        {
          'English': 'Kongo',
          'French': 'kongo',
          'alpha2': 'kg',
          'alpha3': 'kon',
          'alpha3t': null
        },
        {
          'English': 'Korean',
          'French': 'coréen',
          'alpha2': 'ko',
          'alpha3': 'kor',
          'alpha3t': null
        },
        {
          'English': 'Kuanyama; Kwanyama',
          'French': 'kuanyama; kwanyama',
          'alpha2': 'kj',
          'alpha3': 'kua',
          'alpha3t': null
        },
      
        {
          'English': 'Kurdish',
          'French': 'kurde',
          'alpha2': 'ku',
          'alpha3': 'kur',
          'alpha3t': null
        },
      {
          'English': 'Lao',
          'French': 'lao',
          'alpha2': 'lo',
          'alpha3': 'lao',
          'alpha3t': null
        },
        {
          'English': 'Latin',
          'French': 'latin',
          'alpha2': 'la',
          'alpha3': 'lat',
          'alpha3t': null
        },
        {
          'English': 'Latvian',
          'French': 'letton',
          'alpha2': 'lv',
          'alpha3': 'lav',
          'alpha3t': null
        },
      
        {
          'English': 'Limburgan; Limburger; Limburgish',
          'French': 'limbourgeois',
          'alpha2': 'li',
          'alpha3': 'lim',
          'alpha3t': null
        },
        {
          'English': 'Lingala',
          'French': 'lingala',
          'alpha2': 'ln',
          'alpha3': 'lin',
          'alpha3t': null
        },
        {
          'English': 'Lithuanian',
          'French': 'lituanien',
          'alpha2': 'lt',
          'alpha3': 'lit',
          'alpha3t': null
        },
      
      
        {
          'English': 'Luxembourgish; Letzeburgesch',
          'French': 'luxembourgeois',
          'alpha2': 'lb',
          'alpha3': 'ltz',
          'alpha3t': null
        },
      
        {
          'English': 'Luba-Katanga',
          'French': 'luba-katanga',
          'alpha2': 'lu',
          'alpha3': 'lub',
          'alpha3t': null
        },
        {
          'English': 'Ganda',
          'French': 'ganda',
          'alpha2': 'lg',
          'alpha3': 'lug',
          'alpha3t': null
        },
      {
          'English': 'Macedonian',
          'French': 'macédonien',
          'alpha2': 'mk',
          'alpha3': 'mac',
          'alpha3t': 'mkd'
        },
      
      
        {
          'English': 'Marshallese',
          'French': 'marshall',
          'alpha2': 'mh',
          'alpha3': 'mah',
          'alpha3t': null
        },
      
      
        {
          'English': 'Malayalam',
          'French': 'malayalam',
          'alpha2': 'ml',
          'alpha3': 'mal',
          'alpha3t': null
        },
      
        {
          'English': 'Maori',
          'French': 'maori',
          'alpha2': 'mi',
          'alpha3': 'mao',
          'alpha3t': 'mri'
        },
      
        {
          'English': 'Marathi',
          'French': 'marathe',
          'alpha2': 'mr',
          'alpha3': 'mar',
          'alpha3t': null
        },
      
        {
          'English': 'Malay',
          'French': 'malais',
          'alpha2': 'ms',
          'alpha3': 'may',
          'alpha3t': 'msa'
        },
        {
          'English': 'Malagasy',
          'French': 'malgache',
          'alpha2': 'mg',
          'alpha3': 'mlg',
          'alpha3t': null
        },
        {
          'English': 'Maltese',
          'French': 'maltais',
          'alpha2': 'mt',
          'alpha3': 'mlt',
          'alpha3t': null
        },
      {
          'English': 'Mongolian',
          'French': 'mongol',
          'alpha2': 'mn',
          'alpha3': 'mon',
          'alpha3t': null
        },
        {
          'English': 'Nauru',
          'French': 'nauruan',
          'alpha2': 'na',
          'alpha3': 'nau',
          'alpha3t': null
        },
        {
          'English': 'Navajo; Navaho',
          'French': 'navaho',
          'alpha2': 'nv',
          'alpha3': 'nav',
          'alpha3t': null
        },
        {
          'English': 'Ndebele, South; South Ndebele',
          'French': 'ndébélé du Sud',
          'alpha2': 'nr',
          'alpha3': 'nbl',
          'alpha3t': null
        },
        {
          'English': 'Ndebele, North; North Ndebele',
          'French': 'ndébélé du Nord',
          'alpha2': 'nd',
          'alpha3': 'nde',
          'alpha3t': null
        },
        {
          'English': 'Ndonga',
          'French': 'ndonga',
          'alpha2': 'ng',
          'alpha3': 'ndo',
          'alpha3t': null
        },
      
        {
          'English': 'Nepali',
          'French': 'népalais',
          'alpha2': 'ne',
          'alpha3': 'nep',
          'alpha3t': null
        },
        {
          'English': 'Norwegian Nynorsk; Nynorsk, Norwegian',
          'French': 'norvégien nynorsk; nynorsk, norvégien',
          'alpha2': 'nn',
          'alpha3': 'nno',
          'alpha3t': null
        },
        {
          'English': 'Bokmål, Norwegian; Norwegian Bokmål',
          'French': 'norvégien bokmål',
          'alpha2': 'nb',
          'alpha3': 'nob',
          'alpha3t': null
        },
      
      
        {
          'English': 'Norwegian',
          'French': 'norvégien',
          'alpha2': 'no',
          'alpha3': 'nor',
          'alpha3t': null
        },
        {
          'English': 'Chichewa; Chewa; Nyanja',
          'French': 'chichewa; chewa; nyanja',
          'alpha2': 'ny',
          'alpha3': 'nya',
          'alpha3t': null
        },
        {
          'English': 'Occitan (post 1500); Provençal',
          'French': 'occitan (après 1500); provençal',
          'alpha2': 'oc',
          'alpha3': 'oci',
          'alpha3t': null
        },
        {
          'English': 'Ojibwa',
          'French': 'ojibwa',
          'alpha2': 'oj',
          'alpha3': 'oji',
          'alpha3t': null
        },
        {
          'English': 'Oriya',
          'French': 'oriya',
          'alpha2': 'or',
          'alpha3': 'ori',
          'alpha3t': null
        },
        {
          'English': 'Oromo',
          'French': 'galla',
          'alpha2': 'om',
          'alpha3': 'orm',
          'alpha3t': null
        },
      
        {
          'English': 'Ossetian; Ossetic',
          'French': 'ossète',
          'alpha2': 'os',
          'alpha3': 'oss',
          'alpha3t': null
        },
        {
          'English': 'Panjabi; Punjabi',
          'French': 'pendjabi',
          'alpha2': 'pa',
          'alpha3': 'pan',
          'alpha3t': null
        },{
          'English': 'Persian',
          'French': 'persan',
          'alpha2': 'fa',
          'alpha3': 'per',
          'alpha3t': 'fas'
        },
      
      
        {
          'English': 'Pali',
          'French': 'pali',
          'alpha2': 'pi',
          'alpha3': 'pli',
          'alpha3t': null
        },
        {
          'English': 'Polish',
          'French': 'polonais',
          'alpha2': 'pl',
          'alpha3': 'pol',
          'alpha3t': null
        },
      
        {
          'English': 'Portuguese',
          'French': 'portugais',
          'alpha2': 'pt',
          'alpha3': 'por',
          'alpha3t': null
        },
      
      
        {
          'English': 'Pushto; Pashto',
          'French': 'pachto',
          'alpha2': 'ps',
          'alpha3': 'pus',
          'alpha3t': null
        },
      
        {
          'English': 'Quechua',
          'French': 'quechua',
          'alpha2': 'qu',
          'alpha3': 'que',
          'alpha3t': null
        },
      {
          'English': 'Romansh',
          'French': 'romanche',
          'alpha2': 'rm',
          'alpha3': 'roh',
          'alpha3t': null
        },
      
        {
          'English': 'Romanian; Moldavian; Moldovan',
          'French': 'roumain; moldave',
          'alpha2': 'ro',
          'alpha3': 'rum',
          'alpha3t': 'ron'
        },
        {
          'English': 'Rundi',
          'French': 'rundi',
          'alpha2': 'rn',
          'alpha3': 'run',
          'alpha3t': null
        },
      
        {
          'English': 'Russian',
          'French': 'russe',
          'alpha2': 'ru',
          'alpha3': 'rus',
          'alpha3t': null
        },
      
        {
          'English': 'Sango',
          'French': 'sango',
          'alpha2': 'sg',
          'alpha3': 'sag',
          'alpha3t': null
        },
      {
          'English': 'Sanskrit',
          'French': 'sanskrit',
          'alpha2': 'sa',
          'alpha3': 'san',
          'alpha3t': null
        },
        {
          'English': 'Sinhala; Sinhalese',
          'French': 'singhalais',
          'alpha2': 'si',
          'alpha3': 'sin',
          'alpha3t': null
        },
        {
          'English': 'Slovak',
          'French': 'slovaque',
          'alpha2': 'sk',
          'alpha3': 'slo',
          'alpha3t': 'slk'
        },
        {
          'English': 'Slovenian',
          'French': 'slovène',
          'alpha2': 'sl',
          'alpha3': 'slv',
          'alpha3t': null
        },
      
        {
          'English': 'Northern Sami',
          'French': 'sami du Nord',
          'alpha2': 'se',
          'alpha3': 'sme',
          'alpha3t': null
        },
        {
          'English': 'Samoan',
          'French': 'samoan',
          'alpha2': 'sm',
          'alpha3': 'smo',
          'alpha3t': null
        },
      
        {
          'English': 'Shona',
          'French': 'shona',
          'alpha2': 'sn',
          'alpha3': 'sna',
          'alpha3t': null
        },
        {
          'English': 'Sindhi',
          'French': 'sindhi',
          'alpha2': 'sd',
          'alpha3': 'snd',
          'alpha3t': null
        },
      
      
        {
          'English': 'Somali',
          'French': 'somali',
          'alpha2': 'so',
          'alpha3': 'som',
          'alpha3t': null
        },
      
        {
          'English': 'Sotho, Southern',
          'French': 'sotho du Sud',
          'alpha2': 'st',
          'alpha3': 'sot',
          'alpha3t': null
        },
        {
          'English': 'Spanish; Castilian',
          'French': 'espagnol; castillan',
          'alpha2': 'es',
          'alpha3': 'spa',
          'alpha3t': null
        },
        {
          'English': 'Sardinian',
          'French': 'sarde',
          'alpha2': 'sc',
          'alpha3': 'srd',
          'alpha3t': null
        },
      
        {
          'English': 'Serbian',
          'French': 'serbe',
          'alpha2': 'sr',
          'alpha3': 'srp',
          'alpha3t': null
        },
      
      
        {
          'English': 'Swati',
          'French': 'swati',
          'alpha2': 'ss',
          'alpha3': 'ssw',
          'alpha3t': null
        },
      
        {
          'English': 'Sundanese',
          'French': 'soundanais',
          'alpha2': 'su',
          'alpha3': 'sun',
          'alpha3t': null
        },
      
      
        {
          'English': 'Swahili',
          'French': 'swahili',
          'alpha2': 'sw',
          'alpha3': 'swa',
          'alpha3t': null
        },
        {
          'English': 'Swedish',
          'French': 'suédois',
          'alpha2': 'sv',
          'alpha3': 'swe',
          'alpha3t': null
        },
      
      
        {
          'English': 'Tahitian',
          'French': 'tahitien',
          'alpha2': 'ty',
          'alpha3': 'tah',
          'alpha3t': null
        },
      
        {
          'English': 'Tamil',
          'French': 'tamoul',
          'alpha2': 'ta',
          'alpha3': 'tam',
          'alpha3t': null
        },
        {
          'English': 'Tatar',
          'French': 'tatar',
          'alpha2': 'tt',
          'alpha3': 'tat',
          'alpha3t': null
        },
        {
          'English': 'Telugu',
          'French': 'télougou',
          'alpha2': 'te',
          'alpha3': 'tel',
          'alpha3t': null
        },
        {
          'English': 'Tajik',
          'French': 'tadjik',
          'alpha2': 'tg',
          'alpha3': 'tgk',
          'alpha3t': null
        },
        {
          'English': 'Tagalog',
          'French': 'tagalog',
          'alpha2': 'tl',
          'alpha3': 'tgl',
          'alpha3t': null
        },
        {
          'English': 'Thai',
          'French': 'thaï',
          'alpha2': 'th',
          'alpha3': 'tha',
          'alpha3t': null
        },
        {
          'English': 'Tibetan',
          'French': 'tibétain',
          'alpha2': 'bo',
          'alpha3': 'tib',
          'alpha3t': 'bod'
        },
      
        {
          'English': 'Tigrinya',
          'French': 'tigrigna',
          'alpha2': 'ti',
          'alpha3': 'tir',
          'alpha3t': null
        },
        {
          'English': 'Tonga (Tonga Islands)',
          'French': 'tongan (Îles Tonga)',
          'alpha2': 'to',
          'alpha3': 'ton',
          'alpha3t': null
        },
      
      
        {
          'English': 'Tswana',
          'French': 'tswana',
          'alpha2': 'tn',
          'alpha3': 'tsn',
          'alpha3t': null
        },
        {
          'English': 'Tsonga',
          'French': 'tsonga',
          'alpha2': 'ts',
          'alpha3': 'tso',
          'alpha3t': null
        },
        {
          'English': 'Turkmen',
          'French': 'turkmène',
          'alpha2': 'tk',
          'alpha3': 'tuk',
          'alpha3t': null
        },
      
      
        {
          'English': 'Turkish',
          'French': 'turc',
          'alpha2': 'tr',
          'alpha3': 'tur',
          'alpha3t': null
        },
      
      
        {
          'English': 'Twi',
          'French': 'twi',
          'alpha2': 'tw',
          'alpha3': 'twi',
          'alpha3t': null
        },{
          'English': 'Uighur; Uyghur',
          'French': 'ouïgour',
          'alpha2': 'ug',
          'alpha3': 'uig',
          'alpha3t': null
        },
        {
          'English': 'Ukrainian',
          'French': 'ukrainien',
          'alpha2': 'uk',
          'alpha3': 'ukr',
          'alpha3t': null
        },
      
      
        {
          'English': 'Urdu',
          'French': 'ourdou',
          'alpha2': 'ur',
          'alpha3': 'urd',
          'alpha3t': null
        },
        {
          'English': 'Uzbek',
          'French': 'ouszbek',
          'alpha2': 'uz',
          'alpha3': 'uzb',
          'alpha3t': null
        },
      
        {
          'English': 'Venda',
          'French': 'venda',
          'alpha2': 've',
          'alpha3': 'ven',
          'alpha3t': null
        },
        {
          'English': 'Vietnamese',
          'French': 'vietnamien',
          'alpha2': 'vi',
          'alpha3': 'vie',
          'alpha3t': null
        },
        {
          'English': 'Volapük',
          'French': 'volapük',
          'alpha2': 'vo',
          'alpha3': 'vol',
          'alpha3t': null
        },
        {
          'English': 'Welsh',
          'French': 'gallois',
          'alpha2': 'cy',
          'alpha3': 'wel',
          'alpha3t': 'cym'
        },
        {
          'English': 'Walloon',
          'French': 'wallon',
          'alpha2': 'wa',
          'alpha3': 'wln',
          'alpha3t': null
        },
        {
          'English': 'Wolof',
          'French': 'wolof',
          'alpha2': 'wo',
          'alpha3': 'wol',
          'alpha3t': null
        },
      
        {
          'English': 'Xhosa',
          'French': 'xhosa',
          'alpha2': 'xh',
          'alpha3': 'xho',
          'alpha3t': null
        },
        {
          'English': 'Yiddish',
          'French': 'yiddish',
          'alpha2': 'yi',
          'alpha3': 'yid',
          'alpha3t': null
        },
        {
          'English': 'Yoruba',
          'French': 'yoruba',
          'alpha2': 'yo',
          'alpha3': 'yor',
          'alpha3t': null
        },
        {
          'English': 'Zhuang; Chuang',
          'French': 'zhuang; chuang',
          'alpha2': 'za',
          'alpha3': 'zha',
          'alpha3t': null
        },
        {
          'English': 'Zulu',
          'French': 'zoulou',
          'alpha2': 'zu',
          'alpha3': 'zul',
          'alpha3t': null
        },
        ];
        /* eslint-enable */
        return languageData;

    }]
);

angular.module('news').service('MediaUtils',
    ['BarneyConfig', 'Language', 
        function (Config, Language) {
            var languageData = Language;

            return {
                getPosterSize: function () {
                    var mediaQueries = [
                        { q: '(max-width: 767px)', type: 'small' },
                        { q: '(min-width: 768px) and (max-width:991px)', type: 'medium' },
                        { q: '(min-width: 992px)', type: 'big' }
                    ];
                    var currentMQ = mediaQueries.find(function (mq) {
                        return window.matchMedia(mq.q).matches;
                    });
                    return currentMQ ? currentMQ.type : 'big';
                },
                getState: function (playerId) {
                    return jwplayer(playerId).getState();
                    /* buffering, idle, paused, playing */
                },
                langChange: function (langIndex, playerId) {
                    jwplayer(playerId).setCurrentAudioTrack(langIndex);
                },
                getLangs: function (playerId) {
                    return jwplayer(playerId).getAudioTracks();
                },
                getCurrentLang: function (playerId) {
                    return jwplayer(playerId).getCurrentAudioTrack();
                },
                getCorrectLanguage4Country: function (playerId, langs, langChange) {
                    if (!langs || langs.length <= 1) {
                        //console.info('## JW - Single language available', langs);
                        return;
                    }
                    //console.info('## JW - Languages available: ', langs.map(function (lang) { return lang.language; }));
                    var langFromConfig = Config.get('LANGUAGE');
                    var result = languageData.find(function (obj) { return obj.alpha2 === langFromConfig; });
                    for (var i = 0; i < langs.length; i++) {
                        if (langs[i].language === result.alpha3) {
                            langChange(i, playerId);
                            //console.info('## JW - Language autochanged to: ' + langs[i].language);
                            break;
                        }
                    }
                },
                exitFullscreen: function () {
                    try {
                        //http://stackoverflow.com/questions/21630588/can-you-have-a-youtube-video-exit-fullscreen-on-video-complete
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                        } else if (document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                        } else if (document.webkitCancelFullScreen) {
                            document.webkitCancelFullScreen();
                        }
                    } catch (e) {
                        JsLogger.log('Module', 'Clip', 'ERROR', e);
                    }
                },
                getVideoClip: function (video) {
                    var clip = {};
                    //console.log('## JW - getVideoClip param', video);
                    if (video && video.delivery_url){
                        Object.keys(video.delivery_url).forEach(function (key) {
                            if (key.indexOf('m3u8') > -1) {
                                JsLogger.log('getVideoClip', 'MultiLanguage', video.delivery_url[key]);
                                clip.m3u8 = video.delivery_url[key];
                            } else if (key.indexOf('mp4') > -1){
                                JsLogger.log('getVideoClip', 'Mp4', video.delivery_url[key]);
                                clip.mp4 = video.delivery_url[key];
                            } else {
                                JsLogger.log('getVideoClip', 'Any', video.delivery_url[key]);
                                clip.default = video.delivery_url[0];
                            }
                        });
                        //console.info('## JW - getVideoClip result', clip);
                        return clip;
                    } else {
                        return '';
                    }
                }
            };
        }
    ]
);
'use strict';

angular.module('news').controller('AccountCtrl', [
    '$scope', '$sce', '$location', 'orderByFilter', 'Settings', 'User', 'BarneyConfig', 'BarneyDict', '$window', 'BarneyBrowser', 'EventBus',
    function($scope, $sce, $location, orderByFilter, Settings, User, Config, Dict, $window, Browser, Bus){

        // init variables
        $scope.showFooter = false;
        $scope.active = -1;
        $scope.showRestore = false;
        $scope.showUO30LogoutButton = false;
        $scope.showUO20LogoutButton = false;
        var userType = 'not defined';

        var returnUrl = Browser.getQueryParams().return_url || '#!' + Config.get('ROUTER_HOME');

        $scope.isDadanetUser = false;
        $scope.hybridProductInfo = {};

        var settingsParams = {
            SUBSECTION: 'settings',
            CONTENT_ID: 0,
            HYBRID: 0,
            STORETYPE: 0
        };

        // Da sostituire nel codice
        var addSectionsToScope = function(content) {
            $scope.sections = orderByFilter(content, 'position');
            for(var k = 0; k < $scope.sections.length; k++){
                if($scope.sections[k].open_at_start){
                    $scope.open($scope.sections[k], k);
                    break;
                }
            }

            if(!Config.get('HIDE_LOGOUT_BUTTON') && NewtonAdapter.isUserLogged()) {
                if(Config.get('ENABLE_NEWTON_USER')) {
                    $scope.showUO30LogoutButton = true;
                } else {
                    $scope.showUO20LogoutButton = true;
                }

            }

            $scope.showFooter = true;
        };

        // Track Page view of snowplow
        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
            window.snowplow('trackPageView', {
                context: [{
                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                    data: {
                        kind_of_page: 'myaccount'
                    }
                }]
            });
        }

        // open method
        $scope.open = function(section, index){
            // active/deactive section
            if($scope.active !== index){
                $scope.active = index;
            } else {
                $scope.active = -1;
            }

            // fill text
            if(!$scope.sections[index].text){ //$scope.sections[index].page_type !== $scope.LOCAL_PAGE_TYPE &&
                settingsParams.SUBSECTION = section.subsection;
                settingsParams.CONTENT_ID = section.content_id;

                Settings.get(settingsParams).$promise.then(function(resp){
                    $scope.sections[index].text = $sce.trustAsHtml(resp.content);

                    if(section.page_type === 'login'){
                        if(Config.get('ENABLE_NEWTON_USER')){
                            useris.login({
                                element: false,
                                access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                                doNotLoad: true
                            }, {
                                onSuccess: function(userCredentials){

                                    if (userCredentials.type === 'msisdn' && Config.get('INTERNATIONAL_PREFIX')) {
                                        if (userCredentials.msisdn.indexOf(Config.get('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                            userCredentials.msisdn = Config.get('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                            console.log('MSISDN optimized with ' + Config.get('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                                        }
                                    }

                                    // call NewtonAdapter login
                                    NewtonAdapter.login(userCredentials).then(function(userisResp){
                                        console.log(userisResp);

                                        // when login is successful, redirect to returnUrl
                                        Bus.on('User-Login', function(){

                                            if (Config.get('UO30_FORCE_REFRESH_AFTER_LOGIN')) {

                                                JsStorage.set('user-login-show-feedback', 'true', { type: 'cookie', path: '/' });

                                                window.location.href = '/';

                                            } else {
                                                useris.PopupManager.showUserFeedback({
                                                    type: 'positive',
                                                    feedback: {
                                                        message: Dict.get('WEBAPP_UO30_FEEDBACK_LOGIN')
                                                    }
                                                });

                                                $window.location.href = returnUrl;
                                            }
                                        });
                                    }).catch(function(err){
                                        var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                            Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                                        if (dictKey) {
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: dictKey
                                                }
                                            });
                                        }
                                    });
                                },
                                onError: function(error){
                                    console.log(error);
                                },
                                onFacebookSuccess: function(userCredentials){
                                    console.log('To be implemented');
                                },
                                onFacebookError: function(err){
                                    console.log('To be implemented');
                                }
                            });
                        }
                    } else if(section.page_type === 'newtonsmartstatusprofile'){
                        useris.profile({
                            element: false,
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                            doNotLoad: true
                        }, {
                            onSaveNickname: function (obj) {
                                console.log('Username changed in: ' + obj.newNickname);

                                User.setProperties({
                                    name: obj.newNickname
                                }, function (changedNickname) {
                                    console.log(changedNickname);

                                    if (changedNickname) {
                                        obj.callbackSuccess(obj.newNickname);

                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dict.get('WEBAPP_UO30_FEEDBACK_NICKNAME_UPDATED')
                                            }
                                        });
                                    } else {
                                        useris.PopupManager.showUserFeedback({
                                            type: 'error',
                                            feedback: {
                                                message: Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC')
                                            }
                                        });
                                    }
                                });
                            },
                            onError: function (error) {
                                useris.triggerError('useris-username-error');
                            }
                        });
                    } else if (section.page_type === 'newtonsmartstatussocial') {
                        useris.social({
                            element: false,
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                            doNotLoad: true
                        }, {
                            onFacebookRegisterSuccess: function(){
                                console.log('Facebook login');
                            },
                            onFacebookDisconnect: function(){
                                console.log('Facebook disconnect');
                            }
                        });
                    } else if(section.page_type === 'smartstatus'){
                        if(Config.get('ENABLE_NEWTON_USER')){
                            useris.smartstatus({
                                element: false,
                                access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                                doNotLoad: true
                            }, {
                                onUnsubLoggedSuccess: function(params){
                                    unsubscriptionFlow(params);
                                },
                                onUnsubLoggedError: function(err){
                                    console.log(err);
                                },
                                onUnsubUnloggedSuccess: function(params){
                                    if (params.TYPE === 'msisdn' && Config.get('INTERNATIONAL_PREFIX')) {
                                        if (params.IDENTITY.indexOf(Config.get('INTERNATIONAL_PREFIX')) !== 0 && params.IDENTITY.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                            params.IDENTITY = Config.get('INTERNATIONAL_PREFIX') + params.IDENTITY.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                            console.log('MSISDN optimized with ' + Config.get('INTERNATIONAL_PREFIX') + ' ', params.IDENTITY);
                                        }
                                    }
                                    unsubscriptionFlow(params);
                                },
                                onUnsubUnloggedError: function(err){
                                    console.log(err);
                                }
                            });

                        } else {

                            var VALIDATION_PIN = new RegExp(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_PIN')),
                                VALIDATION_TEL = new RegExp(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'));

                            // TO BE FIND ANOTHER SOLUTION
                            console.log('User 2.0 status: action login required!');

                            var validationPinRegexp = new RegExp(VALIDATION_PIN),
                                validationMsisdnRegexp = new RegExp(VALIDATION_TEL);

                            $scope.userform = { username: '', password: '' };

                            $scope.errorUserReq = false;
                            $scope.errorUserPatt = false;
                            $scope.errorPassReq = false;
                            $scope.errorPassPatt = false;
                            $scope.errorCheckbox = false;
                            $scope.error401 = false;
                            $scope.error403 = false;

                            // on input change - validates the username type and changes passwd validation pattern accordingly
                            $scope.watchType = function(){
                                $scope.VALIDATION_USERNAME = (function() {
                                    if(validationMsisdnRegexp.test(document.querySelector('#username').value) === true){
                                        userType = 'msisdn';
                                        $scope.VALIDATION_PASSWORD = validationPinRegexp;
                                        return VALIDATION_TEL;
                                    }
                                })();
                            };

                            $scope.submitForm = function(form) {
                                $scope.errorUserReq = false;
                                $scope.errorUserPatt = false;
                                $scope.errorPassReq = false;
                                $scope.errorPassPatt = false;
                                $scope.errorCheckbox = false;
                                $scope.error401 = false;
                                $scope.error403 = false;

                                if (form.$valid) {
                                    Settings.get({
                                        SUBSECTION: 'smartlogin',
                                        CONTENT_ID: '',
                                        username: $scope.userform.username,
                                        password: $scope.userform.password,
                                        return_url: returnUrl
                                    }, function(e){
                                        switch(e.status){
                                        case '302':
                                            window.location.href = e.content;
                                            break;
                                        default:
                                            $scope.text = $sce.trustAsHtml(e.content);
                                            break;
                                        }
                                    });
                                } else {
                                    $scope.errorUserReq = (form.username.$error.required) ? true : false;
                                    $scope.errorUserPatt = (form.username.$error.pattern) ? true : false;
                                    if(!!form.password){
                                        $scope.errorPassReq = (form.password.$error.required) ? true : false;
                                        $scope.errorPassPatt = (form.password.$error.pattern) ? true : false;
                                    }
                                    if (form.terms && form.terms.$error){
                                        $scope.errorCheckbox = (form.terms.$error.required) ? true : false;
                                    }
                                }
                            };
                        }
                    }
                });
            }
        };

        var unsubscriptionFlow = function(params){
            var redirectUrl = false;
            if (Config.get('HIDE_UNSUB_BUTTON')) {
                var btnContainer = document.getElementById('box_buttons_status_confirm');
                if (btnContainer) {
                    var btns = btnContainer.children;
                    for (var i = 0; i < btns.length; i++) {
                        btns[i].disabled = true;
                        btns[i].style.display = 'none';
                    }
                    var loader = document.createElement('div');
                    loader.className = 'loader general-margin-b-60';
                    btnContainer.appendChild(loader);
                }
            }
            User.unsubscribe(params, function(unsubResp){
                if(unsubResp){
                    console.log('Unsubscription completed', unsubResp);

                    if(Config.get('DISABLE_USERFEEDBACK_POPUP') !== true){
                        useris.PopupManager.showUserFeedback({
                            type: 'positive',
                            feedback: {
                                message: Dict.get('WEBAPP_UO30_FEEDBACK_SUBS_DELETED')
                            }
                        });
                    }

                    if(unsubResp.config_key){
                        redirectUrl = Config.get(unsubResp.config_key);
                    } else if(unsubResp.url){
                        redirectUrl = unsubResp.url;
                    }

                    switch(unsubResp.status){

                    case 302:
                        if(unsubResp.unsubscribed){
                            NewtonAdapter.logout().then(function(logoutResp){
                                window.location.href = redirectUrl;
                            });
                        } else {
                            window.location.href = redirectUrl;
                        }

                        break;

                    case 200:
                        $scope.dictKey = Dict.get(unsubResp.dict_key);
                        break;

                    default:
                        $scope.dictKey = Dict.get(unsubResp.dict_key);
                    }
                } else {
                    $location.path(Config.get('ROUTER_ERROR'));
                }
            });
        };

        $scope.userLogout = function(){
            if (Config.get('ENABLE_NEWTON_USER')){
                NewtonAdapter.logout().then(function (resp) {
                    console.log('success', resp);

                    if (Config.get('UO30_FORCE_REFRESH_AFTER_LOGIN')) {

                        if (Config.get('ENABLE_NEWTON_USER')) {
                            JsStorage.set('user-logout-show-feedback', 'true', { type: 'cookie', path: '/' });
                        }

                        window.location.href = '/';

                    } else {
                        if (Config.get('ENABLE_NEWTON_USER')) {
                            useris.PopupManager.showUserFeedback({
                                type: 'positive',
                                feedback: {
                                    message: Dict.get('WEBAPP_UO30_FEEDBACK_LOGOUT')
                                }
                            });
                        }

                        window.location.href = '#!' + Config.get('ROUTER_HOME');
                    }


                }).catch(function (err) {
                    console.log('err', err);
                    window.location.href = '#!' + Config.get('ROUTER_ERROR');
                });
            }
        };

        Settings.getList(settingsParams).$promise.then(function(resp){
            addSectionsToScope(resp.content);
        });

    }
]);

'use strict';

angular.module('news').controller('ForgotCtrl', [
    '$scope', '$q', '$routeParams', '$sce', '$http', 'Settings', 'BarneyConfig', 'BarneyBrowser',
    function($scope, $q, $routeParams, $sce, $http, Settings, Config, Browser){

        var resetEmailPasswd = Config.get('DEST_DOMAIN') + Config.get('URLMGR_MIP-RESET-LINK');
        var VALIDATION_TEL = new RegExp(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN')),
            VALIDATION_EMAIL = new RegExp(Config.get('REGEXP_VALIDATE_EMAIL')),
            INVALID = new RegExp(/(?=a)b/),
            userType = 'not defined';

        var aliasDefer = $q.defer();

        $scope.showFooter = false;
        $scope.text = '';
        $scope.userform = {};

        if(!Config.get('ENABLE_ALIAS_CHECK')) {
            // get phone number from query string, if present
            var msisdnQS = Browser.getQueryParams().msisdn;
            if(typeof msisdnQS !== 'undefined' && msisdnQS !== 'true'){
                if(msisdnQS.indexOf(' ') === 0){
                    $scope.userform.username = msisdnQS.replace(' ', '+');
                    $scope.userform.phone_number = msisdnQS.replace(' ', '+');
                } else {
                    $scope.userform.username = msisdnQS;
                    $scope.userform.phone_number = msisdnQS;
                }
            }
        }

        /*******************
        ***   METHODS    ***
        *******************/

        //on input change - validates the username type and changes passwd validation pattern accordingly
        $scope.watchType = function(){
            $scope.VALIDATION_USERNAME = (function() {
                if(VALIDATION_EMAIL.test(document.querySelector('#username').value) === true) {
                    userType = 'email';
                    return VALIDATION_EMAIL;
                } else {
                    userType = 'msisdn';
                    return VALIDATION_TEL;
                }
            })();
        };

        $scope.submitForm = function(form) {
            if (form.$valid) {
                $scope.userform.phone_number = $scope.userform.username;
                if (userType === 'email') {
                    var mailData = 'email=' + $scope.userform.phone_number + '&action=reset';
                    $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    $http({
                        method: 'POST',
                        url: resetEmailPasswd,
                        data: mailData,
                        responseType: 'json'
                    }).then(function successCallback(response) {
                        location.href = '/mip/resetcheckemail';
                    }, function errorCallback(response) {
                        //$scope['error'+response.status] = true;
                        console.log('ko', response);
                    });
                } else {
                    if(Config.get('ENABLE_ALIAS_CHECK')){
                        var phoneNumber = '';
                        if($scope.userform.username.indexOf('+') >= 0) {
                            phoneNumber = $scope.userform.username.replace('+', '');
                        } else {
                            phoneNumber = $scope.userform.username;
                        }

                        Settings.getAliasForMsisdn({ MSISDN: phoneNumber }).$promise.then(function(resp) {
                            aliasDefer.resolve(resp.alias);
                        });
                    } else {
                        aliasDefer.resolve(false);
                    }

                    aliasDefer.promise.then(function(resp){
                        if(resp){
                            $scope.userform.phone_number = resp;
                        } else {
                            $scope.userform.phone_number = $scope.userform.username;
                        }

                        document.getElementById('phone_number').value = $scope.userform.phone_number;

                        if(JsStorage.isLocalStorageSupported()){
                            JsStorage.set('userform.username', $scope.userform.phone_number, { type: 'localstorage' });
                        }
                        document.getElementById('frmlogin').setAttribute('action', Config.get('URLMGR_LOSTPASSWORD_URL'));
                        document.getElementById('frmlogin').submit();
                    });
                }
            }
        };

        Settings.get({
            SUBSECTION: 'smartforgot',
            CONTENT_ID: ''
        }, function(resp){
            $scope.text = $sce.trustAsHtml(resp.content);
            $scope.showFooter = true;
        });

    }
]);

'use strict';

angular.module('news').controller('LoginCtrl', [
    '$q', '$scope', '$routeParams', '$sce', '$resource', '$http', 'BarneyConfig', 'BarneyBrowser', 'Settings',
    function($q, $scope, $routeParams, $sce, $resource, $http, Config, Browser, Settings){

        var returnUrl = Browser.getQueryParams().return_url || '/';

        var VALIDATION_PIN = new RegExp(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_PIN')),
            VALIDATION_TEL = new RegExp(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN')),
            VALIDATION_EMAIL = new RegExp(Config.get('REGEXP_VALIDATE_EMAIL')),
            VALIDATION_PASSWD = new RegExp(Config.get('REGEXP_VALIDATE_PASSWD')),
            userType = 'not defined';

        var loginWithEmail = Config.get('MOA_API_MIP_USER_MIPLOGIN');
        var aliasDefer = $q.defer();

        $scope.showFooter = false;
        $scope.text = '';

        // initialize userform object
        $scope.userform = { username: '', password: '' };

        if(!Config.get('ENABLE_ALIAS_CHECK')) {
            // get phone number from localStorage, if present
            if(JsStorage.isLocalStorageSupported()){
                $scope.userform.username = JsStorage.get('userform.username', { type: 'localstorage' }) || '';
            } else {
                $scope.userform.username = '';
            }

            // get phone number from query string, if present
            var msisdnQS = Browser.getQueryParams().msisdn;
            if(typeof msisdnQS !== 'undefined' && msisdnQS !== 'true'){
                if(msisdnQS.indexOf(' ') === 0){
                    $scope.userform.username = msisdnQS.replace(' ', '+');
                } else {
                    $scope.userform.username = msisdnQS;
                }
            }
        }

        $scope.errorUserReq = false;
        $scope.errorUserPatt = false;
        $scope.errorPassReq = false;
        $scope.errorPassPatt = false;
        $scope.errorCheckbox = false;
        $scope.error401 = false;
        $scope.error403 = false;


        $scope.submitForm = function(form) {
            $scope.errorUserReq = false;
            $scope.errorUserPatt = false;
            $scope.errorPassReq = false;
            $scope.errorPassPatt = false;
            $scope.errorCheckbox = false;
            $scope.error401 = false;
            $scope.error403 = false;

            if (form.$valid) {
                if (userType !== 'email') {
                    if(Config.get('ENABLE_ALIAS_CHECK')) {
                        var phoneNumber = '';
                        if($scope.userform.username.indexOf('+') >= 0) {
                            phoneNumber = $scope.userform.username.replace('+', '');
                        } else {
                            phoneNumber = $scope.userform.username;
                        }

                        Settings.getAliasForMsisdn({ MSISDN: phoneNumber }).$promise.then(function(resp) {
                            aliasDefer.resolve(resp.alias);
                        });
                    } else {
                        aliasDefer.resolve(false);
                    }

                    aliasDefer.promise.then(function(aliasResp){
                        Settings.get({
                            SUBSECTION: 'smartlogin',
                            CONTENT_ID: '',
                            username: aliasResp ? aliasResp : $scope.userform.username,
                            password: $scope.userform.password,
                            return_url: returnUrl
                        }, function(e){
                            switch(e.status){
                            case '302':
                                window.location.href = e.content;
                                break;
                            default:
                                $scope.text = $sce.trustAsHtml(e.content);
                                break;
                            }
                        });
                    });
                } else {
                    var mailData = 'email=' + $scope.userform.username + '&password=' + $scope.userform.password + '&action=login';
                    $http({
                        method: 'POST',
                        url: loginWithEmail,
                        data: mailData,
                        responseType: 'json',
                        params: { return_url: returnUrl },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(function successCallback(response) {
                        window.location.href = response.data.redirect_url;
                    }, function errorCallback(response) {
                        $scope['error' + response.status] = true;
                    });
                }
            } else {
                $scope.errorUserReq = (form.username.$error.required) ? true : false;
                $scope.errorUserPatt = (form.username.$error.pattern) ? true : false;
                if(!!form.password){
                    $scope.errorPassReq = (form.password.$error.required) ? true : false;
                    $scope.errorPassPatt = (form.password.$error.pattern) ? true : false;
                }
                if (form.terms && form.terms.$error){
                    $scope.errorCheckbox = (form.terms.$error.required) ? true : false;
                }
            }
        };

        // on input change - validates the username type and changes passwd validation pattern accordingly
        $scope.watchType = function(){
            $scope.VALIDATION_USERNAME = (function() {
                if(VALIDATION_EMAIL.test(document.querySelector('#username').value) === true){
                    userType = 'email';
                    $scope.VALIDATION_PASSWORD = VALIDATION_PASSWD;
                    return VALIDATION_EMAIL;
                } else {
                    userType = 'msisdn';
                    $scope.VALIDATION_PASSWORD = VALIDATION_PIN;
                    return VALIDATION_TEL;
                }
            })();
        };

        Settings.get({
            SUBSECTION: 'smartlogin',
            CONTENT_ID: ''
        }, function(resp){
            $scope.text = $sce.trustAsHtml(resp.content);
            $scope.showFooter = true;
        });


    }
]);

'use strict';

angular.module('news').controller('CanceledCtrl', [
    '$scope', '$routeParams', '$sce', 'Settings', 'BarneyConfig',
    function($scope, $routeParams, $sce, Settings, Config){
        $scope.showFooter = true;
        $scope.telcoRequest = Config.get('HIDE_BUTTON_BACKHOME');
    }
]);
// FROM form_validation.tmpl - /dadanet2/webstore2/dati/tmpl/apps/inc/form_validation.tmpl

var pinPattern = CONFIG.COUNTRY_REGEXP_VALIDATE_PIN ? CONFIG.COUNTRY_REGEXP_VALIDATE_PIN : null;
var msisdnPattern = CONFIG.COUNTRY_REGEXP_VALIDATE_MSISDN ? CONFIG.COUNTRY_REGEXP_VALIDATE_MSISDN : null;
var msisdnerrormsg = DICTIONARY.WEBAPP_LOGIN_INVALID_NUMBER;
var pinerrormsg = DICTIONARY.WEBAPP_WRONG_PIN_FORMAT;
var checkPinBlank = CONFIG.CHECK_PIN_BLANK ? CONFIG.CHECK_PIN_BLANK : null;
var enableValidate = CONFIG.FIELD_VALIDATION ? true : false;
var validateRegexp = CONFIG.FIELD_VALIDATION_JS_REGEXP ? CONFIG.FIELD_VALIDATION_JS_REGEXP : null;

var googleChecked = function(){
    var termsObj = document.getElementById('terms');

    if (typeof termsObj !== 'undefined' && termsObj){
        if(termsObj.checked){
            document.getElementById('empty_terms').style.display = 'none';
        } else {
            document.getElementById('empty_terms').style.display = 'block';
            return false;
        }
    }
};

if(CONFIG.SHOW_GOOGLE_CHECKBOX){
    googleChecked();
}


// FROM validate_key.js - /dadanet2/wl2/webstore_apps/js/webstore_apps/validate_key.js

function validate(evt) {
    if(!enableValidate) {
        return;
    }
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = validateRegexp;
    if(regex === null) {
        regex = /[\d\x08]/; // eslint-disable-line
    }
    if(!regex.test(key)) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) {
            theEvent.preventDefault();
        }
    }
}

'use strict';

angular.module('news').controller('Login30Ctrl', [
    '$scope', '$routeParams', '$window', 'BarneyConfig', 'BarneyDict', 'BarneyBrowser', 'EventBus', '$document', 
    function($scope, $routeParams, $window, Config, Dict, Browser, Bus, $document){

        $scope.showLoggedKey = false;

        var returnUrl = Browser.getQueryParams().return_url || '#!' + Config.get('ROUTER_HOME');

        $scope.logout = function(){
            NewtonAdapter.logout().then(function(resp){
                console.log('Logged Out!');
                $scope.showLoggedKey = false;
                $window.location.href = '#!' + Config.get('ROUTER_HOME');
            });
        };


        if(NewtonAdapter.isUserLogged()){
            //$scope.showLoggedKey = true;
            angular.element($document).ready(function() {
                $window.location.href = '#!' + Config.get('ROUTER_HOME');
            });
        } else {
            // Track Page view of snowplow
            if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                window.snowplow('trackPageView', {
                    context: [{
                        schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                        data: {
                            kind_of_page: 'login'
                        }
                    }]
                });
            }
            useris.login({
                element: document.getElementById('blackboard'),
                access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : ''
            }, {
                onSuccess: function(userCredentials){

                    if (userCredentials.type === 'msisdn' && Config.get('INTERNATIONAL_PREFIX')) {
                        if (userCredentials.msisdn.indexOf(Config.get('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                            userCredentials.msisdn = Config.get('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                            console.log('MSISDN optimized with ' + Config.get('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                        }
                    }

                    // call NewtonAdapter login
                    NewtonAdapter.login(userCredentials).then(function(resp){
                        // console.log(resp);

                        // when login is successful, redirect to returnUrl
                        Bus.on('User-Login', function(){

                            if (Config.get('UO30_FORCE_REFRESH_AFTER_LOGIN')) {

                                JsStorage.set('user-login-show-feedback', 'true', { type: 'cookie', path: '/' });

                                window.location.href = '/';

                            } else {
                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dict.get('WEBAPP_UO30_FEEDBACK_LOGIN')
                                    }
                                });

                                $window.location.href = returnUrl;
                            }
                        });
                    }).catch(function(err){
                        var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                            Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                        if(dictKey){
                            useris.PopupManager.showUserFeedback({
                                type: 'error',
                                feedback: {
                                    message: dictKey
                                }
                            });
                        }
                    });
                },
                onError: function(error){
                    // console.log(error);
                },
                onFacebookSuccess: function(){
                    console.log('To be implemented');
                },
                onFacebookError: function(){
                    console.log('To be implemented');
                }
            });
        }
    }
]);

'use strict';

angular.module('news').controller('LoginOtp30Ctrl', ['$scope', '$routeParams', '$window', 'BarneyConfig', 'BarneyDict', 'BarneyBrowser', 'EventBus', '$document', 
    function($scope, $routeParams, $window, Config, Dict, Browser, Bus, $document){

        $scope.stepPhoneActive = true;
        $scope.stepOTPActive = false;

        $scope.subscribeUrl = Config.get('URLMGR_SUBSCRIBE-URL');

        var returnUrl = Browser.getQueryParams().return_url || '#!' + Config.get('ROUTER_HOME') + '?otp=1';

        $scope.otpModel = {
            msisdn: '',
            passw_: []
        };

        var OTPLength = 6;
        $scope.OTParray = Array.from(Array(OTPLength + 1).keys()).slice(1);

        if(NewtonAdapter.isUserLogged()){
            angular.element($document).ready(function() {
                $window.location.href = '#!' + Config.get('ROUTER_HOME');
            });
            return;
        }

        $scope.changeUI = function() {
            if ($scope.stepPhoneActive === true){
                $scope.stepPhoneActive = false;
                $scope.stepOTPActive = true;
            }
        };

        var manageErr = function(err) {
            var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                    Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

            if(dictKey){
                useris.PopupManager.showUserFeedback({
                    type: 'error',
                    feedback: {
                        message: dictKey
                    }
                });
            }
        };

                //sposta il focus sul prossimo campo dell'otp
        var getCaretPosition = function(el) {
        // Internet Explorer Caret Position
            if (document.selection && document.selection.createRange) {
                var range = document.selection.createRange();
                var bookmark = range.getBookmark();
                return bookmark.charCodeAt(2) - 2;
            }
        // Firefox Caret Position
            return el.setSelectionRange && el.selectionStart;
        };

        var countrySmsMsg = Dict.get('PASSWORD_RECOVERY_SMS') ? Dict.get('PASSWORD_RECOVERY_SMS') : '';
        var fakeSmsMgs = 'Your PIN is: ';
        var countryRegex = new RegExp(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'));
        var fakeRegex = new RegExp(/^(\+00)/i);

        var getRightRegex = function() {
            var field = document.querySelector('#phone_number');
            return {
                regex: field.value.match(fakeRegex) ? fakeRegex : countryRegex, 
                msg: field.value.match(fakeRegex) ? fakeSmsMgs : countrySmsMsg
            };
        };

        $scope.goBack = function(){
            $scope.stepPhoneActive = true;
            $scope.stepOTPActive = false;
        };


        angular.element(document).ready(function () {
            var frmforgot = document.querySelector('#frmforgot') || null;
            var phoneNum = frmforgot.querySelector('#phone_number') || null;
            var phoneNumHidden = frmforgot.querySelector('#username') || null;
            var password = frmforgot.querySelector('#passw') || null;
            var otpNums = document.querySelectorAll('.login-input-otp') || null;

            $scope.setPhoneField = function(e) {
                if (phoneNum.value) { //la validazione la fa useris
                    phoneNumHidden.value = phoneNum.value;
                }
            };

            $scope.doForgot = function() {
                var forgotData = { msisdn: phoneNumHidden.value, smsTemplate: getRightRegex().msg };
                var validateRegex = getRightRegex().regex;
                //console.log('forgot', forgotData, validateRegex);
                if (!phoneNum.value.match(validateRegex)) {
                    useris.PopupManager.showUserFeedback({
                        type: 'error',
                        feedback: {
                            message: Dict.get('WEBAPP_UO30_ERROR_WRONG_USERDATA')
                        }
                    });
                } else {
                    $scope.changeUI();
                    NewtonAdapter.recoverPassword(forgotData).then(function(resp){
                        //console.log('recoverpasswd', resp);
                    }).catch(function(error){
                        //console.log('forgotData forgot error', forgotData);
                    });

                    useris.PopupManager.showUserFeedback({
                        type: 'generic',
                        feedback: {
                            message: Dict.get('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKSMS'),
                            icon: 'icon-sms'
                        }
                    });  
                }
            };

            $scope.resendPIN = function() {
                $scope.doForgot();
                angular.forEach(otpNums, function(otpin){
                    otpin.value = '';
                    $scope.otpModel.passw_ = [];
                });
            };

            if (otpNums) {
                angular.forEach(otpNums, function(otpin){
                    var tabindex = parseInt(otpin.tabIndex, 10);
                    var maxlength = parseInt(otpin.maxLength, 10);

                    otpin.addEventListener('keydown', function(e) {
                        var val = otpin.value,
                            cp, 
                            code = e.which || e.keyCode;

                        if (val.length === maxlength && [8, 37, 38, 39, 40, 46].indexOf(code) === -1) {

                            var next = document.querySelectorAll('#passw_' + (tabindex + 1));
                            /* eslint-disable no-unused-expressions */
                            next.length && next[0].focus();
                            return;
                        }

                        cp = getCaretPosition(this);
                        if ((cp === 0 && code === 46) || (cp === 1 && code === 8)) {
                            var prev = document.querySelectorAll('#passw_' + (tabindex - 1));
                            e.preventDefault();
                            otpin.value = val.substring(1);
                            /* eslint-disable no-unused-expressions */
                            prev.length && prev[0].focus();
                            return;
                        }
                    });
                    otpin.addEventListener('input', function (e) {
                        if (otpin.value) {
                            //password.value = $scope.otpModel.passw_.join('');
                            password.value = ('' + otpNums[0].value + otpNums[1].value + otpNums[2].value + otpNums[3].value + otpNums[4].value + otpNums[5].value);
                        }
                    });
                });
            }

            $scope.doLogin = function(e) {
                var userCredentials = { type: 'msisdn', logged: true, msisdn: phoneNumHidden.value, pin: password.value };
                var validateRegex = getRightRegex().regex;
                //console.log('login data', userCredentials, validateRegex);
                if (!phoneNum.value.match(validateRegex)) {
                    useris.PopupManager.showUserFeedback({
                        type: 'error',
                        feedback: {
                            message: Dict.get('WEBAPP_UO30_ERROR_MSISDN_INVALID')
                        }
                    });
                } else {
                    //console.log('userCredentials login', userCredentials);
                    if (!JsStorage.get('fakeOTPLogin') && userCredentials.msisdn && Config.get('INTERNATIONAL_PREFIX')) {
                        if (userCredentials.msisdn.indexOf(Config.get('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                            userCredentials.msisdn = Config.get('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                            //console.log('MSISDN optimized with ' + Config.get('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                        }
                    }

                    // call NewtonAdapter login
                    NewtonAdapter.login(userCredentials).then(function(resp){
                        //console.log('login resp', resp);

                        // when login is successful, redirect to returnUrl
                        Bus.on('User-Login', function(){

                            if (Config.get('UO30_FORCE_REFRESH_AFTER_LOGIN')) {

                                //JsStorage.set('user-login-show-feedback', 'true', { type: 'cookie', path: '/' });
                                window.location.href = '/?otp=1';

                            } else {
    /*                             useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dict.get('WEBAPP_UO30_FEEDBACK_LOGIN')
                                    }
                                });*/
                                $window.location.href = '/?otp=1';//returnUrl;
                            }
                        });
                    }).catch(function(err){
                        manageErr(err);
                    });
                }
            };

        });

    }
]);

'use strict';

angular.module('news').controller('Forgot30Ctrl', [
    '$scope', '$routeParams', 'BarneyConfig', 'BarneyDict',
    function($scope, $routeParams, Config, Dict){

        $scope.showForgotKey = false;

        useris.forgot({
            element: document.getElementById('blackboard'),
            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
            smsTemplate: Dict.get('PASSWORD_RECOVERY_SMS') ? Dict.get('PASSWORD_RECOVERY_SMS') : ''
        }, {
            onSuccess: function(userCredentials){

                if (userCredentials.msisdn && Config.get('INTERNATIONAL_PREFIX')) {
                    if (userCredentials.msisdn.indexOf(Config.get('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                        userCredentials.msisdn = Config.get('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                        console.log('MSISDN optimized with ' + Config.get('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                    }
                }

                NewtonAdapter.recoverPassword(userCredentials).then(function(resp){
                    console.log(resp);
                    if(userCredentials.msisdn){

                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dict.get('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKSMS'),
                                icon: 'icon-sms'
                            }
                        });

                        window.location.href = '#!' + Config.get('ROUTER_LOGIN') + '?sentpin=1&msisdn=' + encodeURIComponent(userCredentials.msisdn);
                    } else if(userCredentials.email) {

                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dict.get('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKMAIL'),
                                icon: 'icon-email'
                            }
                        });

                        window.location.href = '#!' + Config.get('ROUTER_HOME');

                        $scope.$apply();
                    }
                }).catch(function(error){
                    if(userCredentials.msisdn){
                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dict.get('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKSMS'),
                                icon: 'icon-sms'
                            }
                        });

                        window.location.href = '#!' + Config.get('ROUTER_LOGIN') + '?sentpin=1&msisdn=' + encodeURIComponent(userCredentials.msisdn);
                    } else if(userCredentials.email) {

                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dict.get('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKMAIL'),
                                icon: 'icon-email'
                            }
                        });

                        window.location.href = '#!' + Config.get('ROUTER_HOME');
                    }
                });
            },
            onError: function(error){
                console.log(error);
                window.location.reload();
            }
        });
    }
]);

'use strict';

angular.module('news').controller('AccountCreationCtrl', [
    '$scope', '$routeParams', '$location', '$q', 'BarneyConfig', 'BarneyBrowser', 'BarneyDict', 'Mail', 'User',
    function($scope, $routeParams, $location, $q, Config, Browser, Dict, Mail, User){

        var returnUrl = Browser.getQueryParams().return_url || '#!' + Config.get('ROUTER_HOME');
        var sendSMSonLoad = !!Config.get('FR_FLOW_SEND_SMS_ONPAGELOAD');
        var skip = (Browser.getQueryParams().skip && !sendSMSonLoad) ? Browser.getQueryParams().skip : 0;

        var identityPromises = [];

        var oldMailIdentityPromise = NewtonAdapter.getIdentity('email');
        var genericIdentityPromise = NewtonAdapter.getIdentity('generic');

        var removeIdentities = function(){
            $q.all(identityPromises).then(function(identities){
                identities.forEach(function(identity) {
                    if(identity){
                        identity.delete(function(err){
                            if(err){
                                console.log('Error ', err, 'Removing: ', identity);
                            } else {
                                console.log(identity, 'Removed Successfully');
                            }
                        });
                    }
                }, this);
            });
        };

        $scope.showFooter = Config.get('REMOVE_FOOTER_LINK_ON_ACCOUNT_CREATION') && Browser.getQueryParams().skip ? false : true;

        identityPromises.push(oldMailIdentityPromise);
        identityPromises.push(genericIdentityPromise);

        genericIdentityPromise.then(function(generic){
            console.log('Generic Identity: ', generic);
        });

        oldMailIdentityPromise.then(function(email){
            console.log('Email Identity: ', email);
        });

        User.getStatus(function(userStatus){
            if(userStatus.logged){
                var configParams = Config.get('MAILPRODUCT_OTHERPARAMS');
                var userParams = {};

                useris.userRegistration({
                    element: document.getElementById('blackboard'),
                    access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                    smsTemplate: Dict.get('MIPCONNECT_WELCOME_SKIP_SMS_TEXT') || Dict.get('MIPCONNECT_WELCOME_REGISTER_SMS_TEXT'),
                    skipRegister: skip
                }, {
                    onSuccess: function(userCredentials){

                        for(var key in configParams){
                            if(configParams[key].indexOf(':') >= 0){
                                var value = configParams[key].replace(':', '');

                                if(value === 'USERNAME' || value === 'EMAIL'){
                                    userParams[key] = userCredentials.email;
                                } else {
                                    User.getProperty(value.toLowerCase(), function(resp){ // eslint-disable-line
                                        if(resp){
                                            userParams[key] = resp;
                                        }
                                    });
                                }
                            } else {
                                userParams[key] = configParams[key];
                            }
                        }

                        userCredentials.params = userParams;

                        console.log('User Params to add Identity: ', userCredentials);

                        NewtonAdapter.addIdentity(userCredentials).then(function(resp){
                            console.log(resp);

                            if(userCredentials.skipped){
                                console.log('Identity generic added!', resp);

                                useris.PopupManager.showUserFeedback({
                                    type: 'generic',
                                    feedback: {
                                        message: Dict.get('WEBAPP_UO30_SUGGESTION_ACCOUNTCREATION_CHECKSMS'),
                                        icon: 'icon-sms'
                                    }
                                });

                                window.location.href = '#!/' + Config.get('ROUTER_HOME');
                            } else {
                                if(!Config.get('MIPCONNECT_SIGNUP_TRIANGULATION')){
                                    removeIdentities();
                                }

                                if(!Config.get('MIPCONNECT_SIGNUP_TRIANGULATION') && !Config.get('SEND_MAIL_AFTER_ADDIDENTITY_EMAIL')){
                                    Mail.sendWelcomeMail({
                                        EMAIL: userCredentials.email,
                                        USERNAME: userCredentials.email
                                    }).$promise.then(function(mailResp){

                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dict.get('WEBAPP_UO30_FEEDBACK_EMAILADDED')
                                            }
                                        });

                                        console.log(mailResp);
                                    });
                                } else {
                                    useris.PopupManager.showUserFeedback({
                                        type: 'generic',
                                        feedback: {
                                            message: Dict.get('WEBAPP_UO30_SUGGESTION_EMAILADDED_CHECKMAIL'),
                                            icon: 'icon-email'
                                        }
                                    });
                                }

                                window.location.href = '#!/' + Config.get('ROUTER_HOME');
                            }
                        }).catch(function(err){
                            var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                            if (dictKey) {
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: dictKey
                                    }
                                });
                            }
                        });
                    },
                    onCancel: function(){
                        window.location.href = '#!' + Config.get('ROUTER_ACCOUNT');
                    },
                    onError: function(error){
                        console.log(error);
                        window.location.reload();
                    },
                    onTemplateLoaded: function(options){
                        var skippedGenericCredentials = { skipped: 1, type: 'generic', smsTemplate: Dict.get('MIPCONNECT_WELCOME_SKIP_SMS_TEXT') || Dict.get('MIPCONNECT_WELCOME_REGISTER_SMS_TEXT') };
                        if (sendSMSonLoad){
                            NewtonAdapter.addIdentity(skippedGenericCredentials).then(function(resp){
                                console.log('Identity generic added! Now sendind SMS.', resp);
                            }).catch(function(err){
                                var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                    Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                                if (dictKey) {
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: dictKey
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                $location.path(Config.get('ROUTER_HOME'));
            }
        });
    }
]);

'use strict';

angular.module('news').controller('ChangePasswordCtrl', [
    '$scope', '$q', '$routeParams', '$location', 'BarneyConfig', 'BarneyDict', 'User', 'Mail',
    function($scope, $q, $routeParams, $location, Config, Dict, User, Mail){

        $scope.email = false;

        User.getStatus(function(userStatus){
            if(userStatus.logged){
                NewtonAdapter.getIdentity('email').then(function(identity){
                    if(identity){
                        $scope.email = identity.getIdentifier();

                        useris.changePassword({
                            element: document.getElementById('blackboard'),
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : ''
                        }, {
                            onSuccess: function(userCredentials){
                                identity.updateSecret(userCredentials.oldPassword, userCredentials.newPassword, function(err){
                                    if(!err){
                                        if(Config.get('SEND_EMAIL_AFTER_CHANGEPSW')){
                                            Mail.sendAfterChangePassword({
                                                USERNAME: identity.getIdentifier(),
                                                EMAIL: identity.getIdentifier()
                                            }).$promise.then(function(resp){
                                                console.log('Mail sent');
                                            });
                                        }

                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dict.get('WEBAPP_UO30_FEEDBACK_PSWCHANGED')
                                            }
                                        });

                                        window.location.href = '#!' + Config.get('ROUTER_ACCOUNT');
                                    } else {
                                        var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                            Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                                        if (dictKey) {
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: dictKey
                                                }
                                            });
                                        }
                                    }
                                });
                            },
                            onCancel: function () {
                                window.history.back();
                            },
                            onError: function(error){
                                console.log(error);
                                window.location.reload();
                            }
                        });
                    } else {
                        window.location.href = '#!/' + Config.get('ROUTER_ERROR');
                    }
                }).catch(function(err){
                    var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                        Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                    if (dictKey) {
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: dictKey
                            }
                        });
                    }
                });
            } else {
                $location.path(Config.get('ROUTER_HOME'));
            }
        });
    }
]);

'use strict';

angular.module('news').controller('ResetPasswordCtrl', [
    '$scope', '$routeParams', 'BarneyConfig', 'BarneyDict', 'Mail',
    function($scope, $routeParams, Config, Dict, Mail){

        if(NewtonAdapter.isUserLogged()){

            useris.PopupManager.showUserFeedback({
                type: 'error',
                feedback: {
                    message: Dict.get('WEBAPP_ERROR_NEWTON_GENERIC_ERROR')
                }
            });

            window.location.href = '#!' + Config.get('ROUTER_HOME');
        } else {
            useris.resetPassword({
                element: document.getElementById('blackboard'),
                token: $routeParams.token,
                email: $routeParams.email,
                access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : ''
            }, {
                onSuccess: function (userCredentials) {
                    console.log(userCredentials);
                    NewtonAdapter.resetPassword(userCredentials).then(function (resp) {
                        if (Config.get('SEND_EMAIL_AFTER_RESET')) {
                            Mail.sendAfterReset({
                                USERNAME: $routeParams.email,
                                EMAIL: $routeParams.email
                            }).$promise.then(function (mailResp) {

                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dict.get('WEBAPP_UO30_FEEDBACK_PSWRESET')
                                    }
                                });

                                window.location.href = '#!' + Config.get('ROUTER_LOGIN');
                            });
                        } else {

                            useris.PopupManager.showUserFeedback({
                                type: 'positive',
                                feedback: {
                                    message: Dict.get('WEBAPP_UO30_FEEDBACK_PSWRESET')
                                }
                            });

                            window.location.href = '#!' + Config.get('ROUTER_LOGIN');
                        }
                    }).catch(function (err) {
                        var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                            Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                        if (dictKey) {
                            useris.PopupManager.showUserFeedback({
                                type: 'error',
                                feedback: {
                                    message: dictKey
                                }
                            });
                        }
                    });
                },
                onError: function (error) {
                    console.log(error);
                    window.location.href = '#!' + Config.get('ROUTER_ERROR');
                }
            });
        }
    }
]);

'use strict';

angular.module('news').controller('ConfirmMailCtrl', [
    '$scope', '$routeParams', '$location', 'BarneyConfig', 'BarneyDict', 'User', 'Mail',
    function($scope, $routeParams, $location, Config, Dict, User, Mail){

        var newtonConfirmCallback = function(){
            NewtonAdapter.getIdentity('generic').then(function(genericIdentity){

                useris.PopupManager.showUserFeedback({
                    type: 'positive',
                    feedback: {
                        message: Dict.get('WEBAPP_UO30_FEEDBACK_EMAILADDED_CONFIRMED')
                    }
                });


                if(genericIdentity){
                    genericIdentity.delete(function(err){
                        if(err){
                            console.log(err);
                            window.location.href = '#!' + Config.get('ROUTER_ERROR');
                        } else {
                            console.log('Generic identity Removed!');
                        }
                    });
                }

                Mail.sendWelcomeMail({
                    EMAIL: $routeParams.email,
                    USERNAME: $routeParams.email
                }).$promise.then(function(mailResp){
                    console.log(mailResp);

                    window.location.href = '#!' + Config.get('ROUTER_HOME');
                });

            }).catch(function(err){
                console.log(err);
            });
        };

        User.getStatus(function(userStatus){
            if(userStatus.logged){
                NewtonAdapter.confirmEmail({
                    token: $routeParams.token
                }).then(function(resp){
                    newtonConfirmCallback();
                }).catch(function(err){
                    var dictKey = Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                        Dict.get('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dict.get('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                    if (dictKey) {
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: dictKey
                            }
                        });
                    }

                    window.location.href = '#!' + Config.get('ROUTER_ERROR') + '?code=' + err.code;
                });
            } else {
                NewtonAdapter.confirmEmailAndLogin({
                    token: $routeParams.token
                }).then(function(resp){
                    newtonConfirmCallback();
                }).catch(function(err){
                    console.log('confirmEmail failed', err);

                    useris.PopupManager.showUserFeedback({
                        type: 'error',
                        feedback: {
                            message: 'ERROR'
                        }
                    });

                    window.location.href = '#!' + Config.get('ROUTER_ERROR') + '?code=' + err.code;
                });
            }
        });
    }
]);

'use strict';

angular.module('news').controller('CategoryCtrl', [
    '$scope', '$routeParams', '$location', '$q', 'timestampToDateFilter', 'imagesizeFilter', 'BarneyMeta', 'BarneyDict', 'BarneyConfig', 'Category', 'User', 'GoogleManager', 'MetaTitleManager', 'HiStory', 'EventBus',
    function($scope, $routeParams, $location, $q, timestampToDate, imagesize, Meta, Dict, Config, Category, User, GoogleManager, MetaTitleManager, HiStory, Bus){

        /*******************
        ***  INIT VARS   ***
        *******************/

        var categoryId = $routeParams.categoryId;
        var size = Config.get('TEMPLATING_CATEGORY_SIZE');
        var offset = 0;
        var catInfoPromise = $q.defer();
        var catNewsPromise = $q.defer();


        $scope.showFooter = false;
        $scope.gettingNews = true;
        $scope.firstNews = [];
        $scope.otherNews = [];
        $scope.categoryName = '';
        $scope.gettingResult = false;

        if(Config.get('SHOW_ADV_OVERLAY')){
            if(Config.get('SHOW_ADV_FOR_LOGGED')){
                User.getStatus(function(user){
                    if(user.logged){
                        Bus.trigger('overlay-show', {
                            label: 'Category',

                            content_id: $routeParams.categoryId
                        });
                    }
                });
            } else {
                Bus.trigger('overlay-show', {
                    label: 'Category',
                    content_id: $routeParams.categoryId
                });
            }
        }

        /*******************
        ***  API CALLS   ***
        *******************/

        $scope.getNews = function(reenableInfinite){
            $scope.gettingResult = true;

            // API Calls (1/2) : get category news
            catNewsPromise = Category.get({
                category: categoryId,
                size: size,
                offset: offset
            });

            catNewsPromise.$promise.then(function(data){

                // re-enable infinite scroll, if conditions are satisfied
                if(data.length > 0 && data.length === size){
                    reenableInfinite();
                }

                // get data
                if(offset === 0){
                    // if first call, get first news and copy them to firstNews
                    $scope.firstNews = data.splice(0, Config.get('TEMPLATING_CATEGORY_FIRST'));
                    // if first call, set metatags
                    setMeta();
                    $scope.showFooter = true;
                }
                $scope.otherNews = $scope.otherNews.concat(data);

                // increment offset
                offset += size;

                $scope.gettingResult = false;
            });
        };

        // API Calls (1/2) : get category info
        catInfoPromise = Category.getInfo({
            id: categoryId
        });

        catInfoPromise.$promise.then(function(data){
            $scope.categoryName = data.title;

            /**************************
            ****  PERSONALISATION  ****
            **************************/

            User.getStatus(function(user){
                if(user.logged && Config.get('ENABLE_NEWTON_USER') && Config.get('ENABLE_HISTORY') && Config.get('ENABLE_HISTORY_SET_CATEGORY')){
                    HiStory.set({
                        contentType: data.collection_content_type,
                        categoryId: categoryId
                    });
                }
            });
        });

        /*******************
        ***   METATAGS   ***
        *******************/

        var setMeta = function(){
            $q.all([catInfoPromise, catNewsPromise]).then(function(data){
                Meta.set({
                    title: MetaTitleManager.getMetaTitle({
                        maskType: 'list',
                        content: $scope.categoryName,
                        noMaskValue: $scope.categoryName + ' ' + Dict.get('SEO_WEBAPP_META_TITLE_PAGE_CATEGORIES')
                    }),
                    description: $scope.categoryName + ' ' + Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_CATEGORIES'),
                    ogUrl: $location.absUrl(),
                    ogTitle: $scope.categoryName,
                    ogDescription: Dict.get('SEO_WEBAPP_META_OGTAGS_CATEGORY'),
                    ogImage: Config.get('META_DEFAULT_OGIMAGE_CATEGORY'),
                    jsonld: JSON.stringify({
                        '@context': 'http://schema.org',
                        '@type': 'NewsArticle',
                        mainEntityOfPage: {
                            '@type': 'WebPage',
                            '@id': $location.absUrl()
                        },
                        headline: $scope.categoryName,
                        image: {
                            '@type': 'ImageObject',
                            url: imagesize($scope.firstNews[0].images.cover.ratio_1, 'category', 'big'),
                            height: 768,
                            width: 1024
                        },
                        datePublished: timestampToDate($scope.firstNews[0].timestamp),
                        dateModified: timestampToDate($scope.firstNews[0].timestamp),
                        author: {
                            '@type': 'Person',
                            name: Dict.get('SEO_WEBAPP_JSONLD_NAME')
                        },
                        publisher: {
                            '@type': 'Organization',
                            name: Dict.get('SEO_WEBAPP_TITLE_COUNTRY'),
                            logo: {
                                '@type': 'ImageObject',
                                url: Config.get('IMG_DEST_DOMAIN') + Config.get('IMG_COMMON_PREFIX') + '/images/general/logo-header.png',
                                width: 230,
                                height: 30
                            }
                        },
                        description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX')
                    })
                }, function(){
                    GoogleManager.set({
                        'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_LIST'),
                        'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_LIST_H'),
                        'Contenido': $scope.categoryName,
                        'Contenido /h': $scope.categoryName,
                        'event': 'changePage'
                    });
                });
            });
        };


        /*******************
        ***   TRACKING   ***
        *******************/

        $scope.trackClick = function(newsTitle, newsIndex){
            JsAnalytics.trackEvent({
                category: 'Cat List',
                action: 'Click',
                label: newsTitle
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'Cat List',
                    label: newsTitle,
                    position: parseInt(newsIndex, 10) + 1
                }
            });
        };

        $scope.trackClickOther = function(newsTitle, newsIndex){
            JsAnalytics.trackEvent({
                category: 'Cat List',
                action: 'Click',
                label: newsTitle
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'Cat List',
                    label: newsTitle,
                    position: parseInt(newsIndex, 10) + Config.get('TEMPLATING_CATEGORY_FIRST') + 1
                }
            });
        };

        // Track Page view of snowplow
        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')){
            window.snowplow('trackPageView', {
                context: [{
                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                    data: {
                        kind_of_page: 'servicepage'
                    }
                }]
            });
        }

    }
]);

angular.module('news').controller('ContactUsCtrl',
    ['$scope', 'BarneyConfig', 'BarneyDict', 'Contact',
        function($scope, Config, Dict, Contact){
            $scope.payload = {
                from: '',
                body_text: ''
            };

            $scope.disabled = false;

            $scope.onSubmit = function() {
                $scope.disabled = true;

                Contact.sendMail($scope.payload).$promise
                    .then(function(response) {
                        $scope.disabled = false;
                        $scope.payload = {
                            from: '',
                            body_text: ''
                        };
                        useris.PopupManager.showUserFeedback({
                            type: 'positive',
                            feedback: {
                                message: Dict.get('WEBAPP_CONTACT_US_SUCCESS')
                            }
                        });
                    })
                    .catch(function(err) {
                        var message = Dict.get('WEBAPP_CONTACT_US_ERROR');
                        if (err.name === 'ValidationError' && err.message) {
                            message = err.message;
                        }
                        $scope.disabled = false;
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: message
                            }
                        });
                    });
            };
        }
    ]
);

angular.module('news').controller('ContactFormCtrl',
    ['$scope', 'BarneyConfig', 'BarneyDict', 'Contact',
        function($scope, Config, Dict, Contact){
            $scope.payload = {
                from: '',
                body_text: '',
                name: '',
                msisdn: '',
                email: '',
                subject: '',
                message: ''
            };

            $scope.disabled = false;

            $scope.onSubmit = function() {
                $scope.disabled = true;

                Contact.sendMail({
                    from: $scope.payload.email,
                    name: $scope.payload.name,
                    msisdn: $scope.payload.msisdn,
                    subject: $scope.payload.subject,
                    body_text: $scope.payload.message
                }).$promise
                    .then(function(response) {
                        $scope.disabled = false;
                        $scope.payload = {
                            email: '',
                            name: '',
                            msisdn: '',
                            subject: '',
                            body_text: '',
                            from: ''
                        };
                        useris.PopupManager.showUserFeedback({
                            type: 'positive',
                            feedback: {
                                message: Dict.get('WEBAPP_CONTACT_US_SUCCESS')
                            }
                        });
                    })
                    .catch(function(err) {
                        var message = Dict.get('WEBAPP_CONTACT_US_ERROR');
                        if (err.name === 'ValidationError' && err.message) {
                            message = err.message;
                        }
                        $scope.disabled = false;
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: message
                            }
                        });
                    });
            };
        }
    ]
);

'use strict';

angular.module('news').controller('ErrorCtrl',
    ['$scope', '$sce', '$routeParams', 'BarneyConfig', 'BarneyBrowser', 'Settings',
        function($scope, $sce, $routeParams, Config, Browser, Settings){

            // Get route params
            if($routeParams.code){
                $scope.code = $routeParams.code;
            } else if(Browser.getQueryParams().code) {
                $scope.code = Browser.getQueryParams().code.replace('/', '');
            } else if($routeParams.error) {
                $scope.code = $routeParams.error;
            } else if(Browser.getQueryParams().error) {
                $scope.code = Browser.getQueryParams().error.replace('/', '');
            } else {
                $scope.code = false;
            }

            if(Config.get('REDIRECT_TO_TMPL_ERROR')) {
                window.location.href = '/error' + ($scope.code ? ('?error=' + $scope.code) : '');
            } else if(Config.get('SHOW_TMPL_ERROR')) {
                var errorParams = { SUBSECTION: 'error' };

                if($scope.code) {
                    errorParams.error = $scope.code;
                }

                Settings.get(errorParams)
                .$promise.then(function(resp){
                    console.log('Error: ' + $scope.code);
                    $scope.errorTmpl = $sce.trustAsHtml(resp.content);
                    $scope.showFooter = true;
                });
            } else {
                $scope.showInternalError = true;
                $scope.showFooter = true;
            }
            $scope.telcoRequest = Config.get('HIDE_BUTTON_BACKHOME');
        }
    ]
);

'use strict';

angular.module('news').controller('GlossaryCtrl',
    ['$scope', '$routeParams', 'BarneyConfig', 'BarneyDict', 'Glossary',
        function($scope, $routeParams, Config, Dict, Glossary){

            var availableBuckets = Config.get('BUCKET') || [];
            var k;
            $scope.keysLoaded = false;
            $scope.keys = [];

            /*************************** 
             *  $scope.buckets
             *   (list of all available buckets, useful for links)
            ***************************/

            // initialize it to void array
            $scope.buckets = [];

            // first value is default bucket (with all available buckets)
            $scope.buckets[0] = {
                label: Dict.get('WEBAPP_GLO_ALL'),
                title: Dict.get('WEBAPP_GLO_WORD_LIST'),
                chars: ''
            };

            // iterates every available bucket from config key
            for(k = 0; k < availableBuckets.length; k++){
                // copy every bucket and add link value
                $scope.buckets[$scope.buckets.length] = {
                    label: availableBuckets[k].label,
                    title: availableBuckets[k].label.toUpperCase(),
                    chars: availableBuckets[k].chars
                };
                // added all available chars to default bucket
                $scope.buckets[0].chars += availableBuckets[k].chars + ',';
            }
            // remove last comma
            $scope.buckets[0].chars = $scope.buckets[0].chars.substring(0, $scope.buckets[0].chars.length - 1);

            /***************************
             * $scope.selectBucket()
             *   (method to select correct bucket)
             * $scope.bucketSelected
             *   (selected bucket to take glossary keys)
            ***************************/

            $scope.selectBucket = function(index){
                $scope.keysLoaded = false;
                $scope.bucketSelected = $scope.buckets[index];
                
                // call Glossary getList API with $scope.bucketSelected
                Glossary.getList({ BUCKET: $scope.bucketSelected.chars })
                .$promise.then(function(resp){
                    $scope.keys = resp;
                    $scope.keysLoaded = true;
                    $scope.showFooter = true;
                });
            };

            /***************************
             * select default bucket (index: 0) 
             * on initialization
            ***************************/

            $scope.selectBucket(0);
            
        }
    ]
);

'use strict';

angular.module('news').controller('HomeCtrl',
    ['$scope', '$routeParams', '$window', '$location', '$timeout', 'timestampToDateFilter', 'BarneyConfig', 'BarneyMeta', 'BarneyDict', 'BarneyBrowser', 'Home', 'Video', 'Latest', 'GoogleManager', 'MetaTitleManager',
        function ($scope, $routeParams, $window, $location, $timeout, timestampToDate, Config, Meta, Dict, Browser, Home, Video, Latest, GoogleManager, MetaTitleManager) {

            /*******************
            ***  INIT VARS   ***
            *******************/
            $scope.showFooter = false;
            $scope.showVideo = false;
            $scope.ready = false;
            $scope.showTagSection = Config.get('SHOW_TAG_SECTION');

            //OTP LOGIN MESSAGE

            $scope.fromOTP = (Browser.getQueryParams().otp && NewtonAdapter.isUserLogged()) || false;

            /*********************
            ***  LATEST VARS   ***
            *********************/

            $scope.showLatestSection = Config.get('ENABLE_HOMEPAGE_LATEST_POSTS');
            $scope.activeTab = 'home';
            $scope.gettingLatest = false;
            $scope.firstLatest = [];
            $scope.otherLatest = [];
            var enableLatest = Config.get('ENABLE_HOMEPAGE_LATEST_POSTS');
            var size = Config.get('HOME_PAGE_LATEST_POST_SIZE');
            var offset = 0;

            $scope.getLatest = function (reenableInfinite) {
                $scope.gettingLatest = true;

                // API Calls (1/2) : get category news
                Latest.get({
                    size: size,
                    offset: offset
                }).$promise.then(function (data) {

                    // re-enable infinite scroll, if conditions are satisfied
                    if (data.length > 0 && data.length === size) {
                        reenableInfinite();
                    }

                    // get data
                    if (offset === 0) {
                        // if first call, get first news and copy them to firstNews
                        $scope.firstLatest = data.splice(0, Config.get('TEMPLATING_LATEST_FIRST'));
                    }

                    $scope.otherLatest = $scope.otherLatest.concat(data);

                    // increment offset
                    offset += size;

                    $scope.gettingLatest = false;
                });
            };

            /*******************
            ***  CHANGE TAB  ***
            *******************/

            $scope.changeTab = function (tabToSet) {
                var prevTag = $scope.activeTab;

                if ($scope.activeTab !== tabToSet) {
                    $scope.activeTab = tabToSet;

                    JsAnalytics.trackEvent({
                        category: 'General List',
                        action: 'Click',
                        label: tabToSet
                    });

                    NewtonAdapter.trackEvent({
                        name: 'Click',
                        properties: {
                            category: 'General List',
                            label: tabToSet
                        }
                    });


                    /*********************
                    *** TRACK PAGEVIEW ***
                    *********************/

                    JsAnalytics.trackPage({
                        page: $location.path(),
                        title: $scope.activeTab + 'List'
                    });

                    NewtonAdapter.trackPageview({
                        properties: {
                            http_referrer: document.referrer,
                            page_path: $location.absUrl(),
                            page_title: $scope.activeTab + 'List',
                            previous_page: prevTag + 'List',
                            url: $scope.activeTab
                        }
                    });
                }

                enableInfinite();
            };

            /*******************
            *  INFINITE ON/OFF *
            *******************/

            var enableInfinite = function () {
                if ($scope.activeTab === 'home') {
                    $scope.gettingLatest = false;
                } else {
                    $scope.gettingLatest = true;
                }
            };

            /*******************
            ***  END LATEST ***
            *******************/


            /*******************
            ***  MATCH MEDIA ***
            *******************/

            // Get max width to show the carousel, default to 991px
            var widthMatch = Config.get('MATCH_MEDIA_HOME_CAROUSEL') || 991;

            var showSliderTrigger = function (mql) {
                $timeout(function () {
                    $scope.ready = true;
                    $scope.showSlider = mql ? mql.matches : true;
                });
            };

            if (typeof widthMatch !== 'boolean') {
                // Add media query matcher to show/hide the carousel
                var matchString = '(max-width: ' + widthMatch.toString() + 'px)';
                Browser.mediaMatcher(matchString, showSliderTrigger);
            } else {
                // If the max width from Config is "true", always show the carousel
                showSliderTrigger();
            }


            /*******************
            ***  API CALLS   ***
            *******************/

            // API Calls (1/3) : get categories and slider items
            Home.getCategories({}, function (data) {
                $scope.categories = data.category_items;
                //$scope.categoriesId = data.category_items.id;

                $scope.slides = data.top_carousel;

                // show footer
                $scope.showFooter = true;

                /*******************
                ***  SLIDER ITEM ***
                *******************/
                if (Config.get('ENABLE_SLIDER_ITEM')) {
                    var ItemOpts = {
                        type: 'slider',
                        startAt: 0,
                        gap: 10,
                        focusA: 0,
                        bound: true,
                        peek: {
                            before: 0,
                            after: 50
                        },
                        perView: 6,
                        breakpoints: {
                            320: {
                                perView: 2
                            },
                            680: {
                                perView: 2
                            },
                            768: {
                                perView: 4
                            },
                            1024: {
                                perView: 6
                            }
                        }
                    };

                    if ($scope.ItemOpts && Config.get($scope.ItemOpts)) {
                        //mergia la conf qui sopra con una presa dal vhost, se c'è. (mettere doppi apici su tutte le chiavi, v. esempio LEADERBOARD_SLIDER_CONF su gameasy.conf)
                        //così puoi fare solo l'override di alcune opzioni e aggiungerne, 
                        //e mantiene uguali le opzioni che non sovrascrivi.
                        angular.merge(ItemOpts, Config.get($scope.ItemOpts));
                    }

                    if ($scope.categories) {
                        //qui se ci sono effettivamente i contenuti
                        //definisco lo slider e lo monto. 

                        var sliderCategoryitems = []; //preparo l'array per i selettori

                        angular.element(document).ready(function () {
                            for (var key in $scope.categories) {
                                //metto nell'array il selettore per ogni slider, componendolo usando la chiave di ogni oggetto contanuto in $scope.categories (che è identica all'id della categoria che sta dentro l'oggetto).
                                sliderCategoryitems.push('.sliderItems.slider-' + key);
                            }
                            angular.forEach(sliderCategoryitems, function(slider){ //per ogni selettore dell'array di prima...
                                if (document.querySelector(slider)){ //...se c'è l'elemento nel dom...

                                    var sliderItems = new Glide(slider, ItemOpts); //...creo lo slider
                                    // eslint-disable-next-line
                                    setTimeout(function () {
                                        sliderItems.mount(); //...e lo monto
                                    }, 450);
                                } else {
                                    console.log('no element');
                                }
                            });
                        });

                    }
                }
            });


            // API Calls (2/3) : get tag items
            if (Config.get('ENABLE_HOMEPAGE_TAGS')) {
                Home.getTag({}, function (data) {
                    // tag news must be pair
                    if (data.items.length % 2 !== 0 && data.items.length !== 1) {
                        data.items.splice(-1, 1);
                    }

                    // add tag info/news to scope
                    $scope.tag = data;
                    $scope.showTag = true;
                });
            } else {
                $scope.showTag = false;
            }

            // API Calls (3/3) : get video items
            if (Config.get('ENABLE_CUSTOM_VIDEO_SECTION')) {
                Home.getVideo({}, function (data) {
                    // video news must be pair
                    if (data.length % 2 !== 0 && data.length !== 1) {
                        data.splice(-1, 1);
                    }

                    // add video news to scope and show video section
                    $scope.video = data;
                    $scope.showVideo = true;
                });
            }


            /*******************
            ***   METATAGS   ***
            *******************/

            Meta.set({
                title: MetaTitleManager.getMetaTitle({
                    maskType: 'home',
                    content: '',
                    noMaskValue: Dict.get('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict.get('SEO_WEBAPP_TITLE_COUNTRY')
                }),
                ogTitle: Dict.get('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'),
                ogDescription: Dict.get('SEO_WEBAPP_META_OGTAGS_HOME_DESC'),
                ogSiteName: Dict.get('SEO_WEBAPP_META_OGTAGS_NAME_HOME'),
                jsonld: JSON.stringify({
                    '@context': 'http://schema.org',
                    '@type': 'NewsArticle',
                    mainEntityOfPage: {
                        '@type': 'WebPage',
                        '@id': $location.absUrl()
                    },
                    headline: Dict.get('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict.get('SEO_WEBAPP_TITLE_COUNTRY'),
                    image: {
                        '@type': 'ImageObject',
                        url: Config.get('META_DEFAULT_OGIMAGE_HOME'),
                        height: 630,
                        width: 1200
                    },
                    datePublished: timestampToDate(Date.now() / 1000),
                    dateModified: timestampToDate(Date.now() / 1000),
                    author: {
                        '@type': 'Person',
                        name: Dict.get('SEO_WEBAPP_JSONLD_NAME')
                    },
                    publisher: {
                        '@type': 'Organization',
                        name: Dict.get('SEO_WEBAPP_TITLE_COUNTRY'),
                        logo: {
                            '@type': 'ImageObject',
                            url: Config.get('IMG_DEST_DOMAIN') + Config.get('IMG_COMMON_PREFIX') + '/images/general/logo-header.png',
                            width: 230,
                            height: 30
                        }
                    },
                    description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX')
                })

            }, function () {
                GoogleManager.set({
                    'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_HOME'),
                    'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_HOME'),
                    'Contenido': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT'),
                    'Contenido /h': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                    'event': 'changePage'
                });
            });


            /*******************
            ***   TRACKING   ***
            *******************/

            if (Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter) {
                facebookpixeladapter.pageView();
            }

            // Track Page view of snowplow
            if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                window.snowplow('trackPageView', {
                    context: [{
                        schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                        data: {
                            kind_of_page: 'servicehomepage'
                        }
                    }]
                });
            }

            $scope.trackClickTag = function (newsTitle, newsIndex) {
                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: 'ClickTag',
                    label: newsTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickTag',
                    properties: {
                        category: 'Home Page',
                        label: newsTitle,
                        position: parseInt(newsIndex, 10) + 1
                    }
                });
            };

            $scope.trackClickTagAll = function (event, tagName) {
                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: 'ClickTagAll',
                    label: tagName
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickTagAll',
                    properties: {
                        category: 'Home Page',
                        label: tagName
                    }
                });

                Browser.clickAndGo(event);
            };

            $scope.trackClickCat = function (catIndex, newsTitle, newsIndex) {
                var action = 'ClickCat' + (parseInt(catIndex, 10) + 1);

                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: action,
                    label: newsTitle
                });

                NewtonAdapter.trackEvent({
                    name: action,
                    properties: {
                        category: 'Home Page',
                        label: newsTitle,
                        position: parseInt(newsIndex, 10) + 1
                    }
                });
            };

            $scope.trackClickCatAll = function (event, catName, catIndex) {
                var action = 'ClickCat' + (parseInt(catIndex, 10) + 1) + 'All';

                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: action,
                    label: catName
                });

                NewtonAdapter.trackEvent({
                    name: action,
                    properties: {
                        category: 'Home Page',
                        label: catName
                    }
                });

                Browser.clickAndGo(event);
            };

            $scope.trackClickVideo = function (videoTitle, videoIndex) {
                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: 'ClickVideo',
                    label: videoTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickVideo',
                    properties: {
                        category: 'Home Page',
                        label: videoTitle,
                        position: parseInt(videoIndex, 10) + 1
                    }
                });
            };

            $scope.trackClickVideoAll = function (event, videoName) {
                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: 'ClickVideoAll',
                    label: videoName
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickVideoAll',
                    properties: {
                        category: 'Home Page',
                        label: videoName
                    }
                });

                Browser.clickAndGo(event);
            };

            $scope.trackClickSlider = function (event, title, index) {
                JsAnalytics.trackEvent({
                    category: 'Home Page',
                    action: 'ClickCarousel',
                    label: title
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickCarousel',
                    properties: {
                        category: 'Home Page',
                        label: title,
                        position: parseInt(index, 10) + 1
                    }
                });

                Browser.clickAndGo(event);
            };

        }
    ]
);



angular.module('news').controller('NewsCtrl', [
    '$scope', '$location', '$routeParams', 'BarneyDict', 'BarneyMeta', 'BarneyConfig', 'BarneyBrowser', 'Category', 'Tag', 'GoogleManager', 'MetaTitleManager',
    function($scope, $location, $routeParams, Dict, Meta, Config, Browser, Category, Tag, GoogleManager, MetaTitleManager){

        /*******************
        ***  INIT VARS   ***
        *******************/

        var enableCategories = true;
        var sizeCategories = Config.get('TEMPLATING_NEWS_CATEGORY_SIZE');
        var offsetCategories = 0;
        var enableTags = true;
        var sizeTags = Config.get('TEMPLATING_NEWS_TAG_SIZE');
        var offsetTags = 0;

        $scope.activeTab = $routeParams.section ? $routeParams.section : 'categories';
        $scope.showFooter = false;
        // categories
        $scope.categories = [];
        $scope.showCategoriesLoader = false;
        // tags
        $scope.tags = [];
        $scope.showTagsLoader = false;
        $scope.showTagSection = Config.get('SHOW_TAG_SECTION');


        /*******************
        ***  API CALLS   ***
        *******************/

        $scope.getCategories = function(reenableInfinite){
            // show loader
            $scope.showCategoriesLoader = true;

            // API Calls (1/2) : get categories
            Category.getList({
                size: sizeCategories,
                offset: offsetCategories
            }).$promise.then(function(data){
                // TODO: check headers

                // re-enable infinite scroll, if conditions are satisfied
                if(data.length > 0 && data.length === sizeCategories){
                    reenableInfinite();
                } else {
                    enableCategories = false;
                }

                if(offsetCategories === 0){
                    $scope.showFooter = true;
                }

                // hide loader
                $scope.showCategoriesLoader = false;

                // get data
                $scope.categories = $scope.categories.concat(data);

                // increment offset
                offsetCategories += sizeCategories;
            });
        };

        $scope.getTags = function(reenableInfinite){
            // show loader
            $scope.showTagsLoader = true;

            // API Calls (2/2) : get tags
            Tag.getList({
                size: sizeTags,
                offset: offsetTags
            }).$promise.then(function(data){
                // TODO: check headers

                // re-enable infinite scroll, if conditions are satisfied
                if(data.length > 0 && data.length === sizeTags){
                    reenableInfinite();
                } else {
                    enableTags = false;
                }

                // hide loader
                $scope.showTagsLoader = false;

                if(offsetTags === 0 && !$scope.showFooter){
                    $scope.showFooter = true;
                }

                // get data
                $scope.tags = $scope.tags.concat(data);

                // increment offset
                offsetTags += sizeTags;
            });
        };


        /*******************
        ***  CHANGE TAB  ***
        *******************/

        $scope.changeTab = function(tabToSet){
            var prevTag = $scope.activeTab;

            if($scope.activeTab !== tabToSet){
                $scope.activeTab = tabToSet;

                JsAnalytics.trackEvent({
                    category: 'General List',
                    action: 'Click',
                    label: tabToSet
                });

                NewtonAdapter.trackEvent({
                    name: 'Click',
                    properties: {
                        category: 'General List',
                        label: tabToSet
                    }
                });


                /*********************
                *** TRACK PAGEVIEW ***
                *********************/

                JsAnalytics.trackPage({
                    page: $location.path(),
                    title: $scope.activeTab + 'List'
                });

                NewtonAdapter.trackPageview({
                    properties: {
                        http_referrer: document.referrer,
                        page_path: $location.absUrl(),
                        page_title: $scope.activeTab + 'List',
                        previous_page: prevTag + 'List',
                        url: '/news/' + $scope.activeTab
                    }
                });

            }

            enableInfinite();
        };


        /*******************
        *  INFINITE ON/OFF *
        *******************/

        var enableInfinite = function(){
            if($scope.activeTab === 'categories'){
                if(enableCategories){
                    $scope.gettingCategories = true;
                    $scope.gettingTags = false;
                }
            } else if(enableTags){
                $scope.gettingCategories = false;
                $scope.gettingTags = true;
            }
        };

        enableInfinite();


        /*******************
        ***   METATAGS   ***
        *******************/

        function GoogleManagerCB(){
            GoogleManager.set({
                'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_CATEGORY_LIST'),
                'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_CATEGORY_LIST_H'),
                Contenido: Dict.get('WEBAPP_NO_APPLICABLE_CONTENT'),
                'Contenido /h': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                event: 'changePage'
            });
        }

        if($scope.activeTab === 'categories'){
            Meta.set({
                title: MetaTitleManager.getMetaTitle({
                    maskType: 'list',
                    content: Dict.get('SEO_WEBAPP_HEAD_TITLE_TOP_CATEGORY'),
                    noMaskValue: Dict.get('SEO_WEBAPP_META_TITLE_CATEGORIES_LIST')
                }),
                description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_CATEGORIES_LIST'),
                ogImage: Config.get('META_DEFAULT_OGIMAGE_CATEGORY')
            }, GoogleManagerCB);

        } else {
            Meta.set({
                title: MetaTitleManager.getMetaTitle({
                    maskType: 'list',
                    content: Dict.get('SEO_WEBAPP_HEAD_TITLE_TOP_CATEGORY'),
                    noMaskValue: Dict.get('SEO_WEBAPP_META_TITLE_TAGS_LIST')
                }),
                description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_TAGS_LIST'),
                ogImage: Config.get('META_DEFAULT_OGIMAGE_CATEGORY')
            }, GoogleManagerCB);
        }


        /*******************
        ***   TRACKING   ***
        *******************/

        $scope.trackClickCat = function(title, index){
            JsAnalytics.trackEvent({
                category: 'Cat Page',
                action: 'Click',
                label: title
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'Cat Page',
                    label: title,
                    position: parseInt(index, 10) + 1
                }
            });
        };

        $scope.trackClickTag = function(event, title, index){
            JsAnalytics.trackEvent({
                category: 'Tag Page',
                action: 'Click',
                label: title
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'Tag Page',
                    label: title,
                    position: parseInt(index, 10) + 1
                }
            });

            Browser.clickAndGo(event);
        };

        var prevPage = !!Browser.getPrevState() && !!Browser.getPrevState().className ? Browser.getPrevState().className : '';
        NewtonAdapter.trackPageview({
            properties: {
                url: $location.path(),
                page_path: $location.absUrl(),
                page_title: 'News',
                http_referrer: document.referrer,
                previous_page: prevPage
            }
        });
        // Track Page view of snowplow
        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
            window.snowplow('trackPageView', {
                context: [{
                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                    data: {
                        kind_of_page: 'servicepage'
                    }
                }]
            });
        }

    }
]);



angular.module('news').controller('SearchCtrl',
    ['$scope', '$rootScope', '$window', '$location', '$route', 'BarneyConfig', 'BarneyBrowser', 'BarneyDict', 'BarneyMeta', 'Search', 'Category', 'Home', 'MetaTitleManager', 'GoogleManager', 'addQueryInPath', 'Utility',
        function($scope, $rootScope, $window, $route, $location, Config, Browser, Dict, Meta, Search, Category, Home, MetaTitleManager, GoogleManager, addQueryInPath, Utility){

            /*******************
            ***  INIT VARS   ***
            *******************/

            var offset = 0;
            var size = Config.get('TEMPLATING_SEARCH_SIZE');

            $scope.showFooter = false;
            $scope.categories = [];
            $scope.latestNews = [];
            $scope.categoriesList = [];
            $scope.query = '';
            $scope.phase = 'none';
            $scope.searchedFor = '';
            $scope.gettingResult = false;
            $scope.gettingOtherNews = false;

            /*******************
            ***  API CALLS   ***
            *******************/

            // API Calls 1/2 - topCarousel
            if (Config.get('SHOW_SEARCH_SUGGESTED') && !Config.get('ENABLE_SLIDER_ITEM')) {
                Home.getCategories({}, function(data){
                    $scope.latestNews = data.top_carousel;
                });
            }            

            // API Calls 1/2 - Suggested Categories Items list
            if (Config.get('SHOW_SEARCH_SUGGESTED') && Config.get('ENABLE_SLIDER_ITEM')) {
                Home.getCategories({}, function(data){
                    $scope.categories = data.category_items;
               
                    /*******************
                    ***  SLIDER ITEM ***
                    *******************/                   
                    var ItemOpts = {
                        type: 'slider',
                        startAt: 0,
                        gap: 10,
                        focusA: 0,
                        bound: true,
                        peek: {
                            before: 0,
                            after: 50
                        },
                        perView: 6,
                        breakpoints: {
                            320: {
                                perView: 2
                            },
                            680: {
                                perView: 2
                            },
                            768: {
                                perView: 4
                            },
                            1024: {
                                perView: 6
                            }
                        }
                    };

                    if ($scope.ItemOpts && Config.get($scope.ItemOpts)) {
                        //mergia la conf qui sopra con una presa dal vhost, se c'è. (mettere doppi apici su tutte le chiavi, v. esempio LEADERBOARD_SLIDER_CONF su gameasy.conf)
                        //così puoi fare solo l'override di alcune opzioni e aggiungerne, 
                        //e mantiene uguali le opzioni che non sovrascrivi.
                        angular.merge(ItemOpts, Config.get($scope.ItemOpts));
                    }

                    if ($scope.categories) {
                        //qui se ci sono effettivamente i contenuti
                        //definisco lo slider e lo monto. 

                        var sliderCategoryitems = []; //preparo l'array per i selettori

                        angular.element(document).ready(function () {
                            for (var key in $scope.categories) {
                                //metto nell'array il selettore per ogni slider, componendolo usando la chiave di ogni oggetto contanuto in $scope.categories (che è identica all'id della categoria che sta dentro l'oggetto).
                                sliderCategoryitems.push('.sliderItems.slider-' + key);
                            }
                            angular.forEach(sliderCategoryitems, function(slider){ //per ogni selettore dell'array di prima...
                                if (document.querySelector(slider)){ //...se c'è l'elemento nel dom...

                                    var sliderItems = new Glide(slider, ItemOpts); //...creo lo slider
                                    // eslint-disable-next-line
                                    setTimeout(function () {
                                        sliderItems.mount(); //...e lo monto
                                    }, 800);
                                } else {
                                    console.log('no element');
                                }
                            });
                        });
                    }                      
                });
            }

            // API Calls 2/2 - Category
            Category.getList({
                size: Config.get('TEMPLATING_CAT_IN_SEARCH_SIZE')
            }, function(data){
                $scope.categoriesList = data;
                $scope.showFooter = true;
            });
            
            /*******************
            ***     BLUR     ***
            *******************/

            var blurTextfield = function(){
                $window.document.activeElement.blur();
                var inputs = $window.document.querySelectorAll('input');
                for(var i = 0; i < inputs.length; i++) {
                    inputs[i].blur();
                }
            };
            /*******************
            ***    SUBMIT    ***
            *******************/
            var queryPath;
            if($location.current.params.query){
                queryPath = $location.current.params.query;
            }
            $scope.submit = function(){
                if($scope.query){

                    var eventAction = '';
                    //check IE6 TO IE11
                    if(!Utility.ie6toie11Detection()){
                        blurTextfield();
                    }

                    // change phase
                    if($scope.phase === 'result'){
                        $scope.phase = 'waitAfter';
                    } else {
                        $scope.phase = 'waitFirst';
                    }


                    if($scope.query !== 'crazyjenny'){
                        // Call API
                        Search.get({
                            q: $scope.query,
                            size: size
                        }).$promise.then(function(data){
                            $scope.searchedFor = $scope.query;

                            if(data.length === 0){
                                $scope.phase = 'void';
                                eventAction = 'NoResult';
                                $scope.gettingResult = false;
                            } else {
                                $scope.results = data;
                                $scope.phase = 'result';
                                eventAction = 'SearchEvent';
                                offset += size;
                                $scope.gettingResult = true;
                            }

                            /*******************
                            ***  TRACKING 1  ***
                            *******************/

                            JsAnalytics.trackEvent({
                                category: 'Search Page',
                                action: eventAction,
                                label: $scope.query
                            });

                            NewtonAdapter.trackEvent({
                                name: eventAction,
                                properties: {
                                    category: 'Search Page',
                                    label: $scope.query
                                }
                            });

                            Meta.set({
                                title: MetaTitleManager.getMetaTitle({
                                    maskType: 'list',
                                    content: $scope.query,
                                    noMaskValue: $scope.query + ' - ' + Dict.get('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict.get('SEO_WEBAPP_TITLE_COUNTRY')
                                })
                            });
                            if (Config.get('ENABLE_QUERY_SEARCH_URL') && !queryPath) {
                                addQueryInPath.init();
                                addQueryInPath.addQuery($route.$$path.split('/')[1] + '/', $scope.query, false);
                            }
                            queryPath = undefined;
                        });
                    }
                }
            };

            if(Config.get('ENABLE_QUERY_SEARCH_URL') && $location.current.params.query){
                $scope.query = $location.current.params.query;
                $scope.submit();
            }


            Meta.set({
                title: MetaTitleManager.getMetaTitle({
                    maskType: 'list',
                    content: Dict.get('SEO_WEBAPP_HEAD_TITLE_SEARCH')
                })
            }, function(){
                GoogleManager.set({
                    'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                    'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                    Contenido: Dict.get('WEBAPP_NO_APPLICABLE_CONTENT'),
                    'Contenido /h': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                    event: 'changePage'
                });
            });

            $scope.getOtherNews = function(reenableInfinite){
                $scope.gettingOtherNews = true;

                // get search news
                Search.get({
                    q: $scope.searchedFor,
                    size: size,
                    offset: offset
                }).$promise.then(function(data){

                    // re-enable infinite scroll, if conditions are satisfied
                    if(data.length === size){
                        reenableInfinite();
                    }

                    $scope.results = $scope.results.concat(data);

                    // increment offset
                    offset += size;
                    $scope.gettingOtherNews = false;
                });
            };

            /*******************
            ***  TRACKING 2  ***
            *******************/

            $scope.trackClickResult = function(newsTitle, newsIndex){
                JsAnalytics.trackEvent({
                    category: 'SearchPage',
                    action: 'ClickResult',
                    label: newsTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickResult',
                    properties: {
                        category: 'SearchPage',
                        label: newsTitle,
                        position: parseInt(newsIndex, 10) + 1,
                        query: $scope.query
                    }
                });
            };

            $scope.trackClickOther = function(newsTitle, newsIndex){
                JsAnalytics.trackEvent({
                    category: 'SearchPage',
                    action: 'ClickOther',
                    label: newsTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickOther',
                    properties: {
                        category: 'SearchPage',
                        label: newsTitle,
                        position: parseInt(newsIndex, 10) + 1
                    }
                });
            };

            $scope.trackClickCategory = function(event, catTitle, catIndex){
                JsAnalytics.trackEvent({
                    category: 'SearchPage',
                    action: 'ClickCategory',
                    label: catTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'ClickCategory',
                    properties: {
                        category: 'SearchPage',
                        label: catTitle,
                        position: parseInt(catIndex, 10) + 1
                    }
                });

                Browser.clickAndGo(event);
            };

            /*******************
            *  FACEBOOK PIXEL  *
            *******************/

            if(Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter){
                facebookpixeladapter.pageView();
            }
            // Track Page view of snowplow
            if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                window.snowplow('trackPageView', {
                    context: [{
                        schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                        data: {
                            kind_of_page: 'servicepage'
                        }
                    }]
                });
            }
        }
    ]
);

'use strict';

angular.module('news').controller('TagCtrl', [
    '$scope', '$routeParams', '$location', '$q', 'timestampToDateFilter', 'imagesizeFilter', 'BarneyMeta', 'BarneyDict', 'BarneyConfig', 'Tag', 'GoogleManager', 'MetaTitleManager', 'HiStory', 'User',
    function($scope, $routeParams, $location, $q, timestampToDate, imagesize, Meta, Dict, Config, Tag, GoogleManager, MetaTitleManager, HiStory, User){

        /*******************
        ***  INIT VARS   ***
        *******************/

        var tagId = $routeParams.tagId;
        var size = Config.get('TEMPLATING_TAG_SIZE');
        var offset = 0;
        var tagInfoPromise = $q.defer();
        var tagNewsPromise = $q.defer();

        $scope.showFooter = false;
        $scope.gettingResult = false;
        $scope.gettingNews = true;
        $scope.firstNews = [];
        $scope.otherNews = [];
        $scope.tagName = '';

        $scope.namePrefix = '';


        var ageRangeTagSlugs = Config.get('AGE_RANGE_TAGS_IDS') || [];
        if (ageRangeTagSlugs.indexOf(tagId) >= 0) {
            $scope.namePrefix = Dict.get('WEBAPP_AGE_RANGE_TAG_PREFIX') + ' ';
        }

        /*******************
        ***  API CALLS   ***
        *******************/

        $scope.getNews = function(reenableInfinite){
            $scope.gettingResult = true;

            // API Calls (1/2) : get tag news
            tagNewsPromise = Tag.get({
                tag: tagId,
                size: size,
                offset: offset
            }).$promise;

            tagNewsPromise.then(function(data){
                // re-enable infinite scroll, if conditions are satisfied
                if(data.length > 0 && data.length === size){
                    reenableInfinite();
                }

                // get data
                if(offset === 0){
                    // if first call, get first news and copy them to firstNews
                    $scope.firstNews = data.splice(0, Config.get('TEMPLATING_TAG_FIRST'));
                    // if first call, set metatags
                    setMeta();
                    $scope.showFooter = true;
                }
                $scope.otherNews = $scope.otherNews.concat(data);

                // increment offset
                offset += size;

                $scope.gettingResult = false;

            });
        };

        // API Calls (2/2) : get tag info
        tagInfoPromise = Tag.getInfo({
            id: tagId
        }).$promise;

        tagInfoPromise.then(function(data){
            $scope.tagName = data.title;

            /**************************
            ****  PERSONALISATION  ****
            **************************/

            User.getStatus(function(user){
                if(user.logged && Config.get('ENABLE_NEWTON_USER') && Config.get('ENABLE_HISTORY') && Config.get('ENABLE_HISTORY_SET_TAG')){
                    HiStory.set({
                        contentType: data.collection_content_type,
                        categoryId: tagId
                    });
                }
            });
        });


        /*******************
        ***   METATAGS   ***
        *******************/

        var setMeta = function(){
            $q.all([tagInfoPromise, tagNewsPromise]).then(function(data){
                var customTitle = $scope.tagName + ' ';
                Meta.set({
                    title: MetaTitleManager.getMetaTitle({
                        maskType: 'list',
                        content: $scope.tagName,
                        noMaskValue: customTitle + (Dict.get('SEO_WEBAPP_META_TITLE_PAGE_TAGS') || Dict.get('SEO_WEBAPP_META_TITLE_PAGE_CATEGORIES'))
                    }),
                    description: (Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_TAGS') || Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX')),
                    jsonld: JSON.stringify({
                        '@context': 'http://schema.org',
                        '@type': 'NewsArticle',
                        mainEntityOfPage: {
                            '@type': 'WebPage',
                            '@id': $location.absUrl()
                        },
                        headline: $scope.tagName,
                        image: {
                            '@type': 'ImageObject',
                            url: imagesize($scope.firstNews[0].images.cover.ratio_1, 'tag', 'big'),
                            height: 768,
                            width: 1024
                        },
                        datePublished: timestampToDate($scope.firstNews[0].timestamp),
                        dateModified: timestampToDate($scope.firstNews[0].timestamp),
                        author: {
                            '@type': 'Person',
                            name: Dict.get('SEO_WEBAPP_JSONLD_NAME')
                        },
                        publisher: {
                            '@type': 'Organization',
                            name: Dict.get('SEO_WEBAPP_TITLE_COUNTRY'),
                            logo: {
                                '@type': 'ImageObject',
                                url: Config.get('IMG_DEST_DOMAIN') + Config.get('IMG_COMMON_PREFIX') + '/images/general/logo-header.png',
                                width: 230,
                                height: 30
                            }
                        },
                        description: (Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_TAGS') || Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX'))
                    })
                }, function(){
                    GoogleManager.set({
                        'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_LIST'),
                        'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_LIST_H')
                    });
                });

            });
        };


        /*******************
        ***   TRACKING   ***
        *******************/

        $scope.trackClick = function(newsTitle, newsIndex){
            JsAnalytics.trackEvent({
                category: 'Tag List',
                action: 'Click',
                label: newsTitle
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'Tag List',
                    label: newsTitle,
                    position: parseInt(newsIndex, 10) + 1
                }
            });
        };

        // Track Page view of snowplow
        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')){
            window.snowplow('trackPageView', {
                context: [{
                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                    data: {
                        kind_of_page: 'servicepage'
                    }
                }]
            });
        }

        $scope.trackClickOther = function(newsTitle, newsIndex){
            JsAnalytics.trackEvent({
                category: 'Tag List',
                action: 'Click',
                label: newsTitle
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'Tag List',
                    label: newsTitle,
                    position: parseInt(newsIndex, 10) + Config.get('TEMPLATING_TAG_FIRST') + 1
                }
            });
        };

    }
]);



angular.module('news').controller('TermsCtrl', [
    '$q', '$scope', '$routeParams', '$sce', '$location', 'BarneyDict', 'Settings', 'User', 'BarneyConfig', 'SUBSECTION', 'CONTENT_ID', 'BarneyMeta', 'GoogleManager',
    function($q, $scope, $routeParams, $sce, $location, Dict, Settings, User, Config, SUBSECTION, CONTENT_ID, Meta, GoogleManager){

        /*******************
        ***  INIT VARS   ***
        *******************/

        $scope.showFooter = true;
        var subsectionParam = '';
        var contentidParam = '';
        var settingsDefer = $q.defer();

        var settingsParams = {
            SUBSECTION: '',
            CONTENT_ID: '',
            HYBRID: 0,
            STORETYPE: 0
        };

        if(SUBSECTION){
            subsectionParam = SUBSECTION;
        } else if($routeParams.subsection){
            subsectionParam = $routeParams.subsection;
        }

        if(CONTENT_ID){
            contentidParam = CONTENT_ID;
        } else if($routeParams.contentid){
            contentidParam = $routeParams.contentid;
        }

        // Track Page view of snowplow

        var checkLocation = $location.path();
        var typeOfPage = '';

        if (checkLocation.includes('status')){
            typeOfPage = 'cancelationpage';
        } else {
            typeOfPage = 'termsandconditions';
        }
        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')){
            window.snowplow('trackPageView', {
                context: [{
                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                    data: {
                        kind_of_page: typeOfPage
                    }
                }]
            });
        }

        if(Dict.get('WEBAPP_SERVICE_NAME') && Dict.get('SEO_WEBAPP_META_TITLE_TERMS_' + contentidParam.toUpperCase())){
            Meta.set({
                title: Dict.get('WEBAPP_SERVICE_NAME') + '-' + Dict.get('SEO_WEBAPP_META_TITLE_TERMS_' + contentidParam.toUpperCase())
            }, function(){
                GoogleManager.set({
                    'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                    'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                    Contenido: Dict.get('WEBAPP_NO_APPLICABLE_CONTENT'),
                    'Contenido /h': Dict.get('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                    event: 'changePage'
                });
            });
        }

        settingsParams.SUBSECTION = subsectionParam;
        settingsParams.CONTENT_ID = contentidParam;
        settingsDefer.resolve(settingsParams);

        /*******************
        ***  API CALLS   ***
        *******************/

        settingsDefer.promise.then(function(promiseResp){
            Settings.get(promiseResp, function(resp){
                $scope.text = $sce.trustAsHtml(resp.content);

                if(Config.get('ENABLE_NEWTON_USER') && !Config.get('PAYWALL_IS_ENABLED')){
                    useris.smartstatus({
                        element: false,
                        access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                        doNotLoad: true
                    }, {

                        onUnsubLoggedSuccess: function(params){

                            unsubscriptionFlow(params);
                        },
                        onUnsubLoggedError: function(err){
                            console.log(err);
                        },
                        onUnsubUnloggedSuccess: function(params){
                            if (params.TYPE === 'msisdn' && Config.get('INTERNATIONAL_PREFIX')) {
                                if (params.IDENTITY.indexOf(Config.get('INTERNATIONAL_PREFIX')) !== 0 && params.IDENTITY.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                    params.IDENTITY = Config.get('INTERNATIONAL_PREFIX') + params.IDENTITY.match(Config.get('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                    console.log('MSISDN optimized with ' + Config.get('INTERNATIONAL_PREFIX') + ' ', params.IDENTITY);
                                }
                            }
                            unsubscriptionFlow(params);

                        },
                        onUnsubUnloggedError: function(err){
                            console.log(err);
                        }
                    });
                }
            });
        });

        var unsubscriptionFlow = function(params){
            var redirectUrl = false;

            User.unsubscribe(params, function(unsubResp){
                if(unsubResp){

                    if(Config.get('DISABLE_USERFEEDBACK_POPUP') !== true){
                        useris.PopupManager.showUserFeedback({
                            type: 'positive',
                            feedback: {
                                message: Dict.get('WEBAPP_UO30_FEEDBACK_SUBS_DELETED')
                            }
                        });
                    }

                    if(unsubResp.config_key){
                        redirectUrl = Config.get(unsubResp.config_key);
                    } else if(unsubResp.url){
                        redirectUrl = unsubResp.url;
                    }

                    switch(unsubResp.status){

                    case 302:
                        if(unsubResp.unsubscribed){
                            NewtonAdapter.logout().then(function(logoutResp){
                                window.location.href = redirectUrl;
                            });
                        } else {
                            window.location.href = redirectUrl;
                        }

                        break;

                    case 200:
                        $scope.dictKey = Dict.get(unsubResp.dict_key);
                        break;

                    default:
                        $scope.dictKey = Dict.get(unsubResp.dict_key);
                    }
                } else {
                    $location.path(Config.get('ROUTER_ERROR'));
                }
            });
        };
    }
]);



angular.module('news').controller('MySpaceCtrl', [
    '$scope', '$q', 'User', 'BarneyConfig', 'BarneyBrowser', 'BarneyDict', 'HiStory', 'Favorites', 'WatchLater', 'Latest',
    function($scope, $q, User, Config, Browser, Dict, HiStory, Favorites, WatchLater, Latest){

        $scope.showEmptyState = true;
        $scope.suggestedNews = [];
        $scope.showFooter = false;


        /*********************
        ***   SUGGESTION   ***
        *********************/

        var getSuggestions = function(){
            Latest.get({
                size: Config.get('MYSPACE_SUGGESTED_ITEMS'),
                offset: 0
            }).$promise.then(function(data){
                $scope.suggestedNews = data;
            });
        };


        /*********************
        ***   GET ITEMS    ***
        **********************/

        User.getStatus(function(user){
            var totalElements = 0;

            if(user.logged){
                $q.all([
                    HiStory.getList().$promise,
                    Favorites.getList().$promise,
                    WatchLater.getList().$promise
                ]).then(function(resp){
                    var history = resp[0];
                    var favorites = resp[1];
                    var watchlater = resp[2];
                    var historyTotal = parseInt(history.headers('x-available-contents'), 0) || 0;
                    var favoritesTotal = parseInt(favorites.headers('x-available-contents'), 0) || 0;
                    var watchlaterTotal = parseInt(watchlater.headers('x-available-contents'), 0) || 0;
                    totalElements = historyTotal + favoritesTotal + watchlaterTotal;

                    // TODO: add dict key for "title"
                    $scope.userPlaylist = [{
                        title: Dict.get('WEBAPP_MYSPACE_FAVOURITES_TITLE'),
                        icon: 'icon-favourites',
                        url: Config.get('ROUTER_FAVORITES'),
                        image: favorites.data[0] ? favorites.data[0].images.cover.ratio_1_4 : '',
                        items: favoritesTotal
                    }, {
                        title: Dict.get('WEBAPP_MYSPACE_WATCHLATER_TITLE'),
                        icon: 'icon-read_later',
                        url: Config.get('ROUTER_WATCHLATER'),
                        image: watchlater.data[0] ? watchlater.data[0].images.cover.ratio_1_4 : '',
                        items: watchlaterTotal
                    }, {
                        title: Dict.get('WEBAPP_MYSPACE_HISTORY_TITLE'),
                        icon: 'icon-history',
                        url: Config.get('ROUTER_HISTORY'),
                        image: history.data[0] ? history.data[0].images.cover.ratio_1_4 : '',
                        items: historyTotal
                    }];

                    if(totalElements === 0){
                        getSuggestions();
                    } else {
                        $scope.showEmptyState = false;
                    }

                    $scope.showFooter = true;
                }).catch(function(){
                    getSuggestions();
                    $scope.showFooter = true;

                });
            } else {
                getSuggestions();
                $scope.showFooter = true;

            }
        });


        /*********************
        ***    TRACKING    ***
        *********************/

        $scope.trackClickPlaylist = function(event, title){
            JsAnalytics.trackEvent({
                category: 'MySpace Page',
                action: 'Click',
                label: title
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'MySpace Page',
                    label: title
                }
            });

            Browser.clickAndGo(event);
        };

        $scope.trackClickSuggested = function(event, title, index){
            JsAnalytics.trackEvent({
                category: 'MySpace Page',
                action: 'Click',
                label: title
            });

            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: 'MySpace Page',
                    label: title,
                    position: parseInt(index, 10) + 1
                }
            });

            Browser.clickAndGo(event);
        };
    }
]);

angular.module('news').controller('PlaylistCtrl', [
    '$scope', '$route', 'BarneyDict', 'BarneyConfig', 'BarneyBrowser', 'Model', '$dModal', 'Myspace', '$timeout', 'Utility',
    function($scope, $route, Dict, Config, Browser, Model, $dModal, Myspace, $timeout, Utility){


        var offset = 0;
        var total = 0;
        var counterSize = 0;
        $scope.playlistItems = [];
        $scope.enableInfinite = true;
        $scope.showFooter = false;
        $scope.showTrash = false;
        $scope.hideEmpityListMess = true;
        $scope.gettingResult = false;
        $scope.title = $route.current.$$route.params.title;
        $scope.section = $route.current.$$route.params.section;
        $scope.backButton = function(){
            window.history.back();
        };
        var removeItemFromMyspaceSection = ['Favorites', 'Watchlater'];

        $scope.getPlaylistItems = function(reenableInfinite){
            // show loader
            $scope.gettingResult = true;
            Model.getList({
                size: Config.get('TEMPLATING_PLAYLIST_SIZE'),
                offset: counterSize
            }, function(resp){
                // save total element, only first time
                if(!total){ total = parseInt(resp.headers('x-available-contents'), 0); }
                // concat new elements to the array
                $scope.playlistItems = $scope.playlistItems.concat(resp.data);
                // increment offset
                offset += resp.data.length;
                counterSize += Config.get('TEMPLATING_PLAYLIST_SIZE');
                // if offset is less than total elements, or the API returned a void array
                // then, do not load more content, disable infinite scroll.
                if(offset < total){
                    if(resp.data.length){  // The total number of items is not really the real number of items! :(
                        reenableInfinite();
                    } else {
                        $scope.enableInfinite = false;
                    }
                } else {
                    $scope.enableInfinite = false;
                }
                if(!$scope.showFooter){
                    $scope.showFooter = true;
                }
                // hide loader
                $scope.gettingResult = false;
                /*******************************/
                /* Enable icon to remove item */
                /*******************************/
                if($scope.playlistItems.length > 0 && (removeItemFromMyspaceSection.indexOf($route.current.$$route.params.title) !== -1)){
                    $scope.showTrash = true;
                    $scope.hideEmpityListMess = true;
                }else if(!$scope.playlistItems.length > 0 && (removeItemFromMyspaceSection.indexOf($route.current.$$route.params.title) !== -1)){
                    $scope.hideEmpityListMess = false;
                }


            });

        };
        $scope.trackClickPlaylist = function(newsTitle, newsIndex){
            JsAnalytics.trackEvent({
                category: $scope.title + 'List',
                action: 'Click',
                label: newsTitle
            });
            NewtonAdapter.trackEvent({
                name: 'Click',
                properties: {
                    category: $scope.title + 'List',
                    label: newsTitle,
                    position: parseInt(newsIndex, 10) + 1
                }
            });
        };

        // Track Page view of snowplow
        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')){
            window.snowplow('trackPageView', {
                context: [{
                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                    data: {
                        kind_of_page: 'servicepage'
                    }
                }]
            });
        }

        /*******************************
         * Remove all item from myspace
         ******************************/
        $scope.isfadeOutItem = false;
        $scope.clickFrom = 'allitem';
        $scope.removeItemFromMyspace = function (params) {

            var idslist = '';
            if(params instanceof Array){
                var ids = [];
                angular.forEach(params, function (param, index) {
                    ids.push(param.id_item_collection);
                });
                idslist = ids.join();
            }
            $dModal.open({
                url: Utility.getTemplatePrefix() + '/modules/modal/modal.html',
                clickFrom: $scope.clickFrom,
                onConfirm: function() {
                    Myspace.removeMyspaceItem(idslist, $scope.section).$promise.then(function(data){
                        $scope.isfadeOutItem = true;
                        if(data.status === 200){
                            $timeout(function() {
                                $scope.playlistItems.splice(0, $scope.playlistItems.length);
                                $dModal.close();
                                $scope.showTrash = false;
                                $scope.hideEmpityListMess = false;
                            }, 800);
                        }
                    });
                }
            });

        };


    }
]);



angular.module('news').directive('zoomSection', [
    '$rootScope', '$routeParams', '$location', '$window', '$timeout', 'imagesizeFilter', 'setDateFieldFilter', 'Zoom', 'BarneyBrowser', 'BarneyConfig', 'BarneyMeta', 'BarneyDict', 'User', 'Tag', 'SocialSVC', 'GoogleManager', 'MetaTitleManager', 'HiStory', 'EventThrottler', 'EventBus', 'Utility', '$dModal', 
    function($rootScope, $routeParams, $location, $window, $timeout, imagesize, setDateField, Zoom, Browser, Config, Meta, Dict, User, Tag, SocialSvc, GoogleManager, MetaTitleManager, HiStory, EventThrottler, Bus, Utility, $dModal){
        return {
            restrict: 'E',
            templateUrl: Utility.getTemplatePrefix() + '/modules/zoom/' + Config.get('TEMPLATING_ZOOM') + '.html',
            scope: {
                zoomId: '@?',
                content: '=?',
                isMainNews: '=?',
                onRelatedLoaded: '&?',
                isWifi: '=?'
            },
            link: function($scope, $element, $attr){

                /*******************
                ***  INIT VARS   ***
                *******************/
                var idToExclude = '' + $routeParams.zoomId;

                $scope.zoomName = $routeParams.zoomName;
                $scope.tagNews = [];
                $scope.text = '';
                $scope.textExpanded = false;
                $scope.showContents = false;
                $scope.canPlay = false;
                $scope.showCallToAction = false;
                $scope.images = [];
                $scope.hideSocialBlock = false;
                $scope.favorite = {};
                $scope.watchlater = {};
                $scope.downloadData = {};
                $scope.showCBDownloadButton = false;
                $scope.hideReadMoreButton = false;
                $scope.personalizationRedirect = '#!' + Config.get('ROUTER_LOGIN');
                $scope.suggestedClip = [];
                var downloadFormat = Config.get('DOWNLOAD_FORMAT_WEBAPP');

                var metaTagThrottler = function(){};

                var listenersAttached = false;
                $scope.iframe = null;
                $scope.$watch('text', function(current) {
                    if (current && !listenersAttached) {
                        setTimeout(function() {
                            const match = /<iframe/;
                            if (match.test($scope.text)) {
                                var components = iFrameResize({
                                    log: false,
                                    checkOrigin: false,
                                    heightCalculationMethod: 'taggedElement'
                                }, 'p > iframe');
                                $scope.iframe = components && components.length ? components[0] : null;
                            }
                        }, 0);
                        listenersAttached = true;
                    }
                });

                $scope.$on('$destroy', function() {
                    if ($scope.iframe && $scope.iframe.iframeResizer) {
                        $scope.iframe.iframeResizer.close();
                    }
                });

                // Internal video dld
                $scope.postMessageCallback = function(downloadData){
                    $timeout(function(){
                        $scope.downloadData = downloadData;
                    }, 1);
                };

                var isMobileDevice = Config.get('UA') !== 'DESKTOP';
                $scope.showZoomInteraction = Config.get('ENABLE_NEWTON_USER') && Config.get('ENABLE_MYSPACE');

                if((Config.get('HIDE_ALL_SOCIAL')) ||
                    (!Config.get('FACEBOOK_SHARE_ENABLED') && !Config.get('TWITTER_SHARE_ENABLED') && Config.get('UA') === 'DESKTOP') ||
                    (!Config.get('FACEBOOK_SHARE_ENABLED') && !Config.get('TWITTER_SHARE_ENABLED') && !Config.get('WHATSAPP_SHARE_ENABLED'))) {
                    $scope.hideSocialBlock = true;
                } else {
                    $scope.hideSocialBlock = false;
                }

                $scope.retrieveZoomDatas = function(data){
                    if(Config.get('PERSONALIZATION_GOES_TO_LANDING') && Config.get('ENABLE_NEWTON_USER')){
                        $scope.personalizationRedirect = data.url_leaf_engine_subscription;
                    }

                    var imagesObject = {
                        url_leaf_engine_subscription: data.url_leaf_engine_subscription,
                        aspect: data.images.cover.ratio_1_aspect,
                        nonFilteredUrl: data.images.cover.ratio_1,
                        src: imagesize(data.images.cover.ratio_1, 'zoom', 'big', data.images.cover.ratio_1_aspect),
                        title: data.title
                    };

                    var imgSizeConf = Config.get('IMG_SIZES'),
                        ratio = Config.get('USED_RATIO') ? Config.get('USED_RATIO').split(':') : [4, 3], // fallback, perchè sai mai.
                        imgW = parseInt(imgSizeConf.zoom.big, 10),
                        imgH = Math.round((imgW / parseInt(ratio[0], 10)) * parseInt(ratio[1], 10));

                    if(data.images.cover.ratio_1_aspect === 'vertical'){
                        imagesObject.w = imgH;
                        imagesObject.h = imgW;
                    } else {
                        imagesObject.w = imgW;
                        imagesObject.h = imgH;
                    }
                    $scope.images.push(imagesObject);

                    $scope.item = data;

                    if ((!Config.get('ENABLE_DOWNLOAD_FEATURE') && data.is_downloadable && data.has_download_url && data.url_api_download)
                        || (Config.get('DOWNLOAD_FEATURE_WEBAPP') && isMobileDevice && !data.is_downloadable && !data.has_download_url && data.appid && downloadFormat.indexOf(data.format) !== -1)) {

                        $scope.downloadData = {
                            zoomId: data.category ? data.category.id : '',
                            zoomTitle: data.title,
                            callback: function (resp) {
                                if (resp.status !== 'undefined') {
                                    if (resp.status === 200) {
                                        JsLogger.log('Download started successfully!');
                                    } else {
                                        JsLogger.warn('Error', resp);
                                        window.location.href = Config.get('ROUTER_ERROR') + '?code=' + resp.status;
                                    }
                                } else {
                                    JsLogger.log('Generic error while downloading the content!');
                                }
                            },
                            isDownloadable: data.is_downloadable,
                            hasDownloadUrl: data.has_download_url,
                            downloadUrl: data.url_api_download,
                            urlLeafEngine: data.url_leaf_engine_subscription,
                            appId: data.appid ? data.appid : null,
                            format: data.format ? data.format : null,
                            size: data.size ? data.size : null
                        };

                        if (Config.get('DOWNLOAD_FEATURE_WEBAPP')){
                            $scope.showPHDownloadButton = true;
                        } else {
                            $scope.showCBDownloadButton = true;
                        }
                    }

                    // API Calls (3/4) : get tag news
                    if($scope.item.tags.length > 0){
                        $scope.tag = $scope.item.tags[0];

                        Tag.get({
                            tag: $scope.item.tags[0].slug,
                            size: Config.get('TEMPLATING_ZOOM_TAG_SIZE') + 1
                        }).$promise.then(function(tags){
                            for(var k = 0; (k < tags.length && $scope.tagNews.length < Config.get('TEMPLATING_ZOOM_TAG_SIZE')); k++){
                                if(tags[k].id !== $scope.zoomId){
                                    $scope.tagNews.push(tags[k]);
                                }
                            }
                        });
                    }


                    /**************************
                    ******  USER ACCESS  ******
                    **************************/

                    var redirect = function(resp){
                        var urlToRedirect;
                        if(resp.url){
                            urlToRedirect = resp.url;
                        } else if(resp.config_key){
                            urlToRedirect = Config.get(resp.config_key);
                        } else if(resp.item_field){
                            urlToRedirect = $scope.item[resp.item_field];
                        } else {
                            JsLogger.error('UserAccess', 'invalid redirect field');
                        }
                        if($rootScope.campaignRecognition){
                            urlToRedirect += (urlToRedirect.indexOf('?') === -1) ? '?' : '&';
                            urlToRedirect += 'cr=' + $rootScope.campaignRecognition;
                        }
                        $window.location.href = urlToRedirect;
                    };

                    var showPartialText = function(){
                        $scope.text = $scope.item.abstract;
                        $scope.hideReadMoreButton = Config.get('NOT_CANUSE_HIDE_READMORE_BUTTON');
                        $scope.textExpanded = false;
                        $scope.showContents = true;
                    };

                    var showCompleteText = function(){
                        $scope.text = $scope.item.description;
                        $scope.textExpanded = true;
                        $scope.showContents = true;
                        $scope.canPlay = true;
                    };

                    var trackReadMore = function(){
                        JsAnalytics.trackEvent({
                            category: 'Zoom Page',
                            action: 'Read',
                            label: $scope.item.default_title || $scope.item.title
                        });
                        NewtonAdapter.trackEvent({
                            name: 'Read',
                            properties: {
                                category: 'Zoom Page',
                                title: $scope.item.default_title || $scope.item.title,
                                label: $scope.zoomId
                            }
                        });
                    };

                    var setSuggestedVideo = function() {
                        if($scope.item.custom_content_type === 'video' &&
                        Config.get('SHOW_SUGGESTION_AT_VIDEO_END') && !$scope.item.is_360_video) {

                            if(idToExclude !== $scope.item.id) {
                                idToExclude = idToExclude + ',' + $scope.item.id; //Exclude main zoom content and the id of the content
                            }

                            Tag.getSuggestedVideo({
                                content_id: $scope.item.id,
                                size: Config.get('TEMPLATING_ZOOM_TAG_SUGGESTED_SIZE'), // for now 1
                                exclude_ids: idToExclude
                            }).$promise.then(function(resp) {
                                if(resp.length > 0) {
                                    $scope.suggestedClip.push(resp[0]);
                                }
                            });
                        }
                    };

                    function openModalSuspended() {
                        $dModal.open({
                            url: Utility.getTemplatePrefix() + '/modules/modal/suspendedUserModal.html',
                            clickFrom: $scope.clickFrom,
                            onConfirm: function() {
                                $dModal.close();
                                var rechargeUrl = Dict.get('WEBAPP_SUSPENDED_USER_LINK');
                                if (rechargeUrl && !Config.get('SUSPENDED_REDIRECT_BACK')) {
                                    $window.location.href = rechargeUrl;
                                    return;
                                }
                                var prevPath = Browser.getPrevPath();
                                if (prevPath) {
                                    $window.history.back();
                                } else {
                                    $location.url('/');
                                }
                            }
                        });
                    }

                    User.canUse($scope.zoomId, !$scope.isMainNews, function(userCanUse){

                        //Aggiunto caso suspended - all'inizio in modo da non incasinare il resto dei casi
                        if (JsStorage.get('suspended', { type: 'cookie' }) || (userCanUse.canuse === 0 && userCanUse.do[0] === Config.get('CANUSE_USER_SUSPENDED_FIELD'))) {
                            //console.log('suspended - canuse', userCanUse);
                            showPartialText();
                            $scope.readMore = function(){
                                trackReadMore();
                                console.log('User suspended');
                                openModalSuspended();
                            };
                            openModalSuspended();
                            //MODAL
                        } else {
                            /* eslint-disable no-lonely-if */
                            if(Config.get('IS_FREE')){
                                // (0) read now
                                JsLogger.log('UserAccess', 0, 'Read now');
                                showCompleteText();
                                setSuggestedVideo();

                            } else if(!userCanUse.do){
                                if(userCanUse.status === 200){
                                    // (1) read now
                                    JsLogger.log('UserAccess', 1, 'Read now');
                                    showCompleteText();
                                    setSuggestedVideo();
                                } else if(userCanUse.status === 302){
                                    // (3) redirect now
                                    JsLogger.log('UserAccess', 3, 'Redirect now');
                                    redirect(userCanUse);
                                } else {
                                    JsLogger.error('UserAccess', 'invalid status, with do[0] undefined');
                                }

                            } else if(userCanUse.do[0] === 'show_button'){
                                showPartialText();

                                if(!userCanUse.do[1]){
                                    if(userCanUse.status === 200){
                                        // (2) read after
                                        JsLogger.log('UserAccess', 3, 'Read after');
                                        $scope.canPlay = true;
                                        setSuggestedVideo();

                                        $scope.readMore = function(){
                                            trackReadMore();
                                            showCompleteText();
                                        };
                                    } else if(userCanUse.status === 303){
                                        // (4) redirect after
                                        JsLogger.log('UserAccess', 4, 'Redirect after');
                                        $scope.readMore = function(){
                                            trackReadMore();
                                            redirect(userCanUse);
                                        };
                                    } else {
                                        JsLogger.error('UserAccess', 'invalid status, with do[1] undefined');
                                    }

                                } else if(userCanUse.do[1] === 'show_paywall'){
                                    // (5) paywall after
                                    JsLogger.log('UserAccess', 5, 'Paywall after');
                                    $scope.readMore = function(){
                                        trackReadMore();
                                        console.log('Paywall not enabled');
                                    };

                                } else {
                                    JsLogger.error('UserAccess', 'invalid do[1]');
                                }
                            } else {
                                JsLogger.error('UserAccess', 'invalid do[0]');
                            }

                        } //end else della condizione suspended
                    });


                    /*******************
                    ***   METATAGS   ***
                    *******************/

                    var setMetaTag = function(){
                        if(Meta.get('title').indexOf($scope.item.title) < 0){
                            Meta.set({
                                title: MetaTitleManager.getMetaTitle({
                                    maskType: 'zoom',
                                    content: $scope.item.title,
                                    noMaskValue: $scope.item.title + ' ' + Dict.get('SEO_WEBAPP_TITLE_ZOOM')
                                }),
                                description: $scope.item.abstract,
                                ogTitle: $scope.item.title,
                                ogDescription: $scope.item.abstract,
                                ogUrl: $location.absUrl(),
                                ogImage: imagesize($scope.item.images.cover.ratio_1, 'zoom', 'big'),
                                ogUpdatedTime: setDateField($scope.item, 'updated_date', true),
                                ogImageWidth: imagesObject.w,
                                ogImageHeight: imagesObject.h,
                                jsonld: JSON.stringify({
                                    '@context': 'http://schema.org',
                                    '@type': 'NewsArticle',
                                    mainEntityOfPage: {
                                        '@type': 'WebPage',
                                        '@id': $location.absUrl()
                                    },
                                    headline: $scope.item.title,
                                    image: {
                                        '@type': 'ImageObject',
                                        url: imagesize($scope.item.images.cover.ratio_1, 'zoom', 'big'),
                                        height: 768,
                                        width: 1024
                                    },
                                    datePublished: setDateField($scope.item),
                                    dateModified: setDateField($scope.item),
                                    author: {
                                        '@type': 'Person',
                                        name: Dict.get('SEO_WEBAPP_JSONLD_NAME')
                                    },
                                    publisher: {
                                        '@type': 'Organization',
                                        name: Dict.get('SEO_WEBAPP_TITLE_COUNTRY'),
                                        logo: {
                                            '@type': 'ImageObject',
                                            url: Config.get('IMG_DEST_DOMAIN') + Config.get('IMG_COMMON_PREFIX') + '/images/general/logo-header.png',
                                            width: 230,
                                            height: 30
                                        }
                                    },
                                    description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX')
                                })
                            }, function(){
                                GoogleManager.set({
                                    'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_CONTENT'),
                                    'Tipo de pagina /h': Dict.get('WEBAPP_NAVIGATION_SERVICE_CONTENT_H'),
                                    Contenido: $scope.item.title,
                                    'Contenido /h': $scope.item.title,
                                    event: 'changePage'
                                });
                            });
                        }
                    };

                    var setMetaTagOnScroll = function() {
                        var containerZoom = document.getElementById($scope.zoomId);

                        if(containerZoom && containerZoom.getBoundingClientRect().top <= window.innerHeight - 300 && containerZoom.getBoundingClientRect().top >= 0){
                            setMetaTag();
                        }
                    };

                    /***********************
                    ***  CALL-TO-ACTION  ***
                    ***********************/

                    if(Config.get('SHOW_ZOOM_BUTTON')){
                        if(Config.get('SHOW_ZOOM_BUTTON_FOR_LOGGED')){
                            User.getStatus(function(user){
                                $scope.showCallToAction = user.logged;
                            });
                        } else {
                            $scope.showCallToAction = true;
                        }
                    }


                    /*******************
                    ***  TRACKING 1  ***
                    *******************/

                    var prevPage = !!Browser.getPrevState() && !!Browser.getPrevState().className ? Browser.getPrevState().className : null;

                    var trackPageView = function(){
                        JsAnalytics.trackEvent({
                            category: 'Zoom Page',
                            action: $scope.isMainNews ? 'Play' : 'PlayScroll',
                            label: $scope.item.default_title || $scope.item.title,
                            dimensions: {
                                Valuable: 'Yes'
                            }
                        });

                        NewtonAdapter.trackEvent({
                            name: $scope.isMainNews ? 'Play' : 'PlayScroll',
                            properties: {
                                category: 'Zoom Page',
                                title: $scope.item.default_title || $scope.item.title,
                                label: $scope.zoomId,
                                page: prevPage,
                                valuable: 'Yes'
                            }
                        });

                        if(Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter){
                            facebookpixeladapter.pageView();
                        }
                        // Track Page view of snowplow
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackPageView', {
                                context: [{
                                    schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                                    data: {
                                        kind_of_page: 'servicepage'
                                    }
                                }]
                            });
                        }
                    };

                    trackPageView();

                    if(!Config.get('ENABLE_ZOOM_INFINITE')) {
                        setMetaTag();
                    } else {
                        if($scope.isMainNews){
                            setMetaTag();
                        }

                        metaTagThrottler = new EventThrottler(setMetaTagOnScroll, 50);
                        window.addEventListener('scroll', metaTagThrottler);
                    }


                    /**************************
                    ****  TWITTER LISTENER  ***
                    **************************/
                    if(Config.get('TWITTER_SHARE_ENABLED')){
                        //Not defined in directive because it execute the event many time as the number of the directive present in DOM
                        twttr.ready(function (twttr) {
                            twttr.events.bind('tweet', function (event) {
                                JsAnalytics.trackEvent({
                                    category: 'Zoom Page',
                                    action: 'ShareTW',
                                    label: $scope.item.default_title || $scope.item.title
                                });

                                NewtonAdapter.trackEvent({
                                    name: 'ShareTW',
                                    properties: {
                                        category: 'Zoom Page',
                                        label: $scope.zoomId,
                                        title: $scope.item.default_title || $scope.item.title
                                    }
                                });
                            });
                        });

                        $scope.$on('$destroy', function(){
                            window.removeEventListener('scroll', metaTagThrottler);
                            twttr.events.unbind('tweet');
                        });
                    }

                    /**************************
                    ****  PERSONALISATION  ****
                    **************************/

                    User.getStatus(function(user){
                        if(user.logged && Config.get('ENABLE_NEWTON_USER')){
                            $scope.enablePersonalization = true;
                            if(Config.get('ENABLE_HISTORY') && Config.get('ENABLE_HISTORY_SET_ZOOM') && $scope.isMainNews){
                                HiStory.set({
                                    contentType: $scope.item.collection_content_type,
                                    contentId: $scope.zoomId,
                                    categoryId: $scope.item.category ? $scope.item.category.id : ''
                                });
                            }
                        } else {
                            $scope.enablePersonalization = false;
                        }
                    });
                };


                /*******************
                ***  API CALLS   ***
                *******************/
                if(typeof $scope.content === 'undefined') {
                    // API Calls (1/4) : get zoom info
                    Zoom.get({
                        content_id: $scope.zoomId
                    }).$promise.then(function(data){
                        $scope.retrieveZoomDatas(data);

                        // API Calls (2/4) : get related items
                        Zoom.getRelated({
                            size: Config.get('TEMPLATING_ZOOM_RELATED_SIZE'),
                            content_id: $scope.zoomId
                        }).$promise.then(function(related){
                            $scope.related = related;

                            if (Config.get('ENABLE_ZOOM_INFINITE')) {
                                $scope.onRelatedLoaded()($scope.related);
                            }
                        });
                    });
                } else {
                    $scope.retrieveZoomDatas($scope.content);
                }

                /*******************
                ***  SLIDER ITEM ***
                *******************/
                if (Config.get('ENABLE_SLIDER_ITEM')) {
                    var sliderItems;
                    var ItemOpts = {
                        type: 'slider',
                        startAt: 0,
                        gap: 10,
                        focusA: 0,
                        bound: true,
                        peek: {
                            before: 0,
                            after: 50
                        },
                        perView: 6,
                        breakpoints: {
                            320: {
                                perView: 2
                            },
                            680: {
                                perView: 2
                            },
                            768: {
                                perView: 4
                            },
                            1024: {
                                perView: 6
                            }
                        }
                    };

                    if ($scope.ItemOpts && Config.get($scope.ItemOpts)) {
                        //mergia la conf qui sopra con una presa dal vhost, se c'è. (mettere doppi apici su tutte le chiavi, v. esempio LEADERBOARD_SLIDER_CONF su gameasy.conf)
                        //così puoi fare solo l'override di alcune opzioni e aggiungerne, 
                        //e mantiene uguali le opzioni che non sovrascrivi.
                        angular.merge(ItemOpts, Config.get($scope.ItemOpts));
                    }

                    var mountSlider = function (els) {
                        if ($scope.sliderItems === 'slider') {
                            //qui si prendono tutti gli elementi e gli si dice di rimetterci 
                            //l'onclick tutte le volte che vngono clonati per fare il carousel infinito
                            // NOTA BENE: in questo caso non serve perchè c'è un link normale e non un bottone con un evento attaccato. 
                            // Lo lascio qui per riferimento.
                            /*
                            slider.on('mount.after', function() {
                                var elements = $element[0].querySelectorAll('.glide__slide--clone');
                                angular.forEach(elements, function(el) {
                                    el.addEventListener('click', function() {
                                        var index = el.dataset.itemindex;
                                        var item = $scope.items[index];
                                        if (item) {
                                            $scope.itemPlay(item, true, index + 1, 'custom');
                                        }
                                    });
                                });
                            });
                            */
                        }

                        if (els) {
                            //qui se ci sono effettivamente i contenuti
                            //definisco lo slider e lo monto.
                            if (document.querySelector('.sliderItems')) {
                                sliderItems = new Glide('.sliderItems', ItemOpts);
                                setTimeout(function () {
                                    sliderItems.mount();
                                }, 250);
                            }
                        }
                    };

                    $scope.$watch('related', function (newValue, oldValue) {
                        //quando cambia il valore di $scope.slides, se non è vuoto, faccio partire lo slider
                        if (newValue || oldValue) {
                            mountSlider($scope.related);
                        }
                    });
                }                

                /*******************
                ***  TRACKING 2  ***
                *******************/

                $scope.trackPersonalization = function(action){

                    var name;

                    switch(action){
                    case 'watchlater-add':
                        name = 'AddWatchlater';
                        break;
                    case 'watchlater-remove':
                        name = 'RemoveWatchlater';
                        break;
                    case 'favorites-add':
                        name = 'AddFavorite';
                        break;
                    case 'favorites-remove':
                        name = 'RemoveFavorite';
                        break;
                    default:
                        JsLogger.error('trackPersonalization', 'invalid action name: ' + action);
                    }

                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: name,
                        label: $scope.item.default_title || $scope.item.title
                    });
                    NewtonAdapter.trackEvent({
                        name: name,
                        properties: {
                            url: $window.location.href,
                            title: $scope.item.default_title || $scope.item.title
                        }
                    });
                };

                $scope.trackClickCat = function(event, catTitle){
                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'ClickCat',
                        label: catTitle
                    });

                    NewtonAdapter.trackEvent({
                        name: 'ClickCat',
                        properties: {
                            category: 'Zoom Page',
                            label: catTitle
                        }
                    });

                    Browser.clickAndGo(event);
                };

                $scope.trackClickTag = function(event, tagTitle){
                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'ClickTag',
                        label: tagTitle
                    });

                    NewtonAdapter.trackEvent({
                        name: 'ClickTag',
                        properties: {
                            category: 'Zoom Page',
                            label: tagTitle
                        }
                    });

                    Browser.clickAndGo(event);
                };

                $scope.trackClickRelated = function(newsTitle, newsIndex){
                    var action = '';

                    if(newsIndex === 0){
                        action = 'ClickPrev';
                    } else {
                        action = 'ClickNext';
                    }

                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: action,
                        label: newsTitle
                    });

                    NewtonAdapter.trackEvent({
                        name: action,
                        properties: {
                            category: 'Zoom Page',
                            label: newsTitle
                        }
                    });
                };

                $scope.trackClickSimilar = function(newsTitle, newsIndex){
                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'ClickSimilar',
                        label: newsTitle
                    });

                    NewtonAdapter.trackEvent({
                        name: 'ClickSimilar',
                        properties: {
                            category: 'Zoom Page',
                            label: newsTitle,
                            position: parseInt(newsIndex, 10) + 1
                        }
                    });
                };

                /**********************************
                * Functions to track the actions
                * on button favorites/Watchlater
                **********************************/

                //favorites-add
                var favoritesAdd = function(){

                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'Add Favorite',
                        label: $scope.item.default_title || $scope.item.title
                    });

                    NewtonAdapter.trackEvent({
                        name: 'AddFavorite',
                        properties: {
                            url: $window.location.href,
                            title: $scope.item.default_title || $scope.item.title
                        }
                    });
                };
                //favorites-remove
                var favoritesRemove = function(){
                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'Remove Favorite',
                        label: $scope.item.default_title || $scope.item.title
                    });

                    NewtonAdapter.trackEvent({
                        name: 'RemoveFavorite',
                        properties: {
                            url: ($window.location.href),
                            title: $scope.item.default_title || $scope.item.title
                        }
                    });
                };
                //watchlater-add
                var watchlaterAdd = function (){
                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'Add Watchlater',
                        label: $scope.item.default_title || $scope.item.title
                    });

                    NewtonAdapter.trackEvent({
                        name: 'AddWatchlater',
                        properties: {
                            url: $window.location.href,
                            title: $scope.item.default_title || $scope.item.title
                        }
                    });
                };

                //watchlater-remove
                var watchlaterRemove = function(){
                    JsAnalytics.trackEvent({
                        category: 'Zoom Page',
                        action: 'Remove Watchlater',
                        label: $scope.item.default_title || $scope.item.title
                    });

                    NewtonAdapter.trackEvent({
                        name: 'RemoveWatchlater',
                        properties: {
                            url: $window.location.href,
                            title: $scope.item.default_title || $scope.item.title
                        }
                    });
                };

                /************************
                ***  MARK AS VISITED  ***
                ************************/

                if (Config.get('ENABLE_ALREADY_VISITED') && JsStorage.isLocalStorageSupported() && Array.prototype.indexOf){
                    $timeout(function() {
                        var readItems = JsStorage.get('visitedContents', { type: 'localstorage' });
                        var visited = readItems && readItems.length ? JSON.parse(readItems) : [];
                        if (visited.indexOf($scope.zoomId) === -1) {
                            visited.push($scope.zoomId);
                            if (visited.length >= parseInt(Config.get('VISITED_MAX_ITEMS'), 10)) {
                                visited.shift();
                            }
                            JsStorage.set('visitedContents', JSON.stringify(visited), { type: 'localstorage' });
                        }
                    }, parseInt(Config.get('VISITED_SAVE_TIMER'), 10));
                }
            }
        };
    }
]);

angular.module('news').controller('ZoomParentCtrl', [
    '$scope', '$routeParams', 'EventThrottler', 'Settings',
    function($scope, $routeParams, EventThrottler, Settings){
        var heartbeatProps = {
            name: 'ImagazineZoom',
            properties: {
                category: 'Heartbeat Zoom',
                label: $routeParams.zoomName
            }
        };

        var visibleItemIndex = 0;
        var populateZoomThrottler = null;
        var zoomElement = null;
        var loadingContentEnd = false;

        $scope.showContents = true;
        $scope.relatedHasLoaded = false;

        $scope.itemId = $routeParams.zoomId;

        $scope.zoomSectionArray = [];
        $scope.zoomVisibleItems = [];

        $scope.isWifi = false;

        Settings.getNetworkProperty().$promise.then(function(resp){
            if (typeof resp.networkType !== 'undefined' && resp.networkType !== 'mobile') {
                $scope.isWifi = true;
            }
        });

        // FALLBACK FOR STOP SCROLLING IN END OF PAGE
        var interval = setInterval(function() {
            if(Math.abs(document.body.getBoundingClientRect().top) + document.body.offsetHeight === document.body.scrollHeight) {
                populateZoom();
            }
        }, 500);

        function populateZoom() {
            if($scope.zoomSectionArray.length !== visibleItemIndex) {
                $scope.zoomVisibleItems.push($scope.zoomSectionArray[visibleItemIndex]);
                visibleItemIndex += 1;
            } else {
                window.removeEventListener('scroll', populateZoomThrottler);
                clearInterval(interval);
                loadingContentEnd = true;
            }
        }

        NewtonAdapter.startHeartbeat(heartbeatProps);

        var scrollForPopulate = function() {
            if (!zoomElement) {
                zoomElement = document.getElementById($scope.zoomVisibleItems[visibleItemIndex - 1].id);
            } else if (zoomElement.getBoundingClientRect().top + zoomElement.clientHeight < (window.innerHeight) || (Math.abs(document.body.getBoundingClientRect().top) + document.body.offsetHeight === document.body.scrollHeight)) {
                populateZoom();
            }
        };

        $scope.relatedLoaded = function(related){
            $scope.zoomSectionArray = related;

            // PUSH FIRST ITEM OF RELATED ON LOAD
            $scope.zoomVisibleItems.push($scope.zoomSectionArray[visibleItemIndex]);
            visibleItemIndex += 1;
            $scope.relatedHasLoaded = true;

            // ACTIVATE LISTEN ON SCROLL
            populateZoomThrottler = new EventThrottler(scrollForPopulate, 100);
            window.addEventListener('scroll', populateZoomThrottler);
        };

        $scope.$on('$destroy', function(){
            NewtonAdapter.stopHeartbeat(heartbeatProps);

            if (!loadingContentEnd) {
                window.removeEventListener('scroll', populateZoomThrottler);
                clearInterval(interval);
            }
        });
    }
]);

'use strict';

angular.module('news').controller('VideoListCtrl',
    ['$scope', '$routeParams', '$window', 'BarneyMeta', 'BarneyDict', 'BarneyConfig', 'Video',
        function($scope, $routeParams, $window, Meta, Dict, Config, Video){

            var size = Config.get('TEMPLATING_VIDEO_SIZE');
            var offset = 0;
            var videoEnabled = true;

            $scope.otherVideos = [];
            $scope.firstVideos = [];
            $scope.showCategoriesLoader = false;
            $scope.showFooter = true;

            if(!Config.get('ENABLE_CUSTOM_VIDEO_SECTION')){
                $window.location.href = '/';
            }

            /*******************
            ***  API CALLS   ***
            *******************/


            $scope.getVideoList = function(reenableInfinite){
                // API Calls (1/2) : get video list
                Video.getList({
                    size: size,
                    offset: offset
                }).$promise.then(function(data){
                    // re-enable infinite scroll, if conditions are satisfied
                    if(data.length > 0 && data.length === size){
                        reenableInfinite();
                    }

                    if(offset === 0){
                        $scope.firstVideo = data.splice(0, Config.get('TEMPLATING_VIDEO_FIRST'));
                    }

                    $scope.otherVideos = $scope.otherVideos.concat(data);

                    offset += size;
                });
            };

            /***********************
            ***  INFINITE ON/OFF ***
            ***********************/

            if(videoEnabled){
                $scope.gettingVideos = true;
            }


            /*************************
            ***  ANALYTICS/NEWTON  ***
            *************************/

            $scope.trackClickResult = function(videoIndex, videoTitle){
                JsAnalytics.trackEvent({
                    category: 'Video List',
                    action: 'Click',
                    label: videoTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'Click',
                    properties: {
                        category: 'Video List',
                        label: videoTitle,
                        position: parseInt(videoIndex, 10) + 1
                    }
                });
            };

            // Track Page view of snowplow
            if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')){
                window.snowplow('trackPageView', {
                    context: [{
                        schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                        data: {
                            kind_of_page: 'servicepage'
                        }
                    }]
                });
            }

            $scope.trackClickOther = function(videoIndex, videoTitle){
                JsAnalytics.trackEvent({
                    category: 'Video List',
                    action: 'Click',
                    label: videoTitle
                });

                NewtonAdapter.trackEvent({
                    name: 'Click',
                    properties: {
                        category: 'Video List',
                        label: videoTitle,
                        position: parseInt(videoIndex, 10) + Config.get('TEMPLATING_VIDEO_FIRST') + 1
                    }
                });
            };

        }
    ]
);

'use strict';

angular.module('news').controller('VideoZoomCtrl', [
    '$scope', '$routeParams', '$location', '$window', 'timestampToDateFilter', 'imagesizeFilter', 'Zoom', 'BarneyConfig', 'BarneyMeta', 'BarneyDict', 'BarneyBrowser', 'User', 'Video', 'SocialSVC', 'GoogleManager',
    function($scope, $routeParams, $location, $window, timestampToDate, imagesize, Zoom, Config, Meta, Dict, Browser, User, Video, SocialSvc, GoogleManager){

        /*******************
        ***  INIT VARS   ***
        *******************/

        $scope.showContent = false;
        $scope.videoId = $routeParams.id;
        $scope.provider = $routeParams.provider;
        $scope.relatedVideo = false;
        $scope.showFooter = false;
        $scope.canPlay = false;

        var code = $scope.provider + ':' + $scope.videoId;

        /*******************
        ***  API CALLS   ***
        *******************/

        // API Calls (1/3) : get video info
        Video.get({
            code: code
        }).$promise.then(function(data){
            $scope.video = data;

            /*******************
            ***   METATAGS   ***
            *******************/

            Meta.set({
                title: $scope.video.title + ' ' + Dict.get('SEO_WEBAPP_TITLE_ZOOM'),
                description: ($scope.video.description) ? $scope.video.description : Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX'),
                ogTitle: $scope.video.title,
                ogDescription: ($scope.video.description) ? $scope.video.description : Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX'),
                ogImage: $scope.video.images.medium.url,
                jsonld: JSON.stringify({
                    '@context': 'http://schema.org',
                    '@type': 'NewsArticle',
                    mainEntityOfPage: {
                        '@type': 'WebPage',
                        '@id': $location.absUrl()
                    },
                    headline: $scope.video.title,
                    image: {
                        '@type': 'ImageObject',
                        url: $scope.video.images.medium.url,
                        height: 768,
                        width: 1024
                    },
                    datePublished: timestampToDate($scope.video.timestamp),
                    dateModified: timestampToDate($scope.video.timestamp),
                    author: {
                        '@type': 'Person',
                        name: Dict.get('SEO_WEBAPP_JSONLD_NAME')
                    },
                    publisher: {
                        '@type': 'Organization',
                        name: Dict.get('SEO_WEBAPP_TITLE_COUNTRY'),
                        logo: {
                            '@type': 'ImageObject',
                            url: Config.get('IMG_DEST_DOMAIN') + Config.get('IMG_COMMON_PREFIX') + '/images/general/logo-header.png',
                            width: 230,
                            height: 30
                        }
                    },
                    description: Dict.get('SEO_WEBAPP_META_DESCRIPTION_PAGE_INDEX')
                })
            }, function(){
                GoogleManager.set({
                    'Tipo de pagina': Dict.get('WEBAPP_NAVIGATION_SERVICE_CONTENT'),
                    Contenido: $scope.video.title,
                    'Contenido /h': $scope.video.title,
                    'event': 'changePage'
                });
            });

            /*******************
            ***   TRACKING   ***
            *******************/

            var prevPage = !!Browser.getPrevState() && !!Browser.getPrevState().className ? Browser.getPrevState().className : null;
            JsAnalytics.trackEvent({
                category: 'Video Zoom Page',
                action: 'Play',
                label: $scope.video.default_title || $scope.video.title
            });

            NewtonAdapter.trackEvent({
                name: 'Play',
                properties: {
                    category: 'Video Zoom Page',
                    label: $scope.video.default_title || $scope.video.title,
                    position: prevPage
                }
            });

            var heartbeatProps = {
                name: 'ImagazineZoomVideo',
                properties: {
                    category: 'Video Heartbeat Zoom',
                    label: $scope.video.default_title || $scope.video.title
                }
            };

            NewtonAdapter.startHeartbeat(heartbeatProps);

            //Not defined in directive because it execute the event many time as the number of the directive present in DOM
            twttr.ready(function (twttr) {
                twttr.events.bind('tweet', function (event) {
                    JsAnalytics.trackEvent({
                        category: 'Video Zoom Page',
                        action: 'ShareTW',
                        label: $scope.video.default_title || $scope.video.title
                    });

                    NewtonAdapter.trackEvent({
                        name: 'ShareTW',
                        properties: {
                            category: 'Video Zoom Page',
                            label: $scope.videoId,
                            title: $scope.video.default_title || $scope.video.title
                        }
                    });
                });
            });

            $scope.$on('$destroy', function(){
                NewtonAdapter.stopHeartbeat(heartbeatProps);
                twttr.events.unbind('tweet');
            });

            /*******************
            ***     SHARE    ***
            *******************/

            User.getStatus(function(resp){

                if($scope.video.free || Config.get('IS_FREE')){
                    $scope.canPlay = true;
                } else if(resp.logged){
                    $scope.canPlay = true;
                } else {
                    $scope.canPlay = false;
                }

                showVideoContent();

            });

            // API Calls (3/3) : get related video
            Video.getList({
                size: Config.get('RELATED_CUSTOM_VIDEO_SIZE'),
                related: 1,
                code: code
            }).$promise.then(function(videoList){
                if(videoList.length > 0){
                    $scope.videoListRelated = videoList;
                }
            });

        });

        var showVideoContent = function(){
            // show content
            $scope.showContent = true;
            $scope.showFooter = true;
        };


        $scope.trackClickRelated = function(newsIndex, newsTitle){

            var action = '';
            if(newsIndex === 0){
                action = 'ClickPrev';
            } else {
                action = 'ClickNext';
            }

            JsAnalytics.trackEvent({
                category: 'Video Zoom Page',
                action: action,
                label: newsTitle
            });

            NewtonAdapter.trackEvent({
                name: action,
                properties: {
                    category: 'Video Zoom Page',
                    label: newsTitle
                }
            });
        };

    }]
);

angular.module('news').directive('item',
    ['$timeout', 'BarneyBrowser', 'BarneyConfig', '$dModal', 'Myspace', 'Utility',
        function ($timeout, Browser, Config, $dModal, Myspace, Utility) {

            return {
                restrict: 'E',
                templateUrl: function ($element, $attr) {
                    return Utility.getTemplatePrefix() + '/modules/item/item.html';
                },
                scope: {
                    item: '=content',
                    playlist: '=',
                    section: '=',
                    template: '@',
                    callbackMethod: '&callback',
                    userEvent: '&userAction'
                },
                link: function ($scope, $element, $attribute) {
                    if (!$scope.template) { $scope.template = 'cover'; }

                    /*******************
                    ***  MATCH MEDIA ***
                    *******************/

                    var matchMediaTrigger = function (mql) {
                        $timeout(function () {
                            $scope.small = mql.matches;
                        });
                    };

                    Browser.mediaMatcher('(max-width: 767px)', matchMediaTrigger);

                    /*******************
                    ***   CALLBACK   ***
                    *******************/

                    $scope.callback = function (event) {
                        if (!!$scope.callbackMethod) {
                            $scope.callbackMethod();
                        }
                        Browser.clickAndGo(event);
                    };

                    $scope.isShow = 0;
                    $scope.removeItem = function () {
                        $scope.isShow = 1;

                    };

                    /*******************************
                    ***  FLAG AS ALREADY VISITED ***
                    *******************************/

                    if (Config.get('ENABLE_ALREADY_VISITED') && JsStorage.isLocalStorageSupported() && Array.prototype.indexOf) {
                        $scope.visited = false;
                        var readItems = JsStorage.get('visitedContents', { type: 'localstorage' });
                        var visited = readItems && readItems.length ? JSON.parse(readItems) : [];
                        if (visited.length && visited.indexOf($scope.item.id) > -1) {
                            $scope.visited = true;
                        }
                    }

                    /**************************
                     * Remove item from myspace
                     *************************/
                    $scope.isfadeOutItem = false;
                    $scope.removeItemFromMyspace = function (params) {
                        $dModal.open({
                            id: 'modalItem',
                            url: Utility.getTemplatePrefix() + '/modules/modal/modal.html',
                            onConfirm: function () {
                                //var section = $route.current.$$route.params.section;
                                Myspace.removeMyspaceItem(params, $scope.section).$promise.then(function (data) {
                                    $scope.isfadeOutItem = true;
                                    if (data.status === 200) {
                                        angular.forEach($scope.playlist, function (playlist, index) {
                                            if (playlist.id_item_collection === params) {
                                                $timeout(function () {
                                                    $scope.playlist.splice(index, 1);
                                                    $dModal.close();
                                                }, 800);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    };
                }
            };
        }
    ]
);

angular.module('news').directive('itemDate',
    ['$timeout', 'BarneyBrowser', 'BarneyConfig', 'setDateFieldFilter', 'Utility',
        function($timeout, Browser, Config, setDateField, Utility) {

            return {
                restrict: 'E',
                templateUrl: function ($element, $attr) {
                    return Utility.getTemplatePrefix() + '/modules/item-date/itemDate.html';
                },
                scope: {
                    item: '=content'
                },
                link: function($scope, $element, $attribute) {

                    JsLogger.info('Item', 'Title: ' + $scope.item.title, $scope.item);
                    $scope.itemDate = setDateField($scope.item);

                }
            };
        }
    ]
);

'use strict';

angular.module('news').directive('gallery',
    ['$window', '$rootScope', '$timeout', '$location', 'imagesizeFilter', 'User', 'BarneyConfig', 'Utility',
        function($window, $rootScope, $timeout, $location, imagesize, User, Config, Utility){
            return {
                restrict: 'E',
                scope: {
                    images: '=',
                    cover: '=',
                    zoomId: '=',
                    leaf: '=',
                    item: '=',
                    userCanUse: '=',
                    readMore: '='
                },
                templateUrl: Utility.getTemplatePrefix() + '/modules/gallery/gallery.html',
                link: function($scope, $element, $attr){

                    /*****************
                    *** PHOTOSWIPE ***
                    *****************/

                    var gallery = {};
                    var currentImage = 0;

                    var openGallery = function(){
                        var pswpElement = document.querySelectorAll('.pswp')[0];
                        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default || false, $scope.images, { // eslint-disable-line camelcase
                            index: 0,
                            history: false
                        });

                        gallery.init();

                        $scope.$on('$routeUpdate', function(first, last){
                            if(typeof last.params.galleryOpened === 'undefined'){
                                gallery.close();
                            }
                        });

                        $location.search('galleryOpened', 'true');

                        JsAnalytics.trackEvent({
                            category: 'Zoom Page',
                            action: 'OpenLightbox',
                            label: $scope.images[currentImage].title
                        });

                        NewtonAdapter.trackEvent({
                            name: 'OpenLightbox',
                            properties: {
                                category: 'Zoom Page',
                                label: $scope.zoomId,
                                title: $scope.images[currentImage].title
                            }
                        });

                        // Use Config.value('SNOWPLOW_TRACKING_ANALYTICS') to wrap with an if statement
                        // Send Event Start Video on Snowplow 
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_content_consumption/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/dv_product/jsonschema/1-0-2',
                                        data: {
                                            service_id: '', 
                                            service_category: 'null', 
                                            service_name: window.location.hostname, 
                                            service_type: Config.get('SNOWPLOW_SERVICE_TYPE'), 
                                            rubric_id: $scope.images[currentImage].category.id ? $scope.images[currentImage].category.id.toString() : '',
                                            rubric_name: $scope.images[currentImage].category.name,
                                            content_id: $scope.images[currentImage].id ? $scope.images[currentImage].id.toString() : '',
                                            content_name: $scope.images[currentImage].default_title || $scope.images[currentImage].title,
                                            content_type: $scope.images[currentImage].format,
                                            provider_name: $scope.item.publisher ? $scope.item.publisher.title_publisher : ''
                                        }
                                    }
                                ]
                            });
                        }
                        
                    };

                    $scope.showGallery = function(){

                        //If service is open, show content, else call can use.
                        if($scope.userCanUse){
                            openGallery();
                        } else if(Config.get('IS_FREE')){
                            openGallery();
                        } else {
                            $scope.readMore();
                        }
                    };
                }
            };
        }
    ]
);

angular.module('news').directive('illustration',
    ['BarneyConfig', 'Utility',
        function(Config, Utility){

            return {
                restrict: 'E',
                scope: {
                    url: '@',
                    title: '@',
                    aspect: '@',
                    alt: '@'
                },
                templateUrl: Utility.getTemplatePrefix() + '/modules/illustration/illustration.html',
                link: function($scope, $element, $attr){

                }
            };
        }
    ]
);

    angular.module('news').directive('clip',
        ['$routeParams', 'imagesizeFilter', 'BarneyConfig', 'User', 'EventBus', 'Zoom', 'Utility', '$sce', 'MediaUtils',
            function($routeParams, imagesize, Config, User, Bus, Zoom, Utility, $sce, MediaUtils){

                return {
                    restrict: 'E',
                    templateUrl: Utility.getTemplatePrefix() + '/modules/clip/clip.html',
                    scope: {
                        item: '=',
                        contentid: '@',
                        videoid: '@',
                        isCustomVideo: '@',
                        userCanUse: '=?',
                        readMore: '=',
                        isMainNews: '=',
                        postMessageCallback: '&',
                        suggestedClip: '=',
                        is360: '=',
                        isWifi: '=?',
                        audio: '='
                    },

                    link: function($scope, $element, $attr){
                        var videoCode = $scope.videoid;
                        var videoId = $scope.item.videos_list[videoCode].video_id;
                        var videoTitle = $scope.item ? $scope.item.title : videoId;
                        var trackVideoTitle = $scope.item ? $scope.item.default_title || $scope.item.title : videoTitle;
                        var videoDataDownload = {};

                        var posterImgSize = MediaUtils.getPosterSize();

                        /* DEFINING SCOPE VARS */
                        $scope.video = $scope.item;
                        //console.log('## JW - video', $scope.video);
                        $scope.showLoader = $scope.isMainNews;
                        $scope.player = false;
                        $scope.nextVideo = null;
                        $scope.showStreamingError = false;
                        $scope.idle = true;
                        $scope.posterImage = imagesize($scope.video.images.cover.ratio_1, 'illustration', posterImgSize, 'horizontal');
                        //console.log('## JW - posterImage', posterImage, posterImgSize);

                        // JWPLAYER - upgrade from Flowplayer 7 (Dic 2023/Jan 2024)
                        var getCorrectLanguage4Country = MediaUtils.getCorrectLanguage4Country;
                        var exitFullscreen = MediaUtils.exitFullscreen;
                        var getVideoClip = MediaUtils.getVideoClip;

                        var setupPlayerMultilang = function(trackingObj, options, playerId) {
                            var videoW, 
                                videoH;
                            if ($scope.is360) {
                                return;
                            }
                            //console.log('## JW - Setup player', options, playerId, jwplayer);
                            $scope.jwplayer = jwplayer(playerId);
                            jwplayer(playerId).setup(options);
                            jwplayer(playerId).on('ready', function(levels) {
                                //console.log('## JW - Player ready', levels);
                                trackingObj.ready();
                            });
                            jwplayer(playerId).on('meta', function(e) {
                                //console.log('## JW - Metadata: ', e);
                                if (e.width > 0 && e.height > 0){
                                    videoW = e.width;
                                    videoH = e.height;
                                } else {
                                    videoW = document.getElementById(playerId).querySelector('video').videoWidth;
                                    videoH = document.getElementById(playerId).querySelector('video').videoHeight;
                                }
                                if (videoW > 0 && videoH > 0){
                                    document.getElementById(playerId).style.aspectRatio = videoW + ':' + videoH;
                                    jwplayer(playerId).setConfig({ aspectratio: videoW + ':' + videoH });
                                }
                            });
                            
                            jwplayer(playerId).on('firstFrame', function(e) { 
                                if (!videoW || !videoH){
                                    videoW = document.getElementById(playerId).querySelector('video').videoWidth;
                                    videoH = document.getElementById(playerId).querySelector('video').videoHeight;
                                    document.getElementById(playerId).style.aspectRatio = videoW + '/' + videoH;
                                    jwplayer(playerId).setConfig({ aspectratio: videoW + ':' + videoH });
                                }
                                //console.log('## JW - firstFrame', e);
                                var languageTracks = MediaUtils.getLangs(playerId);
                                getCorrectLanguage4Country(playerId, languageTracks, MediaUtils.langChange);   
                                trackingObj.firstPlay();                                    
                            });
                            jwplayer(playerId).on('play', function(e) {
                                //console.log('## JW - Play', e);
                                trackingObj.play();
                            });
                            jwplayer(playerId).on('pause', function(e) {
                                //console.log('## JW - Pause', e);
                                trackingObj.pause();
                            });
                            jwplayer(playerId).on('setupError', function(e) {
                                //console.log('## JW - Setup error', e);
                                trackingObj.error();
                            });
                            jwplayer(playerId).on('error', function(e) {
                                //console.log('## JW - Error', e);
                                trackingObj.error();
                            });
                            jwplayer(playerId).on('time', function(e) {
                                var total = e.duration;
                                var current = e.currentTime;
                                var percentage = Math.trunc((current / total) * 100);
                                //console.log('## JW - Time', total, current, percentage, e);
                                
                                if (percentage === 25) {
                                    trackingObj.playbackProgress25();
                                    //console.log('## JW - PlaybackProgress25');
                                }
                                if (percentage === 50) {
                                    trackingObj.playbackProgress50();
                                    //console.log('## JW - PlaybackProgress50');
                                }
                                if (percentage === 75) {
                                    trackingObj.playbackProgress75();
                                    //console.log('## JW - PlaybackProgress75');
                                }
                            });
                            
                            jwplayer(playerId).on('complete', function(e) {
                                //console.log('## JW - Complete', e);
                                trackingObj.end();
                            });

                            //Events not used for functionality, but helpful for debugging:
                            /*
                            jwplayer(playerId).on('audioTrackChanged', function(e) {
                                //console.info('## JW - Audio track changed to: ', e.currentTrack, e);
                            });
                            jwplayer(playerId).on('autostartNotAllowed', function(e) {
                                //console.info('## JW - Autoplay not allowed', e);
                            });
                            jwplayer(playerId).on('idle', function(e) {
                                //console.info('## JW - Idle', e);
                            });
                            jwplayer(playerId).on('viewable', function(e) {
                                //console.info('## JW - Viewable', e);
                            });
                            jwplayer(playerId).on('fullscreen', function(e) {
                                //console.info('## JW - Fullscreen', e);
                            });
                            */

                            //console.info('## JW - scope player obj', $scope.jwplayer);
                        };

                        var createPlayerMultilang = function(playerOptions) {
                            //try {
                            var playerContId = 'multiplayer';
                            jwplayer.key = Config.get('JWPLAYER_KEY');
                            var autoplay = $scope.audio ? !!Config.get('AUDIO_PLAYERS_AUTOPLAY') : !!Config.get('VIDEO_PLAYERS_AUTOPLAY');
                            //console.log('## JW - createPlayerMultilang', playerOptions);
                            var file = $sce.trustAsResourceUrl(playerOptions.videoUrl); 
                            // test url: $sce.trustAsResourceUrl('https://smartvideo-delivnd.galaxydve.com/PYPA051_MULTILang_Nursery_FIVE_LITTLE_ALIENS_VIRGO.mov_channels/PYPA051_MULTILang_Nursery_FIVE_LITTLE_ALIENS_VIRGO.mov_channels.m3u8');

                            var jwoptions = {
                                'playlist': [{
                                    'file': file,
                                    'image': $scope.posterImage ? $scope.posterImage : null
                                }],
                                'autoPause': {
                                    'viewability': $scope.audio ? false : true
                                },
                                'autostart': autoplay, 
                                'mute': false,
                                'responsive': true,
                                'aspectratio': '16:9',
                                'width': '100%',
                                'stretching': 'uniform'
                            };

                            //console.log('## JW - ElementReady', jwoptions, playerContId);
                            setTimeout(setupPlayerMultilang(trackingObject, jwoptions, playerContId), 100);
                                
                           // } catch(e) {
                               // console.log('## JW - JWPLAYER ERR', e);
                           // }
                        };

                        //END JWPLAYER

                        var trackVideoEvent = function(actionName) {
                            if(Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter){
                                facebookpixeladapter.trackCustom(actionName, {
                                    id: videoId,
                                    title: videoTitle
                                });
                            }

                            JsAnalytics.trackEvent({
                                category: 'ZoomPage',
                                action: actionName,
                                label: trackVideoTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: actionName,
                                properties: {
                                    action: actionName,
                                    category: 'VideoZoom',
                                    label: $scope.contentid,
                                    videoId: videoId,
                                    videoTitle: trackVideoTitle,
                                    title: trackVideoTitle
                                }
                            });

                            // Snow Plow User Interaction
                            if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                                window.snowplow('trackSelfDescribingEvent', {
                                    event: {
                                        schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                        data: {}
                                    },
                                    context: [
                                        {
                                            schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                            data: {
                                                environment: 'browser', 
                                                tracking_name: actionName
                                            }
                                        }
                                    ]
                                });
                            }

                        };

                        var startTimeTrackVideo = function(){
                            if (Config.get('ENABLE_TIMETRACK_VIDEO_VIEW')) {
                                NewtonAdapter.startHeartbeat({
                                    name: 'VideoView',
                                    properties: {
                                        action: 'VideoView',
                                        category: 'VideoZoom',
                                        label: $scope.contentid,
                                        videoId: videoId,
                                        videoTitle: trackVideoTitle,
                                        title: trackVideoTitle
                                    }
                                });
                            }
                        };

                        var stopTimeTrackVideo = function(stopAction) {
                            if (Config.get('ENABLE_TIMETRACK_VIDEO_VIEW')) {
                                NewtonAdapter.stopHeartbeat({
                                    name: 'VideoView',
                                    properties: {
                                        stop_type: stopAction,
                                        action: 'VideoView',
                                        category: 'VideoZoom',
                                        label: $scope.contentid,
                                        videoId: videoId,
                                        videoTitle: trackVideoTitle,
                                        title: trackVideoTitle
                                    }
                                });
                            }
                        };

                        var trackPlaybackProgress = function(progress) {
                            JsAnalytics.trackEvent({
                                category: 'ZoomPage',
                                action: 'PlaybackProgress' + progress,
                                label: trackVideoTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: 'PlaybackProgress' + progress,
                                properties: {
                                    action: 'PlaybackProgress' + progress,
                                    category: 'VideoZoom',
                                    label: $scope.contentid,
                                    videoId: videoId,
                                    videoTitle: trackVideoTitle,
                                    title: trackVideoTitle
                                }
                            });
                        };

                        var showAdvOverlay = function() {
                            if(Config.get('SHOW_ADV_OVERLAY')){
                                if(Config.get('SHOW_ADV_FOR_LOGGED')){
                                    User.getStatus(function(user){
                                        if(user.logged){
                                            Bus.trigger('overlay-show', {
                                                label: trackVideoTitle,
                                                content_id: videoId
                                            });
                                        }
                                    });
                                    $scope.$apply();
                                } else {
                                    Bus.trigger('overlay-show', {
                                        label: trackVideoTitle,
                                        content_id: videoId
                                    });
                                }
                            }
                        };

                        var trackingObject = {
                            ready: function() {
                                $scope.showLoader = false;
                                $scope.showStreamingError = false;
                            },
                            firstPlay: function() {
                                trackVideoEvent('VideoStart');
                                // Use Config.value('SNOWPLOW_TRACKING_ANALYTICS') to wrap with an if statement
                                // Send Event Start Video on Snowplow 
                                if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                                    window.snowplow('trackSelfDescribingEvent', {
                                        event: {
                                            schema: 'iglu:com.dgp/dv_content_consumption/jsonschema/1-0-0',
                                            data: {}
                                        },
                                        context: [
                                            {
                                                schema: 'iglu:com.dgp/dv_product/jsonschema/1-0-2',
                                                data: {
                                                    service_id: Config.get('REAL_CUSTOMER_ID'), 
                                                    service_category: Config.get('SNOWPLOW_SERVICE_CATEGORY'), 
                                                    service_name: window.location.hostname, 
                                                    service_type: Config.get('SNOWPLOW_SERVICE_TYPE'), 
                                                    rubric_id: $scope.item.category.id ? $scope.item.category.id.toString() : '',
                                                    rubric_name: $scope.item.category.name,
                                                    content_id: $scope.item.id ? $scope.item.id.toString() : '',
                                                    content_name: $scope.item.default_title || $scope.item.title,
                                                    content_type: $scope.item.format,
                                                    provider_name: $scope.item.publisher ? $scope.item.publisher.title_publisher : ''
                                                }
                                            }
                                        ]
                                    });
                                }
                            },
                            play: function() {
                                trackVideoEvent('VideoPlay');
                                startTimeTrackVideo();

                                if($scope.showNextVideo){
                                    $scope.showNextVideo = false;
                                    $scope.$apply();
                                }
                            },
                            pause: function() {
                                setTimeout(function() {
                                    trackVideoEvent('VideoPause');
                                    stopTimeTrackVideo('video_stop');
                                }, 1);
                            },
                            end: function() {
                                trackVideoEvent('VideoEnd');
                               
                                stopTimeTrackVideo('video_end');
                                showAdvOverlay();

                                var posterCont = document.querySelector('.jw-preview');
                                posterCont.style.backgroundImage = 'url(' + $scope.posterImage + ')';
                                document.querySelector('.jw-svg-icon.jw-svg-icon-replay').style.visibility = 'hidden';

                                if($scope.jwplayer.getFullscreen()) {
                                    exitFullscreen();
                                }

                                if (!$scope.is360 && Config.get('SHOW_SUGGESTION_AT_VIDEO_END')) {
                                    $scope.showNextVideo = true;
                                    $scope.$apply();
                                }
                            },
                            onDownloadInfo: function(resp){
                                var dldUrl = Config.get('BPLAYER_DWL_BASE_URL') +
                                Config.get('BPLAYER_URL_PATH') +
                                '?id=' + $scope.item.id +
                                '&videoid=' + videoId +
                                '&country=' + Config.get('API_COUTNRY') +
                                '&action=dwl';

                                if(Config.get('ENABLE_DOWNLOAD_FEATURE')){
                                    videoDataDownload = {
                                        ifrmeUrl: dldUrl,
                                        size: resp.downloadable.size,
                                        videoId: videoId,
                                        videoTitle: videoTitle,
                                        userCanUse: true
                                    };

                                    $scope.postMessageCallback()(videoDataDownload);
                                }
                            },
                            playbackProgress25: function() {
                                trackPlaybackProgress(25);
                            },
                            playbackProgress50: function() {
                                trackPlaybackProgress(50);
                            },
                            playbackProgress75: function() {
                                trackPlaybackProgress(75);
                            },
                            error: function() {
                                $scope.showLoader = false;
                                $scope.showStreamingError = true;
                            }
                        };

                        $scope.loadPlayer = function(userWantLoad) { 
                            if(userWantLoad){
                                $scope.showLoader = true;
                            }
                            var videoUrls = getVideoClip($scope.item);

                            var videoUrl = videoUrls.m3u8 || videoUrls.mp4 || videoUrls.default;
                            var aspectRatio = '800/600';
                            //console.log('## JW - videoUrl', videoUrl);
                            if(!videoUrl) {
                                $scope.showLoader = false;
                                $scope.showStreamingError = true;
                            } else {
                                createPlayerMultilang({ videoUrl: videoUrl, aspectRatio: aspectRatio });
                            }
                        };

                        $scope.contentid = $scope.contentid ? $scope.contentid : $routeParams.zoomId;

                        $scope.goToSuggested = function() {
                            if($scope.nextVideo) {
                                JsAnalytics.trackEvent({
                                    category: 'ZoomPage',
                                    action: 'SuggestedClick',
                                    label: trackVideoTitle
                                });

                                NewtonAdapter.trackEvent({
                                    name: 'SuggestedClick',
                                    properties: {
                                        action: 'SuggestedClick',
                                        category: 'VideoZoom',
                                        label: $scope.contentid,
                                        videoId: videoId,
                                        videoTitle: trackVideoTitle,
                                        title: trackVideoTitle,
                                        nextVideoId: $scope.nextVideo.id,
                                        nextVideoTitle: $scope.nextVideo.default_title || $scope.nextVideo.title
                                    }
                                });

                                window.location.href = $scope.nextVideo.url_zoom;
                            }
                        };

                        $scope.replayVideo = function() {
                            $scope.jwplayer.play();
                            $scope.showNextVideo = false;

                            JsAnalytics.trackEvent({
                                category: 'ZoomPage',
                                action: 'PlayAgain',
                                label: trackVideoTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: 'PlayAgain',
                                properties: {
                                    action: 'PlayAgain',
                                    category: 'VideoZoom',
                                    label: $scope.contentid,
                                    videoId: videoId,
                                    videoTitle: trackVideoTitle,
                                    title: trackVideoTitle
                                }
                            });
                        };

                        $scope.$watch('suggestedClip', function(newVideo, old) {
                            $scope.nextVideo = $scope.suggestedClip.length > 0 ? $scope.suggestedClip[0] : null;
                            //console.log('## JW - suggestedClip', $scope.nextVideo, $scope.suggestedClip);
                        }, true);

                        $scope.$on('$destroy', function() {
                            // REMOVE PLAYER
                            if($scope.jwplayer){
                                //console.log('## JW - remove player');
                                $scope.jwplayer.remove();
                            }

                            if($scope.jwplayer.getState() === 'playing'){
                                stopTimeTrackVideo('video_end');
                            }
                            clipElement = null;
                        });

                        $element.ready(function() {
                            if (typeof $scope.userCanUse === 'undefined') {
                                User.getStatus(function(resp){
                                    $scope.userCanUse = resp.logged;
                                });

                                $scope.$watch('userCanUse', function(){
                                    $scope.loadPlayer(false);
                                });
                            } else if($scope.userCanUse){
                                $scope.loadPlayer(false);
                            } else if (Config.get('ENABLE_DOWNLOAD_FEATURE')) {
                                videoDataDownload = {
                                    videoId: $scope.item.title ? $scope.item.title : '',
                                    videoTitle: $scope.item.id ? $scope.item.id : '',
                                    callback: $scope.readMore,
                                    userCanUse: false
                                };

                                $scope.postMessageCallback()(videoDataDownload);
                            }
                        });

                    }
                };
            }
        ]
    );

angular.module('news').directive('coverItem', ['BarneyConfig', 'BarneyBrowser', 'Utility',
    function(Config, Browser, Utility) {

        return {
            restrict: 'E',
            templateUrl: function($element, $attr) {
                return Utility.getTemplatePrefix() + '/modules/coverItem/cover-item.html';
            },
            scope: {
                item: '=',
                callbackMethod: '&callback'
            },
            link: function($scope, $element, $attribute) {
                $scope.isEmpty = true;

                if ($scope.item.items > 0) {
                    $scope.isEmpty = false;
                }

                $scope.callback = function(event) {
                    if (!!$scope.callbackMethod) {
                        $scope.callbackMethod();
                    }
                    Browser.clickAndGo(event);
                };
            }
        };
    }
]);
angular.module('news').directive('downloadButton',
    ['$timeout', 'BarneyConfig',
        function($timeout, Config) {

            return {
                restrict: 'E',
                templateUrl: function ($element, $attr) {
                    return '/js/wl/webstore_news/app/modules/downloadButton/button.html';
                },
                scope: {
                    downloadInfo: '=',
                    item: '='
                },
                link: function($scope, $element, $attribute) {

                    var videoId = false;
                    var videoTitle = false;
                    var callback = false;
                    var userCanUse = false;

                    $scope.show = false;
                    $scope.downloadUrl = false;
                    $scope.size = false;

                    $scope.download = function(){
                        JsLogger.log('Download: ', $scope.downloadUrl);

                        JsAnalytics.trackEvent({
                            category: 'VideoZoom',
                            action: 'VideoDownload',
                            label: videoTitle
                        });
                        NewtonAdapter.trackEvent({
                            name: 'VideoDownload',
                            properties: {
                                action: 'VideoDownload',
                                category: 'VideoZoom',
                                label: videoId,
                                videoId: videoId,
                                videoTitle: videoTitle,
                                title: videoTitle
                            }
                        });
                        // Use Config.value('SNOWPLOW_TRACKING_ANALYTICS') to wrap with an if statement
                        // Send Event Start Video on Snowplow 
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_content_consumption/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/dv_product/jsonschema/1-0-2',
                                        data: {
                                            service_id: Config.get('REAL_CUSTOMER_ID'), 
                                            service_category: Config.get('SNOWPLOW_SERVICE_CATEGORY'), 
                                            service_name: window.location.hostname, 
                                            service_type: Config.get('SNOWPLOW_SERVICE_TYPE'), 
                                            rubric_id: $scope.item.category.id ? $scope.item.category.id.toString() : '',
                                            rubric_name: $scope.item.category.name,
                                            content_id: $scope.item.id ? $scope.item.id.toString() : '',
                                            content_name: $scope.item.default_title || $scope.item.title,
                                            content_type: $scope.item.format,
                                            provider_name: $scope.item.publisher ? $scope.item.publisher.title_publisher : ''
                                        }
                                    }
                                ]
                            });
                        }
                        if(userCanUse){
                            window.location.href = $scope.downloadUrl;
                        } else {
                            callback();
                        }
                    };

                    $scope.$watch('downloadInfo', function(downloadData){
                        JsLogger.log('Download Info: ', downloadData);

                        $timeout(function () {
                            if (downloadData.userCanUse) {
                                $scope.size = Config.get('DISABLE_DOWNLOAD_SIZE') ? false : downloadData.size;
                                $scope.downloadUrl = downloadData.iframeUrl + '&action=dwl';
                                videoId = downloadData.videoId;
                                videoTitle = downloadData.videoTitle;
                                userCanUse = true;

                                $scope.show = true;
                            } else if(typeof downloadData.userCanUse !== 'undefined' && downloadData.userCanUse === false){
                                videoId = downloadData.videoId;
                                videoTitle = downloadData.videoTitle;
                                callback = downloadData.callback;
                                userCanUse = false;

                                $scope.show = true;
                            } else {
                                JsLogger.warn('Download Button - Not enough datas, any download enabled!');
                            }
                        }, 1);
                    });
                }
            };
        }
    ]
);

angular.module('news').directive('cbDownloadButton',
    ['$http', 'BarneyConfig',
        function ($http, Config) {

            return {
                restrict: 'E',
                templateUrl: function ($element, $attr) {
                    return '/js/wl/webstore_news/app/modules/downloadButton/button.html';
                },
                scope: {
                    downloadInfo: '=',
                    userCanUse: '=?',
                    readMore: '=?',
                    item: '='
                },
                link: function($scope, $element, $attribute) {

                    var zoomTitle = $scope.downloadInfo.zoomTitle;
                    var zoomId = $scope.downloadInfo.zoomId;
                    var callback = $scope.downloadInfo.callback;

                    $scope.show = true;
                    $scope.downloadUrl = $scope.downloadInfo.downloadUrl;
                    $scope.size = false;


                    $scope.download = function(){
                        JsLogger.log('Download: ', $scope.downloadUrl);

                        JsAnalytics.trackEvent({
                            category: 'VideoZoom',
                            action: 'Download',
                            label: zoomTitle
                        });
                        NewtonAdapter.trackEvent({
                            name: 'Download',
                            properties: {
                                action: 'Download',
                                category: 'VideoZoom',
                                label: zoomId,
                                zoomId: zoomId,
                                zoomTitle: zoomTitle,
                                title: zoomTitle
                            }
                        });
                        // Use Config.value('SNOWPLOW_TRACKING_ANALYTICS') to wrap with an if statement
                        // Send Event Start Video on Snowplow 
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_content_consumption/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/dv_product/jsonschema/1-0-2',
                                        data: {
                                            service_id: Config.get('REAL_CUSTOMER_ID'), 
                                            service_category: Config.get('SNOWPLOW_SERVICE_CATEGORY'), 
                                            service_name: window.location.hostname, 
                                            service_type: Config.get('SNOWPLOW_SERVICE_TYPE'), 
                                            rubric_id: $scope.item.category.id ? $scope.item.category.id.toString() : '',
                                            rubric_name: $scope.item.category.name,
                                            content_id: $scope.item.id ? $scope.item.id.toString() : '',
                                            content_name: $scope.item.default_title || $scope.item.title,
                                            content_type: $scope.item.format,
                                            provider_name: $scope.item.publisher ? $scope.item.publisher.title_publisher : ''
                                        }
                                    }
                                ]
                            });
                        }

                        if($scope.userCanUse){
                            var dldUrl = $scope.downloadUrl;

                            if(typeof dldUrl === 'string' && dldUrl.indexOf('?') > 0) {
                                dldUrl = dldUrl + '&access_token=' + NewtonAdapter.getUserToken();
                            } else {
                                dldUrl = dldUrl + '?access_token=' + NewtonAdapter.getUserToken();
                            }

                            $http.get(Config.get('DEST_DOMAIN') + dldUrl).success(function(resp){
                                if (resp.status === 200) {
                                    if (typeof callback === 'function') {
                                        callback({ downloadStarted: 1, status: resp.status });
                                    }

                                    window.location.href = resp.url_download;
                                } else {
                                    JsLogger.log('Download Error ' + resp.status, resp.message);

                                    if (typeof callback === 'function') {
                                        callback({ downloadStarted: 0, status: resp.status });
                                    }
                                }
                            }).error(function(err){
                                JsLogger.log(err);

                                if (typeof callback === 'function') {
                                    callback({ downloadStarted: 0, status: resp.status });
                                }
                            });
                        } else {
                            JsLogger.log('User not able to download!');

                            $scope.readMore();
                        }
                    };
                }
            };
        }
    ]
);

angular.module('news').directive('phDownloadButton',
    ['$http', 'BarneyConfig', 'MFP',
        function ($http, Config, MFP) {

            return {
                restrict: 'E',
                templateUrl: function ($element, $attr) {
                    return '/js/wl/webstore_news/app/modules/downloadButton/ph-button.html';
                },
                scope: {
                    downloadInfo: '=',
                    userCanUse: '=?',
                    readMore: '=?',
                    item: '='
                },
                link: function ($scope, $element, $attribute) {
                    var zoomTitle = $scope.downloadInfo.zoomTitle;
                    var zoomId = $scope.downloadInfo.zoomId;
                    var appId = $scope.downloadInfo.appId;
                    var userCanUse = false;
                    var format = $scope.downloadInfo.format;
                    var downloadFormat = Config.get('DOWNLOAD_FORMAT_WEBAPP');
                    $scope.show = true;

                    var storeUrl = '';
                    if (Config.get('GOTOSTORE_URL')) {
                        storeUrl = Config.get('GOTOSTORE_URL');
                    }

                    $scope.size = false;
                    if ($scope.downloadInfo.size && !Config.get('DISABLE_DOWNLOAD_SIZE')) {
                        $scope.size = $scope.downloadInfo.size;
                    }

                    $scope.download = function () {
                        JsAnalytics.trackEvent({
                            category: 'VideoZoom',
                            action: 'NativeAppPromoClick',
                            label: zoomTitle
                        });
                        NewtonAdapter.trackEvent({
                            name: 'NativeAppPromoClick',
                            properties: {
                                action: 'NativeAppPromoClick',
                                category: 'VideoZoom',
                                label: zoomId,
                                zoomId: zoomId,
                                zoomTitle: zoomTitle,
                                title: zoomTitle
                            }
                        });
                        // Snow Plow User Interaction
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                        data: {
                                            environment: 'browser', 
                                            tracking_name: 'NativeAppPromoClick'
                                        }
                                    }
                                ]
                            });
                        }

                        // Use Config.value('SNOWPLOW_TRACKING_ANALYTICS') to wrap with an if statement
                        // Send Event Start Video on Snowplow 
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_content_consumption/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/dv_product/jsonschema/1-0-2',
                                        data: {
                                            service_id: Config.get('REAL_CUSTOMER_ID'), 
                                            service_category: Config.get('SNOWPLOW_SERVICE_CATEGORY'), 
                                            service_name: window.location.hostname, 
                                            service_type: Config.get('SNOWPLOW_SERVICE_TYPE'), 
                                            rubric_id: $scope.item.category.id ? $scope.item.category.id.toString() : '',
                                            rubric_name: $scope.item.category.name,
                                            content_id: $scope.item.id ? $scope.item.id.toString() : '',
                                            content_name: $scope.item.default_title || $scope.item.title,
                                            content_type: $scope.item.format,
                                            provider_name: $scope.item.publisher ? $scope.item.publisher.title_publisher : ''
                                        }
                                    }
                                ]
                            });
                        }

                        if (userCanUse === false) {
                            $scope.readMore();
                            return;
                        }

                        if (appId && storeUrl && downloadFormat.indexOf(format) !== -1) {
                            var dldButton = document.getElementById('downloadButton');
                            MFP.start({ storeUrl: storeUrl, appId: appId }, function (resp) {
                                /*eslint-disable no-script-url*/
                                dldButton.setAttribute('href', 'javascript:window.location.href=\'' + resp + '\'; 0;');
                                window.location.href = dldButton.getAttribute('href');    
                            });
                        } else {
                            JsLogger.error('mobileFingerPrint params error', { storeUrl: storeUrl, appId: appId });
                        }

                    };


                    $scope.$watch('userCanUse', function () {
                        userCanUse = $scope.userCanUse;
                    });


                }
            };
        }
    ]
);

/*
 * With this directive we adapt angular-carousel in a more easily configurable directive
 *
 * @example
 * <slider slides="slides" transition="slide" duration="300" controls autoplay></slider>
 *
 * Options:
 * - slides: required, array of img;
 * - autoplay: add this attribute to enable autoplay,give it a value for the timer if you don't want the default; (default=3s)
 * - transition:  can be one of slide, zoom, hexagon, fadeAndSlide, none. (default=slide)
 * - duration: add this attribute to set the duration of the transition (default=300)
 * - indicators: give it a value to show indicators (position can be modified with CSS);
 *
 *
 * NB: If you modify slider.html make it shure that angular.element($element).children() is pointing to the right element
 *
 */

angular.module('news').directive('slider',
    ['BarneyConfig', 'Utility',
        function (Config, Utility) {
            return {
                restrict: 'E',
                scope: {
                    slides: '=',
                    autoplay: '@?',
                    transition: '@?',
                    duration: '@?',
                    controls: '@?',
                    indicators: '@?',
                    callbackMethod: '=?callback',
                    show: '='
                },
                templateUrl: Utility.getTemplatePrefix() + '/modules/slider/slider.html',
                link: function ($scope, $element, $attr) {
                    var slider = document.getElementById('slider');

                    if (typeof $attr.autoplay !== 'undefined' && $attr.autoplay !== 'false') {
                        slider.setAttribute('rn-carousel-auto-slide', $attr.autoplay);
                    }

                    if (typeof $attr.transition !== 'undefined' && $attr.transition !== 'false') {
                        slider.setAttribute('rn-carousel-transition', $attr.transition);
                    }

                    if (typeof $attr.duration !== 'undefined' && $attr.duration !== 'false') {
                        slider.setAttribute('rn-carousel-duration', $attr.duration);
                    }

                    $scope.prevSlide = function () {
                        if ($scope.carouselIndex > 0) {
                            $scope.carouselIndex--;
                        }
                    };
                    $scope.nextSlide = function () {
                        if ($scope.carouselIndex < $scope.slides.length - 1) {
                            $scope.carouselIndex++;
                        }
                    };
                }
            };
        }
    ]
);

angular.module('news').directive('newSlider',
    ['BarneyConfig', '$rootScope', 'BarneyBrowser', 'Utility',
        function (Config, $rootScope, Browser, Utility) {
            return {
                restrict: 'E',
                templateUrl: function ($element, $attr) {
                    return Utility.getTemplatePrefix() + '/modules/newSlider/newSlider.html';
                },
                replace: false,
                scope: {
                    slides: '=',
                    slider: '@',
                    sliderconf: '@',
                    show: '=',
                    callbackMethod: '=?callback',
                    shuffleitems: '=',
                    ready: '='
                },
                link: function ($scope, $element, $attr) {
                    $scope.trackClickSliderNew = function (event, title, index) {
                        JsAnalytics.trackEvent({
                            category: 'Home Page',
                            action: 'ClickCarousel',
                            label: title
                        });
        
                        NewtonAdapter.trackEvent({
                            name: 'ClickCarousel',
                            properties: {
                                category: 'Home Page',
                                label: title,
                                position: parseInt(index, 10) + 1
                            }
                        });
                    };                    
                    var slider;
                    var sliderOpts = {
                        type: 'carousel',
                        startAt: 0,
                        gap: 10,
                        focusAt: 'center',
                        direction: $rootScope.RTLlang,
                        peek: 50,
                        perView: 3,
                        breakpoints: {
                            680: {
                                perView: 1
                            },
                            1024: {
                                perView: 2
                            }
                        }
                    };

                    if ($scope.sliderconf && Config.get($scope.sliderconf)) {
                        //mergia la conf qui sopra con una presa dal vhost, se c'è. (mettere doppi apici su tutte le chiavi, v. esempio LEADERBOARD_SLIDER_CONF su gameasy.conf)
                        //così puoi fare solo l'override di alcune opzioni e aggiungerne, 
                        //e mantiene uguali le opzioni che non sovrascrivi.
                        angular.merge(sliderOpts, Config.get($scope.sliderconf));
                    }

                    var mountSlider = function (els) {
                        if ($scope.slider === 'carousel') {
                            //qui si prendono tutti gli elementi e gli si dice di rimetterci 
                            //l'onclick tutte le volte che vngono clonati per fare il carousel infinito
                            // NOTA BENE: in questo caso non serve perchè c'è un link normale e non un bottone con un evento attaccato. 
                            // Lo lascio qui per riferimento.
                        }

                        if (els) {
                            //qui se ci sono effettivamente i contenuti
                            //definisco lo slider e lo monto.
                            slider = new Glide('.glide', sliderOpts);
                            setTimeout(function () {
                                slider.mount();
                            }, 450);

                            slider.on('mount.after', function() {
                                var elements = $element[0].querySelectorAll('.glide__slide--clone');
                                angular.forEach(elements, function(el) {
                                    el.addEventListener('click', function() {
                                        var index = el.dataset.itemindex;
                                        var item = $scope.slides[index];
                                        if (item) {
                                            $scope.trackClickSliderNew(event, title, index + 1);
                                        }
                                    });
                                });
                            });                            
                        }
                    };

                    $scope.$watch('slides', function (newValue, oldValue) {
                        //quando cambia il valore di $scope.slides, se non è vuoto, faccio partire lo slider
                        if (newValue || oldValue) {
                            mountSlider($scope.slides);
                        }
                    });
                }
            };
        }
    ]
);
/*
    don't edit this file: now we use header-main.js instead of header.js
    when we will delete this file, we will make regression on News' services
*/

angular.module('news').directive('header',
    ['$rootScope', '$location', '$route', 'User', 'BarneyConfig', 'BarneyBrowser', 'Utility',
        function($rootScope, $location, $route, User, Config, Browser, Utility){

            return {
                restrict: 'A',
                replace: true,
                transclude: true,
                templateUrl: function($element, $attr){
                    var isKiosk = (Config.get('KIOSK_SERVICE')) ? '_kiosk' : '';

                    if($attr.template){
                        return Utility.getTemplatePrefix() + '/modules/header/' + $attr.template + isKiosk + '.html';
                    } else {
                        return Utility.getTemplatePrefix() + '/modules/header/header' + isKiosk + '.html';
                    }
                },
                scope: {
                    backPage: '@'
                },
                link: function($scope, $element, $attr){

                    User.getStatus(function(user){
                        if(user.logged){
                            $scope.userLink = Config.get('ACCOUNT_LINK_LOGGED');
                            if(Config.get('ENABLE_NEWTON_USER') && user.fake === 'fake'){
                                $scope.userLink = Config.get('ACCOUNT_LINK');
                            }
                        } else if(Config.get('ADD_DOMAIN_TO_ACCOUNT_LINK')){
                            $scope.userLink = Config.get('DEST_DOMAIN') + Config.get('ACCOUNT_LINK');
                        } else {
                            $scope.userLink = Config.get('ACCOUNT_LINK');
                        }
                    });


                    /*******************
                    ***   GO BACK    ***
                    *******************/

                    // TODO: re-check BarneyHistory get() method before
                    // $scope.goBack = function(){
                    //  if($scope.backPage){
                    //      $location.url($scope.backPage);
                    //  } else if(History.getPrevPath() == null) {
                    //      $location.url(Config.get('ROUTER_HOME'));
                    //  } else {
                    //      History.goBack();
                    //  }
                    // }


                    /*******************
                    ***   TRACKING   ***
                    *******************/

                    $scope.trackEvent = function(event, label){
                        // get current page
                        var currentPage = '';
                        var current = $route.current.$$route;
                        if(!!current && !!current.className){
                            currentPage = current.className;
                        }

                        JsAnalytics.trackEvent({
                            category: 'Header',
                            action: 'HeaderClick',
                            label: label
                        });

                        NewtonAdapter.trackEvent({
                            name: 'HeaderClick',
                            properties: {
                                category: 'Header',
                                label: label,
                                page: currentPage
                            }
                        });

                        Browser.clickAndGo(event);
                    };
                }
            };
        }
    ]
);

angular.module('news').directive('headerMain',
    ['$rootScope', '$location', '$route', 'User', 'BarneyConfig', 'BarneyBrowser', 'Utility',
        function($rootScope, $location, $route, User, Config, Browser, Utility){

            return {
                restrict: 'A',
                replace: true,
                transclude: true,
                templateUrl: function($element, $attr){
                    var isKiosk = (Config.get('KIOSK_SERVICE')) ? '_kiosk' : '';

                    var template = Config.get('TEMPLATING_HEADER') || 'header';

                    return Utility.getTemplatePrefix() + '/modules/header/' + template + isKiosk + '.html';
                },
                scope: {
                    backPage: '@'
                },
                link: function($scope, $element, $attr){

                    User.getStatus(function(user){
                        if(user.logged){

                            if(Config.get('ENABLE_NEWTON_USER') && user.fake === 'fake'){
                                $scope.userLink = Config.get('ACCOUNT_LINK');
                            } else {
                                $scope.userLink = Config.get('ACCOUNT_LINK_LOGGED');
                            }
                        } else if(Config.get('ADD_DOMAIN_TO_ACCOUNT_LINK')){
                            $scope.userLink = Config.get('DEST_DOMAIN') + Config.get('ACCOUNT_LINK');
                        } else {
                            $scope.userLink = Config.get('ACCOUNT_LINK');
                        }
                    });


                    /*******************
                    ***   GO BACK    ***
                    *******************/

                    // TODO: re-check BarneyHistory get() method before
                    // $scope.goBack = function(){
                    //  if($scope.backPage){
                    //      $location.url($scope.backPage);
                    //  } else if(History.getPrevPath() == null) {
                    //      $location.url(Config.get('ROUTER_HOME'));
                    //  } else {
                    //      History.goBack();
                    //  }
                    // }


                    /*******************
                    ***   TRACKING   ***
                    *******************/

                    $scope.trackEvent = function(event, label){
                        // get current page
                        var currentPage = '';
                        var current = $route.current.$$route;
                        if(!!current && !!current.className){
                            currentPage = current.className;
                        }

                        JsAnalytics.trackEvent({
                            category: 'Header',
                            action: 'HeaderClick',
                            label: label
                        });

                        NewtonAdapter.trackEvent({
                            name: 'HeaderClick',
                            properties: {
                                category: 'Header',
                                label: label,
                                page: currentPage
                            }
                        });

                        Browser.clickAndGo(event);
                    };
                }
            };
        }
    ]
);

'use strict';

angular.module('news').directive('headerLinks',
    ['BarneyConfig', 'User', 'HeaderLinks', 'Utility', function(Config, User, HeaderLinks, Utility){
        return {
            restrict: 'E',
            templateUrl: Utility.getTemplatePrefix() + '/modules/header/headerlinks.html',
            scope: {},
            link: function($scope, $element, $attr){

                User.getStatus(function(user){
                    if(user.logged){
                        if(Config.get('SHOW_OVER_HEADER_OPERATORS') && Config.get('SHOW_OVER_HEADER_OPERATORS').indexOf(user.operator) > -1){
                            $scope.links = HeaderLinks.getList();
                            $scope.headerLinks = true;
                        }
                    }
                });

            }
        };
    }]
);

angular.module('news').directive('footer',
    ['$rootScope', 'BarneyConfig', 'FooterLinks', 'Banner', 'Utility',
        function($rootScope, Config, FooterLinks, Banner, Utility){

            return {
                restrict: 'E',
                scope: {},
                templateUrl: function($element, $attr){
                    var isKiosk = (Config.get('KIOSK_SERVICE')) ? '_kiosk' : '';
                    if($attr.template){
                        return Utility.getTemplatePrefix() + '/modules/footer/' + $attr.template + isKiosk + '.html';
                    } else {
                        return Utility.getTemplatePrefix() + '/modules/footer/footer' + isKiosk + '.html';
                    }
                },
                link: function($scope, $element, $attr){
                    $scope.unifyFooter = Config.get('UNIFY_FOOTER_BEHAVIOR') ? Config.get('UNIFY_FOOTER_BEHAVIOR') : false;
                    $scope.links = FooterLinks.getList();
                    $scope.showBanner = false;
                    $scope.bannerItem = [];
                    $scope.hybrid = false;
                    $scope.showMultilanguage = Config.get('SHOW_MULTIPLE_LANGUAGE');
                    $scope.verticalFooter = '';

                    if ($scope.showMultilanguage){
                        $scope.languageList = Config.get('MULTILANGUAGE_LIST') || [];
                        $scope.currentLanguage = Config.get('LANGUAGE');
                    }

                    if (Config.get('ENABLE_VERTICAL_FOOTER')) {
                        $scope.verticalFooter = 'vertical-footer';
                    }

                    if (Config.get('ENABLE_MOVISTAR_FOOTER')) {
                        $scope.verticalFooter = 'movistar-footer';
                        $scope.customFooter = 'movistar-footer-main';
                    }

                    var initializeBanner = function(){
                        if(Config.get('SHOW_BANNER_FOOTER') && $scope.platform !== 'iOS'){
                            Banner.get({ type: 'banner', subtype: '' }).$promise.then(function(banners){
                                $scope.bannerItem = banners;
                                $scope.showBanner = true;

                                $scope.active = 0;

                                setInterval(function(){
                                    $scope.active = ($scope.active + 1) % $scope.bannerItem.length;
                                    $scope.$apply();
                                }, 3000);
                            });
                        }
                    };

                    $scope.platform = 'webapp';
                    initializeBanner();

                    if(typeof KIOSK_SERVICES_LIST !== 'undefined' && !!KIOSK_SERVICES_LIST){
                        $scope.kioskServicesList = KIOSK_SERVICES_LIST;
                    } else {
                        $scope.kioskServicesList = false;
                    }

                    $scope.openBanner = function(index){
                        window.location.href = $scope.bannerItem[index].url;
                    };

                    $scope.closeFooterServiceDescription = function(){
                        $rootScope.showFooterServiceDescription = false;
                    };
                }
            };
        }
    ]
);

'use strict';

angular.module('news').directive('scrolltotop',
    ['BarneyConfig', 'EventThrottler', 'Utility',
        function(Config, EventThrottler, Utility) {

            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/scrollToTop/scrollToTop.dir.html',
                replace: true,
                link: function($scope, $element, $attr){

                    var pageHeight = window.innerHeight;

                    function showBackToTop(){
                        $scope.showScrollTop = pageYOffset > pageHeight;
                        $scope.$apply();
                    }

                    var showBackToTopThrottler = new EventThrottler(showBackToTop);

                    window.addEventListener('scroll', showBackToTopThrottler);

                    $scope.$on('$destroy', function() {
                        window.removeEventListener('scroll', showBackToTopThrottler);
                    });

                    $scope.onClickCallback = function () {
                        // Using native smooth scroll if available
                        if ('scrollBehavior' in document.documentElement.style) {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            // No need to manually hide the arrow because the native event is slow enough to make the scroll checking work
                        } else {
                            // Fallback for older / Safari browsers
                            // Greater the number, faster the scroll
                            var scrollSpeed = 100;
                            // Get the first scroll destination
                            var scrollTo = scrollY - scrollSpeed;
                            // Repeat the scrollTo every 15ms
                            var interval = setInterval(function() {
                                if (scrollTo > 0) {
                                    // Scroll to the scroll destination
                                    window.scrollTo(0, scrollTo);
                                    // Update the scroll destination
                                    scrollTo -= scrollSpeed;
                                } else {
                                    // We are on top of the page, clear the interval and manually hide the scroll to top button
                                    clearInterval(interval);
                                    $scope.showScrollTop = false;
                                }
                            }, 15);
                        }
                    };
                }
            };
        }
    ]
);

angular.module('news').directive('socialButtons',
    ['$location', 'BarneyConfig', 'User', 'SocialSVC', 'Shortener', 'Utility',
        function($location, Config, User, SocialSvc, Shortener, Utility){

            return {
                restrict: 'E',
                replace: true,
                templateUrl: Utility.getTemplatePrefix() + '/modules/social/social.html',
                scope: {
                    shareUrl: '=',
                    itemTitle: '=',
                    itemTrackingTitle: '=',
                    id: '='
                },
                link: function($scope, $element, $attr){

                    /**************************
                    ***     SOCIAL SHARE    ***
                    **************************/

                    $scope.shareClass = 'icon-share_hybrid';
                    $scope.socialObj = {};
                    var deviceOs = Config.get('DEVICE_OS');
                    var twitterShareUrl = '';
                    var facebookShareUrl = '';
                    var whatsappShareUrl = '';
                    var generalShareUrl = '';
                    var cleanShareUrl = $location.protocol() + '://' + $location.host() + $scope.shareUrl;

                    var socials = {
                        facebook: Config.get('FACEBOOK_SHARE_ENABLED'),
                        twitter: Config.get('TWITTER_SHARE_ENABLED'),
                        whatsapp: Config.get('WHATSAPP_SHARE_ENABLED') && Config.get('IS_SMARTPHONE')
                    };
                    $scope.socialObj = socials;

                    User.getStatus(function(resp){

                        SocialSvc.setUrl({
                            logged: resp.logged,
                            utmMedium: 'share-button',
                            utmCampaign: $scope.shareUrl,
                            shareUrl: cleanShareUrl,
                            itemId: $scope.id
                        });

                        // Twitter
                        $scope.twShare = function(){
                            if(twitterShareUrl === ''){
                                Shortener.get({
                                    url: SocialSvc.getUrl($scope.id, 'twitter') || cleanShareUrl
                                }).$promise.then(function(url){
                                    twitterShareUrl = url.url;
                                    SocialSvc.share({ type: 'twitter', shareUrl: twitterShareUrl });
                                });
                            } else {
                                SocialSvc.share({ type: 'twitter', shareUrl: twitterShareUrl });
                            }

                            JsAnalytics.trackEvent({
                                category: 'Zoom Page',
                                action: 'ShareTW',
                                label: $scope.itemTrackingTitle || $scope.itemTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: 'ShareTW',
                                properties: {
                                    category: 'Zoom Page',
                                    label: $scope.id,
                                    title: $scope.itemTrackingTitle || $scope.itemTitle
                                }
                            });
                        };

                        // Facebook
                        $scope.fbShare = function(){
                            if(facebookShareUrl === ''){
                                Shortener.get({
                                    url: SocialSvc.getUrl($scope.id, 'facebook') || cleanShareUrl
                                }).$promise.then(function(url){
                                    facebookShareUrl = url.url;
                                    SocialSvc.share({ type: 'facebook', shareUrl: facebookShareUrl });
                                });
                            } else {
                                SocialSvc.share({ type: 'facebook', shareUrl: facebookShareUrl });
                            }

                            JsAnalytics.trackEvent({
                                category: 'Zoom Page',
                                action: 'ShareFB',
                                label: $scope.itemTrackingTitle || $scope.itemTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: 'ShareFB',
                                properties: {
                                    category: 'Zoom Page',
                                    label: $scope.id,
                                    title: $scope.itemTrackingTitle || $scope.itemTitle
                                }
                            });
                        };

                        // Whatsapp
                        $scope.waShare = function(){
                            if(whatsappShareUrl === ''){
                                Shortener.get({
                                    url: SocialSvc.getUrl($scope.id, 'whatsapp') || cleanShareUrl
                                }).$promise.then(function(url){
                                    whatsappShareUrl = url.url;
                                    SocialSvc.share({ type: 'whatsapp', shareUrl: whatsappShareUrl });
                                });
                            } else {
                                SocialSvc.share({ type: 'whatsapp', shareUrl: whatsappShareUrl });
                            }

                            JsAnalytics.trackEvent({
                                category: 'Zoom Page',
                                action: 'ShareWA',
                                label: $scope.itemTrackingTitle || $scope.itemTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: 'ShareWA',
                                properties: {
                                    category: 'Zoom Page',
                                    label: $scope.id,
                                    title: $scope.itemTrackingTitle || $scope.itemTitle
                                }
                            });
                        };

                        $scope.generalShare = function(){
                            if(generalShareUrl === ''){
                                Shortener.get({
                                    url: SocialSvc.getUrl($scope.itemId, 'shareUrl') || cleanShareUrl
                                }).$promise.then(function(url){
                                    generalShareUrl = url.url;
                                    SocialSvc.share({ type: 'chooser', shareUrl: generalShareUrl });
                                });
                            } else {
                                SocialSvc.share({ type: 'chooser', shareUrl: generalShareUrl });
                            }

                            JsAnalytics.trackEvent({
                                category: 'Zoom Page',
                                action: 'ShareGeneralHybrid',
                                label: $scope.itemTrackingTitle || $scope.itemTitle
                            });

                            NewtonAdapter.trackEvent({
                                name: 'GeneralShare',
                                properties: {
                                    category: 'ShareGeneralHybrid',
                                    label: $scope.id,
                                    title: $scope.itemTrackingTitle || $scope.itemTitle
                                }
                            });
                        };
                    });
                }
            };
        }
    ]
);

angular.module('news').directive('smartBanner',
    ['BarneyConfig', 'BarneyMeta', 'User', 'Utility', 'MFP',
        function (Config, Meta, User, Utility, MFP) {

            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/smart-banner/smartBanner.html',
                scope: {},
                link: function ($scope, $element, $attr) {

                    // set config vars
                    var storeUrl = '';

                    $scope.show = false;
                    $scope.isPromo = Config.get('IS_PROMO_SMART_BANNER');
                    $scope.hasMessage = false;

                    if (Config.get('DEVICE_OS') === 'Android') {
                        if (Config.get('GOOGLEPLAY_STORE_URL_INTENT') || Config.get('GOOGLE_PLAY_STORE_URL_HTTP')) {
                            storeUrl = Config.get('GOOGLEPLAY_STORE_URL_INTENT') || Config.get('GOOGLE_PLAY_STORE_URL_HTTP');
                            $scope.hasMessage = Config.get('SMART_BANNER_MESSAGE_ENABLED');
                        }
                    } else if (Config.get('DEVICE_OS') === 'iPhone OS' || Config.get('DEVICE_OS') === 'iOS') {
                        if (Config.get('ITUNES_STORE_URL_HTTP')) {
                            storeUrl = Config.get('ITUNES_STORE_URL_HTTP');
                        }
                    }

                    // show banner
                    if (!!storeUrl) {
                        if (Config.get('SMART_BANNER_ENABLED') && !JsStorage.get('HIDE_SMART_BANNER')) {
                            if (Config.get('SHOW_ADV_FOR_LOGGED')) {
                                User.getStatus(function (user) {
                                    if (user.logged) {
                                        $scope.show = true;
                                    }
                                });
                            } else {
                                $scope.show = true;
                            }
                        }
                    }


                    $scope.closeBanner = function () {
                        $scope.show = false;

                        if (!$scope.isPromo) {
                            JsStorage.set('HIDE_SMART_BANNER', 1, { type: 'cookie', exdays: Config.get('SMART_BANNER_REMINDER') });
                        }

                        NewtonAdapter.trackEvent({
                            name: 'CloseAppPromoClick',
                            properties: {
                                category: 'Behavior',
                                action: 'CloseAppPromoClick',
                                label: window.location.href
                            }
                        });
                    };

                    $scope.getApp = function () {
                        $scope.closeBanner();

                        NewtonAdapter.trackEvent({
                            name: 'NativeAppPromoClick',
                            properties: {
                                category: 'Behavior',
                                action: 'NativeAppPromoClick',
                                label: window.location.href,
                                section: 'SmartBanner'
                            }
                        });
                        // Snow Plow User Interaction
                        if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                        data: {
                                            environment: 'browser', 
                                            tracking_name: 'NativeAppPromoClick'
                                        }
                                    }
                                ]
                            });
                        }

                        if (Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter) {
                            facebookpixeladapter.trackCustom('NativeAppPromoClick', {
                                platform: Config.get('DEVICE_OS')
                            });
                        }


                        var dldButton = document.getElementById('downloadButtonBanner');
                        MFP.start({ storeUrl: storeUrl }, function (resp) {
                            /*eslint-disable no-script-url*/
                            dldButton.setAttribute('href', 'javascript:window.location.href=\'' + resp + '\'; 0;');
                            if (Config.get('DEVICE_OS') === 'Android') {
                                window.location.href = dldButton.getAttribute('href');

                            } else {
                                window.location.href = resp;
                            }

                        });


                    };
                }
            };
        }
    ]
);

angular.module('news').directive('callToAction',
    ['BarneyMeta', 'BarneyConfig', 'MFP', 'Utility', function (Meta, Config, MFP, Utility) {

        return {
            restrict: 'E',
            templateUrl: Utility.getTemplatePrefix() + '/modules/callToAction/callToAction.html',
            replace: true,
            link: function ($scope, $element, $attr) {

                var storeUrl = '';
                $scope.showSection = false;

                if (Config.get('DEVICE_OS') === 'Android') {
                    if (Config.get('GOOGLEPLAY_STORE_URL_INTENT') || Config.get('GOOGLE_PLAY_STORE_URL_HTTP')) {
                        storeUrl = Config.get('GOOGLEPLAY_STORE_URL_INTENT') || Config.get('GOOGLE_PLAY_STORE_URL_HTTP');
                    }
                } else if (Config.get('DEVICE_OS') === 'iPhone OS' || Config.get('DEVICE_OS') === 'iOS') {
                    if (Config.get('ITUNES_STORE_URL_HTTP')) {
                        storeUrl = Config.get('ITUNES_STORE_URL_HTTP');
                    }
                }

                if (!!storeUrl) {
                    $scope.showSection = true;
                }

                $scope.getApp = function () {

                    NewtonAdapter.trackEvent({
                        name: 'NativeAppPromoClick',
                        properties: {
                            category: 'Behavior',
                            action: 'NativeAppPromoClick',
                            label: window.location.href,
                            section: 'CallToAction'
                        }
                    });
                    // Snow Plow User Interaction
                    if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                        window.snowplow('trackSelfDescribingEvent', {
                            event: {
                                schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                data: {}
                            },
                            context: [
                                {
                                    schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                    data: {
                                        environment: 'browser', 
                                        tracking_name: 'NativeAppPromoClick'
                                    }
                                }
                            ]
                        });
                    }

                    if (Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter) {
                        facebookpixeladapter.trackCustom('NativeAppPromoClick', {
                            platform: Config.get('DEVICE_OS')
                        });
                    }

                    var dldButton = document.getElementById('downloadButtonCallToAction');
                    MFP.start({ storeUrl: storeUrl }, function (resp) {
                        /*eslint-disable no-script-url*/
                        dldButton.setAttribute('href', 'javascript:window.location.href=\'' + resp + '\'; 0;');
                        if (Config.get('DEVICE_OS') === 'Android') {
                            window.location.href = dldButton.getAttribute('href');

                        } else {
                            window.location.href = resp;
                        }
                    });

                };
            }
        };
    }]
);

'use strict';

angular.module('news').directive('overlay',
    ['$window', '$timeout', 'BarneyConfig', 'BarneyMeta', 'EventBus', 'Utility', 'MFP',
        function ($window, $timeout, Config, BarneyMeta, Bus, Utility, MFP) {

            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/overlay/overlay.html',
                scope: {},
                link: function ($scope, $element, $attr) {

                    // set config vars
                    var overlayEnabled = Config.get('SHOW_ADV_OVERLAY');
                    var storeUrl = '';

                    $scope.showOverlay = false;
                    $scope.overlayClass = 'overlay-hidden';
                    $scope.isPromo = Config.get('IS_PROMO_SMART_BANNER');

                    if (Config.get('DEVICE_OS') === 'Android' && (Config.get('GOOGLEPLAY_STORE_URL_INTENT') || (Config.get('GOOGLEPLAY_STORE_URL_HTTP')))) {
                        storeUrl = Config.get('GOOGLEPLAY_STORE_URL_INTENT') || Config.get('GOOGLEPLAY_STORE_URL_HTTP');
                    } else if (Config.get('DEVICE_OS') === 'iOS' || (Config.get('DEVICE_OS') === 'iPhone OS' && (Config.get('ITUNES_STORE_URL_HTTP')))) {
                        storeUrl = Config.get('ITUNES_STORE_URL_HTTP');
                    }

                    if (storeUrl) {
                        if (overlayEnabled) {
                            Bus.on('overlay-show', function (callbackyObj) {

                                $scope.showOverlay = true;
                                $timeout(function () {
                                    $scope.overlayClass = 'overlay-open';
                                }, 1);

                                JsAnalytics.trackEvent({
                                    category: 'Overlay',
                                    action: 'OverlayShow',
                                    label: callbackyObj.label
                                });

                                NewtonAdapter.trackEvent({
                                    name: 'OverlayShow',
                                    properties: {
                                        category: 'Overlay',
                                        label: callbackyObj.label,
                                        page: $window.location.href,
                                        content_id: callbackyObj.content_id
                                    }
                                });
                            }, null, false);

                            $scope.closeOverlay = function () {
                                $scope.overlayClass = 'overlay-hidden';

                                NewtonAdapter.trackEvent({
                                    name: 'CloseOverlayPromoClick',
                                    properties: {
                                        category: 'Behavior',
                                        action: 'CloseOverlayPromoClick',
                                        label: window.location.href
                                    }
                                });

                                $timeout(function () {
                                    $scope.showOverlay = false;
                                }, 4000);
                            };

                            $scope.getApp = function () {
                                $scope.closeOverlay();

                                NewtonAdapter.trackEvent({
                                    name: 'NativeAppPromoClick',
                                    properties: {
                                        category: 'Behavior',
                                        action: 'NativeAppPromoClick',
                                        label: window.location.href,
                                        section: 'Overlay'
                                    }
                                });
                                // Snow Plow User Interaction
                                if (window.snowplow !== undefined && Config.get('SNOWPLOW_TRACKING_ANALYTICS')) {
                                    window.snowplow('trackSelfDescribingEvent', {
                                        event: {
                                            schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                            data: {}
                                        },
                                        context: [
                                            {
                                                schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                                data: {
                                                    environment: 'browser', 
                                                    tracking_name: 'NativeAppPromoClick'
                                                }
                                            }
                                        ]
                                    });
                                }

                                if (Config.get('FACEBOOK_PIXEL_ENABLE') && Config.get('FACEBOOK_PIXEL_ID') && !!facebookpixeladapter) {
                                    facebookpixeladapter.trackCustom('NativeAppPromoClick', {
                                        platform: Config.get('DEVICE_OS')
                                    });
                                }
                                if (!Config.get('OTHER_OVERLAY_BUTTON')) {
                                    var dldButton = document.getElementById('downloadButtonOverLay');
                                    MFP.start({ storeUrl: storeUrl }, function (resp) {
                                        /*eslint-disable no-script-url*/

                                        dldButton.setAttribute('href', 'javascript:window.location.href=\'' + resp + '\'; 0;');
                                        if (Config.get('DEVICE_OS') === 'Android') {
                                            window.location.href = dldButton.getAttribute('href');

                                        } else {
                                            window.location.href = resp;
                                        }

                                    });
                                }

                                if (Config.get('OTHER_OVERLAY_BUTTON')) {
                                    var dldButtonOther = document.getElementById('downloadButtonOverLayOther');
                                    MFP.start({ storeUrl: storeUrl }, function (respOther) {
                                        /*eslint-disable no-script-url*/
    
                                        dldButtonOther.setAttribute('href', 'javascript:window.location.href=\'' + respOther + '\'; 0;');
                                        if (Config.get('DEVICE_OS') === 'Android') {
                                            window.location.href = dldButtonOther.getAttribute('href');
    
                                        } else {
                                            window.location.href = respOther;
                                        }
    
                                    });
                                }
                            };
                        }
                    }
                }
            };
        }
    ]
);

angular.module('news').directive('banner',
    ['BarneyConfig', 'User', '$document', 'Utility',
        function (Config, User, $document, Utility) {

            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/banner/banner.html',
                scope: {},
                link: function ($scope, $element, $attr) {
                    
                    if (Config.get('PROMO_BANNER_CHECK_DEVICE')) {

                        if (Config.get('DEVICE_OS') === 'Android' || Config.get('DEVICE_OS') === 'iOS' || Config.get('DEVICE_OS') === 'iPhone OS') {
                            $scope.promoBannerUrl = Config.get('PROMO_BANNER_URL_MOBILE');
                            
                        } else {   
                            $scope.promoBannerUrl = Config.get('PROMO_BANNER_URL_DESKTOP');
                            
                        }
                    }
    

                    User.getProperty('banner_agreed', function (bannerAgreed) {

                        // Init variables
                        var showBannerPromo = !!Config.get('SHOW_BANNER_PROMO');
                        var cookieExist = !!window.sessionStorage.getItem('bannerpromoflag');

                        // Show/hide cookie alert
                        $scope.show = (showBannerPromo && !cookieExist) ? true : false;


                        // JsLogger
                        JsLogger.info('banner', {
                            _show: $scope.show,
                            showBannerPromo: showBannerPromo,
                            cookieExist: cookieExist
                        });

                    });


                    $scope.close = function () {

                        NewtonAdapter.trackEvent({
                            name: 'CloseBannerPromoClick',
                            properties: {
                                category: 'Behavior',
                                action: 'CloseBannerPromoClick',
                                label: window.location.href
                            }
                        });

                        // Set bannerpromoflag cookie       
                        window.sessionStorage.setItem('bannerpromoflag', true);

                        // Hide cookie alert
                        $scope.show = false;

                        // Remove listener on scroll and overlay
                        document.removeEventListener('scroll', $scope.close);
                        if (angular.element(document.querySelector('#cookie-overlay'))) {
                            angular.element(document.querySelector('#cookie-overlay')).remove();
                        }

                    };


                    $scope.closeAfterLink = function () {

                        NewtonAdapter.trackEvent({
                            name: 'BannerPromoLink',
                            properties: {
                                category: 'Behavior',
                                action: 'BannerPromoLink',
                                label: window.location.href
                            }
                        });

                        // Set bannerpromoflag cookie
                        window.sessionStorage.setItem('bannerpromoflag', true);


                        // Hide cookie alert
                        $scope.show = false;

                        // Remove listener on scroll and overlay
                        document.removeEventListener('scroll', $scope.close);
                        if (angular.element(document.querySelector('#cookie-overlay'))) {
                            angular.element(document.querySelector('#cookie-overlay')).remove();
                        }

                    };

                }
            };
        }
    ]
);

angular.module('news').directive('menu',
    ['User', 'BarneyConfig', 'EventBus', 'Utility',
        function(User, Config, Bus, Utility){
            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/menu/menu.html',
                scope: {},
                link: function($scope, $element, $attr){

                    var getUserLink = function(user) {
                        if (user && user.logged || (Config.get('PAYWALL_IS_ENABLED'))) { // eslint-disable-line no-mixed-operators
                            if(Config.get('ENABLE_NEWTON_USER') && user.fake && user.fake === 'fake'){
                                $scope.userLink = Config.get('ACCOUNT_LINK');
                            } else {
                                $scope.userLink = Config.get('ACCOUNT_LINK_LOGGED');
                            }
                        } else if(Config.get('ADD_DOMAIN_TO_ACCOUNT_LINK')){
                            $scope.userLink = Config.get('DEST_DOMAIN') + Config.get('ACCOUNT_LINK');
                        } else {
                            $scope.userLink = Config.get('ACCOUNT_LINK');
                        }
                    };

                    User.getStatus(getUserLink);

                    Bus.on('User-Login-Menu', getUserLink);

                    Bus.on('User-Logout-Menu', getUserLink);


                    if(Config.get('ENABLE_PERSONALIZATION')){
                        $scope.visible = true;
                    }
                }
            };
        }
    ]
);

angular.module('news').directive('thankYou',
    ['$timeout', 'BarneyConfig', 'User', 'BarneyBrowser', 'EventBus', 'Utility',
        function($timeout, Config, User, Browser, Bus, Utility){

            return {
                restrict: 'E',
                replace: true,
                templateUrl: Utility.getTemplatePrefix() + '/modules/thankYou/thank-you.html',

                link: function($scope, $element, $attr){

                    var thankYouPageEnabled = Config.get('THANKYOUPAGE_ON_MIP');
                    var queryParams = Browser.getQueryParams();
                    var timeToShow = Config.get('THANKYOUPAGE_ON_MIP_DELAY_MS') ? Config.get('THANKYOUPAGE_ON_MIP_DELAY_MS') : 3000;
                    var thankYouTimeout = false;
                    $scope.showThankYou = false;

                    if(typeof queryParams.typmip !== 'undefined'){
                        if(thankYouPageEnabled && queryParams.typmip){
                            Bus.on('cssHasFinished', function(){
                                User.getStatus(function(user){
                                    if(user.logged){
                                        $scope.showThankYou = true;
                                        Bus.clear('cssHasFinished');

                                        thankYouTimeout = $timeout(function(){
                                            $scope.showThankYou = false;
                                            $scope.$apply();
                                        }, timeToShow);
                                    }
                                });
                            });
                        }
                    }

                    $scope.closeModal = function () {
                        $scope.showThankYou = false;
                        if(thankYouTimeout){
                            $timeout.cancel(thankYouTimeout);
                        }
                    };
                }
            };
        }
    ]
);

(function() {
    angular.module('news').directive('dModal', ['$dModal', '$compile', '$timeout', 'BarneyConfig', 'Utility', 
        function($dModal, $compile, $timeout, Config, Utility) {
            return {
                restrict: 'AE',
                replace: true,
                templateUrl: Utility.getTemplatePrefix() + '/modules/modal/modalDialog.html',
                scope: {},
                link: function link($scope, $element, $attrs) {
                    
                    var id = $attrs.dModal;
                    var args = [];
                    args.unshift(id);
                        
                    $scope.closeModal = function() {
                        $dModal.close.apply(undefined, args);
                    };

                    $scope.confirm = function() {
                        $dModal.confirm.apply(undefined, args);
                    };

                    $dModal.setModals({
                        id: id,
                        $scope: $scope,
                        $element: $element
                    });

                    $element.on('$destroy', function() {
                        $dModal.unsetModal(id);
                    });
                }
            };
        }]);
}());

(function() {
    angular.module('news').factory('$dModal', ['$rootScope', '$location', '$timeout', '$compile', function($rootScope, $location, $timeout, $compile) {

        var modalAction = {
            waitingForOpen: false,
            setModals: setModals,
            unsetModal: unsetModal,
            open: open,
            close: close,
            confirm: confirm
        };

        var $body = angular.element(document.body);
        var $dModalDialogsWrapper = angular.element('<div role="dialog" tabindex="-1" class="modal"><div class="modal-backdrop"></div></div>');
        var $dModalWrapper = angular.element('<div class="modal-wrapper"></div>');
        var modals = {};
        var openedModals = [];
        var baseOverflow;
        
        $dModalWrapper.css('display', 'none');
        $dModalWrapper.append($dModalDialogsWrapper);
        $body.append($dModalWrapper);
        
        function open (opt) {

            var modal = modals[opt.id || '_default'];
            if(!modal) {
                $dModalDialogsWrapper.append($compile('<div d-modal="' + (opt.id ? opt.id : '_default') + '"></div>')($rootScope));
                $timeout(function() { 
                    modalAction.open(opt);
                });
                return;
            } else if(modal && openedModals.indexOf(opt.id || '_default') !== -1) { 
                modalAction.waitingForOpen = true;
                $timeout(function() { 
                    modalAction.open(opt);
                });
                return;
            }
        
            if(!modalAction.waitingForOpen) {
                if(openedModals.length === 0) { 
                    baseOverflow = document.body.style.overflow;
                    document.body.style.overflow = 'hidden';
                    $dModalWrapper.css('display', 'block');
                } else {
                    for(var i = 0; i < openedModals.length; i++) {
                        var $e = modals[openedModals[i]].$element;
                        modals[openedModals[i]].baseZIndex = $e.css('z-index');
                        $e.css('z-index', '-1');
                    }
                }
            }
            modalAction.waitingForOpen = false;
            openedModals.push(opt.id || '_default');
            modal.params = opt;
            modal.$scope.customClass = modal.params.cls;
            
            $timeout(function() {
                modal.$scope.modalShow = true;
            }, 100);
            
            if(typeof modal.params.onOpen === 'function') {
                modal.params.onOpen();
            }

            if(modal.params.clickFrom){
                modal.$scope.clickFrom = modal.params.clickFrom;
            } 

            if(modal.params.url) {
                modal.$scope.modalUrl = modal.params.url; 
            } else {
                var e = new Error('Url template missed');
                console.log(e);
                throw e;
            }
            
        }

        function setModals (params) {
            modals[params.id || '_default'] = params;
        }

        function unsetModal (id) {
            delete modals[id || '_default'];
        }

        function close(id) {
            var modal = modals[id || openedModals[openedModals.length - 1]];
            if(modal && modal.$scope.modalShow === true) {
                modal.$scope.modalShow = false;
                modal.$element.remove(); 
                openedModals.splice(openedModals.indexOf(id || openedModals[openedModals.length - 1]), 1);
                if(openedModals.length === 0) { 
                    if(!modalAction.waitingForOpen) {
                        document.body.style.overflow = baseOverflow; 
                        $dModalWrapper.css('display', 'none');
                    }
                } else {
                    var topModal = modals[openedModals[openedModals.length - 1]];
                    topModal.$element.css('z-index', topModal.baseZIndex);
                }
                if(typeof modal.params.onClose === 'function') {
                    var args = [];
                    args.unshift(id);
                    modal.params.onClose.apply(undefined, args);
                }
            }
        }

        function confirm(id){
            var modal = modals[id || openedModals[openedModals.length - 1]];
            
            if(typeof modal.params.onConfirm === 'function') {
                var args = [];
                args.unshift(id);
                modal.params.onConfirm.apply(undefined, args);
            }
        }
        
        return modalAction;
    }]);
}());

angular.module('news').directive('userFeedback',
    ['BarneyConfig', 'User', '$document', 'Utility',
        function(Config, User, $document, Utility){

            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/user-feedback/userFeedback.html',
                scope: {},
                link: function($scope, $element, $attr){
                    useris.PopupManager.init(Config.get('USERIS_POPUP_CONFIGURATION'), function(resp){
                        console.log('USERIS', 'Popup initialized', resp);
                    });
                }
            };
        }
    ]
);

angular.module('news').directive('consentManager',
    ['BarneyConfig', 'User', '$document', 'Utility',
        function (Config, User, $document, Utility) {

            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/cookiealert/consent.html',
                scope: {},
                link: function ($scope, $element, $attr) {

                    $scope.openPrefs = function () {
                        if (Didomi && Didomi.preferences) {
                            Didomi.preferences.show();
                        }
                    };

                }
            };
        }
    ]
);

angular.module('news').directive('headerBottom',
    ['$rootScope', '$location', '$route', 'BarneyConfig', 'BarneyBrowser', 'Category', 'Tag', 'Utility',
        function ($rootScope, $location, $route, Config, Browser, Category, Tag, Utility) {
            return {
                templateUrl: Utility.getTemplatePrefix() + '/modules/header/header-split/header-bottom.html',
                link: function($scope, $element, $attr) {

                    console.log('Utility');
                    console.log(Utility);

                    $scope.open = false;
                    $scope.currentIndex = null;
                    $scope.showHeaderBottom = true;

                    $scope.categories = [];
                    $scope.ageRangeTags = [];
                    $scope.trendingTags = [];

                    $scope.currentUrl = '';

                    var hideHeaderBottomClasses = Config.get('HEADER_BOTTOM_HIDDEN_PAGES') || [];

                    var setHeaderBottomVisibility = function($$route) {
                        $scope.showHeaderBottom = hideHeaderBottomClasses.indexOf($$route.className) < 0;
                    };

                    var setCurrentUrl = function() {
                        $scope.currentUrl = '#!' + $location.$$url;
                    };

                    $rootScope.$on('$routeChangeStart', function(event, next) {
                        $scope.open = false;
                        $scope.currentIndex = null;
                        setHeaderBottomVisibility(next.$$route);
                        setCurrentUrl();
                    });

                    $element.ready(function() {
                        setCurrentUrl();
                        setHeaderBottomVisibility($route.current.$$route);
                    });

                    $scope.toggleMenu = function(index) {
                        if ($scope.open && $scope.currentIndex === index) {
                            $scope.open = false;
                            $scope.currentIndex = null;
                        } else {
                            $scope.open = true;
                            $scope.currentIndex = index;
                        }
                    };

                    Category.getList().$promise.then(function(response) {
                        $scope.categories = response;
                    });

                    Tag.getList().$promise.then(function(response) {
                        var ageRangeTagSlugs = Config.get('AGE_RANGE_TAGS_IDS') || [];
                        angular.forEach(response, function(tag) {

                            if (ageRangeTagSlugs.indexOf(tag.slug) >= 0) {
                                var index = Utility.arraySearchIndex(ageRangeTagSlugs, tag.slug);
                                $scope.ageRangeTags[index] = tag;
                            } else {
                                $scope.trendingTags.push(tag);
                            }
                        });

                    });

                    /*******************
                    ***   TRACKING   ***
                    *******************/

                    $scope.trackNavClick = function(event, type, title){
                        JsAnalytics.trackEvent({
                            category: type,
                            action: 'Click',
                            label: title
                        });

                        NewtonAdapter.trackEvent({
                            name: 'Click',
                            properties: {
                                category: type,
                                label: title
                            }
                        });

                        Browser.clickAndGo(event);
                    };
                }
            };
        }
    ]);

angular.module('news').directive('breadcrumbs',
    ['BarneyConfig', 'BarneyBrowser', '$window', '$location', 'Utility', function(Config, Browser, $window, $location, Utility) {
        return {
            restrict: 'E',
            templateUrl: Utility.getTemplatePrefix() + '/modules/breadcrumbs/breadcrumbs.html',
            replace: true,
            scope: {
                item: '=?'
            },
            link: function($scope) {
                $scope.goBack = function() {
                    // Navigate to previous path if is inside the App, else redirect to homepage
                    var prevPath = Browser.getPrevPath();
                    if (prevPath) {
                        $window.history.back();
                    } else {
                        $location.url('/');
                    }
                };

                $scope.breadcrumbs = [];

                if ($scope.item) {
                    $scope.breadcrumbs.push({
                        title: 'Home',
                        href: '#!' + Config.get('ROUTER_HOME'),
                        type: 'Home'
                    });
                    if (
                        $scope.item.category
                        && $scope.item.category.name
                        && $scope.item.category.url_zoom
                    ) {
                        $scope.breadcrumbs.push({
                            title: $scope.item.category.name,
                            href: $scope.item.category.url_zoom,
                            type: 'Category'
                        });
                    }
                    $scope.breadcrumbs.push({
                        title: $scope.item.title,
                        last: true,
                        type: 'Zoom'
                    });
                }

                /*******************
                ***   TRACKING   ***
                *******************/

                $scope.trackNavClick = function(event, type, title){
                    if(type === 'Home'){

                        JsAnalytics.trackEvent({
                            category: 'Zoom Page',
                            action: 'ClickHome',
                            label: 'Home Page'
                        });
                        NewtonAdapter.trackEvent({
                            name: 'ClickHome',
                            properties: {
                                category: 'Zoom Page',
                                label: 'Home Page'
                            }
                        });

                    } else if(type === 'Category'){

                        JsAnalytics.trackEvent({
                            category: 'Zoom Page',
                            action: 'ClickCat',
                            label: title
                        });
                        NewtonAdapter.trackEvent({
                            name: 'ClickCat',
                            properties: {
                                category: 'Zoom Page',
                                label: title
                            }
                        });

                    }
        
                    Browser.clickAndGo(event);
                };
            }
        };
    }]
);

angular.module('news').directive('shareNative',
    ['$location', 'BarneyConfig', 'Shortener', 'SocialSVCPlatformAware', 'BarneyBrowser', 'EventBus', 'Utility',
        function($location, Config, Shortener, SocialSvc, Browser, EventBus, Utility) {
            return {
                restrict: 'E',
                templateUrl: Utility.getTemplatePrefix() + '/modules/share/share.html',
                link: function($scope) {
                    // Cached shorted url for native share
                    var shortedUrl = null;
                    // Cached shorted urls for custom share
                    var shareUrls = {};

                    $scope.isOpen = false;
                    $scope.data = null;

                    $scope.socials = {};

                    var onOpenShare = function(data) {
                        if (navigator.share) {
                            // If native share is available, use that
                            var shortnerPromise = shortedUrl
                                ? Promise.resolve(shortedUrl)
                                // GET shortened url
                                : Shortener.get({
                                    url: data.urls.shareUrl
                                }).$promise.then(function(payload) {
                                    // "Cache it"
                                    shortedUrl = payload.url;
                                    return shortedUrl;
                                });
                            shortnerPromise.then(function(url) {
                                navigator.share({
                                    title: data.title,
                                    url: url
                                }).then(function() {
                                    // Share successful, we can't know which service was used, trigger a generic "Share" event
                                    trackShare({
                                        label: data.trackingTitle || data.title
                                    });
                                }).catch(function(err) {
                                    console.log('Native Share', 'malformed share object', [data, url]);
                                });
                            });
                        } else {
                            // If no native share is available (old phone, no https, desktop), open the custom one
                            $scope.open();
                            $scope.data = data;
                            $scope.socials = {
                                sms: {
                                    enabled: Config.get('SMS_SHARE_ENABLED') && Config.get('IS_SMARTPHONE'),
                                    icon: 'sms'
                                },
                                whatsapp: {
                                    trackAction: 'ShareWA',
                                    enabled: Config.get('WHATSAPP_SHARE_ENABLED'),
                                    icon: 'whatsapp'
                                },
                                email: {
                                    enabled: Config.get('EMAIL_SHARE_ENABLED'),
                                    trackAction: 'Share',
                                    extraArgs: { title: $scope.data.title },
                                    icon: 'email'
                                },
                                facebook: {
                                    enabled: Config.get('FACEBOOK_SHARE_ENABLED'),
                                    trackAction: 'ShareFB',
                                    icon: 'facebook'
                                },
                                twitter: {
                                    enabled: Config.get('TWITTER_SHARE_ENABLED'),
                                    trackAction: 'ShareTW',
                                    icon: 'twitter'
                                },
                                copy: {
                                    enabled: Config.get('COPY_SHARE_ENABLED'),
                                    icon: 'copy'
                                }
                            };
                        }
                    };

                    // Register the share event
                    // To trigger an event, SocialSVCPlatformAware.openShare passing a valid share object (@see shareButton.js)
                    EventBus.on('openShare', onOpenShare);

                    // Deregister the event
                    $scope.$on('$destroy', function() {
                        EventBus.off('openShare', onOpenShare);
                    });

                    $scope.open = function() {
                        $scope.isOpen = true;
                        document.body.classList.add('share-open');
                    };

                    $scope.close = function() {
                        $scope.isOpen = false;
                        document.body.classList.remove('share-open');
                    };

                    /**
                     * Custom share action
                     * @param target The share target (email, facebook, twitter, copy...)
                     * @param trackAction The action name to track
                     * @param extraArgs Parameters to pass to SocialSVCPlatformAware.share function
                     * @return {Promise|Promise|*}
                     */
                    $scope.share = function share(target, trackAction, extraArgs) {
                        trackAction = trackAction || 'Share';
                        extraArgs = extraArgs || {};
                        // Workaround: if the cached url is used (and the promise is resolved immediately), the $digest is not triggered.
                        // In that case we need to trigger it manually calling $scope.$apply()
                        var needApply = true;
                        if (!$scope.data) {
                            // If no data is set, there is nothing to share.
                            // This should never happen since the share is hidden until some data is present
                            return Promise.resolve();
                        }
                        var sharePromise = shareUrls[target]
                            // Use the cached shortened url if available
                            ? Promise.resolve(shareUrls[target])
                            // Else GET the shortened url
                            : Shortener.get({
                                url: SocialSvc.getUrl($scope.data.id, target) || $scope.data.urls.shareUrl
                            }).$promise.then(function(payload) {
                                // "Cache" the url
                                shareUrls[target] = payload.url;
                                // No cache, no $apply needed
                                needApply = false;
                                return shareUrls[target];
                            });

                        return sharePromise.then(function(url) {
                            // Perform the share action based on the requested target
                            SocialSvc.share(angular.merge({ type: target, shareUrl: url }, extraArgs));
                        }).then(function() {
                            // Share complete, close the share popup
                            $scope.close();
                            // Track the share action
                            trackShare(trackAction);
                            // Remove share data
                            $scope.data = null;
                            if(needApply) {
                                $scope.$apply();
                            }
                        });
                    };

                    /**
                     * Track share action
                     * Accepts both a string representing the Action name or an object with action and label
                     * @param actionOrObj
                     */
                    function trackShare(actionOrObj) {
                        function getLabel(obj) {
                            // Get obj.label if defined
                            if (obj && obj.label) {
                                return obj.label;
                            }
                            // Get $scope.data.trackingTitle if present, else get $scope.dta.title, fallback to empty string
                            return $scope.data ? $scope.data.trackingTitle || $scope.data.title : '';
                        }
                        var action,
                            label;
                        // Something is passed
                        if (actionOrObj) {
                            // Action name is passed
                            if (typeof actionOrObj === 'string') {
                                action = actionOrObj;
                                // Get from $scope.data if present
                                label = getLabel();
                            } else { // An object is passed
                                // Default action: Share
                                action = actionOrObj.action || 'Share';
                                // Get from object, fallback to $scope.data if present
                                label = getLabel(actionOrObj);
                            }
                        } else { // Nothing is passed
                            action = 'Share';
                            label = '';
                        }
                        action = action || 'Share';
                        JsAnalytics.trackEvent({
                            category: 'Zoom Page',
                            action: action,
                            label: label
                        });

                        NewtonAdapter.trackEvent({
                            name: action,
                            properties: {
                                category: 'Zoom Page',
                                label: label
                            }
                        });
                    }
                }
            };
        }
    ]
);

angular.module('news').directive('shareButton',
    ['$location', 'BarneyConfig', 'Shortener', 'SocialSVCPlatformAware', 'BarneyBrowser', 'Utility', function($location, Config, Shortener, SocialSVC, Browser, Utility) {
        return {
            restrict: 'E',
            templateUrl: Utility.getTemplatePrefix() + '/modules/shareButton/shareButton.html',
            replace: true,
            scope: {
                shareUrl: '=',
                itemTitle: '=',
                itemTrackingTitle: '=',
                id: '='
            },
            link: function($scope) {
                console.log('sharebtn', $scope.shareUrl);
                $scope.share = function() {
                    SocialSVC.openShare({
                        utmMedium: 'share-button',
                        utmCampaign: $scope.shareUrl,
                        shareUrl: /*$location.protocol() + '://' + $location.host() + */$scope.shareUrl,
                        itemId: $scope.id,
                        itemTitle: $scope.itemTitle,
                        itemTrackingTitle: $scope.itemTrackingTitle
                    });
                };
            }
        };
    }]
);

angular.module('news').directive('sliderContent', [
    'BarneyConfig', '$filter', 'Utility',
    function (Config, $filter, Utility) {
        return {
            restrict: 'E',
            scope: {
                slide: '=',
                size: '@'
            },
            templateUrl: Utility.getTemplatePrefix() + '/modules/slider/slider-content/slider-content.html',
            link: function ($scope) {
                $scope.bgImage = null;
                // Is video if content type is video or if images obj has size obj with a url (external video provider)
                $scope.isVideo = $scope.slide.custom_content_type === 'video'
                    || ($scope.slide.images[$scope.size] && $scope.slide.images[$scope.size].url);

                if ($scope.slide.images.cover.ratio_1
                    && ($scope.slide.custom_content_type === 'text'
                        || $scope.slide.custom_content_type === 'videogallery'
                        || $scope.slide.custom_content_type === 'video'
                        || $scope.slide.custom_content_type === 'audio')
                ) {
                    $scope.bgImage = $filter('imagesize')($scope.slide.images.cover.ratio_1, 'slider', $scope.size);
                } else if ($scope.slide.images[$scope.size] && $scope.slide.images[$scope.size].url) {
                    // VIDEO External Provider
                    $scope.bgImage = $scope.slide.images[$scope.size].url;
                }
            }
        };
    }
]);

angular.module('news').directive('loader',
    ['BarneyConfig', '$sce', 'Utility', function(Config, $sce, Utility) {
        return {
            restrict: 'E',
            templateUrl: Utility.getTemplatePrefix() + '/modules/loader/loader.html',
            replace: true,
            scope: {},
            link: function($scope, $elem) {
                $elem.ready(function() {
                    if (Config.get('LOTTIE_LOADER')) {
                        var lottieElement = createLottie();
                        $elem[0].querySelector('.lottie').appendChild(lottieElement);
                    }
                });

                function createLottie() {
                    const lottieUrl = Config.get('LOTTIE_PLAYER');
                    var lottieElem = document.createElement('lottie-player');
                    lottieElem.setAttribute('autoplay', true);
                    lottieElem.setAttribute('loop', true);
                    lottieElem.setAttribute('mode', 'normal');
                    lottieElem.setAttribute('src', lottieUrl ? $sce.trustAsResourceUrl(lottieUrl) : '');

                    return lottieElem;
                }
            }
        };
    }]
);

angular.module("news").run(["$templateCache", function($templateCache) {$templateCache.put("/js/wl/webstore_news/app/user30test.html","<html><head><meta name=\"viewport\" content=\"width=device-width,user-scalable=no,initial-scale=1,minimum-scale=1,maximum-scale=1\"><script src=\"https://static.newton.pm/js/v2.x/newton.min.js\"></script><script>function init(){\n                // var secretid = document.getElementById(\'secretid\').value;\n                var id = \"<TMPL_VAR NAME=NEWTON_SECRETID>\";\n                if(id.indexOf(\"TMPL_VAR\") != -1){\n                    // var secretid = \"<local_host>\";\n                    var secretid = \"f$xC_L3RwY&h8kraC&!o\";\n                } else {\n                    var secretid = \"<TMPL_VAR NAME=NEWTON_SECRETID>\";\n                }\n                Newton.getSharedInstanceWithConfig(secretid);\n                document.getElementById(\'blackboard\').innerHTML = \"Newton initialized <br/>\";\n                document.getElementById(\'blackboard\').innerHTML += \"isUserLogged: \" + Newton.getSharedInstance().isUserLogged() + \"<br/>\";\n                document.getElementById(\'blackboard\').innerHTML += \"getUserToken: \" + Newton.getSharedInstance().getUserToken();\n            }\n\n            function signup(){\n                var signupEmail = document.getElementById(\'signupEmail\').value;\n                var signupPassword = document.getElementById(\'signupPassword\').value;\n                Newton.getSharedInstance().getLoginBuilder()\n                .setOnFlowCompleteCallback(function() {\n                    document.getElementById(\'blackboard\').innerHTML = \"Signup successful<br/>\";\n                    document.getElementById(\'blackboard\').innerHTML += \"email: \" + signupEmail + \"<br/>\";\n                    document.getElementById(\'blackboard\').innerHTML += \"password: \" + signupPassword + \"<br/>\";\n                })\n                .setEmail(signupEmail)\n                .setPassword(signupPassword)\n                .setCustomData(Newton.SimpleObject.fromJSONObject({\n                    custom: \'data\'\n                }))\n                .setUserProperties(Newton.SimpleObject.fromJSONObject({\n                    registredWith: \'user30test\'\n                }))\n                .getEmailSignupFlow()\n                .startLoginFlow();\n            }\n\n            function login(){\n                var loginEmail = document.getElementById(\'loginEmail\').value;\n                var loginPassword = document.getElementById(\'loginPassword\').value;\n                Newton.getSharedInstance().getLoginBuilder()\n                .setOnFlowCompleteCallback(function() {\n                    document.getElementById(\'blackboard\').innerHTML = \"Login successful<br/>\";\n                    document.getElementById(\'blackboard\').innerHTML += \"email: \" + loginEmail + \"<br/>\";\n                    document.getElementById(\'blackboard\').innerHTML += \"password: \" + loginPassword + \"<br/>\";\n                })\n                .setEmail(loginEmail)\n                .setPassword(loginPassword)\n                // .setCustomData(exampleOfSimpleObject)\n                // .setUserProperties(exampleOfUserProperties)\n                .getEmailLoginFlow()\n                .startLoginFlow();\n            }\n\n            function logout(){\n                Newton.getSharedInstance().userLogout();\n                document.getElementById(\'blackboard\').innerHTML = \"user unlogged\";\n            }\n\n            function isUserLogged(){\n                document.getElementById(\'blackboard\').innerHTML = \"isUserLogged: \" + Newton.getSharedInstance().isUserLogged();\n            }\n\n            function getUserToken(){\n                document.getElementById(\'blackboard\').innerHTML = \"getUserToken: \" + Newton.getSharedInstance().getUserToken();\n            }\n\n            function isUserToken(){\n                document.getElementById(\'blackboard\').innerHTML = \"isUserLogged: \" + Newton.getSharedInstance().isUserLogged() + \"<br/>\";\n                document.getElementById(\'blackboard\').innerHTML += \"getUserToken: \" + Newton.getSharedInstance().getUserToken();\n            }</script></head><body onload=\"init()\"><div id=\"blackboard\" style=\"background-color: midnightblue; color: greenyellow; width: 100%; min-height: 100px; padding: 10px;\"></div><h1>Signup</h1><input type=\"text\" id=\"signupEmail\" placeholder=\"email\"><br><input type=\"text\" id=\"signupPassword\" placeholder=\"password\"><br><br><button onclick=\"signup()\">SIGNUP</button><h1>Login</h1><input type=\"text\" id=\"loginEmail\" placeholder=\"email\" value=\"test@test.it\"><br><input type=\"text\" id=\"loginPassword\" placeholder=\"password\" value=\"testtest\"><br><br><button onclick=\"login()\">LOGIN</button><h1>logout</h1><button onclick=\"logout()\">LOGOUT</button><h1>isUserLogged + getUserToken</h1><button onclick=\"isUserToken()\">ISUSERLOGGED + GETUSERTOKEN</button></body></html>");
$templateCache.put("/js/wl/webstore_news/app/templates/cookiealert.html","<div class=\"message message__alert\" ng-show=\"show\" data-mipqa=\"privacyBox\"><a class=\"icon-delete\" ng-click=\"close()\" data-mipqa=\"privacyBox-close-btn\"><p ng-show=\"{{ \'SHOW_PRIVACY_TEXT_CLOSE_BOX\' | config }}\"><dict key=\"WEBAPP_TEXT_CLOSE_BOX\"></dict></p></a><p><dict key=\"WEBAPP_PRIVACY_BLOCK_TEXT\"></dict></p></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/banner/banner.html","<div class=\"container-banner-digi\" ng-show=\"show\"><div class=\"banner-digi\"><div class=\"banner-close\" ng-click=\"close()\" data-mipqa=\"banner-close\"></div><div class=\"banner-content\"><div class=\"banner-ico\"></div><div class=\"content-text\"><h2>{{\'WEBAPP_TITLE_BANNER_PROMO\' | dict }}</h2><p>{{\'WEBAPP_TEXT_BANNER_PROMO\' | dict }}</p></div><div class=\"banner-button\" data-mipqa=\"banner-link\"><p ng-if=\"(\'PROMO_BANNER_CHECK_DEVICE\'|config)\"><a target=\"_blank\" ng-href=\"{{ promoBannerUrl }}\" class=\"btn-general\" ng-click=\"closeAfterLink()\">{{\'WEBAPP_BUTTON_BANNER_PROMO\' | dict }}</a></p><p ng-if=\"!(\'PROMO_BANNER_CHECK_DEVICE\'|config)\"><a target=\"_blank\" href=\"{{\'WEBAPP_URL_BANNER_PROMO\' | dict }}\" class=\"btn-general\" ng-click=\"closeAfterLink()\">{{\'WEBAPP_BUTTON_BANNER_PROMO\' | dict }}</a></p></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/breadcrumbs/breadcrumbs.html","<div class=\"breadcrumbs\" ng-switch=\"!!item\"><a href ng-click=\"goBack()\" class=\"breadcrumb-go-back\" ng-switch-when=\"false\"><dict key=\"WEBAPP_RETURN_TO_PREVIOUS_PAGE\"></dict></a><ul ng-switch-when=\"true\"><li ng-repeat=\"breadcrumb in breadcrumbs track by $index\" class=\"breadcrumb-item\" ng-class=\"{\'breadcrumb-item-last\': breadcrumb.last}\"><a ng-href=\"{{breadcrumb.href}}\" data-mipqa=\"breadcrumbs-item\" ng-click=\"trackNavClick($event, breadcrumb.type, breadcrumb.title)\"><span>{{breadcrumb.title}}</span></a></li></ul></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/callToAction/callToAction.html","<div><div class=\"call-to-action\" ng-if=\"showSection\"><div class=\"smart-banner\" data-mipqa=\"zoompage-banner\"><div class=\"center-block-banner\"><div class=\"block-banner-text\"><a class=\"ico-service\"></a></div><div class=\"block-banner-text block-banner-text__data\"><h2>{{\'PLAY_STORE_TITLE\' | dict}}<br><p class=\"call-to-action-author\">{{\'PLAY_STORE_AUTHOR\' |dict}}</p><p class=\"call-to-action-price\">{{\'PLAY_STORE_PRICE\' | dict}}</p></h2></div><div class=\"block-banner-text\"><a href=\"\" id=\"downloadButtonCallToAction\" class=\"btn btn__general btn--dwl\" ng-click=\"getApp()\"><dict key=\"WEBAPP_BUTTON_DOWNLOAD\"></dict></a></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/clip/clip.html","<div ng-if=\"userCanUse\" ng-class=\"{\'container-video\': jwplayer && !audio, \'container-audio\': audio, \'video-preview\': !jwplayer && !audio}\"><illustration url=\"{{item.images.cover.ratio_1}}\" title=\"{{item.title}}\" ng-if=\"audio\"></illustration><div id=\"{{videoid}}\" class=\"video-player jw\" dir=\"ltr\"><div class=\"relative video-clip\"><div id=\"multiplayer\" ng-show=\"!showLoader && !showStreamingError\"></div><div class=\"relative loader\" ng-show=\"showLoader\"></div><p class=\"player-error\" ng-show=\"showStreamingError\">{{ \'WEBAPP_VIDEOPLAYER_STREAMING_ERROR\' | dict }}</p></div></div><div ng-show=\"showNextVideo\"><div class=\"box-icon-video jw\"><div class=\"container-replay\"><div class=\"replay-icon\" ng-click=\"replayVideo()\"></div><p class=\"replay-icon-title\"><dict key=\"WEBAPP_VIDEOPLAYER_PLAYAGAIN\"></dict></p></div><div class=\"suggested-video\" ng-show=\"nextVideo\"><div class=\"suggested-video-single\" ng-click=\"goToSuggested()\"><a ng-href=\"\" class=\"suggested-player\"><img ng-src=\"{{nextVideo.images.cover.ratio_1 | imagesize:\'cover_item\':\'big\'}}\"><p>{{nextVideo.title}}</p><div class=\"custom-player\"></div></a></div></div></div></div></div><div ng-if=\"!userCanUse\"><div class=\"relative video-clip\" ng-click=\"readMore()\"><illustration url=\"{{posterImage}}\" title=\"{{video.title}}\"></illustration><div class=\"custom-player\"></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/clip/clip_bk_2023_flowplayer.html","<div ng-if=\"userCanUse\" ng-class=\"{\'container-video\': player && !audio, \'container-audio\': audio, \'video-preview\': !player && !audio}\"><illustration url=\"{{item.images.cover.ratio_1}}\" title=\"{{item.title}}\" ng-if=\"audio\"></illustration><div ng-show=\"player\" ng-class=\"iosFullScreenClassButton\" class=\"fullscreen-common\" ng-click=\"fullScreenIconClick()\">Open</div><div id=\"{{videoid}}\" class=\"video-player\" dir=\"ltr\"><div class=\"relative video-clip\"><illustration url=\"{{video.images.cover.ratio_1}}\" title=\"{{video.title}}\" ng-if=\"!audio\"></illustration><div class=\"custom-player\" ng-click=\"loadPlayer(true)\" ng-show=\"!showLoader && !showStreamingError\"></div><div class=\"relative loader\" ng-show=\"showLoader\"></div><p class=\"player-error\" ng-show=\"showStreamingError\">{{ \'WEBAPP_VIDEOPLAYER_STREAMING_ERROR\' | dict }}</p></div></div><div ng-show=\"showNextVideo\"><div class=\"box-icon-video\"><div class=\"container-replay\"><div class=\"replay-icon\" ng-click=\"replayVideo()\"></div><p class=\"replay-icon-title\"><dict key=\"WEBAPP_VIDEOPLAYER_PLAYAGAIN\"></dict></p></div><div class=\"suggested-video\" ng-show=\"nextVideo\"><div class=\"suggested-video-single\" ng-click=\"goToSuggested()\"><a ng-href=\"\" class=\"suggested-player\"><img ng-src=\"{{nextVideo.images.cover.ratio_1 | imagesize:\'cover_item\':\'big\'}}\"><p>{{nextVideo.title}}</p><div class=\"custom-player\"></div></a></div></div></div></div></div><div ng-if=\"!userCanUse\"><div class=\"relative video-clip\" ng-click=\"readMore()\"><illustration url=\"{{video.images.cover.ratio_1}}\" title=\"{{video.title}}\"></illustration><div class=\"custom-player\"></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/cookiealert/consent.html","<span data-mipqa=\"didomi-prefmanager\" class=\"link-foot\" ng-if=\"(\'SHOW_PRIVACY_BLOCK\' | config) && (\'DIDOMI_API_KEY\'|config) && (\'DIDOMI_ID\'|config)\"><a class=\"didom-consent-btn\" ng-click=\"openPrefs()\" title=\"{{ \'WEBAPP_MANAGE_CONSENT_LINK\' | dict}}\"><dict key=\"WEBAPP_MANAGE_CONSENT_LINK\"></dict></a></span>");
$templateCache.put("/js/wl/webstore_news/app/modules/coverItem/cover-item.html","<div class=\"box-myspace\" ng-hide=\"isEmpty\"><div class=\"title-myspace\"><div class=\"block-cell left\"><h2>{{item.title}}</h2></div><div class=\"block-cell right\"><span ng-class=\"item.icon\" class=\"color-2\"></span><h2 class=\"no-upppercase color-w\">{{item.items}}</h2></div></div><div class=\"box-img-myspace\"><a ng-href=\"#!{{item.url}}\" ng-click=\"callback($event, item.title)\"><img ng-src=\"{{item.image | imagesize:\'cover_item\':\'big\'}}\" class=\"my-image\"></a></div></div><div ng-show=\"isEmpty\"><div class=\"box-myspace box-myspace--empty\"><div class=\"title-myspace\"><div class=\"block-cell left\"><h2>{{item.title}}</h2></div><div class=\"block-cell right\"><span ng-class=\"item.icon\" class=\"color-2\"></span><h2 class=\"no-upppercase color-w\"><dict key=\"WEBAPP_MYSPACE_TEXT_NO_ITEMS\"></dict></h2></div></div><div class=\"box-img-myspace\"><img ng-src=\"{{ \'TRANSPARENT-1024\' | config }}\" class=\"my-image\"><div class=\"txt-empty\"><span class=\"icon-placeholder\"></span><p class=\"text-no-item\"><dict key=\"WEBAPP_MYSPACE_TEXT_NO_ITEMS_YET\"></dict></p></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/custom_player/player.html","<iframe id=\"newsplayer_{{video.id}}\" class=\"player\" data-embed=\"{{video.embed_ur}}\" ng-src=\"{{ video.embed_url | embedUrl:canPlay:video.id }}\" videoid=\"{{video.id}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen video=\"video\"></iframe>");
$templateCache.put("/js/wl/webstore_news/app/modules/downloadButton/button.html","<div class=\"container-dwnl-btn\"><div class=\"btn btn__light\" ng-click=\"download()\" ng-show=\"show\"><span class=\"icon-download\"></span><dict key=\"WEBAPP_BUTTON_DOWNLOAD\"></dict><span ng-if=\"size\">- {{ size | getByteSize }}</span></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/downloadButton/ph-button.html","<div class=\"container-dwnl-btn\"><a href=\"\" id=\"downloadButton\" data-mipqa=\"btn-download\" class=\"btn btn__light\" ng-click=\"download()\" ng-show=\"show\"><span class=\"icon-download\"></span><dict key=\"WEBAPP_BUTTON_DOWNLOAD\"></dict><span ng-if=\"size\">- {{ size | getByteSize }}</span></a></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/footer/footer.html","<div class=\"banner-container container-fluid\" ng-if=\"showBanner\"><div class=\"content-banner\"><div ng-repeat=\"item in bannerItem\" class=\"banner\" ng-class=\"{\'active-banner\': (active==$index)}\" ng-if=\"bannerItem.length > 0\"><a href=\"\" target=\"_blank\" ng-click=\"openBanner($index)\"><img class=\"banner-image\" ng-src=\"{{item.img}}\"></a></div></div></div><div ng-if=\"unifyFooter\" ng-class=\"[customFooter,{\'no-margin\': showBanner}, {\'hybrid-space-foot\': hybrid}, {\'space-personalization\':{{ \'ENABLE_PERSONALIZATION\' | config }}}]\"><div ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_ABOVE\' | config )\" class=\"clear-both general-padding\"><p class=\"center-block small\" data-mipqa=\"footer-text-description-above\"><dict key=\"WEBAPP_FOOTER_SERVICE_DESCRIPTION\"></dict></p></div><div class=\"center-block clear-both general-padding-t-b\" ng-show=\"{{ \'SHOW_MOVISTAR_BACK_HOME\' | config }}\"><p class=\"text-foot\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" ng-href=\"#!{{ \'MOVISTAR_BACK_HOME_URL\' | config }}\"><dict key=\"WEBAPP_MOVISTAR_BACK_HOME\"></dict></a></p></div><div><div class=\"footer\" data-mipqa=\"footer-container\"><div class=\"clear-both general-padding-t-b\" ng-class=\"verticalFooter\"><span class=\"link-foot\" ng-repeat=\"link in links\"><a href=\"{{link.url}}\" title=\"{{link.label}}\" rel=\"nofollow\" data-mipqa=\"footer-link-{{link.content_id}}\"><span ng-bind-html=\"link.label\"></span></a></span><consent-manager></consent-manager></div></div></div><div ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config )\" class=\"clear-both general-padding\"><p class=\"center-block small\" data-mipqa=\"footer-text-description-below\"><dict key=\"WEBAPP_FOOTER_SERVICE_DESCRIPTION\"></dict></p></div></div><div ng-if=\"!unifyFooter\" ng-class=\"[customFooter,{\'hybrid-space-foot\': hybrid}, {\'space-personalization\':{{ \'ENABLE_PERSONALIZATION\' | config }}}]\"><div ng-show=\"$root.showFooterServiceDescription\" class=\"clear-both general-padding message-above-operator\"><a class=\"icon-delete\" ng-click=\"closeFooterServiceDescription()\"></a><span class=\"logo-operator\"></span><p class=\"center-block small\"><dict key=\"WEBAPP_OPERATOR_MESSAGE\"></dict></p></div><div ng-class=\"{\'no-margin\': showBanner}\"><div class=\"shadow-footer\"></div><div class=\"wave-footer\"></div><div class=\"footer\"><p ng-if=\"(\'SHOW_STATIC_TEXT_FOOTER\'|config)\"><a href=\"#!{{ \'ROUTER_CONTACT_US\' | config }}\" title=\"{{\'WEBAPP_TEXT_CONTACTUS_FOOT\' | dict }}\"><dict key=\"WEBAPP_TEXT_CONTACTUS_FOOT\"></dict></a></p><div class=\"center-block logo-service\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" href=\"#!/\"><span ng-hide=\"{{ \'HIDE_FOOTER_LOGO\' | config}}\" class=\"logo-foot\"></span><p class=\"container-additional-logo\" ng-if=\"(\'SHOW_ADDITIONAL_LOGO\'|config)\"><span class=\"text-additional-logo\">{{\'WEBAPP_POWERED_BY\' | dict }}</span><span class=\"additional-logo\"></span></p></a></div><div class=\"center-block clear-both general-padding-t-b\" ng-show=\"{{ \'SHOW_MOVISTAR_BACK_HOME\' | config }}\"><p class=\"text-foot\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" ng-href=\"#!{{ \'MOVISTAR_BACK_HOME_URL\' | config }}\"><dict key=\"WEBAPP_MOVISTAR_BACK_HOME\"></dict></a></p></div><div class=\"clear-both general-padding-t-b container-link-foot\" ng-class=\"verticalFooter\" data-mipqa=\"footer-container\"><span class=\"link-foot\" ng-repeat=\"link in links\"><a href=\"{{link.url}}\" title=\"{{link.label}}\" rel=\"nofollow\" data-mipqa=\"footer-link-{{link.content_id}}\"><span ng-bind-html=\"link.label\"></span></a></span><consent-manager></consent-manager></div><div ng-show=\"{{ \'SHOW_POWEREDBY\' | config }}\" class=\"powered-container\"><div class=\"powered\"><dict key=\"WEBAPP_FOOTER_POWEREDBY\"></dict></div><div class=\"logo-powered\"></div></div></div></div><div ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config )\" class=\"clear-both general-padding\"><p class=\"center-block small\" data-mipqa=\"footer-text-description-below\"><dict key=\"WEBAPP_FOOTER_SERVICE_DESCRIPTION\"></dict></p></div><div ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION2\' | config )\" class=\"clear-both general-padding\"><p class=\"center-block small\" data-mipqa=\"footer-text-description\"><dict key=\"WEBAPP_FOOTER_SERVICE_DESCRIPTION\"></dict></p></div><div ng-if=\"showMultilanguage\" class=\"multiple-language\" data-mipqa=\"container-multilanguage\"><p class=\"center-block small\"><dict key=\"WEBAPP_CHANGE_LANGUAGE\"></dict></p><span ng-repeat=\"language in languageList\"><a id=\"{{language.ID}}\" ng-href=\"{{language.IS_SELECTED ? \'\' : window.location.origin + language._LANGURL_ABSOLUTE}}\" ng-class=\"{\'curr-lang\': language.IS_SELECTED}\" ng-attr-data-mipqa=\"{{language.IS_SELECTED ? \'current-language\' : \'link-other-language\'}}\">{{language.LABEL}}</a></span></div><div ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW_MULTILANGUAGE\' | config )\" class=\"footer-container-text-below\"><div class=\"footer-text-below\"><p class=\"text-below small\" data-mipqa=\"footer-text-below-multilanguage\"><dict key=\"WEBAPP_FOOTER_SERVICE_DESCRIPTION_BELOW_MULTILANGUAGE\"></dict></p></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/footer/footer_kiosk.html","<div ng-if=\"!(\'SHOW_WIND\'|config) && kioskServicesList.length > 1\" class=\"container-fluid banner-kiosk container-fluid--padding double-general-padding-t-b\"><div class=\"col-xs-6\" ng-repeat=\"service in kioskServicesList\"><div class=\"bg-service bg-{{service.theme}}\"><a href=\"{{service.url}}/#!/\"><span>{{service.title}}</span><span class=\"arrow-foot-k\"></span></a></div></div></div><div class=\"footer footer-kiosk\" ng-class=\"{\'hybrid-space-foot\': hybrid, \'space-personalization\':{{ \'ENABLE_PERSONALIZATION\' | config }}}\"><div class=\"center-block\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" href=\"{{\'KIOSK_DOMAIN\' | config }}\"><span ng-if=\"!(\'SHOW_WIND\'|config)\" class=\"logo-foot-k\"></span><h1 ng-if=\"(\'SHOW_WIND\'|config)\"><span>{{ \'TITLE_SERVICE\' | config }}</span></h1><hr class=\"line-foot\"></a></div><div ng-if=\"\'SHOW_WIND\'|config\" class=\"wind-footer\"><a href=\"{{\'KIOSK_DOMAIN\' | config }}\" title=\"Wind Planet\"></a></div><div class=\"clear-both general-padding-t-b container--footerK\"><p class=\"link-foot\"><a ng-repeat=\"link in links\" href=\"{{link.url}}\" title=\"{{link.label}}\" rel=\"nofollow\"><span ng-bind-html=\"link.label\"></span></a></p><div ng-show=\"{{ \'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config }}\" class=\"clear-both general-padding\"><p class=\"center-block small k-text-foot\"><dict key=\"WEBAPP_FOOTER_SERVICE_DESCRIPTION\"></dict></p></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/gallery/gallery.html","<div><illustration ng-if=\"!(\'HIDE_ZOOM_GALLERY\' | config)\" title=\"{{item.title}}\" alt=\"{{item.title}}\" url=\"{{images[0].nonFilteredUrl}}\" aspect=\"{{images[0].aspect}}\" ng-click=\"showGallery()\"></illustration><illustration ng-if=\"(\'HIDE_ZOOM_GALLERY\' | config)\" title=\"{{item.title}}\" alt=\"{{item.title}}\" url=\"{{images[0].nonFilteredUrl}}\" aspect=\"{{images[0].aspect}}\" ng-disabled=\"userCanUse\" ng-click=\"readMore()\"></illustration><div class=\"pswp\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"pswp__bg\"></div><div class=\"pswp__scroll-wrap\"><div class=\"pswp__container\"><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div></div><div class=\"pswp__ui pswp__ui--hidden\"><div class=\"pswp__top-bar\"><div class=\"pswp__counter\"></div><button class=\"pswp__button pswp__button--close\" title=\"Close (Esc)\"></button><button class=\"pswp__button pswp__button--zoom\" title=\"Zoom in/out\"></button><div class=\"pswp__preloader\"><div class=\"pswp__preloader__icn\"><div class=\"pswp__preloader__cut\"><div class=\"pswp__preloader__donut\"></div></div></div></div></div><div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\"><div class=\"pswp__share-tooltip\"></div></div><button class=\"pswp__button pswp__button--arrow--left ahhhh\" title=\"Previous (arrow left)\"></button><button class=\"pswp__button pswp__button--arrow--right\" title=\"Next (arrow right)\"></button><div class=\"pswp__caption\"><div class=\"pswp__caption__center\"></div></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/back.html","<header><div class=\"pull-left\"><a class=\"link-head\" ng-click=\"goBack()\"><ng-transclude></ng-transclude></a></div></header>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/back_hybrid.html","");
$templateCache.put("/js/wl/webstore_news/app/modules/header/back_hybrid_kiosk.html","");
$templateCache.put("/js/wl/webstore_news/app/modules/header/back_kiosk.html","<header><div class=\"pull-left\"><a class=\"link-head\" ng-click=\"goBack()\"><ng-transclude></ng-transclude></a></div></header>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/header-digi.html","<div><div class=\"container-header\"><header class=\"top-fixed\"><div class=\"container-fluid\"><div class=\"pull-left\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" class=\"inline-block\" href=\"#!/\" ng-click=\"trackEvent($event, \'logo\')\"><span class=\"ico-brand\" data-mipqa=\"brand-icon\"></span></a></div><div class=\"pull-right\"><a class=\"link-head link-head--action ico-search\" href=\"#!/search\" ng-click=\"trackEvent($event, \'search\')\" data-mipqa=\"header-link-search\"><span class=\"search-icon\"></span></a></div></div></header></div><div class=\"container-header logo-service\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" class=\"link-head\" href=\"#!/\" ng-click=\"trackEvent($event, \'logo\')\" data-mipqa=\"logo-link\"><span class=\"logo-header\"></span></a></div><header-bottom></header-bottom></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/header.html","<div class=\"container-header\"><header ng-class=\"{\'personalization-header\':{{ \'ENABLE_PERSONALIZATION\' | config }}}\"><div class=\"container-fluid\"><div class=\"pull-left\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" class=\"link-head\" href=\"#!/\" ng-click=\"trackEvent($event, \'logo\')\" data-mipqa=\"logo-link\"><span class=\"logo-header\"></span><p class=\"container-additional-logo\" ng-if=\"(\'SHOW_ADDITIONAL_LOGO\'|config)\"><span class=\"text-additional-logo\">{{\'WEBAPP_POWERED_BY\' | dict }}</span>&nbsp;<span class=\"additional-logo\"></span></p></a></div><div class=\"pull-right\"><a title=\"{{\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\' | dict }}\" class=\"link-head link-head--action ico-category\" href=\"#!/news/categories\" ng-click=\"trackEvent($event, \'category\')\" data-mipqa=\"header-link-categories\"><span class=\"icon-category\"></span><span class=\"name-section\">{{\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\' | dict }}</span></a><a class=\"link-head link-head--action ico-myspace\" href=\"#!/myspace\" title=\"{{\'WEBAPP_GOLD_HEADER_MENU_MYSPACE\' | dict }}\" ng-if=\"(\'ENABLE_NEWTON_USER\'|config) && (\'ENABLE_MYSPACE\'|config)\" ng-click=\"trackEvent($event, \'myspace\')\" data-mipqa=\"header-link-myspace\"><span class=\"icon-archive_favourites\"></span><span class=\"name-section\">{{\'WEBAPP_GOLD_HEADER_MENU_MYSPACE\' | dict }}</span></a><a class=\"link-head link-head--action ico-search\" href=\"#!/search\" title=\"{{\'WEBAPP_GOLD_HEADER_MENU_SEARCH\' | dict }}\" ng-click=\"trackEvent($event, \'search\')\" data-mipqa=\"header-link-search\"><span class=\"icon-search\"></span><span class=\"name-section\">{{\'WEBAPP_GOLD_HEADER_MENU_SEARCH\' | dict }}</span></a><a class=\"link-head link-head--action ico-account\" ng-href=\"{{userLink}}\" title=\"{{\'WEBAPP_ACCOUNT_FOOTER\' | dict }}\" ng-click=\"trackEvent($event, \'account\')\" data-mipqa=\"header-link-account\" ng-if=\"!(\'HIDE_ACCOUNT_HEADER_BUTTON\'|config)\"><span class=\"icon-account\"></span><span class=\"name-section\">{{\'WEBAPP_ACCOUNT_FOOTER\' | dict }}</span></a></div></div></header><div class=\"wave-header\"></div><div class=\"shadow-header\"></div><header-links></header-links><div ng-show=\"{{ \'SHOW_OTHER_TEXT_HEADER\' | config }}\" class=\"top-message other-style container-fluid\"><dict key=\"WEBAPP_MESSAGE_OTHER_TEXT_HEADER\"></dict></div><div ng-show=\"{{ \'SHOW_TEXT_HEADER\' | config }}\" class=\"top-message container-fluid\"><span ng-show=\"$root.userReady && $root.userLogged\" class=\"message-section\"><dict key=\"WEBAPP_HOME_IS_LOGGED\"></dict></span><span ng-show=\"$root.userReady && !$root.userLogged\" class=\"message-section\"><dict key=\"WEBAPP_HOME_NOT_LOGGED\"></dict></span></div><div ng-if=\"(\'ENABLE_NEWTON_USER\'|config) &&  !(\'UO30_FEEDBACK_IN_INDEX\'|config)\" id=\"user-feedback\" class=\"form__message form__message--pop-up\" style=\"display:none\"><div class=\"form__line\"><div class=\"form__message-icon\"><span id=\"user-feedback-icon\" class=\"icon\"></span></div><div class=\"form__message-text\"><div id=\"user-feedback-message\" class=\"message\"></div><a id=\"user-feedback-link\" class=\"link\" href=\"\" style=\"display:none\"></a></div></div><div id=\"user-feedback-close\" class=\"close\" data-mipqa=\"exit-popup\"></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/header_hybrid.html","<header class=\"hybrid\"><div class=\"center-block\"><a ng-click=\"trackEvent($event, \'logo\')\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\"><span class=\"logo-header logo-header--hybrid\"></span></a></div><header-links></header-links></header>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/header_hybrid_kiosk.html","<header class=\"ikioske ikioske--hybrid\"><div ng-if=\"(\'SHOW_WIND\'|config)\"><a href=\"{{\'KIOSK_DOMAIN\' | config }}\" title=\"Wind Planet\" class=\"nav-wind\"><div class=\"home-wind\"></div><div class=\"block-wind-planet\"><div class=\"wind-planet\"></div></div></a></div><div class=\"head-back-k\" ng-if=\"!(\'SHOW_WIND\'|config)\"><div class=\"container-fluid container-fluid--padding\"><a class=\"logo-head-bk\" href=\"{{\'KIOSK_DOMAIN\' | config }}\"></a></div></div><div class=\"header-size-hybrid header\"><div class=\"container-fluid\"><div class=\"center-block\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" class=\"link-head link-head--k\" href=\"#!/\" ng-click=\"trackEvent($event,\'logo\')\"><h1><span>{{ \'TITLE_SERVICE\' | config }}</span></h1></a></div></div></div><header-links></header-links></header>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/header_kiosk.html","<header class=\"ikioske\"><div ng-if=\"(\'SHOW_WIND\'|config)\"><a href=\"{{\'KIOSK_DOMAIN\' | config }}\" title=\"Wind Planet\" class=\"nav-wind\"><div class=\"home-wind\"></div><div class=\"block-wind-planet\"><div class=\"wind-planet\"></div></div></a></div><div class=\"head-back-k\" ng-if=\"!(\'SHOW_WIND\'|config)\"><div class=\"container-fluid container-fluid--padding\"><a class=\"logo-head-bk\" href=\"{{\'KIOSK_DOMAIN\' | config }}\"></a></div></div><div class=\"header-size header\"><div class=\"container-fluid\"><div class=\"pull-left\"><a title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" class=\"link-head link-head--k\" href=\"#!/\" ng-click=\"trackEvent($event,\'logo\')\"><h1><span>{{ \'TITLE_SERVICE\' | config }}</span></h1></a></div><div class=\"pull-right\"><a class=\"link-head link-head--action ico-category\" href=\"#!/news/categories\" ng-click=\"trackEvent($event, \'category\')\"><span class=\"icon-category\"></span><span class=\"name-section\">{{\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\' | dict }}</span></a><a class=\"link-head link-head--action ico-search\" href=\"#!/search\" ng-click=\"trackEvent($event, \'search\')\"><span class=\"icon-search\"></span><span class=\"name-section\">{{\'WEBAPP_GOLD_HEADER_MENU_SEARCH\' | dict }}</span></a><a ng-if=\"!(\'KIOSK_SINGLE_ACCOUNT\'|config)\" class=\"link-head link-head--action ico-account\" href=\"{{ \'DEST_DOMAIN\' | config }}{{ \'ACCOUNT_LINK\' | config }}\" ng-click=\"trackEvent($event, \'account\')\" data-mipqa=\"header-link-account\"><span class=\"icon-account\"></span><span class=\"name-section\">{{\'WEBAPP_ACCOUNT_FOOTER\' | dict }}</span></a><a ng-if=\"(\'KIOSK_SINGLE_ACCOUNT\'|config)\" class=\"link-head link-head--action ico-account\" ng-href=\"{{ \'KIOSK_DOMAIN\' | config }}{{ \'ROUTER_SETTINGS\' | config }}\" ng-click=\"trackEvent($event, \'account\')\" data-mipqa=\"header-link-account\"><span class=\"icon-account\"></span><span class=\"name-section\">{{\'WEBAPP_ACCOUNT_FOOTER\' | dict }}</span></a></div></div></div><header-links></header-links></header>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/headerlinks.html","<div class=\"clear-both text-center header-op-links\" ng-if=\"headerLinks\"><span class=\"link-foot\" ng-repeat=\"link in links\" data-mipqa=\"header-links\"><a href=\"{{link.url}}\" title=\"{{link.label}}\" rel=\"nofollow\"><span ng-bind-html=\"link.label\"></span></a></span></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/illustration/illustration.html","<div class=\"container-cover bg-second\"><div class=\"box-cover\"><div class=\"small-bg-illustration\"><div class=\"item-illustration\" alt=\"{{title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" data-mipqa=\"img-zoom\" ng-attr-style=\"background-image:url(\'{{url | imagesize:\'illustration\':\'small\':aspect}}\');\"></div></div><div class=\"medium-bg-illustration\"><div class=\"item-illustration\" alt=\"{{item.title}} {{title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" data-mipqa=\"img-zoom\" ng-attr-style=\"background-image:url(\'{{url | imagesize:\'illustration\':\'medium\':aspect}}\');\"></div></div><div class=\"big-bg-illustration\"><div class=\"item-illustration\" alt=\"{{item.title}} {{title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" data-mipqa=\"img-zoom\" ng-attr-style=\"background-image:url(\'{{url | imagesize:\'illustration\':\'big\':aspect}}\');\"></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/item/item.html","<div class=\"general-item row-negative\" ng-class=\"{\'fadeOutItem\': isfadeOutItem}\"><ul><li><div title=\"{{item.title}}\" class=\"block\"><i ng-if=\"!(\'DIGIPARENTING-SERVICE\'|config)\" data-mipqa=\"list-item\" data-format=\"{{item.format}}\"></i><i ng-if=\"(\'DIGIPARENTING-SERVICE\'|config)\" data-mipqa=\"list-item\" data-format=\"{{item.custom_content_type}}\"></i><figure ng-class=\"item.format === \'androidapplications\' || item.format === \'html5applications\' ? \'cover-game\' : \'\'\"><div class=\"relative bg-general-list\" ng-class=\"{\'already-read\': visited}\"><span ng-if=\"item.hot\" class=\"badge badge--hot\">{{\'WEBAPP_HOT\' | dict }}</span><span ng-if=\"!item.hot\" class=\"badge badge--lasted\">{{\'WEBAPP_LAST\' | dict }}</span><div class=\"small-bg-item\" ng-if=\"small\"><a ng-href=\"{{item.url_zoom}}\" data-mipqa=\"clickitem\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"(item.images.cover.ratio_1 &&\n								(item.custom_content_type == \'text\' || item.custom_content_type == \'videogallery\')) || item.cs_id\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.cover.ratio_1 | imagesize:\'item\':\'small\':item.images.cover.ratio_1_aspect}}\"><div class=\"ico-game\" ng-if=\"(item.format == \'androidapplications\' || item.format == \'html5applications\')\"></div></div></a><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"item.images.small.url\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.medium.url}}\"><div ng-class=\"item.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"item.duration\" class=\"duration\"><span>{{item.duration.formatted}}</span></div></div></a><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"item.custom_content_type == \'video\'\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.cover.ratio_1 | imagesize:\'item\':\'small\':item.images.cover.ratio_1_aspect}}\"><div ng-class=\"item.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"item.duration\" class=\"duration\"><span>{{item.duration.formatted}}</span></div></div></a><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"item.custom_content_type == \'audio\'\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.cover.ratio_1 | imagesize:\'item\':\'small\':item.images.cover.ratio_1_aspect}}\"><div ng-class=\"item.duration ? \'custom-player w-duration\' : \'custom-player-audio\'\"></div><div ng-if=\"item.duration\" class=\"duration\"><span>{{item.duration.formatted}}</span></div></div></a></div><div class=\"big-bg-item\" ng-if=\"!small\"><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"(item.images.cover.ratio_1 &&\n								(item.custom_content_type == \'text\' || item.custom_content_type == \'videogallery\')) || item.cs_id\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.cover.ratio_1 | imagesize:\'item\':\'big\':item.images.cover.ratio_1_aspect}}\"><div class=\"ico-game\" ng-if=\"(item.format == \'androidapplications\' || item.format == \'html5applications\')\"></div></div></a><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"item.images.small.url\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.medium.url}}\"><div ng-class=\"item.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"item.duration\" class=\"duration\"><span>{{item.duration.formatted}}</span></div></div></a><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"item.custom_content_type == \'video\'\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.cover.ratio_1 | imagesize:\'item\':\'big\':item.images.cover.ratio_1_aspect}}\"><div ng-class=\"item.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"item.duration\" class=\"duration\"><span>{{item.duration.formatted}}</span></div></div></a><a ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\" ng-if=\"item.custom_content_type == \'audio\'\" data-mipqa=\"clickitem\"><div class=\"item-bg b-lazy-bg\" alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" style=\"background-image:url(\'{{\'load\' | config}}\');\" lazy-img=\"{{item.images.cover.ratio_1 | imagesize:\'item\':\'big\':item.images.cover.ratio_1_aspect}}\"><div ng-class=\"item.duration ? \'custom-player w-duration\' : \'custom-player-audio\'\"></div><div ng-if=\"item.duration\" class=\"duration\"><span>{{item.duration.formatted}}</span></div></div></a></div><figcaption><a data-mipqa=\"title-item\" ng-href=\"{{item.url_zoom}}\" ng-click=\"callback($event)\" title=\"{{item.title}}\"><p ng-if=\"(\'SHOW_DATES\'|config) &&  (\'SHOW_DATE_TOP\'|config)\" class=\"date\"><item-date content=\"item\"></item-date></p><h3>{{item.title}}</h3><p ng-if=\"(\'SHOW_DATES\'|config) &&  !(\'SHOW_DATE_TOP\'|config)\" class=\"date\"><item-date content=\"item\"></item-date></p></a></figcaption></div></figure></div><div ng-click=\"removeItemFromMyspace(item.id_item_collection)\" ng-show=\"$parent.showTrash\" class=\"cancel-item title-color-section pointer\"><span class=\"icon-trash\"></span></div></li></ul></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/item-date/itemDate.html","<span>{{itemDate}}</span>");
$templateCache.put("/js/wl/webstore_news/app/modules/loader/loader.html","<div><div ng-if=\"!(\'LOTTIE_LOADER\'|config)\" class=\"center-block general-padding\"><div class=\"loader\"></div></div><div ng-if=\"(\'LOTTIE_LOADER\'|config)\" class=\"center-block lottie\"></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/menu/menu.html","<div ng-if=\"visible\" class=\"menu\" ng-class=\"{\'menu-hybrid\': hybrid}\"><div class=\"row-flex\"><div class=\"col-xs-flex\"><a class=\"ico-home block-icons\" href=\"#!/\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\" ng-click=\"trackEvent($event, \'logo\')\"><span class=\"icon-home link-menu\"></span></a></div><div class=\"col-xs-flex\"><a class=\"ico-category block-icons\" href=\"#!/news/categories\" ng-click=\"trackEvent($event, \'category\')\"><span class=\"icon-category link-menu\"></span></a></div><div class=\"col-xs-flex\" ng-if=\"(\'ENABLE_NEWTON_USER\'|config) && (\'ENABLE_MYSPACE\'|config)\"><a class=\"ico-myspace block-icons\" href=\"#!/myspace\" ng-click=\"trackEvent($event, \'myspace\')\"><span class=\"icon-archive_favourites link-menu\"></span></a></div><div class=\"col-xs-flex\"><a class=\"ico-search block-icons\" href=\"#!/search\" ng-click=\"trackEvent($event, \'search\')\"><span class=\"icon-search link-menu\"></span></a></div><div class=\"col-xs-flex\"><a class=\"ico-account block-icons\" ng-href=\"{{userLink}}\" ng-click=\"trackEvent($event, \'account\')\"><span class=\"icon-account link-menu\"></span></a></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/modal/modal.html","<div class=\"modal-header\"><div type=\"button\" ng-click=\"closeModal()\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"></div></div><div class=\"modal-body\"><h3 ng-show=\"clickFrom!==\'allitem\'\">{{\'WEBAPP_MODAL_REMOVE_FROM_MYSPACE_TEXT\' | dict}}</h3><h3 ng-show=\"clickFrom==\'allitem\'\">{{\'WEBAPP_MODAL_REMOVE_ALL_ITEMS_FROM_MYSPACE_TEXT\' | dict}}</h3><p><button type=\"button\" class=\"btn btn__general\" ng-click=\"confirm()\">{{\'WEBAPP_MODAL_BUTTON_CONFIRM\' | dict}}</button></p><p><a class=\"cancel-link\" href=\"\" ng-click=\"closeModal()\">{{\'WEBAPP_MODAL_LINK_CANCEL\' | dict}}</a></p></div><div class=\"modal-footer\"></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/modal/modalDialog.html","<div class=\"modal-dialog\"><div class=\"modal-content {{customClass}}\" ng-class=\"{opened: modalShow}\" ng-include=\"modalUrl\"></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/modal/suspendedUserModal.html","<div class=\"modal-dialog\"><div class=\"modal-content {{customClass}}\" ng-class=\"{opened: modalShow}\"><div class=\"modal-header\"><div type=\"button\" ng-click=\"closeModal()\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"></div></div><div class=\"modal-body\"><h3><dict key=\"WEBAPP_MODAL_SUSPENDED_USER_TITLE\"></dict></h3><p><dict key=\"WEBAPP_MODAL_SUSPENDED_USER_TEXT\"></dict></p><p><button type=\"button\" class=\"btn btn__general\" ng-click=\"confirm()\"><dict key=\"WEBAPP_MODAL_BUTTON_SUSPENDED_USER_RECHARGE\"></dict></button></p></div><div class=\"modal-footer\"></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/newSlider/newSlider.html","<div class=\"container-slider-new\" ng-class=\"{\'remove-space\':( \'SHOW_ADDITIONAL_CONTEST\' | config )}\" ng-show=\"show\"><div class=\"container-glide--carousel\" ng-show=\"show\"><div class=\"glide\"><div class=\"container-badge\"><div class=\"badge badge--lasted\"><h1 class=\"font-mini\"><dict key=\"SEO_WEBAPP_HEAD_TITLE_TOP\"></dict></h1></div><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-if=\"\'SHOW_ADDITIONAL_BANNER\'|config\"><a href=\"{{(\'URL_ADDITIONAL_BANNER\'|config)}}\" title=\"{{(\'URL_ADDITIONAL_BANNER\'|config)}}\" target=\"_blank\"><div class=\"additional-banner\"></div></a></li><li class=\"glide__slide\" ng-repeat=\"slide in slides\" ng-attr-data-format=\"{{(\'DIGIPARENTING-SERVICE\'|config) ? slide.custom_content_type : slide.format}}\"><a data-mipqa=\"slider-item\" ng-href=\"{{slide.url_zoom}}\" title=\"{{slide.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\' | dict }}\" ng-click=\"trackClickSliderNew($event, slide.title, $index)\"><img ng-src=\"{{slide.images.cover.ratio_1 | imagesize:\'slider\':\'medium\'}}\" alt=\"{{slide.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\"><div ng-if=\"slide.custom_content_type == \'video\'\" ng-class=\"slide.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"slide.title\" class=\"content-title-carousel\"><h3>{{slide.title}}</h3></div><div ng-if=\"slide.duration\" class=\"duration\"><span>{{slide.duration.formatted}}</span></div></a></li></ul></div></div><div class=\"glide__bullets\" data-glide-el=\"controls[nav]\"><button ng-repeat=\"slide in slides\" class=\"glide__bullet\" data-glide-dir=\"={{$index}}\"><span class=\"element-text-hidden\">slide</span></button><button ng-if=\"\'SHOW_ADDITIONAL_BANNER\'|config\" class=\"glide__bullet\" data-glide-dir=\"=3\"><span class=\"element-text-hidden\">slide</span></button></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/overlay/overlay.html","<div class=\"overlay\" ng-class=\"overlayClass\" ng-if=\"showOverlay\" data-mipqa=\"banner-overlay\"><div class=\"head-overlay\"><div class=\"small-img\"><div class=\"box-gradient\"></div><div class=\"img-view\" style=\"background-image:url(\'{{\'TOP-ADV-SMALL\' | config}}\')\"></div></div><div class=\"big-img\"><div class=\"box-gradient\"></div><div class=\"img-view\" style=\"background-image:url(\'{{\'TOP-ADV-BIG\' | config}}\')\"></div></div></div><div class=\"body-overlay\"><div class=\"block-banner-text\"><a class=\"ico-service\"></a></div><div class=\"block-banner-text block-banner-text__data\"><h2>{{\'PLAY_STORE_TITLE\' | dict}}</h2></div><p class=\"general-margin-t-b\">{{\'WEBAPP_TEXT_DESCRIPTION_ADV\' | dict}}</p><div class=\"buttons-overlay\"><a href=\"\" id=\"downloadButtonOverLay\" class=\"btn btn__general btn--dwl general-margin-b\" ng-click=\"getApp()\" data-mipqa=\"banner-overlay-download\"><dict key=\"WEBAPP_BUTTON_DOWNLOAD\"></dict></a><a href=\"\" id=\"downloadButtonOverLayOther\" ng-if=\"(\'OTHER_OVERLAY_BUTTON\' | config )\" class=\"btn btn__general btn--dwl general-margin-b\" ng-click=\"getApp()\" data-mipqa=\"banner-overlay-download\"><dict key=\"WEBAPP_BUTTON_DOWNLOAD\"></dict></a></div></div><div class=\"foot-overlay\"><p class=\"font-mini general-margin-b\">{{\'WEBAPP_ON_GOOGLEPLAY_ADV\' | dict}}</p><hr><p class=\"link-adv\" ng-click=\"closeOverlay()\" data-mipqa=\"banner-overlay-close\">{{\'WEBAPP_CONTINUE_ADV\' | dict}}</p></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/paywall/paywall.html","<div class=\"overlay-standard\" ng-class=\"overlay-show\" ng-if=\"showPaywall\"><div class=\"overlay-box overlay-box--paywall\"><div class=\"head-overlay\"><span class=\"logo-header\"></span></div><div class=\"body-overlay\" ng-show=\"!showThankYouPaywall\"><div><h2>{{\'WEBAPP_TEXT_DESCRIPTION_PAYWALL_1\' | dict}}</h2><p class=\"general-margin-t-b\">{{\'WEBAPP_TEXT_SUBSCRIBE_PAYWALL\' | dict}}</p><illustration url=\"{{paywallItem.images.cover.ratio_1}}\" aspect=\"{{paywallItem.image.cover.ratio_1_aspect}}\" title=\"{{paywallItem.title}}\"></illustration><p class=\"general-margin-t-b\" ng-show=\"{{deviceOs === \'Android\'}}\">{{\'WEBAPP_TEXT_SUBSCRIBE_PAYWALL_1_ANDROID\' | dict}} {{price}} {{\'WEBAPP_TEXT_SUBSCRIBE_PAYWALL_2_ANDROID\' | dict}}</p><p class=\"general-margin-t-b\" ng-show=\"!{{deviceOs === \'Android\'}}\">{{\'WEBAPP_TEXT_SUBSCRIBE_PAYWALL_1_IOS\' | dict}} {{price}} {{\'WEBAPP_TEXT_SUBSCRIBE_PAYWALL_2_IOS\' | dict}}</p></div></div><div class=\"body-overlay\" ng-show=\"showThankYouPaywall\"><div class=\"block-banner-text\"><h2>{{\'WEBAPP_THANK_YOU_PAYWALL\' | dict}}</h2></div></div><div class=\"foot-overlay\" ng-show=\"!showThankYouPaywall\"><span class=\"btn btn__general general-margin-b\" ng-click=\"startPaymentFlow()\">{{\'WEBAPP_SUBSCRIBE\' | dict }}</span><span class=\"btn btn__general general-margin-b\" ng-click=\"restorePayment()\" ng-show=\"showRestoreButton\">{{\'WEBAPP_RESTORE\' | dict }}</span><p class=\"font-mini general-margin-b\" ng-click=\"closePaywall()\">{{\'WEBAPP_NO_PAYWALL\' | dict}}</p><hr><p class=\"link-adv\" ng-click=\"alreadyPayed()\">{{\'WEBAPP_LOGIN_PAYWALL\' | dict}}</p></div><div class=\"foot-overlay\" ng-show=\"showThankYouPaywall\"><span class=\"btn btn__general general-margin-b\" ng-click=\"closeThankYou()\">{{\'WEBAPP_CLOSE\' | dict }}</span></div><div class=\"foot-overlay overlay-footer-link\" ng-if=\"modalFooter\"><div class=\"center-block\"><span ng-repeat=\"(key, value) in modalFooter\"><a ng-href=\"{{value.link}}\">{{value.key | dict}}</a></span></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/scrollToTop/scrollToTop.dir.html","<div class=\"scrolltop-button\" ng-class=\"{\'showed\':showScrollTop}\" ng-click=\"onClickCallback()\"><span class=\"icon-scroll\"></span></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/share/share.html","<div class=\"modal-share\" ng-class=\"{\'share-visible\': isOpen && data}\"><div class=\"modal-share-overlay\" data-mipqa=\"close-modal-share\" ng-click=\"close()\"></div><div class=\"modal share-content\"><p class=\"modal-share-title\"><dict key=\"WEBAPP_TEXT_SHARE\"></dict><button ng-click=\"close()\"></button></p><div class=\"share-options\"><a ng-repeat=\"(name, socialObj) in socials\" rel=\"nofollow\" class=\"content-social\" ng-if=\"socialObj.enabled\" ng-click=\"share(name, socialObj.trackAction, socialObj.extraArgs)\"><span class=\"{{\'icon-social_\' + socialObj.icon}}\">{{socialObj.icon}}</span></a></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/shareButton/shareButton.html","<div class=\"share\"><button ng-click=\"share()\" data-mipqa=\"zoom-button-share\"></button></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/slider/slider.html","<div ng-show=\"show\"><div class=\"container-slider both\"><div class=\"content-img\"><div class=\"badge badge--lasted\"><h1 class=\"font-mini\"><dict key=\"SEO_WEBAPP_HEAD_TITLE_TOP\"></dict></h1></div><ul rn-carousel class=\"image\" rn-carousel-index=\"carouselIndex\" id=\"slider\"><li ng-repeat=\"slide in slides\" data-mipqa=\"slider-item\" ng-attr-data-format=\"{{(\'DIGIPARENTING-SERVICE\'|config) ? slide.custom_content_type : slide.format}}\"><h3 ng-if=\"slide.title\"><a ng-href=\"{{slide.url_zoom}}\" title=\"{{slide.title}}\">{{slide.title}}</a></h3><a ng-href=\"{{slide.url_zoom}}\" title=\"{{slide.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\' | dict }}\" ng-click=\"callbackMethod($event, slide.title, $index)\"><slider-content slide=\"slide\" size=\"small\"></slider-content><slider-content slide=\"slide\" size=\"medium\"></slider-content></a><p ng-show=\"{{ \'SHOW_DATES\' | config }}\" class=\"italic\" ng-if=\"slide.born_date || slide.timestamp\"><item-date content=\"slide\"></item-date></p></li></ul></div></div><div ng-show=\"{{ \'SHOW_CAROUSEL_ARROWS\' | config }}\"><button ng-click=\"nextSlide()\" class=\"next-arrow\">Next</button><button ng-click=\"prevSlide()\" class=\"previous-arrow\">Previous</button></div><div rn-carousel-indicators ng-if=\"slides.length>1 && indicators\" slides=\"slides\" rn-carousel-index=\"carouselIndex\"></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/smart-banner/smartBanner.html","<div class=\"smart-banner\" ng-if=\"show\" data-mipqa=\"smart-banner\"><div class=\"center-block-banner\"><div class=\"block-banner-text block-banner-text__first\"><a ng-click=\"closeBanner()\" data-mipqa=\"close-smart-banner\"><span class=\"icon-delete\"></span></a></div><div class=\"block-banner-text\"><a ng-click=\"closeBanner()\" class=\"ico-service\"></a></div><div class=\"block-banner-text block-banner-text__data\"><h2><span class=\"title-smartbanner\">{{\'PLAY_STORE_TITLE\' | dict}}</span><br><span class=\"author-smartbanner\">{{\'PLAY_STORE_AUTHOR\' |dict}}</span><br><span class=\"price-smartbanner\">{{\'PLAY_STORE_PRICE\' | dict}}</span></h2></div><a href=\"\" id=\"downloadButtonBanner\" class=\"btn btn__general btn--dwl\" ng-click=\"getApp()\" data-mipqa=\"link-download-app\"><dict key=\"WEBAPP_BUTTON_DOWNLOAD\"></dict></a><div class=\"general-margin-t-b\" ng-if=\"hasMessage\"><p>{{ \'WEBAPP_SMART_BANNER_MESSAGE\' | dict }}</p></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/social/social.html","<div class=\"inline-block\"><a class=\"content-social\" ng-if=\"socialObj.facebook\" ng-click=\"fbShare()\" rel=\"nofollow\"><span class=\"icon-social_facebook\"></span></a><a class=\"content-social\" ng-if=\"socialObj.whatsapp\" ng-click=\"waShare()\" rel=\"nofollow\"><span class=\"icon-social_whatsapp\"></span></a><a class=\"content-social\" ng-if=\"socialObj.twitter\" ng-click=\"twShare()\" rel=\"nofollow\"><span class=\"icon-social_twitter\"></span></a><a class=\"content-social\" ng-if=\"hybrid\" ng-click=\"generalShare()\" rel=\"nofollow\"><span ng-class=\"shareClass\"></span></a></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/thankYou/thank-you.html","<div id=\"modal-thankyou\" class=\"thankyou-container\" ng-show=\"showThankYou\"><div class=\"box-thankyou\"><div class=\"modal-close\" ng-click=\"closeModal()\"></div><div class=\"thankyou-content\"><p>{{\'MIP_THANKYOUPAGE_MESSAGE_TITLE\' | dict}}</p><p>{{\'MIP_THANKYOUPAGE_MESSAGE_BODY\' | dict}}</p></div><div class=\"img-thankyou\"></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/user-feedback/userFeedback.html","<div id=\"user-feedback\" class=\"form__message form__message--pop-up\" style=\"display:none\"><div class=\"form__line\"><div class=\"form__message-icon\"><span id=\"user-feedback-icon\" class=\"icon\"></span></div><div class=\"form__message-text\"><div id=\"user-feedback-message\" class=\"message\"></div><a id=\"user-feedback-link\" class=\"link\" href=\"\" style=\"display:none\"></a></div></div><div id=\"user-feedback-close\" class=\"close\" data-mipqa=\"exit-popup\"></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/zoom/digiparenting.html","<div class=\"headerBottom-container\" ng-if=\"showContents\"><breadcrumbs item=\"item\"></breadcrumbs></div><div class=\"container-fluid\" ng-if=\"showContents\" data-mipqa=\"zoom-container\"><div class=\"relative\" data-mipqa=\"content-format\" data-format=\"{{item.custom_content_type}}\"><div ng-if=\"item.custom_content_type == \'text\'\"><div class=\"display-large\"><div class=\"display-table-cell\" ng-if=\"!item.properties.hide_zoom_preview\"><gallery class=\"zoom-img\" images=\"images\" cover=\"images[0].src\" zoom-id=\"zoomId\" leaf=\"item.url_leaf_engine_subscription\" item=\"item\" user-can-use=\"canPlay\" read-more=\"readMore\"></gallery></div></div></div><div ng-if=\"item.custom_content_type == \'imagegallery\'\"><gallery images=\"images\" cover=\"item.images.cover.ratio_1\" zoom-id=\"zoomId\" leaf=\"item.url_leaf_engine_subscription\" item=\"item\"></gallery></div><div ng-if=\"item.custom_content_type == \'video\' || item.custom_content_type == \'audio\'\"><clip item=\"item\" contentid=\"{{item.id}}\" videoid=\"{{item | topVideo}}\" is-custom-video=\"false\" audio=\"item.custom_content_type == \'audio\'\" user-can-use=\"canPlay\" get-video-data=\"getVideoData\" read-more=\"readMore\" post-message-callback=\"postMessageCallback\" is-main-news=\"isMainNews\" suggested-clip=\"suggestedClip\" is-360=\"item.is_360_video\" is-wifi=\"isWifi\"></clip></div></div><div class=\"zoom-box\"><div class=\"general-padding\"><share-button share-url=\"item.url_share\" item-title=\"item.title\" item-tracking-title=\"item.default_title || item.title\" id=\"item.id\"></share-button><h2 class=\"h2 double-general-padding-t\"><a href=\"{{item.category.url_zoom}}\" data-mipqa=\"zoom-category-title\" title=\"{{item.category.name}}\" ng-click=\"trackClickCat($event, item.category.name)\">{{item.category.name}}</a></h2><div><h1 class=\"big general-margin-b\" data-mipqa=\"zoom-title\">{{item.title}}</h1></div><div class=\"content-text-zoom\" data-mipqa=\"content-text-zoom\"><p ng-show=\"{{ \'SHOW_DATES\' | config }}\" class=\"date\"><item-date content=\"item\"></item-date></p><p live-html=\"text\"></p></div><share-button share-url=\"item.url_share\" item-title=\"item.title\" item-tracking-title=\"item.default_title || item.title\" id=\"item.id\"></share-button></div><div class=\"bg-second\" ng-if=\"(\'SHOW_TAG_SECTION\'|config)\"><h4><dict key=\"WEBAPP_RELATED_TOPICS\"></dict></h4><div class=\"center-block\" data-mipqa=\"container-list-tags\"><div ng-repeat=\"itemTag in item.tags\" class=\"inline-block\"><span class=\"btn btn--tags\"><a ng-href=\"{{itemTag.url_zoom}}\" ng-click=\"trackClickTag($event, itemTag.title)\">{{itemTag.title}}</a></span></div></div></div><banner></banner></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div><div class=\"zoom-box-two\"><div class=\"other-news general-margin-t\"><div class=\"general-padding\"><h3 class=\"small double-general-margin-b uppercase special-font\"><dict key=\"WEBAPP_OTHER_NEWS\"></dict></h3><div ng-repeat=\"rel in related\" class=\"repeat-item\" data-mipqa=\"zoom-related\"><item content=\"rel\" class=\"both {{\'TEMPLATING_ITEM_ZOOM_RELATED\' | config }}\" callback=\"trackClickRelated(rel.title, $index)\"></item></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/zoom/three.html","<div class=\"container-fluid\" ng-if=\"showContents\" data-mipqa=\"zoom-container\"><div ng-if=\"(\'ZOOMPAGE_TITLE_BEFORE_ITEM\' | config)\"><div><h2 class=\"h2\" data-mipqa=\"title-category\"><a href=\"{{item.category.url_zoom}}\" title=\"{{category.name}}\" ng-click=\"trackClickCat($event, item.category.name)\">{{item.category.name}}</a></h2></div></div><div class=\"relative\" data-mipqa=\"content-format\" data-format=\"{{item.format}}\"><div ng-if=\"item.custom_content_type == \'text\'\"><div class=\"display-large\"><div class=\"display-table-cell\" ng-if=\"!item.properties.hide_zoom_preview\"><gallery class=\"zoom-img\" images=\"images\" cover=\"images[0].src\" zoom-id=\"zoomId\" leaf=\"item.url_leaf_engine_subscription\" item=\"item\" user-can-use=\"canPlay\" read-more=\"readMore\"></gallery></div></div></div><div ng-if=\"item.custom_content_type == \'imagegallery\'\"><gallery images=\"images\" cover=\"item.images.cover.ratio_1\" zoom-id=\"zoomId\" leaf=\"item.url_leaf_engine_subscription\" item=\"item\"></gallery></div><div ng-if=\"item.custom_content_type == \'video\'\"><clip item=\"item\" contentid=\"{{item.id}}\" videoid=\"{{item | topVideo}}\" is-custom-video=\"false\" user-can-use=\"canPlay\" get-video-data=\"getVideoData\" read-more=\"readMore\" post-message-callback=\"postMessageCallback\" is-main-news=\"isMainNews\" suggested-clip=\"suggestedClip\" is-360=\"item.is_360_video\" is-wifi=\"isWifi\"></clip></div><div ng-if=\"(\'ENABLE_DOWNLOAD_FEATURE\' | config)\"><download-button download-info=\"downloadData\" item=\"item\"></download-button></div><div ng-if=\"showCBDownloadButton\"><cb-download-button download-info=\"downloadData\" item=\"item\" user-can-use=\"canPlay\" read-more=\"readMore\"></cb-download-button></div><div ng-if=\"showPHDownloadButton\"><ph-download-button download-info=\"downloadData\" item=\"item\" user-can-use=\"canPlay\" read-more=\"readMore\"></ph-download-button></div></div><div class=\"zoom-box\"><div class=\"general-padding\"><div ng-hide=\"(\'ZOOMPAGE_TITLE_BEFORE_ITEM\' | config)\"><h2 class=\"h2 double-general-padding-t\"><a href=\"{{item.category.url_zoom}}\" title=\"{{category.name}}\" ng-click=\"trackClickCat($event, item.category.name)\">{{item.category.name}}</a></h2></div><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icons\"></div><div><h1 class=\"big general-margin-b\" data-mipqa=\"zoom-title\">{{item.title}}</h1><p ng-show=\"{{ \'SHOW_DATES\' | config }}\" class=\"date\"><item-date content=\"item\"></item-date></p><personalization-buttons enable=\"enablePersonalization\" enable-favorites=\"{{ \'ENABLE_FAVORITES\' | config }}\" enable-watchlater=\"{{ \'ENABLE_WATCHLATER\' | config }}\" redirect-url=\"{{personalizationRedirect}}\" content-id=\"zoomId\" category-id=\"item.category.id\" content-type=\"item.collection_content_type\" template=\"/modules/zoomInteraction/zoomInteraction.html\" ng-if=\"showZoomInteraction\" callback=\"trackPersonalization(action)\"></personalization-buttons></div><div ng-if=\"showPHDownloadButton\"></div><div class=\"content-text-zoom\" data-mipqa=\"content-text-zoom\"><p live-html=\"text\"></p></div><div class=\"center-block\" ng-if=\"!textExpanded && !hideReadMoreButton\"><span class=\"btn btn__general btn--read\"><a ng-click=\"readMore()\" data-mipqa=\"readmore-button\"><dict key=\"{{\'WEBAPP_READ_MORE\' | getFormattedKey:item.format}}\"></dict></a></span></div><call-to-action ng-if=\"showCallToAction\"></call-to-action><div ng-hide=\"hideSocialBlock\" class=\"list-social list-social__no-img\"><div><div class=\"inline-block\"><p class=\"uppercase italic\"><dict key=\"WEBAPP_SHARE_WITH\"></dict></p></div><div class=\"inline-block\"><social-buttons share-url=\"item.url_share\" item-title=\"item.title\" item-tracking-title=\"item.default_title || item.title\" id=\"zoomId\"></social-buttons></div></div></div></div><div class=\"bg-second\" ng-if=\"(\'SHOW_TAG_SECTION\'|config)\"><div class=\"center-block\" data-mipqa=\"container-list-tags\"><div ng-repeat=\"itemTag in item.tags\" class=\"inline-block\"><span class=\"btn btn--tags\"><a ng-href=\"{{itemTag.url_zoom}}\" ng-click=\"trackClickTag($event, itemTag.title)\">{{itemTag.title}}</a></span></div></div></div></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div><div class=\"zoom-box-two\"><div class=\"other-news general-margin-t\"><div class=\"general-padding\"><h3 class=\"small double-general-margin-b uppercase special-font\"><dict key=\"WEBAPP_OTHER_NEWS\"></dict></h3><div ng-if=\"(\'ENABLE_SLIDER_ITEM\'|config)\" related=\"related\" slideritems=\"slider\"><div class=\"container-glide--carousel\"><div class=\"glide sliderItems\"><div class=\"glide__track\" data-glide-el=\"track\"><div class=\"glide__slides\"><div ng-repeat=\"rel in related\" class=\"glide__slide repeat-item\"><item itemopts=\"ITEM_OPTIONS\" content=\"rel\" class=\"both {{\'TEMPLATING_ITEM_ZOOM_RELATED\' | config }}\" callback=\"trackClickRelated(rel.default_title || rel.title, $index)\"></item></div></div></div></div></div></div><div ng-if=\"!(\'ENABLE_SLIDER_ITEM\'|config)\" ng-repeat=\"rel in related\" class=\"repeat-item\"><item content=\"rel\" class=\"both {{\'TEMPLATING_ITEM_ZOOM_RELATED\' | config }}\" callback=\"trackClickRelated(rel.default_title || rel.title, $index)\"></item></div></div></div><div class=\"bg-first general-padding\" ng-if=\"tagNews.length > 0 && (\'SHOW_TAG_SECTION\'|config)\"><div class=\"title-sections\"><div class=\"pull-left\"><h2 class=\"italic\"><dict key=\"WEBAPP_TITLE_NEWS_TAG\"></dict></h2><h2 class=\"h2\"><a href=\"{{tag.url_zoom}}\" title=\"{{tag.name}}\">{{tag.name}}</a></h2></div><div class=\"pull-right\"><div class=\"btn btn--more\"><a class=\"italic\" href=\"{{tag.url_zoom}}\" title=\"{{tag.name}}\">{{\'WEBAPP_ALL\' | dict }}</a></div></div></div><div class=\"both tag\"><div ng-repeat=\"news in tagNews\" class=\"repeat-item\"><item content=\"news\" class=\"both {{\'TEMPLATING_ITEM_ZOOM_TAG\' | config }}\" callback=\"trackClickSimilar(news.default_title || news.title, $index)\"></item></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/zoom/zoomInfinite.html","<div class=\"container-fluid\" ng-attr-id=\"{{zoomId}}\" ng-if=\"showContents\" data-mipqa=\"zoom-container\"><div ng-if=\"(\'ZOOMPAGE_TITLE_BEFORE_ITEM\' | config)\"><div><h2 class=\"h2\"><a href=\"{{item.category.url_zoom}}\" title=\"{{category.name}}\" ng-click=\"trackClickCat($event, item.category.name)\">{{item.category.name}}</a></h2></div></div><div class=\"relative\"><div ng-if=\"item.custom_content_type == \'text\'\"><div class=\"display-large\"><div class=\"display-table-cell\" ng-if=\"!item.properties.hide_zoom_preview\"><gallery class=\"zoom-img\" images=\"images\" cover=\"images[0].src\" zoom-id=\"zoomId\" leaf=\"item.url_leaf_engine_subscription\" item=\"item\" user-can-use=\"canPlay\" read-more=\"readMore\"></gallery></div></div></div><div ng-if=\"item.custom_content_type == \'imagegallery\'\"><gallery images=\"images\" cover=\"item.images.cover.ratio_1\" zoom-id=\"zoomId\" leaf=\"item.url_leaf_engine_subscription\" item=\"item\"></gallery></div><div ng-if=\"item.custom_content_type == \'video\'\"><clip item=\"item\" contentid=\"{{item.id}}\" videoid=\"{{item | topVideo}}\" is-custom-video=\"false\" user-can-use=\"canPlay\" get-video-data=\"getVideoData\" read-more=\"readMore\" post-message-callback=\"postMessageCallback\" is-main-news=\"isMainNews\" suggested-clip=\"suggestedClip\" is-360=\"item.is_360_video\" is-wifi=\"isWifi\"></clip></div><div ng-if=\"(\'ENABLE_DOWNLOAD_FEATURE\' | config)\"><download-button download-info=\"downloadData\"></download-button></div><div ng-if=\"showCBDownloadButton\"><cb-download-button download-info=\"downloadData\" user-can-use=\"canPlay\" read-more=\"readMore\"></cb-download-button></div><div ng-if=\"showPHDownloadButton\"><ph-download-button download-info=\"downloadData\" user-can-use=\"canPlay\"></ph-download-button></div></div><div class=\"general-padding\"><div ng-hide=\"(\'ZOOMPAGE_TITLE_BEFORE_ITEM\' | config)\"><h2 class=\"h2 double-general-padding-t\"><a href=\"{{item.category.url_zoom}}\" title=\"{{category.name}}\" ng-click=\"trackClickCat($event, item.category.name)\">{{item.category.name}}</a></h2></div><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icons\"></div><div><h1 class=\"big general-margin-b\">{{item.title}}</h1><p ng-show=\"{{ \'SHOW_DATES\' | config }}\" class=\"date\"><item-date content=\"item\"></item-date></p><personalization-buttons enable=\"enablePersonalization\" enable-favorites=\"{{ \'ENABLE_FAVORITES\' | config }}\" enable-watchlater=\"{{ \'ENABLE_WATCHLATER\' | config }}\" redirect-url=\"{{personalizationRedirect}}\" content-id=\"zoomId\" category-id=\"item.category.id\" content-type=\"item.collection_content_type\" template=\"/modules/zoomInteraction/zoomInteraction.html\" ng-if=\"showZoomInteraction\" callback=\"trackPersonalization(action)\"></personalization-buttons></div><div class=\"content-text-zoom\" data-mipqa=\"content-text-zoom\"><p live-html=\"text\"></p></div><div class=\"center-block\" ng-if=\"!textExpanded && !hideReadMoreButton\"><span class=\"btn btn__general btn--read\"><a ng-click=\"readMore()\" data-mipqa=\"readmore-button\"><dict key=\"{{\'WEBAPP_READ_MORE\' | getFormattedKey:item.format}}\"></dict></a></span></div><call-to-action ng-show=\"showCallToAction\"></call-to-action><div ng-hide=\"hideSocialBlock\" class=\"list-social list-social__no-img\"><div><div class=\"inline-block\"><p class=\"uppercase italic\"><dict key=\"WEBAPP_SHARE_WITH\"></dict></p></div><div class=\"inline-block\"><social-buttons share-url=\"item.url_share\" item-title=\"item.title\" item-tracking-title=\"item.default_title || item.title\" id=\"zoomId\"></social-buttons></div></div></div></div><div class=\"bg-second\" ng-if=\"(\'SHOW_TAG_SECTION\'|config)\"><div class=\"center-block\" data-mipqa=\"container-list-tags\"><div ng-repeat=\"itemTag in item.tags\" class=\"inline-block\"><span class=\"btn btn--tags\"><a ng-href=\"{{itemTag.url_zoom}}\" ng-click=\"trackClickTag($event, itemTag.title)\">{{itemTag.title}}</a></span></div></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/zoomInteraction/zoomInteraction.html","<div class=\"center container-icon-personalization\"><div><div class=\"btn btn__light btn__light--mini\" ng-click=\"favoriteInteraction()\"><span ng-class=\"isFavorite ? \'icon-favourites_pressed\' : \'icon-favourites\'\"></span><dict key=\"WEBAPP_ADD_TO_FAVOURITES\" ng-hide=\"isFavorite\"></dict><dict key=\"WEBAPP_REMOVE_FROM_FAVOURITES\" ng-show=\"isFavorite\"></dict></div><div class=\"btn btn__light btn__light--mini\" ng-click=\"watchlaterInteraction()\"><span ng-class=\"isWatchlater ? \'icon-read_later_pressed\' : \'icon-read_later\'\"></span><dict key=\"WEBAPP_ADD_TO_WATCHLATER\" ng-hide=\"isWatchlater\"></dict><dict key=\"WEBAPP_REMOVE_FROM_WATCHLATER\" ng-show=\"isWatchlater\"></dict></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/pages/account/account.html","<div class=\"container-fluid\" data-mipqa=\"account-page\"><ul><li ng-class=\"{\'active\' : (active == {{$index}})}\" ng-repeat=\"single in sections\" class=\"simple-list simple-list--single-line\" data-mipqa=\"{{single.subsection}}-{{single.content_id}}\"><h2 ng-click=\"open(single, $index)\">{{single.label}}</h2><span ng-click=\"open(single, $index)\" class=\"icon-arrow_dx arrow-account\"></span><ul><li ng-class=\"{\'active\' : (active == {{$index}})}\" live-html=\"single.text\" class=\"account-section\"></li></ul></li></ul><div ng-show=\"showUO30LogoutButton\" class=\"center-block general-padding\"><span class=\"btn btn__general btn--read\" data-mipqa=\"logout-button\"><a ng-click=\"userLogout()\"><dict key=\"WEBAPP_UO30_LOGOUT\"></dict></a></span></div><div ng-show=\"showUO20LogoutButton\" class=\"center-block general-padding\"><span class=\"btn btn__general btn--read\" data-mipqa=\"logout-button-uo20\"><a href=\"{{\'URLMGR_USER20LOGOUT\' | config }}\"><dict key=\"WEBAPP_UO30_LOGOUT\"></dict></a></span></div><div ng-show=\"showRestore\" class=\"center-block general-padding\"><p class=\"text-center\"><span>{{ \'WEBAPP_USER_RESTORE\' | dict }}</span></p><span class=\"btn btn__general btn--read\"><a ng-click=\"restorePayment()\"><dict key=\"WEBAPP_RESTORE_BUTTON\"></dict></a></span></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account/canceled.html","<div class=\"container-fluid general-padding\" data-mipqa=\"unsubscribed-page\"><p><dict key=\"STATUS_UNSUBSCRIBE_TEXT_WEBAPP1\"></dict></p><p><dict key=\"STATUS_UNSUBSCRIBE_TEXT_WEBAPP2\"></dict></p><div ng-if=\"!telcoRequest\"><a href=\"/#!/\" class=\"block\" data-mipqa=\"unsubscribed-return-home\"><div class=\"btn btn__general\"><dict key=\"WEBAPP_NEXT\"></dict></div></a></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account/forgot.html","<div class=\"container-fluid\"><div live-html=\"text\"></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account/login.html","<div class=\"container-fluid\"><div live-html=\"text\"></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/accountCreation.html","<div class=\"container-fluid\"><div id=\"blackboard\"></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/changePassword.html","<div class=\"container-fluid\"><div class=\"center-block\" ng-hide=\"showSuccessKey\"><p class=\"general-margin-t\"><dict key=\"WEBAPP_CHANGEPASSWORD_MESSAGE\"></dict></p><div id=\"blackboard\"></div></div><div class=\"center-block\" ng-show=\"showSuccessKey\"><p class=\"general-margin-t\"><dict key=\"WEBAPP_CHANGEPASSWORD_SUCCESS\"></dict></p><span class=\"btn btn__general btn--read\"><a href=\"#!/\"><dict key=\"WEBAPP_GO_HOME\"></dict></a></span></div></div><footer></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/confirmMail.html","<div class=\"container-fluid general-padding\"></div><footer></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/forgot.html","<div class=\"container-fluid\"><div id=\"blackboard\" ng-hide=\"showForgotKey\"></div><div class=\"center-block general-padding\" ng-show=\"showForgotKey\"><p class=\"general-padding-t-b\"><dict key=\"WEBAPP_SEND_EMAIL_SUCCESS\"></dict></p><a class=\"btn btn__general center-block btn--forgot\" href=\"#!/\"><span><dict key=\"MIPCONNECT_LABEL_BACK_TO_SITE\"></dict></span></a></div></div><footer></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/login.html","<div class=\"container-fluid\"><div id=\"blackboard\"></div><div class=\"center-block general-padding\" ng-show=\"showLoggedKey\"><div><h3><dict key=\"MIPCONNECT_ALREADY_SUBSCRIBE\"></dict></h3><a class=\"btn btn__general center-block btn--forgot\" href=\"#!/\"><dict key=\"MIPCONNECT_LABEL_BACK_TO_SITE\"></dict></a></div><p><dict key=\"MIPCONNECT_FB_OR\"></dict></p><div><a href=\"\" class=\"btn center-block\" id=\"logout\" ng-click=\"logout()\"><dict key=\"MIPCONNECT_LBL_LOGOUT\"></dict></a></div></div></div><footer></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/loginOtp.html","<div class=\"container-fluid\"><div id=\"blackboard\"><div class=\"account30 container\" data-mipqa=\"login-page\"><div id=\"smartlogin-container\" class=\"form\"><form id=\"frmforgot\" name=\"frmforgot\" class=\"form\"><div id=\"errormsg\" class=\"form__message useris-error-msg\" data-mipqa=\"error-inpage-message\" style=\"display:none\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dict key=\"WEBAPP_UO30_ERROR_WRONG_USERDATA\"></dict></div></div></div><div id=\"useris-error-newton-error\" class=\"form__message useris-error-newton-error\" data-mipqa=\"error-inpage-message\" style=\"display:none\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dict key=\"WEBAPP_UO30_ERROR_NEWTON_GENERIC\"></dict></div></div></div><input type=\"hidden\" name=\"action\" value=\"sendPassword\"> <input type=\"hidden\" name=\"password_requested\" value=\"1\"><div class=\"form__line\" id=\"msisdnBox\" ng-show=\"stepPhoneActive\"><h2 data-mipqa=\"page-titol\"><dict key=\"WEBAPP_UO30_OTP_FORGOT_INSERT_NUMBER\"></dict></h2><label for=\"phone_number\" class=\"flying_label\"><input type=\"text\" id=\"phone_number\" ng-model=\"otpModel.msisdn\" name=\"phone_number\" required data-mipqa=\"msisdn-email-form\" inputmode=\"tel\" ng-change=\"setPhoneField($event)\"><dict key=\"	WEBAPP_UO30_LOGIN_INSERT_USER\"></dict></label><div class=\"form__control\"><button id=\"forgotbutton\" class=\"btn-success\" data-doform=\"1\" type=\"button\" ng-disabled=\"frmforgot.phone_number.$invalid\" data-mipqa=\"forgot-confirm-button\" ng-click=\"doForgot()\"><dict key=\"WEBAPP_UO30_FORGOT_GET_PASSWORD\"></dict></button><p class=\"more-actions\"><a href=\"{{subscribeUrl}}\"><dict key=\"WEBAPP_UO30_SUBSCRIBE\"></dict></a></p></div></div><input type=\"hidden\" id=\"passw\" name=\"password\" required> <input type=\"hidden\" id=\"username\" name=\"username\"><div class=\"form__line\" id=\"otpBox\" ng-show=\"stepOTPActive\"><h2 data-mipqa=\"page-titol\"><dict key=\"WEBAPP_UO30_OTP_LOGIN_INSERT_PIN\"></dict></h2><input ng-repeat=\"otp in OTParray track by $index\" maxlength=\"1\" class=\"login-input login-input-otp\" id=\"{{\'passw_\'+($index + 1) }}\" type=\"text\" required inputmode=\"numeric\" size=\"1\" pattern=\"[0-9]\" tabindex=\"{{$index + 1}}\" ng-model=\"otpModel.passw_[$index]\" name=\"{{\'passw_\'+($index + 1) }}\" value=\"\" data-mipqa=\"pin-psw-form\" autocomplete=\"off\"><div class=\"form__control\"><button id=\"frmbutton\" class=\"btn-success\" data-doform=\"1\" ng-disabled=\"frmforgot.passw_1.$invalid || frmforgot.passw_2.$invalid || frmforgot.passw_3.$invalid || frmforgot.passw_4.$invalid || frmforgot.passw_5.$invalid || frmforgot.passw_6.$invalid\" value=\"\" data-mipqa=\"confirm-button\" type=\"button\" ng-click=\"doLogin($event)\"><dict key=\"WEBAPP_UO30_LOGIN_CONFIRM\"></dict></button><p class=\"more-actions\"><button type=\"button\" id=\"forgotbutton_resend\" ng-click=\"resendPIN()\" class=\"link-button\"><dict key=\"WEBAPP_UO30_RESEND\"></dict></button><button type=\"button\" id=\"backToMsisdn\" class=\"link-button\" ng-click=\"goBack()\"><dict key=\"WEBAPP_UO30_BACK_TO_FORM\"></dict></button></p></div></div></form></div></div></div></div><div class=\"center-block general-padding\" ng-show=\"showForgotKey\"><p class=\"general-padding-t-b\"><dict key=\"WEBAPP_SEND_EMAIL_SUCCESS\"></dict></p><a class=\"btn btn__general center-block btn--forgot\" href=\"#!/\"><span><dict key=\"MIPCONNECT_LABEL_BACK_TO_SITE\"></dict></span></a></div><footer></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/account30/resetPassword.html","<div class=\"container-fluid\"><div id=\"blackboard\"></div></div><footer></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/category/category.html","<div class=\"container-fluid\" data-mipqa=\"category-page\"><div class=\"bg-first general-padding\" ng-if=\"firstNews.length\" data-mipqa=\"category-container\"><h1 class=\"h2 general-margin-t-b\">{{categoryName}}</h1><div class=\"both category {{ \'TEMPLATING_ITEM_CATEGORY_FIRST\' | config }}\"><div ng-repeat=\"item in firstNews\" class=\"repeat-item\" data-mipqa=\"firstnews-item\"><item content=\"item\" class=\"both\" callback=\"trackClick(item.default_title || item.title, $index)\"></item></div></div></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div><div infinite-scroll infinite-callback=\"getNews\" infinite-enable=\"gettingNews\" infinite-offset=\"0\"><div class=\"background-category\"><div class=\"other-news\" ng-if=\"otherNews.length\" data-mipqa=\"othernews-container\"><div class=\"general-padding\"><div class=\"both {{ \'TEMPLATING_ITEM_CATEGORY_OTHERS\' | config }}\"><h3 class=\"double-general-margin-b uppercase\">{{\'WEBAPP_OTHER_NEWS\' | dict }}</h3><div ng-repeat=\"item in otherNews\" class=\"item-layout\" data-mipqa=\"othernews-item\"><item content=\"item\" class=\"both\" callback=\"trackClickOther(item.default_title || item.title, $index)\"></item></div></div></div></div></div></div><div ng-show=\"gettingResult\"><loader></loader></div></div><footer ng-show=\"showFooter\"></footer><banner></banner>");
$templateCache.put("/js/wl/webstore_news/app/pages/contactForm/contactForm.html","<div class=\"headerBottom-container\"><breadcrumbs></breadcrumbs></div><div class=\"container-fluid account30\" data-mipqa=\"content-terms-contactus\"><div class=\"general-padding\"><h2 class=\"h2\"><dict key=\"WEBAPP_CONTACT_US\"></dict></h2><h4><dict key=\"WEBAPP_CONTACT_US_SUBTITLE\"></dict></h4><form ng-submit=\"onSubmit()\" name=\"form\" class=\"form\"><div class=\"form__line\"><label for=\"contact-us-name\"><dict key=\"WEBAPP_CONTACT_US_NAME\"></dict></label><input id=\"contact-us-name\" name=\"name\" type=\"text\" ng-model=\"payload.name\"></div><div class=\"form__line\"><label for=\"contact-us-msisdn\"><dict key=\"WEBAPP_CONTACT_US_MSISDN\"></dict></label><input id=\"contact-us-msisdn\" name=\"msisdn\" type=\"tel\" inputmode=\"tel\" ng-model=\"payload.msisdn\"></div><div class=\"form__line\"><label for=\"contact-us-email\"><dict key=\"WEBAPP_CONTACT_US_EMAIL\"></dict><span>*</span></label><input id=\"contact-us-email\" name=\"email\" type=\"email\" required ng-model=\"payload.email\"></div><div class=\"form__line\"><label for=\"contact-us-subject\"><dict key=\"WEBAPP_CONTACT_US_SUBJECT\"></dict></label><input id=\"contact-us-subject\" name=\"subject\" type=\"text\" ng-model=\"payload.subject\"></div><div class=\"form__line\"><label for=\"contact-us-message\"><dict key=\"WEBAPP_CONTACT_US_MESSAGE\"></dict><span>*</span></label><textarea id=\"contact-us-message\" name=\"message\" required ng-model=\"payload.message\"></textarea></div><span>*<dict key=\"WEBAPP_NECESSARY_INFORMATION\"></dict></span><div class=\"form__line\"><button type=\"submit\" ng-disabled=\"disabled\" class=\"button btn-success\"><dict key=\"WEBAPP_SEND\"></dict></button></div></form><p><dict key=\"WEBAPP_CONTACT_US_FURTHERINFO\"></dict></p></div></div>");
$templateCache.put("/js/wl/webstore_news/app/pages/contactUs/contactUs.html","<div class=\"headerBottom-container\"><breadcrumbs></breadcrumbs></div><div class=\"container-fluid\" data-mipqa=\"content-terms-contactus\"><div class=\"general-padding\"><h2 class=\"h2\"><dict key=\"WEBAPP_CONTACT_US\"></dict></h2><form ng-submit=\"onSubmit()\" name=\"form\"><div class=\"form__line\"><label for=\"contact-us-email\"><dict key=\"WEBAPP_EMAIL\"></dict><span>*</span></label><input id=\"contact-us-email\" name=\"email\" placeholder=\"{{\'WEBAPP_EMAIL_PLACEHOLDER\' | dict}}\" type=\"email\" required ng-model=\"payload.from\"></div><div class=\"form__line\"><label for=\"contact-us-message\"><dict key=\"WEBAPP_MESSAGE\"></dict><span>*</span></label><textarea id=\"contact-us-message\" name=\"message\" placeholder=\"{{\'WEBAPP_MESSAGE_PLACEHOLDER\' | dict}}\" required ng-model=\"payload.body_text\"></textarea></div><span>*<dict key=\"WEBAPP_NECESSARY_INFORMATIONS\"></dict></span><div class=\"form__line\"><button type=\"submit\" ng-disabled=\"disabled\" class=\"button btn-success\"><dict key=\"WEBAPP_SEND\"></dict></button></div></form></div></div>");
$templateCache.put("/js/wl/webstore_news/app/pages/error/error.html","<div class=\"container-fluid\"><div class=\"general-padding\" ng-show=\"showInternalError\"><h3 class=\"font-big center-block special-font\"><dict key=\"WEBAPP_ERROR_GETIT\"></dict></h3><h3 class=\"text-center\" ng-if=\"code\"><dict key=\"ERROR_{{code}}_DESCRIPTION\"></dict></h3><h3 class=\"text-center\" ng-if=\"!code\"><dict key=\"ERROR_DESCRIPTION\"></dict></h3><div class=\"double-general-margin-t-b center-block\"><div ng-hide=\"telcoRequest\" class=\"box-button\"><a href=\"#!/\" class=\"block\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dict }}\"><span class=\"btn btn__general\"><dict key=\"MIPCONNECT_GO_HOME\"></dict></span></a></div></div></div><div class=\"general-padding\" ng-show=\"{{ \'SHOW_TMPL_ERROR\' | config}}\"><div ng-bind-html=\"errorTmpl\"></div></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/glossary/glossary.html","<div class=\"headerBottom-container\"><breadcrumbs></breadcrumbs></div><div class=\"container-fluid\"><ul ng-if=\"buckets.length\" class=\"index-letters\"><li ng-repeat=\"bucket in buckets\" ng-class=\"{ \'glossary-active\' : bucketSelected.chars === bucket.chars }\"><a ng-click=\"selectBucket($index)\">{{bucket.label}}</a></li></ul><h1>{{ \'WEBAPP_GLO_CATEGORY\' | dict }}</h1><h2>{{ bucketSelected.title }}</h2><div ng-if=\"keysLoaded\" class=\"key-loaded\"><div ng-if=\"keys.length\"><div ng-repeat=\"key in keys\" class=\"key-index\"><h2>{{key.title}}</h2><p>{{key.description}}</p></div></div></div></div><footer ng-if=\"showFooter\"></footer><banner></banner>");
$templateCache.put("/js/wl/webstore_news/app/pages/home/home.html","<div class=\"container-fluid\" data-mipqa=\"home-page\"><h1 class=\"claim-header-home\" ng-if=\"(\'SHOW_CLAIM_IN_HOME\'|config)\">{{\'WEBAPP_HOME_HEADER_CLAIM\' | dict }}</h1><h2 class=\"h2\" ng-if=\"fromOTP\">{{\'WEBAPP_HOME_FROM_OTP\' | dict }}</h2><ul class=\"tab-news tab-news--home\" ng-show=\"showLatestSection\"><li class=\"col-xs-6\"><h1 class=\"medium special-font uppercase\"><a href=\"\" ng-click=\"changeTab(\'home\')\" ng-class=\"{\'active\' : activeTab == \'home\'}\">{{\'WEBAPP_HOME\' | dict }}</a></h1></li><li class=\"col-xs-6\"><h1 class=\"medium special-font uppercase\"><a href=\"\" ng-click=\"changeTab(\'latest\')\">{{\'WEBAPP_LATEST\' | dict }}</a></h1></li><li class=\"col-xs-6\"><div class=\"animation-tab\" ng-class=\"{\'active-tab\' : activeTab == \'latest\'}\"></div></li></ul><div class=\"ng-hide\" ng-show=\"activeTab == \'home\'\"><div class=\"additional-contest\" ng-if=\"\'SHOW_ADDITIONAL_CONTEST\'|config\"><a title=\"{{(\'WEBAPP_URL_ADDITIONAL_CONTEST\'|dict)}}\" href=\"{{(\'WEBAPP_URL_ADDITIONAL_CONTEST\'|dict)}}\" target=\"_blank\"><picture><img ng-if=\"$root.currentLanguage === \'ar\'\" ng-src=\"{{ \'ADDITIONAL_CONTEST_AR\' | config }}\" alt=\"{{ \'WEBAPP_URL_ADDITIONAL_CONTEST\' | dict }}\"> <img ng-if=\"$root.currentLanguage !== \'ar\'\" ng-src=\"{{ \'ADDITIONAL_CONTEST\' | config }}\" alt=\"{{ \'WEBAPP_URL_ADDITIONAL_CONTEST\' | dict }}\"></picture></a></div><div class=\"on-slider\" ng-if=\"ready && showSlider\" data-mipqa=\"slider-container\"><slider show=\"ready && showSlider && !(\'SHOW_NEW_SLIDER\'|config)\" ng-if=\"!(\'SHOW_NEW_SLIDER\'|config)\" slides=\"slides\" autoplay transition=\"slide\" duration=\"300\" indicators=\"true\" ng-show=\"{{ \'SHOW_HOME_CAROUSEL\' | config }}\" callback=\"trackClickSlider\"></slider><new-slider ng-if=\"(\'SHOW_NEW_SLIDER\'|config)\" slides=\"slides\" slider=\"carousel\" show=\"ready && showSlider && (\'SHOW_NEW_SLIDER\'|config)\" ng-show=\"{{ \'SHOW_HOME_CAROUSEL\' | config }}\" sliderconf=\"CAROUSEL_OPTIONS\" callback=\"trackClickSlider\"></new-slider></div><div class=\"test\"><div class=\"off-slider\" ng-if=\"ready && !showSlider\" data-mipqa=\"slider-container\"><div class=\"container-slider both\" ng-class=\"{\'remove-space\':( \'SHOW_ADDITIONAL_CONTEST\' | config )}\"><div class=\"content-img\"><div class=\"badge badge--lasted\"><h1 class=\"font-mini\"><dict key=\"SEO_WEBAPP_HEAD_TITLE_TOP\"></dict></h1></div><ul><li ng-repeat=\"slide in slides\" data-mipqa=\"slider-item\" data-format=\"{{slide.format}}\"><h3 ng-if=\"slide.title\"><a ng-href=\"{{slide.url_zoom}}\" title=\"{{slide.title}}\" ng-click=\"trackClickSlider($event, slide.title, $index)\">{{slide.title}}</a></h3><a ng-href=\"{{slide.url_zoom}}\" title=\"{{slide.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\' | dict }}\" ng-click=\"trackClickSlider($event, slide.title, $index)\"><picture><img ng-src=\"{{slide.images.cover.ratio_1 | imagesize:\'home\':\'big\'}}\" alt=\"{{slide.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\"><div ng-if=\"slide.custom_content_type == \'video\'\" ng-class=\"slide.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"slide.duration\" class=\"duration\"><span>{{slide.duration.formatted}}</span></div></picture></a><p ng-show=\"{{ \'SHOW_DATES\' | config }}\" class=\"italic\" ng-if=\"slide.born_date || slide.timestamp\"><item-date content=\"slide\"></item-date></p></li><li class=\"additional-banner-desktop\" ng-if=\"\'SHOW_ADDITIONAL_BANNER\'|config\"><a title=\"{{(\'URL_ADDITIONAL_BANNER\'|config)}}\" href=\"{{(\'URL_ADDITIONAL_BANNER\'|config)}}\" target=\"_blank\"><picture><img src=\"/static_env/img/wl/webstore_news/images/general/additional-banner-desktop.jpg\" alt=\"{{(\'URL_ADDITIONAL_BANNER\'|config)}}\"></picture></a></li></ul></div></div></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div></div><div class=\"bg-first general-padding\" ng-if=\"video.length\"><div class=\"title-sections\"><div><h2 class=\"italic\">{{\'WEBAPP_VIDEO\' | dict }}</h2><h2 class=\"h2 pull-left\"><a href=\"/#!/video\" title=\"VIDEO\" ng-click=\"trackClickVideoAll($event, \'Video\')\">{{\'WEBAPP_VIDEO\' | dict }}</a></h2><div class=\"pull-right\"><a class=\"inline-block\" href=\"/#!/video\" title=\"Video\" ng-click=\"trackClickVideoAll($event, \'Video\')\"><div class=\"btn btn--more\" data-mipqa=\"link-category-page\">{{\'WEBAPP_ALL\' | dict }}</div></a></div></div></div><div class=\"both tag video-item\"><div ng-repeat=\"item in video\" class=\"repeat-item\"><item content=\"item\" class=\"both {{ \'TEMPLATING_ITEM_HOME_VIDEO\' | config }}\" callback=\"trackClickVideo(item.default_title || item.title, $index)\"></item></div></div></div><div class=\"bg-first general-padding\" data-mipqa=\"home-tag-div\" ng-if=\"showTag\"><div class=\"title-sections\"><div><h2 class=\"italic\"><dict key=\"WEBAPP_TITLE_NEWS_TAG\"></dict></h2><h2 class=\"h2 pull-left\"><a href=\"{{tag.url_zoom}}\" title=\"{{tag.name}}\" ng-click=\"trackClickTagAll($event, tag.name)\">{{tag.name}}</a></h2><div class=\"pull-right\" ng-if=\"showTagSection\"><a class=\"inline-block\" href=\"{{tag.url_zoom}}\" title=\"{{tag.name}}\" ng-click=\"trackClickTagAll($event, tag.name)\"><div class=\"btn btn--more\" data-mipqa=\"link-tag-page\">{{\'WEBAPP_ALL\' | dict }}</div></a></div></div></div><div class=\"both tag\"><div ng-repeat=\"item in tag.items\" class=\"repeat-item\" data-mipqa=\"home-tag-item\"><item content=\"item\" class=\"both {{ \'TEMPLATING_ITEM_HOME_TAG\' | config }}\" callback=\"trackClickTag(item.default_title || item.title, $index)\"></item></div></div></div><div class=\"general-padding bg-second\" data-mipqa=\"home-category-div\"><div ng-repeat=\"category in categories\"><div class=\"title-sections title-sections--category\"><div><h2 class=\"h2 pull-left\"><a ng-href=\"{{category.url_zoom}}\" title=\"{{category.name}}\" ng-click=\"trackClickCatAll($event, category.name, $index)\">{{category.name}}</a></h2><div class=\"pull-right\"><a class=\"inline-block\" ng-href=\"{{category.url_zoom}}\" title=\"{{category.name}}\" ng-click=\"trackClickCatAll($event, category.name, $index)\"><div class=\"btn btn--more\" data-mipqa=\"link-category-page\">{{\'WEBAPP_ALL\' | dict }}</div></a></div></div></div><div ng-if=\"(\'ENABLE_SLIDER_ITEM\'|config)\" class=\"both category {{ \'TEMPLATING_ITEM_HOME_CATEGORY\' | config }} bg-second\"><div class=\"container-glide--carousel\"><div class=\"glide sliderItems slider-{{category.id}}\"><div class=\"glide__track\" data-glide-el=\"track\"><div class=\"glide__slides\"><div ng-repeat=\"item in category.items\" class=\"glide__slide\" data-mipqa=\"home-category-item\"><item itemopts=\"ITEM_OPTIONS\" content=\"item\" class=\"both category\" callback=\"trackClickCat($parent.$index, item.default_title || item.title, $index)\"></item></div></div></div></div></div></div><div ng-if=\"!(\'ENABLE_SLIDER_ITEM\'|config)\" class=\"both category {{ \'TEMPLATING_ITEM_HOME_CATEGORY\' | config }} bg-second\"><div ng-repeat=\"item in category.items\" class=\"repeat-item\" data-mipqa=\"home-category-item\"><item content=\"item\" class=\"both category\" callback=\"trackClickCat($parent.$index, item.default_title || item.title, $index)\"></item></div></div></div></div></div><div class=\"\" ng-show=\"activeTab == \'latest\' && showLatestSection\"><div class=\"bg-first general-padding\"><h1 class=\"h2 general-margin-t-b\">{{\'WEBAPP_LATEST\' | dict }}</h1><div class=\"both category {{ \'TEMPLATING_ITEM_LATEST_FIRST\' | config }}\"><div ng-repeat=\"item in firstLatest\" class=\"repeat-item\"><item content=\"item\" class=\"both\" callback=\"trackClick(item.default_title || item.title, $index)\"></item></div></div></div><div infinite-scroll infinite-callback=\"getLatest\" infinite-enable=\"gettingLatest\" infinite-offset=\"0\"><div class=\"other-news\" ng-show=\"otherLatest.length\"><div class=\"general-padding\"><div class=\"both {{ \'TEMPLATING_ITEM_LATEST_OTHERS\' | config }}\"><h3 class=\"double-general-margin-b uppercase\">{{\'WEBAPP_OTHER_NEWS\' | dict }}</h3><div ng-repeat=\"item in otherLatest\" class=\"item-layout\"><item content=\"item\" class=\"both\" callback=\"trackClickOther(item.default_title || item.title, $index)\"></item></div></div></div></div></div><div ng-show=\"gettingLatest\"><loader></loader></div></div></div><footer ng-show=\"showFooter\"></footer><banner></banner>");
$templateCache.put("/js/wl/webstore_news/app/pages/myspace/myspace.html","<div class=\"container-fluid\"><div ng-hide=\"showEmptyState\"><div ng-repeat=\"playlist in userPlaylist\" class=\"repeat-item\"><cover-item item=\"playlist\" class=\"both {{ \'TEMPLATING_ITEM_HOME_TAG\' | config }}\" callback=\"trackClickPlaylist\"></cover-item></div></div><div ng-show=\"showEmptyState\"><div class=\"box-myspace\"><p class=\"center general-padding\"><dict key=\"WEBAPP_MYSPACE_TEXT_NOLOGGED\"></dict></p><div class=\"center general-padding\"><div class=\"table box-icon-personalization\"><div class=\"block-cell center\"><span class=\"icon-favourites\"></span><dict key=\"WEBAPP_ADD_TO_FAVOURITES\"></dict></div><div class=\"block-cell center\"><span class=\"icon-read_later\"></span><dict key=\"WEBAPP_ADD_TO_WATCHLATER\"></dict></div></div></div></div><div class=\"general-padding\"><div class=\"title-sections\"><div><h2 class=\"italic\"><dict key=\"WEBAPP_START_NOW\"></dict></h2></div></div><div class=\"both tag\"><div ng-repeat=\"item in suggestedNews track by $index\" class=\"repeat-item\"><item content=\"item\" class=\"both {{ \'TEMPLATING_ITEM_HOME_TAG\' | config }}\" callback=\"trackClickSuggested\"></item></div></div></div></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/news/news.html","<div class=\"container-fluid\"><div class=\"\"><ul class=\"tab-news\" ng-show=\"showTagSection\"><li class=\"col-xs-6\"><h1 class=\"medium special-font uppercase\"><a href=\"\" ng-click=\"changeTab(\'categories\')\" ng-class=\"{\'active\' : activeTab == \'categories\'}\">{{\'WEBAPP_CATEGORY\' | dict }}</a></h1></li><li class=\"col-xs-6\"><h1 class=\"medium special-font uppercase\"><a href=\"\" ng-click=\"changeTab(\'tags\')\" data-mipqa=\"tags-button\">{{\'WEBAPP_TAGS\' | dict }}</a></h1></li><li class=\"col-xs-6\"><div class=\"animation-tab\" ng-class=\"{\'active-tab\' : activeTab == \'tags\'}\"></div></li></ul><div class=\"ng-hide\" ng-show=\"activeTab == \'categories\'\" data-mipqa=\"categories-page\"><div infinite-scroll infinite-callback=\"getCategories\" infinite-enable=\"gettingCategories\" infinite-offset=\"0\"><div class=\"general-padding bg-first\"><div class=\"categories-page\" ng-if=\"categories.length\" data-mipqa=\"categories-container\"><div ng-repeat=\"item in categories\" data-mipqa=\"category-item\"><item content=\"item\" class=\"both {{ \'TEMPLATING_ITEM_CATEGORIES\' | config }}\" callback=\"trackClickCat(item.title, $index)\"></item></div></div></div></div><div ng-show=\"showCategoriesLoader\"><loader></loader></div></div><div class=\"\" ng-show=\"activeTab == \'tags\' && showTagSection\" data-mipqa=\"tags-container\"><div class=\"tags-page\" infinite-scroll infinite-callback=\"getTags\" infinite-enable=\"gettingTags\" infinite-offset=\"0\"><div ng-repeat=\"item in tags\" data-mipqa=\"tags-item\"><div class=\"simple-list\"><a ng-href=\"{{item.url_zoom}}\" title=\"{{item.title}}\" ng-click=\"trackClickTag($event, item.title, $index)\"><h2>{{item.title}}</h2><p class=\"font-mini\">{{item.num_items}} {{\'WEBAPP_NEWS\' | dict }}</p></a></div></div></div><div ng-show=\"showTagsLoader\"><div class=\"center-block general-padding\"><div class=\"loader\"></div></div></div></div></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/playlist/playlist.html","<div class=\"container-fluid\"><div class=\"bg-first general-padding\"><h1 class=\"h2 general-margin-t-b\"><span ng-click=\"backButton()\" class=\"icon-back pointer\"></span>&nbsp;{{title}}</h1></div><div ng-show=\"showTrash\" class=\"pull-right title-color-section general-padding pointer\" ng-click=\"removeItemFromMyspace(playlistItems)\"><span class=\"icon-trash\"></span><span>{{\'WEBAPP_CLEAR_LIST\' | dict}}</span></div><div infinite-scroll infinite-callback=\"getPlaylistItems\" infinite-enable=\"enableInfinite\" infinite-offset=\"0\"><div class=\"general-padding bg-first\"><div class=\"playlist-page both {{ \'TEMPLATING_ITEM_SEARCH_OTHERS\' | config }}\"><div ng-repeat=\"item in playlistItems\" class=\"item-layout\" data-mipqa=\"playlist-item\" ng-class=\"{\'fadeOutItem\': isfadeOutItem}\"><item content=\"item\" playlist=\"playlistItems\" section=\"section\" class=\"both ng-isolate-scope\" callback=\"trackClickPlaylist(item.default_title || item.title, $index)\"></item></div></div></div></div><div ng-show=\"!hideEmpityListMess\" class=\"text-center title-color-section\">{{\'WEBAPP_EMPTY_LIST_ITEM\' | dict}}</div><div ng-show=\"gettingResult\"><loader></loader></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/search/search.html","<div class=\"headerBottom-container\" ng-if=\"(\'SHOW_SEARCH_GO_BACK\' | config)\"><breadcrumbs></breadcrumbs></div><div class=\"container-fluid\" data-mipqa=\"search-page\"><div class=\"background-search\"><div class=\"general-padding bg-input-search\"><div class=\"container-input center-block\" data-mipqa=\"container-search-input\"><form ng-submit=\"submit()\"><a class=\"icon-search\" ng-click=\"submit()\" data-mipqa=\"button-search\"></a><input type=\"text\" ng-model=\"query\" placeholder=\"{{\'WEBAPP_LOOKING_FOR\' | dict }}\" required><button type=\"reset\" data-mipqa=\"button-search-reset\" ng-if=\"(\'SHOW_BUTTON_SEARCH_RESET\' | config)\"></button><span class=\"icon-delete\"></span></form></div><div ng-show=\"phase == \'waitFirst\' || phase == \'waitAfter\'\"><loader></loader></div><div class=\"result general-padding\" data-mipqa=\"search-no-result\" ng-if=\"phase == \'void\'\"><h3 class=\"small italic center\"><dict key=\"WEBAPP_GOLD_SEARCH_NORESULTS\"></dict></h3></div></div></div><div class=\"noResult\" ng-show=\"phase == \'none\' || phase == \'waitFirst\' || phase == \'void\'\"><div class=\"background-search-two\"><div class=\"other-news\" data-mipqa=\"search-suggested-items\" ng-if=\"(\'SHOW_SEARCH_SUGGESTED\' | config)\"><div class=\"general-padding\"><div class=\"both {{ \'TEMPLATING_ITEM_SEARCH_OTHERS\' | config }}\"><h3 class=\"small row-title general-margin-b uppercase special-font\"><dict key=\"WEBAPP_OTHER_NEWS\"></dict></h3><div ng-if=\"(\'ENABLE_SLIDER_ITEM\'|config)\"><div ng-repeat=\"category in categories\" ng-if=\"$index>2\"><div class=\"container-glide--carousel\"><div class=\"glide sliderItems slider-{{category.id}}\"><div class=\"glide__track\" data-glide-el=\"track\"><div class=\"glide__slides\"><div ng-repeat=\"item in category.items\" class=\"glide__slide\"><item itemopts=\"ITEM_OPTIONS\" content=\"item\" class=\"both\" callback=\"trackClickCat($parent.$index, item.default_title || item.title, $index)\"></item></div></div></div></div></div></div></div><div ng-if=\"!(\'ENABLE_SLIDER_ITEM\'|config)\" ng-repeat=\"item in latestNews\" class=\"item-layout ng-scope\"><item content=\"item\" class=\"both ng-isolate-scope\" callback=\"trackClickOther(item.title, $index)\"></item></div></div></div></div></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div><div class=\"popular-categories\" data-mipqa=\"search-container-categories-list\" ng-if=\"categoriesList.length\"><div class=\"general-padding bg-first\"><h3 class=\"small general-margin-t general-margin-b uppercase special-font\">{{\'WEBAPP_POPULAR_CATEGORIES\' | dict }}</h3></div><div ng-repeat=\"item in categoriesList\"><div class=\"simple-list simple-list--single-line\"><a ng-href=\"{{item.url_zoom}}\" data-mipqa=\"search-categories-list\" title=\"{{item.title}}\" ng-click=\"trackClickCategory($event, item.title, $index)\"><h2>{{item.title}}</h2><span class=\"icon-arrow_dx\"></span></a></div></div></div><div class=\"shadow-search\"></div><div class=\"wave-search\"></div></div><div class=\"result\" data-mipqa=\"search-result\" ng-if=\"phase == \'waitAfter\' || phase == \'result\'\"><div infinite-scroll infinite-callback=\"getOtherNews\" infinite-enable=\"gettingResult\" infinite-offset=\"0\"><div class=\"other-news\"><div class=\"general-padding\"><div class=\"both {{ \'TEMPLATING_ITEM_SEARCH_RESULTS\' | config }}\"><h3 class=\"small double-general-margin-b uppercase special-font\">{{\'WEBAPP_RESULTS\' | dict }}:<span class=\"h2\">{{searchedFor}}</span></h3><div ng-repeat=\"item in results\" class=\"item-layout ng-scope\"><item content=\"item\" class=\"both ng-isolate-scope\" callback=\"trackClickResult(item.title, $index)\"></item></div></div></div></div></div><div ng-show=\"gettingOtherNews\"><div class=\"center-block general-padding\"><div class=\"loader\"></div></div></div><div class=\"shadow-section\"></div><div class=\"wave-section\"></div></div></div><footer ng-show=\"showFooter\"></footer><banner></banner>");
$templateCache.put("/js/wl/webstore_news/app/pages/tag/tag.html","<div class=\"container-fluid\"><div class=\"bg-first general-padding\" ng-if=\"firstNews.length\" data-mipqa=\"tag-page\"><h1 class=\"h2 general-margin-t-b\">{{namePrefix}}{{tagName}}</h1><div class=\"both category {{ \'TEMPLATING_ITEM_TAG_FIRST\' | config }}\"><div ng-repeat=\"item in firstNews\" data-mipqa=\"tags-news-item\"><item content=\"item\" class=\"both\" callback=\"trackClick(item.default_title || item.title, $index)\"></item></div></div></div><div infinite-scroll infinite-callback=\"getNews\" infinite-enable=\"gettingNews\" infinite-offset=\"0\"><div class=\"other-news\" ng-if=\"otherNews.length\" data-mipqa=\"tags-othernews-container\"><div class=\"general-padding\"><div class=\"both {{ \'TEMPLATING_ITEM_CATEGORY_OTHERS\' | config }}\"><h3 class=\"uppercase special-font double-general-margin-b\">{{\'WEBAPP_OTHER_NEWS\' | dict }}</h3><div ng-repeat=\"item in otherNews\" class=\"item-layout\" data-mipqa=\"tags-othernews-item\"><item content=\"item\" class=\"both\" callback=\"trackClickOther(item.default_title || item.title, $index)\"></item></div></div></div></div></div><div ng-show=\"gettingResult\"><loader></loader></div></div><footer ng-show=\"showFooter\"></footer><banner></banner>");
$templateCache.put("/js/wl/webstore_news/app/pages/terms/terms.html","<div class=\"container-fluid\"><div live-html=\"text\"></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/video/video-list.html","<div class=\"container-fluid\"><div class=\"bg-first general-padding\"><h1 class=\"h2 general-margin-t-b\">{{\'WEBAPP_VIDEO\' | dict }}</h1><div class=\"both category {{ \'TEMPLATING_ITEM_HOME_VIDEO\' | config }}\"><div ng-repeat=\"item in firstVideo\" class=\"repeat-item\"><item content=\"item\" class=\"both\" callback=\"trackClickResult($index, item.default_title || item.title)\"></item></div></div></div><div infinite-scroll infinite-callback=\"getVideoList\" infinite-enable=\"gettingVideos\" infinite-offset=\"0\"><div class=\"other-news\" ng-show=\"otherVideos.length\"><div class=\"general-padding\"><div class=\"both {{ \'TEMPLATING_ITEM_CATEGORY_OTHERS\' | config }}\"><h3 class=\"double-general-margin-b uppercase\">{{\'WEBAPP_OTHER_NEWS\' | dict }}</h3><div ng-repeat=\"item in otherVideos\" class=\"padding-l-5 col-xs-12 col-ms-6\"><item content=\"item\" class=\"both\" callback=\"trackClickOther($index, item.default_title || item.title)\"></item></div></div></div></div></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/video/video-zoom.html","<div class=\"container-fluid\" ng-if=\"showContent\"><div class=\"general-padding bg-first\"><h2 class=\"h2\"><a href=\"/#!/video\" title=\"Video\" ng-click=\"trackClickCat($event, \'video\')\">{{\'WEBAPP_VIDEO\' | dict }}</a></h2></div><div class=\"general-padding bg-second\"><h1 class=\"big general-margin-b\">{{video.title}}</h1><p ng-show=\"{{ \'SHOW_DATES\' | config }}\" class=\"date\"><item-date content=\"video\"></item-date></p></div><div class=\"center-block\"><clip item=\"video\" contentid=\"{{video.id}}\" videoid=\"{{video.id}}\" is-custom-video=\"true\" user-can-use=\"canPlay\"></clip><p class=\"general-padding\">{{\'WEBAPP_DURATION\' | dict }} {{video.duration.formatted}}</p></div><div class=\"general-padding bg-second\"><div><p ng-bind-html=\"video.description\"></p></div></div><div class=\"list-social list-social__no-img\"><div class=\"pull-right\"><div class=\"inline-block\"><p class=\"uppercase italic\"><dict key=\"WEBAPP_SHARE_WITH\"></dict></p></div><div class=\"inline-block\"><social-buttons share-url=\"video.url_share\" item-title=\"video.title\" item-tracking-title=\"video.default_title || video.title\" id=\"videoId\"></social-buttons></div></div></div><div class=\"other-news general-margin-t\"><div class=\"general-padding\"><h3 class=\"small double-general-margin-b uppercase special-font\"><dict key=\"WEBAPP_OTHER_NEWS\"></dict></h3><div ng-if=\"videoListRelated\" ng-repeat=\"item in videoListRelated\"><item content=\"item\" class=\"both {{\'TEMPLATING_ITEM_ZOOM_VIDEO\' | config }}\" callback=\"trackClickRelated($index, item.default_title || item.title)\"></item></div></div></div></div><footer ng-show=\"showFooter\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/pages/zoomParent/zoomParent.html","<div class=\"container-fluid\" data-mipqa=\"zoom-page\"><zoom-section zoom-id=\"{{itemId}}\" is-main-news=\"true\" on-related-loaded=\"relatedLoaded\" is-wifi=\"isWifi\"></zoom-section><div ng-show=\"zoomSectionArray.length > 0 && relatedHasLoaded\"><div ng-repeat=\"zoomSection in zoomVisibleItems track by $index\" class=\"infinite-zoom\"><zoom-section content=\"zoomSection\" zoom-id=\"{{zoomSection.id}}\" is-wifi=\"isWifi\"></zoom-section></div></div></div><footer ng-show=\"showContents\"></footer>");
$templateCache.put("/js/wl/webstore_news/app/modules/header/header-split/header-bottom.html","<div ng-if=\"showHeaderBottom\"><div class=\"menu-tabs\"><div ng-click=\"toggleMenu(0)\" ng-class=\"{\'active-tab\': currentIndex === 0}\"><span data-mipqa=\"tab-categories\"><dict key=\"WEBAPP_HEADER_CATEGORIES\"></dict></span></div><div ng-click=\"toggleMenu(1)\" ng-class=\"{\'active-tab\': currentIndex === 1}\"><span data-mipqa=\"age-range\"><dict key=\"WEBAPP_HEADER_AGE_RANGE\"></dict></span></div><div ng-click=\"toggleMenu(2)\" ng-class=\"{\'active-tab\': currentIndex === 2}\"><span data-mipqa=\"trending-topics\"><dict key=\"WEBAPP_HEADER_TRENDING_TOPICS\"></dict></span></div></div><div class=\"sub-menu\"><div ng-if=\"open && currentIndex === 0\"><ul class=\"content-list-tabs\"><li ng-repeat=\"category in categories\" ng-class=\"{\'active-header\': currentUrl === category.url_zoom}\"><a href=\"{{category.url_zoom}}\" ng-click=\"trackNavClick($event, \'Cat Page\', category.title)\" data-mipqa=\"submenu-tabs-categories\">{{category.title}}</a></li><li><a href=\"#!{{ \'ROUTER_GLOSSARY\' | config }}\" ng-click=\"trackNavClick($event, \'Cat Page\', \'Glossary\')\"><dict key=\"WEBAPP_HEADER_GLOSSARY\"></dict></a></li></ul></div><div ng-if=\"open && currentIndex === 1\"><ul class=\"content-list-tabs\"><li ng-repeat=\"tag in ageRangeTags\" ng-class=\"{\'active-header\': currentUrl === tag.url_zoom}\"><a ng-href=\"{{tag.url_zoom}}\" ng-click=\"trackNavClick($event, \'Age Range Page\', tag.title)\" data-mipqa=\"submenu-tabs-age-range\"><span>{{tag.title}}</span></a></li></ul></div><div ng-if=\"open && currentIndex === 2\"><ul class=\"center-block\"><li ng-repeat=\"trending in trendingTags\" class=\"btn btn--tags\" ng-class=\"{\'active-header\': currentUrl === trending.url_zoom}\"><a ng-href=\"{{trending.url_zoom}}\" ng-click=\"trackNavClick($event, \'Tag Page\', trending.title)\" data-mipqa=\"submenu-tabs-trending-topics\">{{trending.title}}</a></li></ul></div></div></div>");
$templateCache.put("/js/wl/webstore_news/app/modules/slider/slider-content/slider-content.html","<div ng-class=\"(size + \'-slide\')\"><div class=\"bg-slide\" alt=\"{{slide.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dict }}\" ng-style=\"{\'background-image\': \'url({{bgImage}})\'}\" ng-if=\"bgImage\"><div ng-if=\"isVideo\" ng-class=\"slide.duration ? \'custom-player w-duration\' : \'custom-player\'\"></div><div ng-if=\"isVideo && slide.duration\" class=\"duration\"><span>{{slide.duration.formatted}}</span></div><button class=\"btn btn__general\" ng-if=\"(\'SHOW_CAROUSEL_BUTTONS\' | config)\"><dict key=\"WEBAPP_FIND_OUT_MORE\"></dict></button></div></div>");}]);